export const translations = {
    "en-US": {
        // Preferred hour cycle for locale
        // NOTE: Only necessary to specify if default for country/region from CLDR supplementary data used by browser Intl API is incorrect
        // See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Locale/hourCycle
        // See: https://github.com/unicode-org/cldr/blob/master/common/supplemental/supplementalData.xml#L4768
        "date-time-hour-cycle": "h12",

        // Date and time formats as Luxon format strings
        // See: https://moment.github.io/luxon/docs/manual/formatting.html#table-of-tokens
        "date-time-format-date": "MM/dd/yyyy",
        "date-time-format-day-and-date": "EEEE dd/MM",
        "date-time-format-time": "hh:mm\u00A0a",
        "date-time-format-time-hms": "hh:mm:ss\u00A0a",
        "date-time-format-date-and-time": "MM/dd/yyyy\u00A0hh:mm\u00A0a",
        "date-time-format-duration-hours-minutes": "h'h.' m'min.'",
        "date-time-format-duration-minutes": "m'min.'",
        "date-time-format-duration-seconds": "s's'",
        "date-time-compact-period-start": "M/d-yy 'at' HH:mm\u00A0a",
        "date-time-invalid-date": "N/A",

        // Money formats
        "money-amount-unit-month": "mo.",
        "money-amount-unit-year": "yr.",

        // User types
        "-user-type-support": "Support",
        "-user-type-supplier": "Supplier",
        "-user-type-merchant": "Merchant",
        "-user-type-company": "Company",
        "-user-type-office-manager": "Office manager",
        "-user-type-user": "User",
        "-user-type-service-center": "Service center",


        // Shared components
        "error-boundary-modal": "\n .title = Something went wrong\n .message = Error code: { $errorCode }\n .buttonLabel = Close dialog",
        "query-error-boundary": "\n .title = Something went wrong\n .message = Error code: { $errorCode }\n .buttonLabel = Retry",
        "confirmation-dialog-cancel": "Cancel",
        "confirmation-dialog-approve": "Approve",
        "error-dialog-show-details-label": "Show details",
        "error-dialog-close-button": "Close",
        "error-dialog-support-request": "Please contact <supportMessage>support@facilitynet.dk</supportMessage> if the problem persists.",
        "error-route": "\n .title = Something went wrong \n .message This page cannot be shown due to an unknown error \n .buttonLabel = Go to home",
        "time-or-date-picker-time-label": "Time",
        "api-call-timeout-message": "Request is taking longer than expected",

        // authenticate common texts
        "-authenticate-submit-button": "Next",

        // --- Error boundaries ---
        "app-error-boundary": "\n .title = Something went wrong\n .buttonLabel = Close dialog",
        "app-error-boundary-title": "Something went wrong",
        "app-error-boundary-button": "Close dialog",
        "route-error-boundary": "\n .title = Something went wrong\n .buttonLabel = Go home",
        "inline-error-boundary-message": "Could not render component",
        "inline-error-boundary-calendar-event-message": 'Could not parse event',
        "query-error-boundary-message": "Error fetching data.",
        "query-error-boundary-no-data-message": "No data.",
        "query-error-boundary-retry-button": "Retry",


        // --- Language selector ---
        "language-selector-lang-en-us": "English",
        "language-selector-lang-da-dk": "Danish",


        // --- Footer ---
        "footer-read-more": "Read more at <linkElem>{ $linkName }</linkElem>",


        // --- Avatar menu ---
        "avatar-menu-menu-item-help": "Help",
        "avatar-menu-menu-item-news": "Facilitynet news",
        "avatar-menu-menu-item-profile": "User account",
        "avatar-menu-menu-item-archive": "Archive",
        "avatar-menu-menu-item-change-user-account": "Change user account",
        "avatar-menu-menu-item-swift-merchant": "Switch merchant",
        "avatar-menu-menu-item-settings": "Settings",
        "avatar-menu-menu-item-logout": "Logout",


        // --- Confirm dialogs ---
        "confirm-modal-confirm-label": "Are you sure",
        "delete-confirm-modal-title": "Delete { $itemType }",
        "delete-confirm-modal-question": "Are you sure you want to delete '{ $itemName }'?",
        "delete-confirm-modal-button-delete": "Delete",
        "delete-confirm-modal-button-cancel": "Cancel",
        "delete-confirm-modal-button-submit": "Submit",
        "cancel-subscription-modal-title": "Cancel Subscription",
        "cancel-subscription-modal-message": "Are you sure you want to cancel the subscription '{ $subscriptionName }' for { $customerName }?",
        "cancel-subscription-modal-label-ignore-terms": "\n .label = Effective immediately",
        "cancel-subscription-modal-helper-text-ignore-terms": "This will ignore the terms of the subscription.",
        "cancel-subscription-modal-button-delete": "Delete",


        // --- Not found ---
        "not-found-title": "Not Found",
        "not-found-explanation": "The page you are looking for does not exist.",
        "not-found-path-label": "Path:",
        "not-found-go-home-button": "Go home",


        // --- Access denied ---
        "access-denied-title": "Access Denied",
        "access-denied-explanation": "Your user profile does not have access to this page.",
        "access-denied-required-usertype-label": "Required user type:",
        "access-denied-actual-usertype-label": "Your user type:",
        "access-denied-path-label": "Path:",
        "access-denied-go-home-button": "Go home",
        "access-denied-logout-button": "Logout",

        "access-denied-usertype-support": "{ -user-type-support }",
        "access-denied-usertype-supplier": "{ -user-type-supplier }",
        "access-denied-usertype-merchant": "{ -user-type-merchant }",
        "access-denied-usertype-company": "{ -user-type-company }",
        "access-denied-usertype-office-manager": "{ -user-type-office-manager }",
        "access-denied-usertype-unknown": "Unknown",


        "login-email-label": "Sign in",
        "login-password-label": "Enter your password",
        "login-email-field-label": "\n .label = Email",
        "test": "Test",
        "bottom-menu-item-home": "\n .label = Home",
        "bottom-menu-item-profile": "\n .label = Profile",

        "confirm-email-button": "Confirm\n .loadingLabel = Confirming...",
        "confirm-email-description": "The following user accounts are all registered with the email address <email>{ $email }</email> and will be able to switch account. Make sure they all belong to you:",
        "confirm-email-title": "Confirm account access",
        "confirm-email-success-message": "You can now switch between your user accounts",
        "confirm-email-error-message": "We could not confirm your email",
        "confirm-email-missing-userid-or-otp": "Missing user id or otp",

        "purchases-payment-method-free": "Free",
        "purchases-payment-method-credit-card": "Credit card",
        "purchases-payment-method-one-click-payment": "Credit card",
        "purchases-payment-method-mobile-pay": "MobilePay",
        "purchases-payment-method-payroll-deduction": "Payroll deduction",
        "purchases-payment-method-lunch-registration": "Lunch registration",
        "purchases-payment-method-gopay-wallet": "GoPay Wallet",
        "purchases-payment-method-invoice": "Invoice",
        "purchases-payment-method-cash": "Cash",
        "purchases-payment-method-gopay-account": "GoPay Wallet",
        "purchases-payment-method-refund": "Refund",
        "purchases-payment-method-subscribe-payment-card": "Subscribe payment card",

        // --- Error handling ---
        "api-call-error-title-unknown-error": "Unknown Error",
        "api-call-error-title-network-error": "Network Error",
        "api-call-error-title-bad-request": "Bad Request",
        "api-call-error-title-unauthorized": "Invalid login",
        "api-call-error-title-forbidden": "Access Denied",
        "api-call-error-title-not-found": "Not Found",
        "api-call-error-title-conflict": "Conflict",
        "api-call-error-title-too-many-requests": "Too Many Requests",
        "api-call-error-title-internal-server-error": "Internal Server Error",
        "api-call-error-title-service-unavailable": "Service Unavailable",
        "api-call-error-title-request-failed": "Request Failed",
        "api-call-error-unknown-error": "Unknown error",
        "api-call-error-no-internet-connection": "No Internet connection",
        "api-call-error-could-not-reach-server": "Could not reach server",
        "api-call-error-protocol-error": "Server error: { $responseCode } { $responseStatus }",
        "api-call-error-api-returned-error": "Unexpected server error",
        "api-call-error-response-not-json": "Unexpected response from server",
        "api-call-error-retry-button": "Retry",


        // --- Receipts ---

        // Page
        "receipt-title": "Receipt",

        // Payment methods
        "receipt-payment-method-free": "Free",
        "receipt-payment-method-credit-card": "Credit card",
        "receipt-payment-method-one-click-payment": "Credit card",
        "receipt-payment-method-mobile-pay": "MobilePay",
        "receipt-payment-method-payroll-deduction": "Payroll deduction",
        "receipt-payment-method-lunch-registration": "Lunch registration",
        "receipt-payment-method-gopay-account": "GoPay Wallet",
        "receipt-payment-method-invoice": "Invoice",

        // Purchase section
        "receipt-purchase-details-section": "\n .heading = Purchase Details",
        "receipt-purchase-payment-status-paid": "PAID",
        "receipt-purchase-payment-status-unpaid": "UNPAID",
        "receipt-purchase-payment-status-invoiced": "INVOICED",
        "receipt-purchase-payment-status-refunded": "REFUNDED",
        "receipt-purchase-payment-status-cancelled": "REFUNDED",
        "receipt-purchase-address-item": "\n .label = Location:",
        "receipt-purchase-seller-vat-number": "VAT\u00A0No:\u00A0{ $vatNumber }",
        "receipt-purchase-customer-item": "\n .label = Customer:",
        "receipt-purchase-employee-id-item": "\n .label = Employee id:",
        "receipt-purchase-company-item": "\n .label = Company:",
        "receipt-purchase-time-item": "\n .label = Purchase time:",
        "receipt-purchase-payment-method-item": "\n .label = Payment method:",
        "receipt-purchase-order-id-item": "\n .label = Order id:",
        "receipt-purchase-shop-channel-item": "\n .label = Channel:",
        "receipt-purchase-receipt-error": "Failed to load order with id #{ $orderId }",
        "receipt-purchase-receipt-error-description": "This order could not be processed due to missing or invalid data.",

        // Delivery section
        "receipt-delivery-details-section": "\n .heading = Delivery",
        "receipt-delivery-order-type-item": "\n .label = Order type:",
        "receipt-order-type-catering": "Meeting services",
        "receipt-order-type-lunch": "Lunch",
        "receipt-order-type-takeaway": "Takeaway",
        "receipt-order-type-refill-account": "Wallet Top up",
        "receipt-order-type-auto-refill-account": "Automatic top up subscription",
        "receipt-order-type-lunch-subscription": "Subscription",
        "receipt-order-type-subscribe-payment-card": "Payment card subscription",
        "receipt-order-type-meeting": "Meeting",
        "receipt-order-type-refund": "Refund",
        "receipt-delivery-type-item": "\n .label = Delivery type:",
        "receipt-delivery-type-pick-up": "Pick up",
        "receipt-delivery-time-item": "\n .label = Delivery time:",
        "receipt-delivery-comment-item": "\n .label = Comment:",

        // Order details section
        "receipt-order-details-buyerparty-private": "Private purchase",
        "receipt-order-details-buyerparty-company": "Company purchase",
        "receipt-order-details-payment-method-item": "\n .label = Payment method:",
        "receipt-order-details-vat-total": "\n .label = VAT amounts to (25%):",

        // Subscription details section
        "receipt-subscription-details-section": "\n .heading = Subscription",
        "receipt-subscription-details-subscription-id": "\n .label = Subscription id:",
        "receipt-subscription-details-subscription-name": "\n .label = Subscription name:",
        "receipt-subscription-details-subscription-valid-from": "\n .label = Valid from:",
        "receipt-subscription-details-subscription-valid-to": "\n .label = Valid to:",
        "receipt-subscription-details-subscription-price": "\n .label = Subscription price:",

        // Actions section
        "receipt-actions-forward-receipt-button": "Send Receipt",
        "receipt-actions-cancel-order-button": "Refund Order",
        "receipt-actions-confirm-cancel-dialog": "\n .description = You are about to refund this order. Are you sure?\n .confirmLabel = Yes\n .cancelLabel = No\n .loadingDescription = Refunding order...",
        "receipt-actions-cancel-disabled-dialog": "\n .title = Refunding not implemented\n .message = This function is not yet ready. It will come later.\n .buttonLabel = Understood",
        "receipt-actions-cancel-unavailable-dialog": "\n .buttonLabel = Understood",

        "receipt-order-label": "Receipt #{ $orderId }, { $orderDate }",

        // Forward receipt
        "receipt-forward-receipt-dialog": "\n .title = { $receipts -> \n *[one] Send Receipt \n [other] Send Receipts \n } \n .cancelButtonLabel = Cancel\n .submitButtonLabel = Send\n .submitButtonLoadingLabel = Sending...",
        "receipt-forward-receipt-email-field": "\n .label = Email Address",
        "receipt-forward-receipt-email-field-is-required": "Email address is required",
        "receipt-forward-receipt-email-field-must-be-valid": "Invalid email address",


        // --- Login domain ---

        // login auth flow hook
        "auth-flow-authentication-result-server-error": "Client expected authentication complete but server said: { $action }.",
        "auth-flow-authentication-unexpected-server-error":  `Unexpected authentication action { $action } in API response`,

        // Create password page
        "create-password-required": "This is a required field",
        "create-password-password-invalid-for-policy": "Password does not follow the password policy",
        "create-password-new-required": "This is a required field",
        "create-password-matching": "Passwords do not match",
        "create-password-title": "New Password",
        "create-password-new-password-field": "\n .label = New Password",
        "create-password-submit-button": "Reset Password",
        "create-password-confirm-password-field": "\n .label = Confirm Password",


        // Forgot password page
        "forgot-password-username-required": "Username is required",
        "forgot-password-username-title": "Forgotten Password",
        "forgot-password-username-invalid": "Username is not valid",
        "forgot-password-button-label": "Next",
        "forgot-password-enter-username-field": "\n .label = Enter your username",

        // SignInWithActivationCode page
        "sign-in-with-activation-code-min-length": "Activation code should be of minimum 6 characters length",
        "sign-in-with-activation-code-required": "Activation code is required",
        "sign-in-with-activation-code-title": "Enter your activation code",
        "sign-in-with-activation-code-field-label": " \n Activation code",
        "sign-in-with-activation-code-submit-button": "Next",

        // SignInWithPassword page
        "sign-in-with-password-required": "Password is required",
        "sign-in-with-password-title": "Enter your password",
        "sign-in-with-password-field-label": "\n Password",
        "sign-in-with-password-submit-button": "Sign in",
        "sign-in-with-password-reset-password-link": "Forgot password",

        // SignInWithUsername page
        "sign-in-with-username-min-length": "Username should be of minimum 3 characters length",
        "sign-in-with-username-required": "Username is required",
        "sign-in-with-username-title": "Welcome",
        "sign-in-with-username-subtitle": " Welcome to Facilitynet",
        "sign-in-with-username-field-label": "\n .label = Username\n .placeholder = Enter your username",
        "sign-in-with-username-remember-me": "Remember me",
        "sign-in-with-username-submit-button": "Next",
        "sign-in-with-username-reset-password-link": "Forgot password?",

        // StartPageLayout
        "start-page-layout-title": "Your portal to meeting planning and canteen services",
        "start-page-layout-sub-title-1": "Accept payments with the POS and mobile phone",
        "start-page-layout-sub-title-2": "Get insight into sales figures with Facilitynet Manager",
        "start-page-layout-sub-title-3": "Better communication between merchant and customers",
        "start-page-layout-login-button-label": "Login",

        // Login Layout
        "login-layout-card-title": "Facilitynet Manager",
        "login-layout-card-subtitle": "Canteen management made easy",
        "auto-login-title":"Signing you in...",
        "auto-login-description":"Please wait while we authenticate you.",
        "auto-login-error-title":" otp token not found",
        "auto-login-error-description":"  You have received an invalid link. Please contact support.",

        // Invitation
        "invitation-title": "Create your passwords to Facilitynet",
        "invitation-username-rules": "The username must be at least 3 characters long.",
        "invitation-password-rules": "The password must be at least 8 characters long and contain a lowercase letter, an uppercase letter and a number.",
        "invitation-usertype-support": "{ -user-type-support }",
        "invitation-usertype-supplier": "{ -user-type-supplier }",
        "invitation-usertype-merchant": "{ -user-type-merchant }",
        "invitation-usertype-company": "{ -user-type-company }",
        "invitation-usertype-office-manager": "{ -user-type-office-manager }",
        "invitation-usertype-unknown": "Unknown user type",
        "invitation-field-username": "\n .label = Username",
        "invitation-field-password": "\n .label = Password",
        "invitation-field-repeat-password": "\n .label = Repeat password",
        "invitation-submit-button": "Activate account\n .loadingLabel = Activating...",
        "invitation-field-username-required": "Username is required",
        "invitation-field-username-min-chars": "Username must be at least { $minChars } characters",
        "invitation-field-password-required": "Password is required",
        "invitation-field-password-invalid-for-policy": "Password does not follow the password policy",
        "invitation-field-password-min-chars": "Password must be at least { $minChars } characters",
        "invitation-field-password-contain-lowercase": "Password must contain lowercase character",
        "invitation-field-password-contain-uppercase": "Password must contain uppercase character",
        "invitation-field-password-contain-number": "Password must contain number",
        "invitation-field-repeatPassword-required": "Field is required",
        "invitation-field-repeatPassword-match-password": "Passwords do not match",

        // Confirm account change
        "confirm-account-change-confirming-email-message": "Confirming email address...",
        "confirm-account-change-login-button": "Sign in",
        "confirm-account-change-failure-message": "Email address could not be confirmed",

        // Id Card Signup
        "id-card-signup-title": "Complete registration",
        "id-card-signup-description": "Please complete the registration process. Once you have registered your ID card, you can use it to purchase food in the canteen by simply scanning it at the POS screen.",
        "id-card-signup-subscription": "Select subscription",
        "id-card-signup-next-button": "Next",
        "id-card-signup-back-button": "Back",
        "id-card-signup-field-company": "\n .label = Your company:\n .placeholder = Select the company you work for",
        "id-card-signup-field-user-group": "\n .label = Your user group:\n .placeholder = Select user group",
        "id-card-signup-field-name": "\n .label = Your name (*):\n .placeholder = Enter your full name",
        "id-card-signup-field-mobile-number": "\n .label = Your phone:\n .placeholder = Enter your mobile number (optional)",
        "id-card-signup-field-mobile-number-invalid": "Invalid mobile number",
        "id-card-signup-field-name-max-length": "Name cannot exceed 50 characters",
        "id-card-signup-companies-error": "Failed to load companies. Please try again.",
        "id-card-activation-generic-error": "Failed to load companies. Please try again.",
        "id-card-signup-no-subscriptions": "An error occurred while activating your card. Please try again.",
        "id-card-signup-using-company": "Your company: ",
        "id-card-signup-using-user-group": "Your user group: ",
        "id-card-signup-using-user-name": "User name: ",
        "id-card-signup-complete": "Congratulation",
        "id-card-signup-complete-description": "Your card has now been subscribed and you can start using it.",
        "id-card-signup-complete-learn-more": "Learn more:",
        "id-card-signup-complete-learn-more-link": "How to I use Facilitynet payment solution?",

        // Activate account
        "activation-account-username-title": "Activate account",
        "activation-account-username-subtitle": "In order to use Facilitynet, please activate your account below",
        "activation-account-username-button": "Activate",
        "activation-account-username-field": "\n .label = Enter your e-mail-address:",
        "activation-account-password-title": "Create password",
        "activation-account-password-new-password-field": "\n .label = Enter password",
        "activation-account-password-button": "Create password",

        // select company
        "authenticate-select-company-header-reason-multiple-companies-for-domain": "Choose company",
        "authenticate-select-company-header-reason-multiple-accounts-for-username": "Select user account",
        "authenticate-select-company-reason-message-multiple-companies-for-domain": "We were unable to determine your company automatically since your email domain <duplicateValue>{ $duplicateValue }</duplicateValue> occurs multiple times in our system.",
        "authenticate-select-company-reason-message-multiple-accounts-for-username": "We found multiple accounts in our system for the email address <duplicateValue>{ $duplicateValue }</duplicateValue>.",
        "authenticate-select-company-action-message-multiple-companies-for-domain": "Please choose the location (company) that you wish to create your account under:",
        "authenticate-select-company-action-message-multiple-accounts-for-username": "Please select the user account you want to log in with.",
        "authenticate-select-company-show-list-button": "Show companies",
        "authenticate-select-company-submit-button": "{ -authenticate-submit-button }\n .loadingLabel = Saving...",
        "authenticate-select-company-form-error-message": "Please select a company",
        "authenticate-select-company-company-group-unknown-uid": "Unknown Company UID",
        "authenticate-select-company-company-group-unknown-name": "Unknown Name",
        "authenticate-select-company-company-group-unknown-address": "Unknown Address",
        "authenticate-select-company-no-companies-available": "No companies available",

        // Public > Self Sign Up
        "self-sign-up-title": "Sign Up",
        "self-sign-up-description": "Please complete the registration process. Once you have finished signing up, you can use account",
        "self-sign-up-field-company": "\n .label = Your company:\n .placeholder = Select the company you work for",
        "self-sign-up-field-user-group": "\n .label = Your user group:\n .placeholder = Select user group",
        "self-sign-up-field-name": "\n .label = Your name (*):\n .placeholder = Enter your full name",
        "self-sign-up-field-email": "\n .label = Email (*):\n .placeholder = Enter your email",
        "self-sign-up-field-mobile-number": "\n .label = Your phone:\n .placeholder = Enter your mobile number (optional)",
        "self-sign-up-complete-button": "Sign Up",
        "self-sign-up-field-email-invalid": "Invalid email address",
        "self-sign-up-congratulation-title": "Congratulation",
        "self-sign-up-congratulation-message": "We have sent an activation link to your email address.",
        "self-sign-up-error-message": "Something went wrong. Please try again.",
        "self-sign-up-confirm-dialog": "\n .title = Confirm details\n .message = Are you sure you want to create your account with the provided information?\n .buttonLabelSubmit = Confirm\n .buttonLabelCancel = Cancel",
        "self-sign-up-confirm-company": "\n .label = Company:",
        "self-sign-up-confirm-user-group": "\n .label = User group:",
        "self-sign-up-confirm-name": "\n .label = Your name:",
        "self-sign-up-confirm-email": "\n .label = Your email:",
        "self-sign-up-confirm-mobile-number": "\n .label = Your phone:",

        // Booking > Confirm Booking
        'confirm-booking-complete': "Congratulation",
        'confirm-booking-failed': "Failed",
        'confirm-booking-loading': "Loading...",

        // ExportButton
        "export-button-export-text": "Export",
        "export-button-export-all": "Export all",
        "export-button-export-all-with-filter": "Export all with filter",
        "export-button-export-selected": "Export selected",
        "export-button-export-selected-rows": "Export Selected rows",
        "export-button-export-as-csv-title": "\n .title = Save as CSV",
        "export-button-export-as-pdf-title": "\n .title = Save as PDF",
        "export-button-print": "Print",
        "export-button-remove-print-title": "\n .title = Remove from printer queue",

        // Export
        "export-period": "Period",

        // print
        "print-queued": "Your request is queued",


        // --- ContextDisplay ---
        "context-display-org-unit-supplier": "\n .label = Supplier:",
        "context-display-org-unit-merchant": "\n .label = Merchant:",
        "context-display-org-unit-tenant": "\n .label = Tenant:",
        "context-display-org-unit-company": "\n .label = Company:",
        "context-display-org-unit-user": "\n .label = User:",
        "context-display-org-unit-service-center": "\n .label = Service center:",


        // --- Environment dropdown ---
        "env-dropdown-menu-header": "Switch environment to:",
        "env-dropdown-title-admin-support":"Admin",
        "env-dropdown-title-reports-support":"Dashboard",
        "env-dropdown-title-admin-supplier":"Admin",
        "env-dropdown-title-reports-supplier":"Dashboard",
        "env-dropdown-title-admin-merchant":"Admin",
        "env-dropdown-title-reports-merchant":"Production",
        "env-dropdown-title-accounting-merchant":"Accounting",
        "env-dropdown-title-admin-company":"Admin",
        "env-dropdown-title-reports-company":"Dashboard",
        "env-dropdown-title-admin-office-manager":"Admin",
        "env-dropdown-title-reports-office-manager":"Dashboard",
        "env-dropdown-title-reports-service-center":"Service center reports",
        "env-dropdown-title-admin-service-center":"Admin",
        "env-dropdown-subtitle-admin-support":"Manage entities and users.",
        "env-dropdown-subtitle-reports-support":"View system reports.",
        "env-dropdown-subtitle-admin-supplier":"Manage merchants and global settings.",
        "env-dropdown-subtitle-reports-supplier":"View aggregate reports across your merchants.",
        "env-dropdown-subtitle-admin-merchant":"Manage products, shops, and customer communication.",
        "env-dropdown-subtitle-reports-merchant":"Get an operational overview and view production figures.",
        "env-dropdown-subtitle-admin-company":"Manage organizational data, users and administrators.",
        "env-dropdown-subtitle-reports-company":"View accounting figures.",
        "env-dropdown-subtitle-admin-office-manager":"Manage users and administrators.",
        "env-dropdown-subtitle-reports-office-manager":"View accounting figures.",
        "env-dropdown-subtitle-reports-service-center":"Service center reports",
        "env-dropdown-subtitle-admin-service-center":"Service center admin",
        "env-dropdown-subtitle-accounting-merchant":"View accounting reports.",


        // --- API components ---
        "api-query-table-fetch-error-message": "Error loading data",
        "api-query-autocomplete": "\n .loadingText = Loading data...",
        "api-query-autocomplete-fetch-error-message": "Error loading data. <retryLink>Retry</retryLink>",

        // Top Bar
        "help-tooltip-text": "\n .title = Help",
        "notifications-tooltip-text": "\n .title = View messages",
        "new-order-tooltip-text": "\n .title = Create new order",
        "qa-env-warning-part-one": "You are in QA environment. This is not intended for customers. Please use",
        "qa-env-warning-part-two": "instead.",

        // Top Bar > Help
        "help-dialog-search-title": "Hello, how can we help you?",
        "help-dialog-search":"\n .placeholder = Search for articles...",
        "help-dialog-support": "\n .title = Support",
        "help-dialog-email-support": "\n .title = Email support \n .description = If you still need help, you can email us here.",
        "help-dialog-chat-support": "\n .title = Chat support \n .description = For quick questions, you can chat with our customer support team.",
        "help-dialog-troubleshooting": "\n .title = Troubleshooting",
        "help-dialog-troubleshooting-pos-screen": "\n .title = POS screen \n .description = Get help for your POS screen, receipt printer and credit card terminal.",
        "help-dialog-troubleshooting-check-in-screen": "\n .title = Check in screen \n .description = Get help for your check in screen and receipt printer.",
        "help-breadcrumb": "Help",
        "help-dialog-troubleshooting-breadcrumb": "Troubleshooting",
        "help-dialog-troubleshooting-printer-not-working": "\n .title = Printer not working",
        "help-dialog-troubleshooting-credit-card-terminal-not-working": "\n .title = Credit card terminal not working",
        "help-dialog-troubleshooting-pos-screen-not-working": "\n .title = POS screen not working",
        "help-dialog-troubleshooting-check-in-screen-not-working": "\n .title = Check-in screen not working",
        "help-dialog-troubleshooting-start-up-backup-terminal": "\n .title = Start up backup terminal",
        "help-dialog-training": "\n .title = Training",
        "help-dialog-training-education-center": "\n .title = Education Center \n .description = In the Education Center you can view Get Started guides and other training material.",
        "help-dialog-training-guide-button": "View Guide",
        "consent-dialog": "\n .title = Allow Intercom \n .message = We make use of Intercom for our chat support. If you consent, we will share the data below with Intercom. \n .skipLabel = Not now \n .consentLabel = Allow",
        "consent-dialog-personal-information": "Personal Information",
        "consent-dialog-pii-category-contact-info": "Contact Information",
        "consent-dialog-pii-category-identifiers": "Identifiers",
        "consent-dialog-pii-category-purchases": "Purchases",
        "consent-dialog-pii-category-user-content": "User Content",
        "consent-dialog-privacy-policy": "Privacy",
        "consent-dialog-view-company-privacy-policy": "View company privacy policy",
        "consent-dialog-pii-item-name": "Name",
        "consent-dialog-pii-item-email-address": "E-mail",
        "consent-dialog-pii-item-phone-number": "Phone Number",
        "consent-dialog-pii-item-user-id": "User ID",
        "consent-dialog-pii-item-device-id": "Device ID",
        "consent-dialog-pii-item-customer-support": "Customer Service",
        "consent-dialog-pii-item-purchase-history": "Purchase History",
        "intercom-error-dialog": "\n .title = Chat Failed\n .message = Something went wrong when loading the chat. You can send an email to support instead.\n .buttonLabel = Understood",
        "intercom-loading-dialog": "\n .description = Chat is loading...",

        //ControlKitchen page
        "control-kitchen-checked-in-yes-chip": "Yes",
        "control-kitchen-checked-in-no-chip": "No",
        "control-kitchen-column-check-in-time": "Check-in time",
        "control-kitchen-column-id": "User id",
        "control-kitchen-column-name": "Name",
        "control-kitchen-column-items": "Items",
        "control-kitchen-column-order-details": "Order",
        "control-kitchen-checked-in": "Checked in",
        "control-kitchen-checked-in-sub-title": "Todays control code:",
        "control-kitchen-last-updated": "Last updated: {$lastUpdated}",
        "control-kitchen-refresh": "Refresh page",
        "control-kitchen-receipt": "Receipt",
        "control-kitchen-date-label": "Purchase date",
        "control-kitchen-date-delivery-label": "Delivery",
        "control-kitchen-datetime-from-label": "From",
        "control-kitchen-datetime-to-label": "To",
        "control-kitchen-period-label": "Period",
        "control-kitchen-check-in-type": "Type",
        "control-kitchen-checked-in-filter-all": "All",
        "control-kitchen-checked-in-filter-checked-in": "Checked in",
        "control-kitchen-checked-in-filter-not-checked-in": "Not checked in",

        // News folder
        "news-published": "Published: {$date}",
        "news-implemented": "Released: {$date}",
        "news-created": "Created: {$date}",
        "news-updated": "Updated: {$date}",
        "news-gopay": "Facilitynet news ",
        "news-roadmap": "Roadmap",
        "news-new-features": "New features",
        "news-new-load-error": "Error loading roadmap features",
        "news-start-date": "Start Date",
        "news-end-date": "End Date",
        "news-type": "Type",
        "news-bug-fix": "Bug fix",
        "news-new-feature": "New feature",
        "news-upcoming": "Upcoming",
        "news-all": "All",
        "news-current-news": "Current news",
        "news-archive-news": "Archive",
        "news-create-new-button": "Create new",
        "news-draft-type": "Draft",
        "news-published-type": "Published",
        "news-schedule-type": "Scheduled",
        "news-expired-type": "Expired",
        "news-edit": "Edit",
        "news-delete": "Delete",
        "news-default-error-message": "Something went wrong",
        "news-archive-title": "Title",
        "news-archive-expiration-date": "Expiration Date",
        "news-archive-active-status": "Status",
        "merchant-news-header": "\n .title = News",
        "news-no-news-title": "No news",
        "news-no-roadmap-title": "No roadmaps",
        "news-no-news-body": "Create your first news ",
        "news-no-news-here-link": "here",
        "news-gopay-read-more": "Read more",
        "news-table-delete-success-message": "Article deleted",
        "create-news-header": "\n .title = Create news",
        "edit-news-header": "\n .title = Edit news",
        "nav-item-create-news-header": "Create news",
        "nav-item-edit-news-header": "Edit news",
        "create-news-save-button": "Create",
        "edit-news-save-button": "Save",


        // Office folder
        "office-period-total": "Total for period: {$periodTotal}",
        "office-transation-period-total": "Total transations for period: {$transactionPeriodTotal}",
        "office-purchase-time": "Time",
        "office-purchase-name": "Name",
        "office-purchase-payment-details": "Payment method",
        "office-purchase-payment-channel": "Channel",
        "office-purchase-amount": "Amount",
        "office-purchase-receipt": "Receipt",
        "office-last-updated": "Last updated: {$lastUpdated}",
        "office-refresh": "Refresh page",

        "office-meeting-service-title": "Meeting Service",
        "office-meeting-service-header": "\n .title = Meeting Service",
        "office-meeting-service-table-booked-start-date": "Booked start date",
        "office-meeting-service-table-booked-end-date": "Booked end date",
        "office-meeting-service-table-merchant": "Merchant",
        "office-meeting-service-table-order-id-column": "Order ID",
        "office-meeting-service-table-booked-date-column": "Booked date",
        "office-meeting-service-table-delivery-time-column": "Delivery time",
        "office-meeting-service-table-creator-column": "Creator",
        "office-meeting-service-table-amount-column": "Amount (DKK)",
        "office-meeting-service-table-show-receipt": "Show receipt",
        "office-meeting-service-table-floating-action-bar-receipts": "\n .title = Receipts",
        "office-meeting-service-table-floating-action-bar-export": "\n .title = Export",


        // --- Profile page ---
        "profile-user-account-id": "ID:",
        "profile-administrator-for": "Administrator for",
        "profile-hosted-by": "Hosted by",
        "profile-hosted-by-office-hotel": "Office Hotel",
        "profile-actions": "Shortcuts",
        "profile-settings-card": "Settings",
        "profile-password-card": "Password",
        "profile-actions-change-password": "Change password",
        "profile-actions-edit-profile": "Edit profile",
        "profile-actions-delete-account": "Delete account",
        "profile-security": "Security",
        "profile-security-manage-admins": "Manage admins:",
        "profile-security-manage-admins-yes": "Yes",
        "profile-security-manage-admins-no": "No",
        "profile-security-ip-address-allowlist": "IP address allowlist:",
        "profile-roles": "Your roles",
        "profile-user-info": "User account",
        "profile-user-type": "User Type",
        "profile-username": "Username:",
        "profile-email": "Email:",
        "profile-phone-number": "Phone number:",
        "profile-mobil-number": "Mobile number:",
        "profile-name": "Name:",
        "profile-page-header": "\n .title = User account",
        "profile-nav-item-home": "Home",
        "profile-user-type-info-mode-supplier": "As a supplier administrator, you can access and manage merchants and administrators on behalf of your company. For each merchant, you can do everything a merchant administrator can do. Additionally you can manage shared settings and view cross-merchant reports.",
        "profile-user-type-info-mode-merchant": "As a merchant administrator, you can manage shops and products under your merchant. You also have access to detailed accounting reports and production views, where you can manage and fulfill customer orders.",
        "profile-user-type-info-mode-company": "As a company administrator, you can manage users and integrations for your company. You can also view accounting reports for orders made by your company employees.",
        "profile-user-type-info-mode-office-manager": "As an office manager, you can manage users and integrations for your tenant. You can also view accounting reports for orders made by your company employees.",
        "profile-user-type-info-mode-support": "As a supporter, you can manage users, devices and entities for the whole system. You can also lookup necessary information about orders, users and entities for handling support tickets.",
        "profile-user-type-info-mode-user": "As a user you can make orders in the system and view your previous orders.",
        "profile-roles-mode-agreement-owner": "Agreement owner",
        "profile-roles-mode-bookkeeper": "Bookkeeper",
        "profile-roles-mode-dpo": "DPO",
        "profile-roles-mode-it-administrator": "IT administrator",
        "profile-roles-mode-news-subscriber": "News subscriber",
        "profile-roles-mode-system-operation-subscriber": "System operation subscriber",
        "profile-roles-read-more": "Read about administrator roles",
        "profile-roles-no-roles": "You have no roles",

        // --- Profile page > Change password ---
        "profile-change-password-page-header": "\n .title = Change password",
        "profile-change-password": "Change password",
        "profile-change-password-profile": "Profile",
        "profile-change-password-profile-currentPassword": "\n .label = Current password",
        "profile-change-password-profile-newPassword": "\n .label = New password",
        "profile-change-password-profile-confirmPassword": "\n .label = Confirm password",
        "profile-change-password-profile-match-password": "Passwords do not match",
        "profile-change-password-password-policy": "\n .title = Password policy",
        "profile-change-password-default-policy": "Facilitynet default policy",
        "profile-change-password-info": "To define or change the password policy for your company, please contact support.",
        "profile-change-password-submit-button": "Update password",

        // --- Change User Account > Dialog ---
        "change-user-account-dialog-title": "Change user account",
        "change-user-account-dialog-pending-state-email-has-been-sent": "An email has been sent. Please check your inbox.",
        "change-user-account-dialog-pending-state-pending-approval": "{ -authenticate-submit-button }\n .loadingLabel = Pending approval...",
        "change-user-account-dialog-confirm-email-subtitle": "Before you can switch between user accounts, you must first confirm that you own the email account <element>{ $email }</element>.",
        "change-user-account-dialog-click-below-subtitle": "Click on the button below to send me a confirmation link:",
        "change-user-account-dialog-send-confirmation-button": "Send confirmation link",
        "change-user-account-dialog-empty-content-subtitle": "No other accounts were found with the email address <email>{ $email }</email>.",
        "change-user-account-dialog-users-list-available-accounts-subtitle": "You have { $totalUserAccounts } other user accounts with the e-mail: { $email }",
        "change-user-account-dialog-users-list-swift-to-another-account": "Switch to another account below:",

        // User Types
        "profile-usertype-support": "{ -user-type-support }",
        "profile-usertype-supplier": "{ -user-type-supplier }",
        "profile-usertype-merchant": "{ -user-type-merchant }",
        "profile-usertype-company": "{ -user-type-company }",
        "profile-usertype-office-manager": "{ -user-type-office-manager }",
        "profile-usertype-user": "{ -user-type-user }",
        "profile-usertype-service-center": "{ -user-type-service-center }",


        // --- Settings page ---
        "settings-page-header": "\n .title = Settings",
        "settings-title": "Settings",
        "settings-nav-item-home": "Home",
        "settings-language-setting": "Language",
        "settings-social-media-label": "Social media",
        "settings-social-media-text": "Follow us on LinkedIn",


        // --- Admin home card ---
        "admin-home-card-show-all-button": "Show all",


        // Back Button
        "back-button-label": "Back",

        //AvatarMenu
        "avatar-menu-tooltip": "Open settings",


        // ArticleSettingsPanel
        "article-settings-panel-settings-title": "\n .title = Visibility",
        "article-settings-panel-published": "\n .label = Published",
        "article-settings-panel-schedule-for": "\n .label = Publish date",
        "article-settings-panel-expires": "\n .label = Expiration date",



        // ImageUploader
        "image-uploader-button-label": "Upload image",
        "image-uploader-drag-and-drop": "Drag and Drop or Browse",
        "image-uploader-max-file-size-exceeded": "File size exceeds { $maxFileSize } limit.",
        "image-previewer-button-label": "Upload new image",
        "image-previewer-button-delete": "Delete",

        // CreateOrEditMerchantArticle
        "create-or-edit-merchant-article-mode-normal-article": "Normal article",
        "create-or-edit-merchant-article-mode-external-article": "External article",
        "create-or-edit-merchant-article-mode-product-news": "Product news",
        "create-or-edit-merchant-article-title": "\n .label = Title",
        "create-or-edit-merchant-article-body": `\n .placeholder = Description\n .helperText = Remaining characters: { $charsRemaining }`,
        "create-or-edit-merchant-article-body-too-long": `You have exceed the max amount of characters: { $charsLimit }`,
        "create-or-edit-merchant-article-product-id": "\n .label = Product id",
        "create-or-edit-merchant-article-info-label-draft": "\n .label = Article is a draft. It will not be visible to users until you publish it.",
        "create-or-edit-merchant-article-info-label-schedule": "\n .label = Article is a schedule for publication on: ",
        "create-or-edit-merchant-article-type": "\n .label = Article type",
        "create-or-edit-merchant-article-delete": "article",
        "news-create-image-field-label": "\n .label = Upload image",

        // CreateAndPublishSplitButton
        "create-and-publish-split-button-create-draft": "Draft",
        "create-and-publish-split-button-publish": "Publish",
        "create-and-publish-split-button-save": "Save",
        "create-and-publish-split-button-unpublish": "Unpublish",
        "create-and-publish-split-button-cancel-publication": "Cancel publication",
        "create-and-publish-split-button-republish": "Republish",


        "table-summary-box-total-period": "\n .title = Total this period",
        "table-summary-box-number-of-orders": "\n .title = Number of orders",
        "table-summary-box-number-of-subscriptions": "\n .title = Number of subscriptions",

        // --- Office manager ---

        // Navigation
        "tenant-nav-item-home": "Home",

        // - reporting
        "tenant-nav-item-accounting": "\n .title = Accounting",
        "tenant-nav-item-pos": "POS",
        "tenant-nav-item-meeting-service": "Meeting service",
        "tenant-nav-item-subscriptions": "Subscriptions",

        // - admin
        "tenant-nav-item-users": "Users",
        "tenant-nav-item-organization-page-header":"\n .title = Organization",
        "tenant-nav-item-administrators": "Administrators",

        // Reports

        // Home
        "tenant-reports-home-placeholder": "\n .title = Office manager dashboard coming soon\n .body = Your dashboard will show an overview of important key figures, so you always have a good overview of purchases.",

        // Purchases
        "tenant-purchases-header": "\n .title = POS",
        "tenant-subscriptions-header": "\n .title = Subscriptions",

        // Admin

        // Home page
        "office-manager-home-user-card-group": "\n .title = Users",
        "office-manager-home-user-admin-placeholder": "Coming soon. Here you will be able to manage your users and office managers.",
        "office-manager-home-user-card": "  \n .title = Users\n .description = Manage users for your tenant",
        "office-manager-home-admin-card": "  \n .title = Administrators\n .description = Manage administrators",
        "office-manager-home-card-show-all": "Show all",
        "office-manager-users-header": "\n .title = Users",
        "office-manager-users-tab-users": "Users",
        "office-manager-users-tab-admins": "Administrators",
        "office-manager-users-table-id-column": "User-ID",
        "office-manager-users-table-name-column": "Name",
        "office-manager-users-table-email-column": "Email",
        "office-manager-users-table-status-column": "Status",
        "office-manager-users-table-status-column-active": "Active",
        "office-manager-users-table-status-column-inactive": "In active",
        "office-manager-user-show-details": "Show details",
        "office-manager-user-edit": "Edit user",
        "office-manager-user-delete": "Delete user",
        "office-manager-user-delete-title": "user",
        "office-manager-users-create-user-button": "Create user",
        "office-manager-users-create-admin-button": "Create admin",
        "office-manager-user-details-dialog-title": "User Details",
        "office-manager-settings-panel": "\n .title = Settings",
        "office-manager-settings-send-invitation": "Send email invitation",
        "office-manager-settings-disable-sync": "Disable synchronization",
        "office-manager-settings-disable-sync-text": "When disabled this user will be ignored by user synchronization jobs",

        // show user details dialog
        "user-details-user-id": "User id:",
        "user-details-employee-id": "Employee id:",
        "user-details-name": "Name:",
        "user-details-role-type-news-subscriber" : "Subscriber",
        "user-details-role-type-system-operation-subscriber" : "System status subscriber",
        "user-details-email": "Email:",
        "user-details-mobile": "Mobile:",
        "user-details-phone": "Phone:",
        "user-details-role": "User roles:",
        "user-details-sync-jobs": "Disconnect sync jobs:",
        "user-details-sync-jobs-ignored": "YES",
        "user-details-sync-jobs-included": "NO",
        "user-details-security-title": "Security",
        "user-details-settings-title": "Settings",
        "user-details-security-settings-yes": "YES",
        "user-details-security-settings-no": "NO",
        "user-details-security-manage-admins": "Manage admins:",
        "user-details-security-ip-address": "IP address allowlist:",
        "user-details-history-title": "History",
        "user-details-history-created": "Created:",
        "user-details-history-edited": "Edited:",

        // Create or edit user page
        "office-manager-create-user-form": "Create",
        "office-manager-edit-user-form": "Save",
        "office-manager-create-user-form-title": "Create user",
        "office-manager-edit-user-form-title": "Edit user",
        "office-manager-create-user-home-breadcrumb": "Home",
        "office-manager-create-user-users-breadcrumb": "Account",
        "office-manager-create-user-create-breadcrumb": "Create user",
        "office-manager-create-user-edit-breadcrumb": "Edit user",
        "office-manager-create-administrator-breadcrumb":"Create administrator",
        "office-manager-edit-administrator-breadcrumb":"Edit administrator",
        "office-manager-create-admin-form-title": "\n .title = Create administrator",
        "office-manager-edit-admin-form-title": "\n .title = Edit administrator",
        "office-manager-create-user-field-id": "\n .label = Employee ID",
        "office-manager-create-user-field-name": "\n .label = Name",
        "office-manager-create-user-field-email": "\n .label = Email",
        "office-manager-create-user-field-mobile": "\n .label = Mobile",
        "office-manager-create-user-field-phone": "\n .label = Phone no.",
        "office-manager-create-user-field-active": "Active",
        "office-manager-security-panel": "\n .title = Security",
        "office-manager-security-manage-admins": "Can manage other admins",
        "office-manager-security-ip-field": " \n .label = Whitelist IP address\n .helperText = The user will only be allowed to sign in from this IP address. For registering multiple IP addresses, separate with comma.",
        "office-manager-create-user-required-field-empty": "This field is required",
        "office-manager-create-user-invalid-email-address": "Invalid email address",
        "office-manager-create-user-invalid-phone-number": "Invalid phone number",

        // Create or edit room
        "resource-room-create-form-title": "\n .title = Create room",
        "resource-room-edit-form-title": "\n .title = Edit room",
        "resource-room-create-required-field-empty": "This field is required",
        "resource-room-create-user-home-breadcrumb": "Home",
        "resource-room-create-user-users-breadcrumb": "Users",
        "resource-room-create-room-breadcrumb":"Create room",
        "resource-room-edit-room-breadcrumb":"Edit room",

        // Purchases page
        "tenant-pos-title": "POS",
        "tenant-purchases-tab-orders":"\n .title = Orders",
        "tenant-purchases-tab-subscriptions-details":"Details",
        "tenant-purchases-tab-subscriptions-cancel": "Cancel",

        //Admin roles field
        "tenant-admin-roles-field-label": "Assign roles",
        "tenant-admin-role-agreement-owner": "System owner",
        "tenant-admin-role-dpo": "GDPR responsible",
        "tenant-admin-role-it-administrator": "IT administrator",
        "tenant-admin-role-bookkeeper": "Bookkeeper",
        "tenant-admin-role-news-subscriber": "News subscriber",
        "tenant-admin-role-system-operation-subscriber": "System operation subscriber",


        // Survey Page
        "survey-header": "\n .title = Survey",
        "survey-tab-overview": "Overview",
        "survey-tab-ratings": "All ratings",
        "survey-tab-ratings-no-survey-data": "No data available.",
        "survey-tab-overview-no-surveys": "No surveys defined yet.",
        "survey-tab-overview-no-questions": "No questions defined for this survey.",
        "survey-tab-ratings-good-topics-card": "\n .title = Satisfied with\n .datasetLabel = Votes",
        "survey-tab-ratings-bad-topics-card": "\n .title = Dissatisfied with\n .datasetLabel = Votes",
        "survey-tab-overview-trend-card": "\n .title = Satisfaction trend\n .scoreLabel = Average score\n .votesLabel = Number of ratings",
        "survey-tab-comment": "Comments",
        "survey-tab-surveys": "Surveys",
        "survey-period-select": "\n .label = Period",
        "survey-period-today": "Today",
        "survey-period-last-day": "Last day",
        "survey-period-last-week": "Last week",
        "survey-period-last-month": "Last month",
        "survey-period-last-quarter": "Last quarter",
        "survey-period-last-year": "Last year",

        // All rating
        "all-rating-time": "Time",
        "all-rating-question": "Question",
        "all-rating-score": "Score",
        "all-rating-topics": "Topics",
        "all-rating-comment": "Comment",

        // SelectSurvey
        "select-survey": "\n .label = Survey",

        // --- Smiley summary card ---
        "survey-smiley-summary-card": "\n .title = Overall score",
        "survey-smiley-summary-card-overall-score-label": "Score: { $averageScore }",

        // --- Survey participation card ---
        "survey-participation-card": "\n .title = Participation",
        "survey-participation-card-participants-label": "Participants",
        "survey-participation-card-non-participants-label": "Non participants",
        "survey-participation-card-participation-label": "Percentage",
        "survey-participation-card-participation-breakdown": "{ $ratings } ratings of { $orders } purchases",

        // --- Survey smiley distribution card ---
        "survey-smiley-distribution-card": "\n .title = Satisfaction",
        "survey-smiley-distribution-card-votes-label": "Votes",
        "smiley-label-bad": "Very bad",
        "smiley-label-poor": "Poor",
        "smiley-label-medium": "Medium",
        "smiley-label-good": "Good",
        "smiley-label-excellent": "Excellent",


        // Production
        "production-meeting-service-breadcrumb": "Meeting service",
        "production-planning-breadcrumb": "Planning",
        "production-pos-purchases-breadcrumb": "POS purchases",
        "production-takeaway-page-header": "\n .title = Takeaway",
        "production-takeaway-breadcrumb": "Takeaway",
        "production-transactions-print-label": "Print label",
        "production-table-toolbar-banner-unprinted-receipts-message": "Receipts not printed on the cloud printer.",
        "production-table-toolbar-banner-show-button": "Show",
        "production-table-toolbar-banner-showing-unprinted-message": "Showing unprinted orders.",
        "production-table-toolbar-banner-clear-filter-button": "Clear filter",
        "production-planning-page-header": "\n .title = Planning",
        "production-meeting-service-page-header": "\n .title = Meeting service",
        "production-pos-purchases-page-header": "\n .title = POS purchases",
        "production-tab-production-list": "Production list",
        "production-tab-pos-transactions": "POS transactions",
        "production-tab-orders": "Production {$amount}",
        "planning-tab-takeaway": "Takeaway",
        "planning-tab-calendar": "Calendar",
        "planning-tab-not-approved": "Awaiting approval {$amount}",
        "planning-tab-to-be-booked": "To be invoiced {$amount}",
        "meeting-service-refresh": "Refresh",
        "planning-tabs-placeholder": "\n .title = Coming soon \n .body = We are working to bring you this feature.",
        "production-list-no-result": "No result",
        "production-orders-action-bar-confirm-queue-remove-dialog": "\n .title = Remove from printer queue\n .message = Are you sure that you want to remove selected receipts from the printer queue?\n .buttonLabelSubmit = Remove",
        "production-orders-action-bar-confirm-print-dialog": "\n .title = Print Receipts\n .message = Are you sure that you want to print the selected receipts?\n .buttonLabelSubmit = Print",
        "production-meeting-service-shortcuts-button": "Shortcuts",
        "production-meeting-service-shortcut-booked-orders": "Booked orders",

        // Production package slip
        "production-package-slip-order-error": "Failed to load packing slip with id #{ $orderId }",
        "production-package-slip-order-error-description": "This order could not be processed due to missing or invalid data.",
        "production-package-slip-order-id-number": "Order ID: {$orderId}",
        "production-package-slip-section-delivery-details-title": "Delivery details",
        "production-package-slip-section-delivery-details-type": "Delivery type:",
        "production-package-slip-section-delivery-details-time": "Delivery time:",
        "production-package-slip-section-delivery-details-meeting-time": "Meeting time:",
        "production-package-slip-section-delivery-details-location": "Delivery location:",
        "production-package-slip-section-delivery-details-sittings": "Sittings:",
        "production-package-slip-section-delivery-details-merchant": "Merchant:",
        "production-package-slip-section-contact-details-title": "Contact details",
        "production-package-slip-section-contact-details-meeting-creator": "\n .label = Creator:",
        "production-package-slip-section-contact-details-meeting-host": "\n .label = Meeting host:",
        "production-package-slip-table-column-items": "Items",
        "production-package-slip-table-column-products": "Products",
        "production-package-slip-table-column-delivery-time": "Delivery time",
        "production-package-slip-section-note-title": "Note",
        "production-package-slip-section-header-slip-title": "Packing slip",
        "production-package-slip-section-header-digital-slip-title": "Digital slip",
        "production-package-slip-header-orders-count": "Packing slips: {$orderCount} selected",

        // Production credit note
        "production-credit-note-dialog-title": "\n .dialogTitle = Create credit note",
        "production-credit-note-credit-info": "\n .title = A credit note is used to reverser parts of a booked order.",
        "production-credit-note-debit-info": "\n .title = A supplementary order is used to add items to an order that is already booked.",
        "production-credit-note-table-column-order-id": "Order ID",
        "production-credit-note-table-column-type": "Type",
        "production-credit-note-table-column-booked": "Booked",
        "production-credit-note-table-column-amount": "Amount (DKK)",
        "production-credit-note-table-column-type-cell-original-order": "Original order",
        "production-credit-note-table-column-type-cell-credit": "Credit note",
        "production-credit-note-table-column-type-cell-debit": "Supplementary order",
        "production-credit-note-button-next": "Next",
        "production-credit-note-button-cancel": "Cancel",
        "production-credit-note-select-label": "Create",

        // Accounting
        "accounting-header": "\n .title = Accounting",
        "accounting-product-sales-page-header": "\n .title = Product sales",
        "merchant-nav-item-accounting-product-sales": "Product sales",
        "accounting-orders-page-header": "\n .title = Orders",
        "merchant-nav-item-accounting-orders": "Orders",
        "accounting-subscriptions-page-header": "\n .title = Subscriptions",
        "merchant-nav-item-accounting-subscriptions": "Subscriptions",
        "accounting-cash-register-page-header": "\n .title = Balance",
        "merchant-nav-item-accounting-cash-register": "Balance",
        "accounting-customers-page-header": "\n .title = Customers",
        "merchant-nav-item-accounting-customers": "Customers",
        "accounting-customer-balance-page-header": "\n .title = User balance",
        "merchant-nav-item-accounting-customer-balance": "User balance",
        "merchant-nav-item-accounting-z-report": "Z-report",
        "merchant-nav-item-accounting-custom-reports": "Custom reports",
        "merchant-accounting-z-reports-table-date-range-filter": "\n .label = Date range",

        "accounting-product-sales-breadcrumb-title": "Product sales",
        "accounting-orders-breadcrumb-title": "Orders",
        "accounting-subscriptions-breadcrumb-title": "Subscriptions",
        "accounting-cash-register-breadcrumb-title": "Balance",
        "accounting-customers-breadcrumb-title": "Customers",
        "accounting-customer-balance-breadcrumb-title": "User balance",
        "accounting-customers-button-expand-all": "Expand all",
        "accounting-customers-button-collapse-all": "Collapse all",

        "accounting-orders-tab-transactions": "Transactions",
        "accounting-orders-tab-refill": "Refill",
        "accounting-orders-tab-meetingService": "Meeting service",
        "transactions-table-list-refund": "\n .title = Refund \n .message = Are you sure you want to refund order #{ $orderId } ({ $amount })? \n .buttonLabelSubmit = Confirm\n .buttonLabelCancel = Cancel",
        "transactions-table-list-refund-success-dialog-title": "Order was refunded",
        "transactions-table-list-refund-error-message": "Failed to refund order. Please try again.",
        "transactions-table-list-message-customer": "Message customer",

        "filter-menu-title": "Filters",
        "filter-menu-clear-all-button": "Clear all",
        "filter-menu-clear-button": "Clear",

        "filter-menu-accordion-shops-title": "\n .title = Shops",
        "filter-menu-accordion-customers-title": "\n .title = Customers",
        "filter-menu-accordion-transactions-order-details-title": "\n .title = Order details",
        "filter-menu-accordion-transactions-order-number": "\n .label = Order number \n .placeholder = Search by order no...",
        "filter-menu-accordion-transactions-user": "\n .label = User \n .placeholder = Enter id or email",

        "standard-email-filter-label": "\n .label = Email",
        "standard-email-filter-error-message": "Invalid email address",
        "standard-id-filter-order-id-label": "\n .label = Order ID",
        "standard-id-filter-employee-id-label": "\n .label = Employee ID",
        "standard-id-filter-only-numbers-error-message": "Must contain only numbers",
        "standard-last-4-numbers-filter": "\n .label = Credit card, last 4 digits",
        "standard-last-4-numbers-filter-error-message": "Only last 4 numbers",
        "standard-payment-method-input-label": "Payment method",
        "standard-payment-method-item-credit-card": "Credit card",
        "standard-payment-method-item-contant": "Contant",
        "standard-payment-method-item-invoicing": "Invoicing",
        "standard-payment-method-item-wallet": "Wallet",
        "standard-payment-method-item-free": "Free",
        "standard-merchants-filter-label": "Merchants",
        "standard-merchants-shops-filter-label": "Shops",

        "standard-start-date-picker": "\n .label = Start date",
        "standard-end-date-picker": "\n .label = End date",
        "standard-period-date-picker": "Period",

        "table-select-data-type-filter-on-label": "Filter on",
        "table-select-data-type-filter-on-label-label": "\n .label = Filter on",
        "table-select-data-type-filter-on-item-order-date": "Order date",
        "table-select-data-type-filter-on-item-delivery-date": "Delivery date",

        "table-select-date-period-filter-by-label": "Period",
        "table-select-date-period-filter-by-label-label": "\n .label = Period",
        "table-select-date-period-filter-by-all": "All",
        "table-select-date-period-filter-by-today": "Today",
        "table-select-date-period-filter-by-yesterday": "Yesterday",
        "table-select-date-period-filter-by-tomorrow": "Tomorrow",
        "table-select-date-period-filter-by-this-week": "This week",
        "table-select-date-period-filter-by-this-month": "This month",

        "table-select-resource-type-filter-by-label": "Resource type",
        "table-select-resource-type-filter-by-label-label": "\n .label = Resource type",
        "table-select-resource-type-filter-by-all": "All",
        "table-select-resource-type-filter-by-room": "Room",
        "table-select-resource-type-filter-by-mobile-av": "Mobile av",
        "table-select-resource-type-filter-by-car": "Car",

        "standard-order-type-filter-mode-all": "All",
        "standard-order-type-filter-mode-pos": "POS",
        "standard-order-type-filter-mode-meeting-service": "Meeting service",
        "standard-order-type-filter-mode-resource-booking": "Resource booking",
        "standard-order-type-filter-mode-internal": "Internal",
        "standard-order-type-filter-mode-external": "External",

        // Accounting > Orders > Meeting service
        "accounting-orders-meeting-service-receipt": "Receipt",
        "accounting-orders-meeting-service-table-startDate-date-picker": "\n .label = Booked start date",
        "accounting-orders-meeting-service-table-endDate-date-picker": "\n .label = Booked end date",
        "accounting-orders-meeting-service-table-number": "Order id",
        "accounting-orders-meeting-service-table-ref": "Ref.",
        "accounting-orders-meeting-service-table-booked-date": "Booked date",
        "accounting-orders-meeting-service-table-delivery-date": "Delivery date",
        "accounting-orders-meeting-service-table-creator": "Creator",
        "accounting-orders-meeting-service-table-status": "Status",
        "accounting-orders-meeting-service-table-amount": "Amount",
        "filter-menu-accordion-booked-date-title": "\n .title = Booked date",
        "filter-menu-accordion-delivery-date-title": "\n .title = Delivery date",
        "filter-menu-accordion-order-details-title": "\n .title = Order details",
        "filter-menu-accordion-meeting-service-start-date-picker": "\n .label = Start date",
        "filter-menu-accordion-meeting-service-end-date-picker": "\n .label = End date",
        "filter-menu-accordion-meeting-service-order-number": "\n .label = Order number \n .placeholder = Search by order no...",
        "filter-menu-accordion-meeting-service-customer": "\n .label = Customer \n .placeholder = Name of customer...",
        "accounting-orders-meeting-service-payment-type-credit": "Credit note",
        "accounting-orders-meeting-service-payment-type-debit": "",

        // Accounting subscription
        "accounting-subscription-title": "Subscription",
        "accounting-subscription-name": "Name",
        "accounting-subscription-subscribed": "Subscribed",
        "accounting-subscription-unsubscribed": "Unsubscribed",
        "accounting-subscription-payment-method": "Payment method",
        "accounting-subscription-amount": "Amount",
        "accounting-subscription-cancel": "Cancel subscription",
        "accounting-subscription-cancel-true": "Your subscription has been cancelled",


        // Accounting product sale
        "accounting-product-sale-product-code": "Product code",
        "accounting-product-sale-product": "Products",
        "accounting-product-sale-product-quantity": "Quantity",
        "accounting-product-sale-product-amount": "Amount",
        "accounting-product-sale-export-empty": "No sales for this period.",
        "accounting-product-sale-date-range-label": "\n .label = Period",

        // Accounting balance
        "accounting-amount": "Amount",
        "accounting-amount-no-sales": "No sales in the given period",

        // Accounting debtors
        "accounting-debtors-export-items-label": "Items",
        "accounting-debtors-export-amount-label": "Amount",
        "accounting-debtors-export-subtotal-label": "Subtotal",
        "accounting-debtors-export-failed": "Failed to export debtors",
        "accounting-debtors-export-account-total":  "Account total",
        "accounting-debtors-export-subtotal": "Subtotal",
        "accounting-customers-export-sales-summary": "Customer sales summary",
        "accounting-customers-export-payroll": "Customer payroll files (ZIP file)",


        // Merchant > Reports > Accounting > Z-report
        "merchant-accounting-z-reports-page-header": "\n .title = Z-report",
        "merchant-accounting-z-reports-table-date-column": "Date",
        "merchant-accounting-z-reports-table-pos-terminal-column": "POS terminal",
        "merchant-accounting-z-reports-table-amount-column": "Amount",

        // Merchant > Reports > Accounting > Z-report
        "merchant-accounting-custom-reports-page-header": "\n .title = Custom reports",
        "merchant-accounting-custom-reports-table-name-column": "Name",
        "merchant-accounting-custom-reports-table-interval-column": "Interval",
        "merchant-accounting-custom-reports-table-last-run-column": "Last run",
        "merchant-accounting-custom-reports-table-status-column": "Status",
        "merchant-accounting-custom-reports-table-button-details": "Details",
        "merchant-accounting-custom-reports-table-button-download-report": "Download report",
        "merchant-accounting-custom-reports-table-button-activate": "Activate",
        "merchant-accounting-custom-reports-table-button-deactivate": "Deactivate",
        "merchant-accounting-custom-reports-confirm-modal-question": "Are you sure you want to { $status} '{ $itemName }'?",
        "merchant-accounting-custom-reports-run-modal-form-title": "Download report",
        "merchant-accounting-custom-reports-run-modal-form-subtitle-name": "Name:",
        "merchant-accounting-custom-reports-run-modal-form-subtitle": "Payroll deduction",
        "merchant-accounting-custom-reports-run-modal-form-startDate-date-picker": "\n .label = Start date",
        "merchant-accounting-custom-reports-run-modal-form-endDate-date-picker": "\n .label = End date",
        "merchant-accounting-custom-reports-run-form-save-button": "Download",

        // SelectCustomer
        "select-customer": "\n .label = Customer",
        "select-debtor": "\n .label = Company",
        "select-customer-all": "All",

        // SelectShop
        "select-shop": "Shop",
        "select-shop-label": "\n .label = Shop",
        "select-shop-all": "All",


        // SelectWeek
        "select-week": "Select week",
        "select-week-week": "Week",

        // Select Kitchen
        "control-kitchen-mode-delivery-time": "Delivery time",
        "control-kitchen-mode-purchase-time": "Purchase time",
        "control-kitchen-mode-period-report": "Period report",

        // Merchant > Reports > Menu Planning
        "merchant-menu-planning-header": "\n .title = Menu planning",
        "merchant-menu-planning-tab-calendar": "Calendar",
        "merchant-menu-planning-tab-menus": "Menus",
        "merchant-menu-planning-tab-digital-signage": "Digital signage",
        "merchant-menu-planning-table-startDate-date-picker": "\n .label = Start date",
        "merchant-menu-planning-table-endDate-date-picker": "\n .label = End date",
        "merchant-menu-planning-table-week-select": "\n .label = Week",
        "merchant-menu-planning-table-week-select-option": "Week { $countOfWeek } ({ $startDate } - { $endDate })",
        "merchant-menu-planning-table-date-column": "Date",
        "merchant-menu-planning-table-dish": "Dish { $counter }:",
        "merchant-menu-planning-table-price": "Price: { $price }",
        "merchant-menu-planning-table-allergens": "Allergens: { $allergens }",
        "merchant-menu-planning-table-type-mode-digital-signage": "Digital signage",
        "merchant-menu-planning-table-type-mode-web-menu": "Web menu",
        "merchant-menu-planning-table-type-recurring": "Recurring",
        "merchant-menu-planning-table-status-column": "Status",
        "merchant-menu-planning-table-active-column-active": "Active",
        "merchant-menu-planning-table-active-column-inactive": "Inactive",
        "merchant-menu-planning-table-active-column-active-filter-yes": "Active",
        "merchant-menu-planning-table-active-column-inactive-filter-no": "Inactive",
        "merchant-menu-planning-table-dishes-count": "dishes",
        "merchant-menu-planning-table-recurrence": "Recurrence",
        "merchant-menu-planning-table-create-button": "Create menu",
        "merchant-menu-planning-table-week-menu-rss-button": "Week menu as RSS",
        "merchant-menu-planning-table-week-menu-atom-button": "Week menu as Atom",
        "merchant-menu-planning-table-menu-item-edit": "Edit",
        "merchant-menu-planning-table-menu-item-set-inactive": "Set inactive",
        "merchant-menu-planning-table-menu-item-set-active": "Set active",
        "merchant-menu-planning-table-menu-item-delete": "Delete",
        "merchant-menu-planning-confirm-delete-shop-dialog": "\n .typeOfEntity = menu",
        "merchant-menu-planning-dialog-create-title": "Create menu",
        "merchant-menu-planning-dialog-edit-title": "Edit menu",
        "merchant-menu-planning-dialog-max-dishes": "Available dish signs: { $countOfDishes }",
        "merchant-menu-planning-dialog-add-marketing-details-button": "\n .title =+ Add marketing details",
        "merchant-menu-planning-dialog-add-dish-button": "Add dish",
        "merchant-menu-planning-dialog-add-recurrence-button": "\n .title =+ Add Recurrence",
        "merchant-menu-planning-dialog-remove-recurrence-button": "\n .title =Remove Recurrence",
        "merchant-menu-planning-dialog-create-submit-button": "Create",
        "merchant-menu-planning-dialog-save-submit-button": "Save",
        "merchant-menu-planning-dialog-dish": "Dish { $countOfDish }",
        "merchant-menu-planning-dialog-publishDate-date-picker": "\n .label = Publish date",
        "merchant-menu-planning-dialog-recurrence": "Recurrence",
        "merchant-menu-planning-dialog-name-of-dish-field": "\n .label = Name of dish *",
        "merchant-menu-planning-dialog-brief-field": "\n .label = Brief \n .placeholder = Short description, max. 80 characters including space.",
        "merchant-menu-planning-dialog-marketing-tag-field": "\n .label = Marketing tag \n .helperText = Examples: Offer of the day, Discount",
        "merchant-menu-planning-dialog-from-date-picker": "\n .label = From date",
        "merchant-menu-planning-dialog-to-date-picker": "\n .label = To date",
        "merchant-menu-planning-dialog-currency-field": "\n .label = Currency",
        "merchant-menu-planning-dialog-price-field": "\n .label = Price",
        "merchant-menu-planning-dialog-upload-image": "\n .label = Upload image",
        "merchant-menu-planning-week-day-monday": "Monday",
        "merchant-menu-planning-week-day-tuesday": "Tuesday",
        "merchant-menu-planning-week-day-wednesday": "Wednesday",
        "merchant-menu-planning-week-day-thursday": "Thursday",
        "merchant-menu-planning-week-day-friday": "Friday",
        "merchant-menu-planning-week-day-saturday": "Saturday",
        "merchant-menu-planning-week-day-sunday": "Sunday",
        "merchant-menu-planning-dialog-signageTypes-label": "Publish to:",
        "merchant-menu-planning-dialog-signageTypes-mode-web-menu": "Web menu",
        "merchant-menu-planning-dialog-signageTypes-mode-buffet-sign": "Buffet sign",
        "merchant-menu-planning-dialog-signageTypes-mode-day-menu-sign": "Todays menu sign",
        "merchant-menu-planning-dialog-signageTypes-min-error": "Please select at least one signage type",
        "merchant-menu-planning-digital-signage-card-serial-no": "Serialno:",
        "merchant-menu-planning-digital-signage-card-device-id": "Device ID:",
        "merchant-menu-planning-digital-signage-card-device-name": "Device name:",
        "merchant-menu-planning-digital-signage-card-last-update": "Last updated:",
        "merchant-menu-planning-digital-signage-card-battery-status": "Battery status:",
        "merchant-menu-planning-digital-signage-card-battery-status-0": "Undefined",
        "merchant-menu-planning-digital-signage-card-battery-status-1": "Unknown",
        "merchant-menu-planning-digital-signage-card-battery-status-2": "Good",
        "merchant-menu-planning-digital-signage-card-battery-status-3": "Poor",
        "merchant-menu-planning-digital-signage-card-battery-status-4": "Poor chiller",
        "merchant-menu-planning-digital-signage-card-battery-status-5": "Replace",
        "merchant-menu-planning-digital-signage-card-battery-status-6": "Replace chiller",
        "merchant-menu-planning-digital-signage-card-status-code": "Status code:",
        "merchant-menu-planning-digital-signage-card-status-code--99": "Unknown",
        "merchant-menu-planning-digital-signage-card-status-code--10": "Failed Cleansing",
        "merchant-menu-planning-digital-signage-card-status-code--2": "Failed System Configuration",
        "merchant-menu-planning-digital-signage-card-status-code--1": "Failed Network Configuration",
        "merchant-menu-planning-digital-signage-card-status-code-0": "Not Configured",
        "merchant-menu-planning-digital-signage-card-status-code-1": "Network Configured",
        "merchant-menu-planning-digital-signage-card-status-code-2": "Failed Communication",
        "merchant-menu-planning-digital-signage-card-status-code-3": "Low Battery",
        "merchant-menu-planning-digital-signage-card-status-code-4": "Current Page Design Not Found",
        "merchant-menu-planning-digital-signage-card-status-code-5": "Current Page Product Not Found",
        "merchant-menu-planning-digital-signage-card-status-code-6": "Current Page Failed Update",
        "merchant-menu-planning-digital-signage-card-status-code-7": "Alternate Page Design Not Found",
        "merchant-menu-planning-digital-signage-card-status-code-8": "Alternate Page Product Not Found",
        "merchant-menu-planning-digital-signage-card-status-code-9": "Alternate Page Failed Update",
        "merchant-menu-planning-digital-signage-card-status-code-10": "Ok",
        "merchant-menu-planning-digital-signage-card-status-code-11": "Failed Health Check",
        "merchant-menu-planning-digital-signage-card-status-code-12": "Low Temperature",
        "merchant-menu-planning-digital-signage-card-status-code-20": "Image Overwritten",
        "merchant-menu-planning-digital-signage-card-status-code-50": "Preconfigured",
        "merchant-menu-planning-digital-signage-card-status-code-99": "Queued",
        "merchant-menu-planning-digital-signage-empty": "No digital signage devices found",
        "merchant-menu-planning-digital-signage-dialog-title": "Digital sign",
        "merchant-menu-planning-digital-signage-menu-details": "Details",
        "merchant-menu-planning-digital-signage-menu-clear-sign": "Clear sign",
        "merchant-menu-planning-color-field-label": "\n .label = Color",

        // --- Merchant ---

        // Navigation
        "merchant-nav-item-home": "Home",

        //  - reporting
        "merchant-nav-item-production": "\n .title = Production",
        "merchant-nav-item-menu-planning": "Menu Planning",
        "merchant-nav-item-purchase-control": "Purchase Control",
        "merchant-nav-item-survey": "Survey",
        "merchant-nav-item-accounting": "Accounting",
        "merchant-nav-item-accounting-page-header": "\n .title = Accounting",
        "merchant-nav-item-production-planning": "Planning",
        "merchant-nav-item-production-meeting-service": "Meeting Service",
        "merchant-nav-item-production-takeaway": "Takeaway",
        "merchant-nav-item-production-pos-purchases": "POS purchases",

        //  - admin
        "merchant-nav-item-settings-page-header": "\n .title = Settings",
        "merchant-nav-item-settings-header": "Settings",
        "merchant-nav-item-customer-access": "Customer Access",
        "merchant-nav-item-id-cards": "ID cards",
        "merchant-nav-item-custom-jobs":"Custom jobs",
        "merchant-nav-item-merchant-news": "News",
        "merchant-nav-item-messaging": "Push messages",
        "merchant-nav-item-news": "Merchant news",
        "merchant-nav-item-users": "Administrators",
        "merchant-nav-item-shops": "Shops",
        "merchant-nav-item-payment-links": "Payment links",
        "merchant-nav-item-products": "Products",
        "merchant-nav-item-product-create": "Create product",
        "merchant-nav-item-extra-service-create": 'Create extra service',
        "merchant-nav-item-extra-service-edit": 'Edit extra service',
        "merchant-nav-item-product-update": "Edit product",
        "merchant-nav-item-product-groups": "Product Groups",
        "merchant-nav-item-extra-services": "Extra Services",
        "merchant-nav-item-product-group-create": "Create product group",
        "merchant-nav-item-product-group-update": "Edit product group",
        "merchant-nav-item-price-lists": "Price Lists",
        "merchant-nav-item-price-list-create": "Create price list",
        "merchant-nav-item-price-list-edit": "Edit price list",
        "merchant-nav-item-surveys": "Surveys",
        "merchant-nav-item-devices": "Devices",
        "merchant-nav-item-communication-page-header":"\n .title = Communication",
        "merchant-nav-item-communication-header":"Communication",
        "merchant-nav-item-group-products":"\n .title = Products",
        "merchant-nav-item-products-header":"Products",
        "merchant-nav-item-group-shops":"\n .title = Shops",
        "merchant-nav-item-offers":"Offers",
        "merchant-nav-item-vat-codes":"VAT codes",
        "merchant-nav-item-create-vat-code":"Create VAT code",
        "merchant-nav-item-edit-vat-code":"Edit VAT code",
        "merchant-nav-item-group-organization":"\n .title = Organization",
        "merchant-nav-item-group-account":"\n .title = Account",
        "merchant-nav-item-billing":"Billing",
        "merchant-nav-item-account":"Account",
        "merchant-nav-item-merchant-account":"Merchant account",
        "merchant-nav-item-delivery-locations": "Delivery locations",
        "merchant-nav-item-sales-accounts": "Sales accounts",
        "merchant-nav-item-live-dashboard": "Live dashboard",

        // Admin home
        "merchant-admin-home-products-group": "\n .title = Products",
        "merchant-admin-home-communication-group": "\n .title = Communication",
        "merchant-admin-home-customers-group": "\n .title = Customers",
        "merchant-admin-home-settings-group": "\n .title = Settings",
        "merchant-admin-home-customers-card": "\n .title = Customer Access\n .description = Manage customer access to your merchant.",
        "merchant-admin-home-merchant-news-card": "\n .title = Merchant news\n .description = Write and publish news articles for your merchant to your customers.",
        "merchant-admin-home-admin-card": "\n .title = Administrators\n .description = Manage administrators for your merchant.",
        "merchant-admin-home-shop": "\n .title = Shops \n .description = Sell your products through shops with customizable branding.",
        "merchant-admin-home-payment-links": "\n .title = Payment links \n .description = Create a unique payment link for guest or course participants.",
        "merchant-admin-home-products": "\n .title = Products \n .description = Add and maintain products for your shops",
        "merchant-admin-home-product-groups": "\n .title = Product Groups \n .description = Group your products and control the visibility of groups throughout the day.",
        "merchant-admin-home-price-list": "\n .title = Price Lists\n .description = Use price lists to offer differentiated  products and prices to customers.",
        "merchant-admin-home-extra-services": "\n .title = Extra Services\n .description = Tilføj og vedligehold produkter for dine shops.",
        "merchant-admin-home-merchant-surveys": "\n .title = Surveys\n .description = Monitor your customer satisfaction by creating and managing surveys.",
        "merchant-admin-home-devices-card": "\n .title = Devices\n .description = Show devices like screens, printers and credit card terminals.",
        "merchant-admin-home-offers-card": "\n .title = Offers\n .description = Manage your offers",
        "merchant-admin-home-vat-codes-card": "\n .title = VAT Codes\n .description = Manage VAT codes",
        "merchant-admin-home-id-cards-card": "\n .title = ID cards\n .description = View your customers ID cards used for POS payments.",
        "merchant-admin-home-account-group": "\n .title = Account",
        "merchant-admin-home-merchant-account-card": "\n .title = Merchant Account\n .description = Maintain your merchant account details\n .buttonText = Show",
        "merchant-admin-home-delivery-locations-card": "\n .title = Delivery locations\n .description = Manage delivery locations where customers can pick up orders.",
        "merchant-admin-home-sales-accounts-card": "\n .title = Sales accounts \n .description = Create sales accounts for posting sales.",

        // Merchant > Admin > Settings > Custom jobs
        "merchant-admin-settings-custom-jobs-title":" \n .title = Custom jobs",
        "merchant-admin-settings-custom-jobs-table-name":"Name",
        "merchant-admin-settings-custom-jobs-table-interval":"Interval",
        "merchant-admin-settings-custom-jobs-table-last-run":"Last run",
        "merchant-admin-settings-custom-jobs-table-status":"Status",
        "merchant-admin-settings-custom-jobs-table-action-details":"Details",
        "merchant-admin-settings-custom-jobs-table-action-run-job":"Run job",
        "merchant-admin-settings-custom-jobs-table-action-activate":"Activate",
        "merchant-admin-settings-custom-jobs-table-action-inactivate":"Inactivate",

        // Messages
        "messages-list-header": "\n .title = Push messages",
        "messages-list-create-button": "Create message",
        "merchant-nav-item-messages": "Push messages",
        "messages-table-subject-column" : "Subject",
        "messages-table-publish-time-column": "Publish time",
        "messages-table-edit-button": "Edit",
        "messages-table-delete-button": "Delete",
        "messages-table-delete-modal-title": "message",
        "messages-table-delete-success-message": "Message was deleted",
        "messages-table-update-delete-dialog-title": "This message can't be updated / deleted",
        "messages-table-update-delete-dialog-description": "Messages can't be updated or deleted because it's published.",
        "messages-table-update-delete-dialog-button": "Close",

        // create / edit messages
        "create-message-header": "\n .title = Create message",
        "edit-message-header": "\n .title = Edit message",
        "nav-item-create-message-header": "Create message",
        "nav-item-edit-message-header": "Edit message",
        "create-message-save-button": "Create",
        "edit-message-save-button": "Save",
        "create-or-edit-message-info": "\n .title = Send short important messages to the users, eg. about closing days, events or similar. Messages will be visible for all users who are connected to your shops.",
        "create-or-edit-message-field-subject": "\n .label = Subject \n .placeholder = Add a catchy subject, which users wish to read *",
        "create-or-edit-message-dialog-field-subject-label": "Subject:",
        "create-or-edit-message-field-title-page": "\n .label = Subject\n .placeholder = Subject\n .helperText = Add a catchy subject, which users wish to read.",
        "create-or-edit-message-dialog-field-message-label": "Message:",
        "create-or-edit-message-field-message": "\n .label = Message\n .placeholder = Enter a message *\n .helperText = Remaining characters: { $charsRemaining }",
        "create-or-edit-message-settings": "\n .title = Settings",
        "create-or-edit-message-field-publishDate": "\n .label = Publish:",
        "create-or-edit-message-field-publish-title": "Publish:",
        "create-or-edit-message-accordion-title": "Settings",
        "create-or-edit-message-field-publishDate-page": "\n .label = Publish",
        "create-or-edit-message-field-publishDate-helperText": "The time that the message will be visible to users.",
        "create-or-edit-message-field-title-required": "Subject is required",
        "create-or-edit-message-field-body-required": "Message is required",
        "create-or-edit-message-field-body-too-long": `You have exceed the max amount of characters: { $charsLimit }`,
        "create-or-edit-message-field-channels-required": "Select at least one channel",
        "create-or-edit-message-field-channel-type-mode-in-app": "App message",
        "create-or-edit-message-field-channel-type-description-mode-in-app": "Sent as message in web and app",
        "create-or-edit-message-field-channel-type-mode-push": "Push notification",
        "create-or-edit-message-field-channel-type-description-mode-push": "Send as mobile push notification",
        "create-or-edit-message-field-channel-type-mode-sms": "SMS message",
        "create-or-edit-message-field-channel-type-description-mode-sms": "Send as SMS text message",
        "create-or-edit-message-field-channel-type-mode-email": "Email",
        "create-or-edit-message-field-channel-type-description-mode-email": "Send as an email",
        "create-or-edit-message-field-channel-type-mode-in-app-card": "App card",
        "create-or-edit-message-field-channel-type-description-mode-in-app-card": "Show as a card inside GoPay app",
        "create-or-edit-message-field-tag": "\n .label = Topic: \n .placeholder = Select a topic *",
        "create-or-edit-message-dialog-topic-label": "Topic:",
        "create-or-edit-message-dialog-topic-placeholder": "Select a topic *",
        "create-or-edit-message-field-tag-page": "\n .label = Topic",
        "create-or-edit-message-field-tag-mode-info": "Info",
        "create-or-edit-message-field-tag-description-mode-info": "For general information about the merchant, opening hours, food selection or procedures.",
        "create-or-edit-message-field-tag-mode-important": "Important",
        "create-or-edit-message-field-tag-description-mode-important": "For critical messages such as changes to opening hours, health- and safety related information or other urgent messages.",
        "create-or-edit-message-field-tag-mode-offer": "Offer",
        "create-or-edit-message-field-tag-description-mode-offer": "For offers, discounts, campaigns or special arrangements.",
        "create-or-edit-message-field-tag-mode-menu-change": "Menu",
        "create-or-edit-message-field-tag-description-mode-menu-change": "To inform users about changes to the daily menu, new dishes or seasonal offers.",
        "create-or-edit-message-field-tag-mode-event": "Event",
        "create-or-edit-message-field-tag-description-mode-event": "For upcoming events such as theme days, food festivals or special events in the canteen.",
        "create-or-edit-message-field-tag-mode-reminder": "Reminder",
        "create-or-edit-message-field-tag-description-mode-reminder": "To remind users of important dates or deadlines for example registration for events or deadline for preorder of food.",
        "create-or-edit-message-field-tag-mode-feedback": "Feedback",
        "create-or-edit-message-field-tag-description-mode-feedback": "To request feedback for food and service or customer satisfaction surveys.",
        "create-or-edit-message-field-tag-mode-news": "News",
        "create-or-edit-message-field-tag-description-mode-news": "For updates about the activities of the merchant, measures or changes to operation that could be of interest to customers.",
        "create-or-edit-message-field-tag-mode-health": "Health",
        "create-or-edit-message-field-tag-description-mode-health": "For information about healthy choices, nutrition tips or allergy information related to the menu.",
        "create-or-edit-message-field-tag-mode-social": "Social",
        "create-or-edit-message-field-tag-description-mode-social": "To promote social initiatives, theme days or social events.",
        "create-or-edit-message-field-tag-required": "Tag is required",
        "create-message-success-dialog-title": "Message has been created",
        "create-message-success-dialog-view-archive": "View message archive",
        "create-message-success-dialog-close-button": "Close",
        "create-message-success-dialog-view-list-button": "Go to messages",


        // Customer access
        "merchant-customer-access-header": "\n .title = Customer Access",
        "merchant-customer-access-customers-table-name-column": "Name",
        "merchant-customer-access-customers-table-active-column": "Status",
        "merchant-customer-access-customers-table-domains-column": "Domains",
        "merchant-customer-access-customers-table-active-filter-yes": "Active",
        "merchant-customer-access-customers-table-active-filter-no": "Inactive",
        "merchant-customer-access-customers-table-active-column-active": "Active",
        "merchant-customer-access-customers-table-active-column-inactive": "Inactive",

        // Merchant account > Swift dialog
        "merchant-account-swift-dialog-title":"Switch merchant",
        "merchant-account-swift-dialog-subtitle":"You have access to the following merchant. Select one to swift.",
        "merchant-account-swift-dialog-empty-title":"You don't have access to other merchants.",

        // Merchant home
        "merchant-home-today-card-group": "\n .title = POS Sales\n .subtitle = today",
        "merchant-home-todays-control-code": "Todays control code",
        "merchant-home-todays-offers": "Todays offers",
        "merchant-home-number-of-orders": "\n .title = Orders",
        "merchant-home-turnover": "\n .title = Turnover",
        "merchant-home-avg-amount": "\n .title = Avg. amount",
        "merchant-home-subscriptions": "\n .title = Subscriptions",
        "merchant-home-statistics-card-group": "\n .title = Statistics",
        "merchant-home-checkin-card": "\n .title = Check-in screen",
        "merchant-home-checkin-card-participants": "Checked in ({ $checkedIn })",
        "merchant-home-checkin-card-none-participants": "Not checked in ({ $notCheckedIn })",
        "merchant-home-checkin-card-participation-percentage": "Percentage",
        "merchant-home-survey-card-empty": "\n .title = Satisfaction",
        "merchant-home-meeting-service-card-group": "\n .title = Meeting service\n .subtitle = Today",
        "merchant-home-meeting-service-number-of-orders-card": "\n .title = Number of orders",
        "merchant-home-meeting-service-awaiting-approval-card": "\n .title = Awaiting approval",
        "merchant-home-meeting-service-ready-for-invoicing-card": "\n .title = Ready for invoicing",
        "merchant-home-meeting-service-ready-for-invoicing-card-description": "&gt; {$overdueDays} days ago",
        "merchant-home-meeting-service-delivery-planning-card": "\n .title = Delivery planning",
        "merchant-home-meeting-service-delivery-planning-delivery": "Delivery",
        "merchant-home-meeting-service-delivery-planning-picked-up": "Picked up",
        "merchant-home-meeting-service-delivery-planning-eating-in-canteen": "Eating in canteen",
        "merchant-home-meeting-service-next-deliveries-card": "\n .title = Next {$numberOfOrders} deliveries",
        "merchant-home-meeting-service-table-name-column": "Customer",
        "merchant-home-meeting-service-table-delivery-column": "Delivery",
        "merchant-home-views-button": "Live Dashboards",
        "merchant-home-views-dialog-title": "Live Dashboards",
        "merchant-home-views-dialog-subtitle": "Select a dashboard below:",
        "merchant-home-views-dialog-conference": "Conference",
        "merchant-home-views-dialog-conference-live-sales-part-1": "Live",
        "merchant-home-views-dialog-conference-live-sales-part-2": "sales",
        "merchant-home-views-dialog-conference-orders": "Orders",
        "merchant-home-views-dialog-conference-turnover": "Turnover",
        "merchant-home-views-dialog-conference-avg-price": "Avg price",
        "merchant-home-views-dialog-conference-free-riders": "Free riders",
        "merchant-home-views-dialog-conference-satisfaction": "Satisfaction",
        "merchant-home-statistics-pos-turnover-card": "\n .title = POS turnover",
        "merchant-home-statistics-pos-orders-card": "\n .title = POS orders",
        "merchant-home-statistics-number-of-users-card": "\n .title = Number of users",
        "merchant-home-statistics-period-base-3": "Last 3 days",
        "merchant-home-statistics-period-base-14": "Last 14 days",
        "merchant-home-statistics-period-base-30": "Last 30 days",
        "merchant-home-statistics-period-base-60": "Last 60 days",
        "merchant-home-statistics-period-base-180": "Last 180 days",
        "merchant-home-statistics-compared-to-last-period": "compared to last period",

        // Merchant home tooltips
        "merchant-home-todays-control-code-tooltip": "\n .title = This will be displayed on the proof of purchase (app) and the printed receipt",
        "merchant-home-todays-offers-tooltip": "\n .title = Number of active offers for today",
        "merchant-home-number-of-orders-tooltip": "\n .title = Number of POS orders for today",
        "merchant-home-turnover-tooltip": "\n .title = Total POS sales amount for today",
        "merchant-home-avg-amount-tooltip": "\n .title = Average order amount for today's orders",
        "merchant-home-subscriptions-tooltip": "\n .title = Today's active lunch subscriptions",

        // Merchant home statistics tooltips
        "merchant-home-statistics-check-in-card-tooltip": "\n .title = Shows how many customers remember to scan their proof of purchase on the check-in screen versus how many forget to do it",
        "merchant-home-statistics-pos-turnover-card-tooltip": "\n .title = Shows POS sales for the selected period versus the sales for the previous period",
        "merchant-home-statistics-pos-orders-card-tooltip": "\n .title = Shows number of POS for the selected period versus the orders for the previous period",
        "merchant-home-statistics-number-of-users-card-tooltip": "\n .title = Shows number of new users for selected period versus new users for previous period",
        "merchant-home-statistics-meeting-orders-card-tooltip": "\n .title = Number of meeting service orders today",
        "merchant-home-statistics-meeting-orders-approval-card-tooltip": "\n .title = Total number of meeting service orders awaiting approval",
        "merchant-home-statistics-meeting-orders-invoicing-card-tooltip": "\n .title = Total number of meeting service orders awaiting booking and was delivered more than [X] days",
        "merchant-home-statistics-next-deliveries-card-tooltip": "\n .title = The next 5 deliveries for today",
        "merchant-home-statistics-meeting-distribution-chart-tooltip": "\n .title = Shows the distribution of meeting service orders during today",

        // Merchant Account
        "merchant-update-account-page-header": "\n .title = Merchant account",
        "merchant-update-account-save-button": "Save",
        "merchant-update-account-opening-hours-title":"\n .title = Opening hours",
        "merchant-update-account-opening-hours-action-button-add":"Add",
        "merchant-update-account-opening-hours-action-button-edit":"Edit",
        "merchant-update-account-opening-hours-empty-text":"Opening hours not set",
        "merchant-update-account-opening-hours-dialog-title":"Opening hours",
        "merchant-update-account-opening-hours-dialog-save-button":"Save",
        "merchant-update-account-opening-hours-dialog-before-start-error":"Before start time",
        "merchant-update-account-opening-hours-dialog-closed-time-select-from":"\n .label = From",
        "merchant-update-account-opening-hours-dialog-time-select-to":"\n .label = To",
        "merchant-update-account-opening-hours-dialog-closed":"Closed",
        "merchant-update-account-opening-hours-day-monday": "Monday",
        "merchant-update-account-opening-hours-day-tuesday": "Tuesday",
        "merchant-update-account-opening-hours-day-wednesday": "Wednesday",
        "merchant-update-account-opening-hours-day-thursday": "Thursday",
        "merchant-update-account-opening-hours-day-friday": "Friday",
        "merchant-update-account-opening-hours-day-saturday": "Saturday",
        "merchant-update-account-opening-hours-day-sunday": "Sunday",



        //Merchant reports
        "merchant-reports-id-cards-title": "\n .title = ID cards",
        "merchant-reports-id-cards-nav-item-home": "Home",
        "merchant-reports-id-cards-nav-item-id-cars": "ID cards",

        // Merchant ID table
        "merchant-id-cards-table-card-number": "Card number",
        "merchant-id-cards-table-card-type": "Card type",
        "merchant-id-cards-table-user": "User",
        "merchant-id-cards-table-company": "Company",
        "merchant-id-cards-table-status": "Status",
        "merchant-id-cards-table-card-type-select-label": "\n .label = Card type",
        "merchant-id-cards-table-company-select-label": "\n .label = Company",
        "merchant-id-cards-table-card-type-select-item-wallet":"Wallet",
        "merchant-id-cards-table-card-type-select-item-company-credit":"Company credit",
        "merchant-id-cards-table-card-type-select-item-tickets":"Tickets",
        "merchant-id-cards-table-card-type-select-item-unlimited-tickets":"Unlimited tickets",
        "merchant-id-cards-table-card-type-select-item-tickets-unlimited":"Unlimited tickets",
        "merchant-id-cards-table-card-type-select-item-top-up": "Top up",
        "merchant-id-cards-table-card-type-select-item-payroll-deduction": "Payroll deduction",


        // Merchant ID Cards Dialog
        "merchant-id-cards-dialog-title": "ID card details",
        "merchant-id-cards-dialog-status": "Status:",
        "merchant-id-cards-dialog-card-name": "Card name:",
        "merchant-id-cards-dialog-card-type": "Card type:",
        "merchant-id-cards-dialog-card-type-top-up": "Top up",
        "merchant-id-cards-dialog-card-type-wallet": "Wallet",
        "merchant-id-cards-dialog-card-type-company-credit": "Company credit",
        "merchant-id-cards-dialog-card-type-tickets": "Tickets",
        "merchant-id-cards-dialog-card-type-tickets-unlimited": "Tickets unlimited",
        "merchant-id-cards-dialog-card-type-payroll-deduction": "Payroll deduction",
        "merchant-id-cards-dialog-validated": "Validated:",
        "merchant-id-cards-dialog-expiry": "Expiry:",
        "merchant-id-cards-dialog-payment-method": "Payment method:",
        "merchant-id-cards-dialog-user-id": "User ID:",
        "merchant-id-cards-dialog-employee-id": "Employee ID:",
        "merchant-id-cards-dialog-name": "Name:",
        "merchant-id-cards-dialog-email": "Email:",
        "merchant-id-cards-dialog-mobile": "Mobile:",
        "merchant-id-cards-dialog-phone": "Phone:",

        "id-cars-table-button-details": "Details",
        "id-cars-filter-card-title":"\n .title = Card",
        "id-cars-filter-debtor-title":"\n .title = Debtor",
        "id-cars-filter-end-user-title":"\n .title = End user",
        "id-cars-filter-card-number-label":"\n .label = Card number \n .placeholder = Search by card number",
        "id-cars-filter-switch-label":"\n .label = Include inactive cards",
        "id-cars-filter-debtor-label":"\n .label = Debtor",
        "id-cars-filter-email-label":"\n .label = Email",
        "id-cars-filter-employee-id-label":"\n .label = Employee ID",

        "merchant-production": "Production",

        // Merchant > Admin > Shops > Products
        "products-page-header": "\n .title = Products",
        "products-tab-all-products": "All products",
        "products-tab-sort-products": "Sort products",
        "products-table-info-box": "Please select a shop to proceed",
        "products-table-show-inactive": "\n .label = Show inactive",
        "products-page-table-price-list-label": "\n .label = Price list",
        "products-name-column": "Name",
        "products-price-column": "Price",
        "products-status-column": "Status",
        "products-create-product-button": "Create new",
        "products-edit-product-menu-item": "Edit",
        "products-delete-product-menu-item": "Delete",
        "products-confirm-delete-product-dialog": "\n .typeOfEntity = product",
        "product-offer-chip": "Offer",

        // Merchant > Admin > Extra Services
        "extra-services-page-header": "\n .title = Extra Services",
        "extra-services-create-service-button": "Create new",
        "extra-services-services-column": "Services",
        "extra-services-min-price-column": "Min. price",
        "extra-services-max-price-column": "Max. price",
        "extra-services-price-per-seat-column": "Price per seat",
        "extra-services-status-column": "Status",

        // Merchant > Admin > Extra Services > Create / Edit
        "extra-services-create-page-header": "\n .title = Create extra service",
        "extra-services-create-active-switch": "Active:",
        "extra-services-create-mandatory": "Always add to order",
        "extra-services-create-mandatory-without-pickup": "Add when picked up",
        "extra-services-create-meeting-location-required-switch": "Meeting location required:",
        "extra-services-create-meeting-time-required-switch": "Request meeting time",
        "extra-services-create-price-field-label": "\n .label = Price",
        "extra-services-create-min-price-field-label": "\n .label = Min.price",
        "extra-services-create-max-price-field-label": "\n .label = Max.price",
        "extra-services-create-price-per-seat-field-label": "\n .label = Price per seat",
        "extra-services-create-currency-field-label": "\n .label = Currency",
        "extra-services-create-service-description-field":  "\n .label = Description",
        "extra-services-create-service-description-field-max-length": "Description cannot exceed { $maxLength } characters",
        "extra-services-create-service-name-field":  "\n .label = Name*",
        "extra-services-create-service-type-field":  "\n .label = Service type",
        "extra-services-create-service-pricing-type-field":  "\n .label = Pricing type",
        "extra-services-create-panel-pricing": "\n .label = Pricing",
        "extra-services-create-settings-panel": "\n .title = Settings",
        "extra-services-create-service-time-panel": "\n .title = Available time",
        "extra-services-create-form-type-dropdown-item-pickup-fee": "Pickup fee",
        "extra-services-create-form-type-dropdown-item-eat-in-canteen-fee": "Eat in canteen fee",
        "extra-services-create-form-type-dropdown-item-delivery-fee": "Delivery fee",
        "extra-services-create-form-type-dropdown-item-table-setting-fee": "Table setting fee",
        "extra-services-create-form-type-dropdown-item-cleanup-fee": "Cleanup fee",
        "extra-services-create-form-type-dropdown-item-out-of-opening-hours-fee": "Out of opening hours fee",
        "extra-services-create-form-type-dropdown-item-other": "Other",
        "extra-services-create-form-pricing-type-dropdown-item-per-seat": "Per seat",
        "extra-services-create-form-pricing-type-dropdown-item-flat-fee": "Flat fee",
        "extra-services-create-when-add-to-order-field": "\n .label = Action",
        "extra-services-create-when-add-to-order-no-action": "No actions selected",
        "extra-services-create-form-action-dropdown-item-add-always": "Add always",
        "extra-services-create-form-action-dropdown-item-add-when-pick-up": "Add when pick up",
        "extra-services-create-form-action-dropdown-item-add-when-delivered": "Add when delivered",

        // Merchant > Admin > Shops > Products > Create / Edit
        "product-create-page-header": "\n .title = Create product",
        "product-create-submit-button": "Create",
        "product-edit-page-header": "\n .title = Edit product",
        "product-edit-submit-button": "Save",
        "product-create-shops-field-label": "Shops",
        "product-create-group-field-label": "\n .label = Product group",
        "product-create-number-field-label": "\n .label = Product number",
        "product-create-name-field-label": "\n .label = Product name",
        "product-create-price-field-label": "\n .label = Price",
        "product-create-currency-field-label": "\n .label = Currency",
        "product-create-description-field-label": "\n .label = Description",
        "product-create-panel-access": "\n .title = Access",
        "product-create-panel-access-shop-alert-title": "\n .title = A shop represents a virtual or physical point of sale, such as webshops in the GoPay app or the shop connected to POS terminals in a canteen. A user that is NOT connected to a price list will see the products that are directly assigned to shops here. ",
        "product-create-panel-access-price-list-alert-title": "\n .title = Price lists can be used to offer different selections of products or different prices to different groups of users. Several price lists can be associated with the same shop in order to show different selections. A user will always see a single price list - or - the default selection. What price list is shown depends on the user group or - in the case of POS - the subscription type of the user.",
        "product-create-panel-description": "\n .title = Description",
        "product-create-image-field-label": "\n .label = Image",
        "create-image-file-support": "File types supported: { $supportedFileTypes }. Max size: { $maxSize }",
        "product-create-general-panel": "\n .title = General",
        "product-create-active-switch": "Active:",
        "product-create-product-description-panel": "\n .title = Product description",
        "product-create-product-description-marketing-tag-field": "\n .label = Marketing tag\n .helperText = Examples: 'Offer', 'CO2', 'Hot dish', 'Vegetarian'",
        "product-create-product-description-allergens-field": "\n .label = Allergens",
        "product-create-availability-panel": "\n .title = Availability",
        "product-create-availability-from-date-picker": "\n .label = From date",
        "product-create-availability-to-date-picker": "\n .label = To date",
        "product-create-availability-preorder-switch": "Disallow pre-order:",
        "product-create-availability-info": "Customers can pre-order products for future dates in the GoPay app unless you disallow it here.",
        "product-create-deadline-panel": "\n .title = Deadline",
        "product-create-deadline-purchases-subtitle": "Purchases:",
        "product-create-deadline-cancellation-subtitle": "Cancellation:",
        "product-create-deadline-day-field": "\n .label = Day",
        "product-create-deadline-day-limit-day-before": "The day before",
        "product-create-deadline-day-limit-x-days-before": "{ $daysBefore } days before",
        "product-create-deadline-time-picker": "\n .label = Time",
        "product-create-barcode-panel": "\n .title = ERP numbers",
        "product-create-barcode-field-label": "\n .label = Barcode",
        "product-create-offer-panel": "\n .title = Offer",
        "product-create-offer-discount-percentage": "Discount percentage:",
        "product-create-offer-discount-price": "Discounted price:",
        "product-create-offer-items-in-stock": "Items in stock:",
        "product-create-offer-available-from": "Available from:",
        "product-create-offer-available-to": "Available to:",
        "product-create-offer-edit-button": "Edit",
        "product-create-offer-create-button": "Create",
        "product-create-offer-dialog-create-title": "Create offer",
        "product-create-offer-dialog-edit-title": "Edit offer",
        "product-create-offer-dialog-normal-price": "Normal price:",
        "product-create-offer-dialog-price-adjustment-field": "\n .label = Price adjustment",
        "product-create-offer-dialog-price-adjustment-option-none": "None",
        "product-create-offer-dialog-price-adjustment-option-discount-price": "Discount",
        "product-create-offer-dialog-price-adjustment-option-discount-percentage": "Discount percentage",
        "product-create-offer-dialog-adjust-price-field": "\n .label = Adjust price",
        "product-create-offer-dialog-items-field": "\n .label = Available items per day",
        "product-create-offer-dialog-percentage-field": "\n .label = Percentage",
        "product-create-offer-dialog-available-offer-period": "Offer period",
        "product-create-offer-dialog-available-from-date-picker": "\n .label = Available from",
        "product-create-offer-dialog-available-to-date-picker": "\n .label = Available to",
        "product-create-offer-dialog-marketing-tag-label": "Marketing tag:",
        "product-create-offer-dialog-marketing-tag-mode-old-new-price-new": "25,00 kr",
        "product-create-offer-dialog-marketing-tag-mode-old-new-price-old": "35,00 kr",
        "product-create-offer-dialog-marketing-tag-mode-old-new-price": "25,00 kr 35,00 kr",
        "product-create-offer-dialog-marketing-tag-mode-save-x": "Save -[x] %",
        "product-create-offer-dialog-marketing-tag-mode-limited-on-sale": "Save [x] kr",
        "product-create-offer-dialog-marketing-tag-mode-great-offer": "Great offer",
        "product-create-offer-dialog-marketing-tag-mode-buy-now": "Buy now",
        "product-create-offer-dialog-marketing-tag-mode-good-price": "Good price",
        "product-create-offer-dialog-marketing-tag-mode-discount": "Discount",
        "product-create-offer-dialog-marketing-tag-mode-week-offer": "Week's offer",
        "product-create-offer-dialog-marketing-tag-mode-day-offer": "Todays offer",
        "product-create-offer-dialog-save-button": "Save",
        "product-create-add-price-list-button": "Add to price list",
        "product-create-add-to-price-list": "Add to price list",
        "product-create-price-list-step-one": "Select price list",
        "product-create-price-list-step-two": "Specify price",
        "product-create-price-list-table-name-column": "Name",
        "product-create-price-list-table-status-column": "Status",
        "product-create-price-list-table-active-column-active": "Active",
        "product-create-price-list-table-active-column-inactive": "Inactive",
        "product-create-price-list-table-active-column-active-filter-yes": "Active",
        "product-create-price-list-table-active-column-inactive-filter-no": "Inactive",
        "product-create-price-list-table-currency": "Currency:",
        "product-create-price-list-table-vat": "VAT:",
        "product-create-price-list-table-connected-shops": "Connected shops:",
        "product-create-price-list-table-connected-customers": "Connected customers:",
        "product-create-price-list-table-vat-code": "VAT code:",
        "product-create-price-list-table-select-button": "Select",
        "product-create-price-list-selected-price-list": "Selected price list:",
        "product-create-price-list-price-field-label": "\n .label = Price",
        "product-create-price-list-add-button": "Add",
        "product-create-payment-panel": "\n .title = Payment",
        "product-create-payment-price-switch": "Hide price:",
        "product-create-delivery-panel": "\n .title = Delivery",
        "product-create-delivery-deliveryDetails-field": "\n .label = Pickup location",
        "product-create-item-limits-panel": "\n .title = Item limits",
        "product-create-item-limits-max-field": "Max. daily items per person:",
        "product-create-item-limits-max-info": "This determines how many items total of this type a customer can order per day.",
        "product-create-item-limits-min-field": "Min. items per order:",
        "product-create-item-limits-min-info": "This determines minimum number of items of this type a customer has to add to an order.",
        "product-create-item-limits-error": "Either max daily items or min items per order must be filled out",
        "product-create-item-limits-min-error": "Min items per order should be empty or >= 2",
        "product-create-item-limits-max-error": "Max daily items should be empty or >= 1",


        // Merchant > Admin > Shops > Product groups
        "product-groups-page-header-title": "\n .title = Product Groups",
        "product-groups-create-button": "Create new",
        "create-product-group-create-button": "Create",
        "create-product-group-save-button": "Save",
        "product-group-page-title-create": "\n .title = Create product group",
        "product-group-page-title-update": "\n .title = Edit product group",
        "product-group-delete": "product group",
        "product-group-delete-success-message": "Product group deleted",
        "product-group-code-column-header": "ERP no.",
        "product-group-name-column-header": "Name",
        "product-group-status-column-header": "Status",

        // Merchant > Admin > Shops > Product groups > Create / Edit
        "product-group-form-name-field": "\n .label = Name",
        "product-group-form-code-field": "\n .label = ERP number",
        "product-group-form-code-field-helper-text": "ERP numbers are used when integrating with an accounting system. They are created by a supplier admin.",
        "product-group-form-code-field-helper-text-no-items": "No available product codes for supplier",
        "product-group-form-settings-panel": "\n .title = Settings",
        "product-group-form-active-switch": "Active:",
        "product-group-form-pin-code-required-switch": "PIN code required:",
        "product-group-form-pin-code-required-explanation": "Products in this group will require a staff PIN code to purchase. PIN code can be seen in device details.",
        "product-group-form-limited-availability-panel-title": "\n .title = Limited availability \n .offContent = Products in this group are always available for purchase",
        "product-group-form-start-time-picker": "\n .label = From time",
        "product-group-form-end-time-picker": "\n .label = To time",
        "product-group-form-week-day-monday": "Monday",
        "product-group-form-week-day-tuesday": "Tuesday",
        "product-group-form-week-day-wednesday": "Wednesday",
        "product-group-form-week-day-thursday": "Thursday",
        "product-group-form-week-day-friday": "Friday",
        "product-group-form-week-day-saturday": "Saturday",
        "product-group-form-week-day-sunday": "Sunday",
        "product-group-form-end-time-picker-min-error-label": "Should be greater than 'From time'",


        // Merchant > Admin > Shops > Price lists
        "price-lists-header": "\n .title = Price Lists",
        "price-lists-create-button": "Create new",
        "price-list-vat-code": "VAT code",
        "price-list-currency": "Currency",
        "price-list-shops": "Connected Shops",
        "price-list-company": "Connected Company",
        "price-list-no-result": "There are no price lists. Please create you first price list",
        "price-list-delete": "price list",
        "price-list-delete-success-message": "Price list deleted",

        // Merchant > Admin > Shops > Price lists > Create / Edit
        "create-price-list-page-header": "\n .title = Create price list",
        "edit-price-list-page-header":"\n .title = Edit price list",
        "create-price-list-save-button": "Save",
        "create-price-list-create-button": "Create",
        "create-price-list-tab-general": "General",
        "create-price-list-tab-customers": "Customers",
        "create-price-list-tab-products": "Products",
        "create-price-list-tab-pos": "POS",
        "create-price-list-required-name": "Name is required",
        "create-price-list-required-shops": "You must attach the price list to one or more shops",
        "create-price-list-required-price-adjustment": "Price adjustment is required",
        "create-price-list-required-currency-code": "Currency is required",
        "create-price-list-required-percentage": "Percentage is required",
        "create-price-list-max-percentage":"Percentage cannot be more than 100",
        "create-or-edit-price-list-field-name":"\n .label = Name",
        "create-or-edit-price-list-field-shops":"\n .label = Shops",
        "create-or-edit-price-list-field-aside-settings":"\n .title = Settings",
        "create-or-edit-price-list-field-active":"Active:",
        "create-or-edit-price-list-field-message-to-customers":"\n .label = Message to customers",
        "create-or-edit-price-list-aside-pricing":"\n .title = Pricing",
        "create-or-edit-price-list-field-vat-code":"\n .label = VAT code",
        "create-or-edit-price-list-field-currency-code":"\n .label = Currency",
        "create-or-edit-price-list-field-dropdown-dkk":"DKK",
        "create-or-edit-price-list-field-price-adjustment":"\n .label = Price adjustment",
        "create-or-edit-price-list-field-dropdown-none":"None",
        "create-or-edit-price-list-field-dropdown-discount": "Discount",
        "create-or-edit-price-list-field-dropdown-increase": "Increase",
        "create-or-edit-price-list-field-internal-note":"\n .placeholder = Internal note",
        "create-or-edit-price-list-field-percentage":"Percentage (%):",
        "create-or-edit-price-list-customer-table-header-name":"Name",
        "create-or-edit-price-list-customer-table-header-user-group":"User group",
        "create-or-edit-price-list-customer-table-button-remove":"Remove",
        "create-or-edit-price-list-customer-table-button-details":"Details",
        "create-or-edit-price-list-customer-subtitle":"If no customers are added here, then all customers can access the price list.",
        "create-or-edit-price-list-customer-table-title":"Customers with access",
        "create-or-edit-price-list-customer-button-add-customer":"Add customer",
        "create-or-edit-price-list-customer-table-empty-state":"All customers have access",
        "create-or-edit-price-list-general-tab-error":"General tab has validation errors",
        "create-or-edit-price-list-customer-tab-error":"Customer tab has validation errors",
        "create-or-edit-price-list-products-tab-error":"Products tab has validation errors",
        "create-or-edit-price-list-pos-tab-error":"POS tab has validation errors",
        "create-or-edit-price-list-customer-table-add-customers-title":"Add customers",
        "create-or-edit-price-list-customer-table-add-button":"Add",
        "create-or-edit-price-list-products-table-title":"Products",
        "create-or-edit-price-list-products-table-header-name":"Name",
        "create-or-edit-price-list-products-table-header-product-no":"Product no.",
        "create-or-edit-price-list-products-table-header-normal-price":"Normal price",
        "create-or-edit-price-list-products-table-header-adjusted-price":"Adjusted price",
        "create-or-edit-price-list-products-table-header-status":"Status",
        "create-or-edit-price-list-products-table-status-active":"Active",
        "create-or-edit-price-list-products-table-status-inactive":"Inactive",
        "create-or-edit-price-list-pos-table-title":"ID card subscriptions",
        "create-or-edit-price-list-pos-info-description":"\n .description = One price list must be the default for the POS system. If an ID card is scanned and its subscription type is not assigned to a price list, the default price list will be shown.",
        "create-or-edit-price-list-pos-is-default-price-list":"Default price list",
        "create-or-edit-price-list-pos-table-type":"Type",
        "create-or-edit-price-list-pos-table-description":"Description",

        // Merchant > Admin > Shops > Shops
        "shops-page-header": "\n .title = Shops",
        "shops-table-case-column": "Case no.",
        "shops-table-name-column": "Name",
        "shops-table-type-column": "Type",
        "shops-table-status-column": "Status",
        "shops-table-status-column-active": "Active",
        "shops-table-status-column-inactive": "Inactive",
        "shops-table-status-column-demo": "Demo",
        "shops-table-status-column-active-filter-active": "Active",
        "shops-table-status-column-inactive-filter-inactive": "Inactive",
        "shops-table-status-column-demo-filter-demo": "Demo",
        "shops-table-create-button": "Create",
        "shops-table-menu-item-edit": "Edit",
        "shops-table-menu-item-delete": "Delete",
        "shops-confirm-delete-shop-dialog": "\n .typeOfEntity = shop",

        // Merchant > Admin > Shops > Shops > Create - Edit shop
        "merchant-shop-create-header": "\n .title = Create shop",
        "merchant-shop-edit-header": "\n .title = Edit shop",
        "merchant-shop-create-breadcrumb": "Create shop",
        "merchant-shop-edit-breadcrumb": "Edit shop",
        "merchant-shop-create-button": "Create",
        "merchant-shop-save-button": "Save",
        "merchant-create-edit-shop-tab-general": "General",
        "merchant-create-edit-shop-tab-settings": "Settings",
        "merchant-shop-form-field-name": "\n .label = Name \n .helperText = The shop name will be visible for your customers.",
        "merchant-shop-form-field-type": "\n .label = Type",
        "merchant-shop-form-field-type-helperText": "Select the type of shop.",
        "merchant-shop-form-field-type-mode-meeting-service": "Meeting service",
        "merchant-shop-form-field-type-mode-take-away": "Take away",
        "merchant-shop-form-field-type-mode-lunch": "GoPay",
        "merchant-shop-form-field-type-mode-pos": "POS",
        "merchant-shop-form-field-type-mode-subscription": "Subscription",
        "merchant-shop-form-hardware-packages": "Select hardware packages",
        "merchant-shop-form-hardware-packages-info": "\n .description = Selecting products below will not result in a purchase. You will subsequently receive an offer for hardware, which you can approve.",
        "merchant-shop-form-hardware-packages-tablet-size": "Tablet size:",
        "merchant-shop-form-hardware-packages-color": "Color:",
        "merchant-shop-form-payment-methods": "Available payment methods",
        "merchant-shop-form-make-shop-public": "\n .title = Public shop \n .offContent = This shop is only accessible to invited companies.",
        "merchant-shop-form-make-shop-public-info": "\n .description = A public shop is accessible to everyone.",
        "merchant-shop-form-make-shop-public-title": "Share the following with your customers",
        "merchant-shop-form-make-shop-public-description": "To pay as a guest, you must either scan a QR code or enter the shop number to access the shop. Read more about public shops <externalLink>here</externalLink>.",
        "merchant-shop-form-make-shop-public-number": "Shop number:",
        "merchant-shop-form-make-shop-public-url": "Direct public url:",
        "merchant-shop-form-make-shop-public-qr-code": "- or users can scan the following QR with their mobile phone",
        "merchant-shop-form-make-shop-public-offContent": "Save to see sharing details.",
        "merchant-shop-form-field-isVisibleForAppUsers": "\n .label = Make shop visible for internal users in GoPay mobile app",
        "merchant-shop-form-general": "\n .title = General",
        "merchant-shop-form-field-active": "Active:",
        "merchant-shop-form-field-demo": "Demo:",
        "merchant-shop-form-erp": "\n .title = ERP",
        "merchant-shop-form-field-case-number": "\n .label = Case number \n .helperText = The case number is used to import sales data into your organizations ERP.",
        "merchant-shop-form-internal-note": "\n .title = Internal note",
        "merchant-shop-form-field-internal-note": "\n .label = Internal note:",
        "merchant-shop-form-posDetails-defaultLanguage-field-label": "\n .label = Default language",
        "merchant-shop-form-posDetails-defaultLanguage-lang-en": "Engelsk",
        "merchant-shop-form-posDetails-defaultLanguage-lang-da": "Dansk",
        "merchant-shop-form-check-in": "Check in",
        "merchant-shop-form-check-in-qr-code-on-receipt": "Show check in QR code on receipt",
        "merchant-shop-form-accept-multiple-check-ins": "Accept multiple check ins",
        "merchant-shop-form-deadline": "\n .title = Deadline \n .offContent = Deadline not activated",
        "merchant-shop-form-purchases": "Purchases:",
        "merchant-shop-form-cancellation": "Cancellation:",
        "merchant-shop-form-deadline-day-field": "\n .label = Day",
        "merchant-shop-form-deadline-day-limit-day-before": "The day before",
        "merchant-shop-form-deadline-day-limit-x-days-before": "{ $daysBefore } days before",
        "merchant-shop-form-deadline-time-picker": "\n .label = Time",
        "merchant-shop-form-posDetails-configuration-for-supporters": "\n .title = Configuration for supporters",
        "merchant-shop-form-posDetails-configuration-for-supporters-returnToHomeScreenDelay-field-label": "\n .label = Return to home screen delay",
        "merchant-shop-form-posDetails-configuration-for-supporters-returnToHomeAfterPurchase-field-label": "\n .label = Return to home after purchase",
        "merchant-shop-form-posDetails-configuration-for-supporters-ms": "ms",

        // Merchant > Admin > Shops > Offers
        "offers-page-header": "\n .title = Offers",
        "offers-table-name-column": "Product name",
        "offers-table-price-column": "Normal price",
        "offers-table-discount-price-column": "Discount price",
        "offers-table-valid-from-column": "Valid from",
        "offers-table-expires-column": "Expires",
        "offers-table-status-column": "Status",
        "offers-table-edit-menu-item": "Edit",
        "offers-table-remove-offer-menu-item": "Remove offer",


        // Merchant > Admin > Shops > VAT Codes
        "merchant-vat-codes-header": "\n .title = VAT codes",
        "merchant-vat-codes-create-button": "Create",
        "merchant-vat-codes-save-button": "Save",
        "merchant-vat-codes-delete-entity-dialog": "\n .typeOfEntity = VAT code",
        "merchant-vat-codes-table-header-vat-code":"VAT code",
        "merchant-vat-codes-table-header-name":"Name",
        "merchant-vat-codes-table-header-percentage":"Percentage",
        "merchant-vat-codes-table-button-edit":"Edit",
        "merchant-vat-codes-table-button-delete":"Delete",

        // Merchant > Admin > Shops > Create/Edit VAT Codes
        "merchant-vat-codes-create-header": "\n .title = Create VAT code",
        "merchant-vat-codes-edit-header": "\n .title = Edit Create VAT code",
        "merchant-vat-codes-create-edit-field-code":"\n .label = Code(*)",
        "merchant-vat-codes-create-edit-field-name":"\n .label = Name(*)",
        "merchant-vat-codes-create-edit-vat-percentage-amount":"\n .label = VAT percentage(*)",
        "merchant-vat-codes-create-edit-required-name": "Name is required",
        "merchant-vat-codes-create-edit-required-code": "Code is required",
        "merchant-vat-codes-create-edit-required-vat-percentage-amount": "VAT percentage is required",
        "merchant-vat-codes-create-edit-type-error-vat-percentage-amount": "VAT percentage must be a number",

        // Merchant > Admin > Shops > Delivery locations
        "merchant-delivery-locations-header": "\n .title = Delivery locations",
        "merchant-delivery-locations-create-button-link": "Create delivery location",
        "merchant-delivery-locations-delete-entity-dialog": "\n .typeOfEntity = delivery location",
        "merchant-delivery-locations-table-header-name": "Name",
        "merchant-delivery-locations-table-header-status": "Status",
        "merchant-delivery-locations-table-active-column-active": "Active",
        "merchant-delivery-locations-table-active-column-inactive": "Inactive",
        "merchant-delivery-locations-table-active-column-active-filter-yes": "Active",
        "merchant-delivery-locations-table-active-column-inactive-filter-no": "Inactive",
        "merchant-delivery-locations-table-button-edit": "Edit",
        "merchant-delivery-locations-table-button-delete": "Delete",

        // Merchant > Admin > Shops > Delivery locations
        "merchant-delivery-location-create-header": "\n .title = Create delivery location",
        "merchant-delivery-location-edit-header": "\n .title = Edit delivery location",
        "merchant-delivery-location-create-breadcrumb": "Create delivery location",
        "merchant-delivery-location-edit-breadcrumb": "Edit delivery location",
        "merchant-delivery-location-form-field-name": "\n .label = Name *",
        "merchant-delivery-location-form-start-time-picker": "\n .label = From time",
        "merchant-delivery-location-form-end-time-picker": "\n .label = End time",
        "merchant-delivery-location-form-end-time-picker-min-error-label": "Should be greater than 'From time'",
        "merchant-delivery-location-form-settings": "\n .title = Settings",
        "merchant-delivery-location-form-field-active": "Active:",
        "merchant-delivery-locations-create-button": "Create",
        "merchant-delivery-locations-save-button": "Save",

        // Merchant > Admin > Shops > Payment links
        "payment-links-page-header": "\n .title = Payment links",
        "payment-links-table-name-column": "Name",
        "payment-links-table-shop-column": "Shop",
        "payment-links-table-valid-from-column": "Valid from",
        "payment-links-table-valid-to-column": "Valid to",
        "payment-links-table-create-button": "Create new",
        "payment-links-table-menu-item-edit": "Edit",
        "payment-links-table-menu-item-delete": "Delete",
        "payment-links-confirm-delete-dialog": "\n .typeOfEntity = payment links",

        // Merchant > Admin > Shops > Payment links > Create / Edit
        "payment-links-create-page-header": "\n .title = Create payment link",
        "payment-links-create-page": "Create payment link",
        "payment-links-form-create-submit-button": "Create",
        "payment-links-edit-page-header": "\n .title = Edit payment link",
        "payment-links-edit-page": "Edit payment link",
        "payment-links-form-edit-submit-button": "Save",
        "payment-links-form-public-title-label": "\n .label = Title *",
        "payment-links-form-description-label": "\n .label = Description",
        "payment-links-form-public-shop-field-label": "\n .label = Public shop *",
        "payment-links-form-sales-account-field-label": "\n .label = Sales account",
        "payment-links-form-hasPasswordProtection-switch": "Password protected",
        "payment-links-form-password-field-label": "\n .label = Password \n .helperText = Protect your link with a password if the shop supports invoicing as a payment method.",
        "payment-links-form-general-panel": "\n .title = General",
        "payment-links-form-active-switch": "Active:",
        "payment-links-form-availability-panel": "\n .title = Validity period \n .offContent = Valid indefinitely",
        "payment-links-form-availability-from-date-picker": "\n .label = Start date",
        "payment-links-form-availability-to-date-picker": "\n .label = End date",
        "payment-links-form-availability-error-picker": "Start date and End date must be filled in",

        // Merchant > Admin > Setting > Sales accounts
        "sales-accounts-page-header": "\n .title = Sales accounts",
        "sales-accounts-table-name-column": "Name",
        "sales-accounts-table-number-column": "Number",
        "sales-accounts-table-create-button": "Create new",
        "sales-accounts-table-menu-item-edit": "Edit",
        "sales-accounts-table-menu-item-delete": "Delete",
        "sales-accounts-confirm-delete-dialog": "\n .typeOfEntity = sales accounts",

        // Merchant > Admin > Setting > Sales accounts > Create / Edit
        "sales-accounts-create-page-header": "\n .title = Create sales account",
        "sales-accounts-create-page": "Create sales account",
        "sales-accounts-form-create-submit-button": "Create",
        "sales-accounts-edit-page-header": "\n .title = Edit sales account",
        "sales-accounts-edit-page": "Edit sales account",
        "sales-accounts-form-edit-submit-button": "Save",
        "sales-accounts-form-public-name-label": "\n .label = Name * \n .placeholder = Enter a name for the sales account",
        "sales-accounts-form-number-label": "\n .label = Number * \n .placeholder = Enter account number from ERP system",
        "sales-accounts-form-general-panel": "\n .title = General",
        "sales-accounts-form-active-switch": "Active:",

        // ADMIN DEVICES
        "merchant-admin-devices-page-header": "\n .title = Devices",
        // Merchant users
        "merchant-admin-users-create-admin-button": "Create administrator",
        "merchant-admin-users-page-title": "\n .title = Administrators",


        // --- Supplier ---

        // Supplier > Navigation
        "supplier-nav-item-home": "Home",
        "supplier-nav-item-accounting-title": "\n .title = Accounting",
        "supplier-nav-item-accounting": "Accounting",
        "supplier-nav-item-pos": "POS",
        "supplier-nav-item-meeting-service": "Meeting service",
        "supplier-nav-item-subscriptions": "Subscriptions",
        "supplier-nav-item-z-reports": "Z-reports",
        "supplier-nav-item-merchant-sales": "Merchant sales",
        "supplier-nav-item-customer-sales": "Customer sales",
        "supplier-nav-item-balance": "Balance",

        // Supplier > Navigation > Reports
        "supplier-nav-item-merchant-access": "Merchant Access",

        // Supplier > Navigation > Admin
        "supplier-nav-item-merchants-page-header":"\n .title = Merchants",
        "supplier-nav-item-settings-page-header":"\n .title = Settings",
        "supplier-nav-item-account-page-header":"\n .title = Account",
        "supplier-nav-item-erp-page-header":"\n .title = ERP",
        "supplier-nav-item-acquiring-reports-page-header":"\n .title = Reconciliation",
        "supplier-admin-nav-item-merchants": "Merchants",
        "supplier-admin-nav-item-merchants-create": "Create merchant",
        "supplier-admin-nav-item-merchants-edit": "Edit merchant",
        "supplier-admin-nav-item-administrators": "Administrators",
        "supplier-admin-nav-item-admins": "Administrators",
        "supplier-admin-nav-item-devices": "Devices",
        "supplier-admin-nav-item-settings": "Settings",
        "supplier-admin-nav-item-acquiring": "Payment acquiring",
        "supplier-admin-nav-item-terms-and-conditions": "Terms and conditions",
        "supplier-admin-nav-item-pos-settings":"POS settings",
        "supplier-admin-nav-item-pos-settings-template-create": "Create template",
        "supplier-admin-nav-item-pos-settings-template-edit": "Edit template",
        "supplier-admin-nav-item-company-account":"Company account",
        "supplier-admin-nav-item-account-gdpr":"GDPR",
        "supplier-admin-nav-item-erp":"ERP",
        "supplier-admin-nav-item-acquiring-fees": "Acquiring fees",
        "supplier-admin-nav-item-bank-transfers":"Bank transfers",
        "supplier-admin-nav-item-product-numbers":"Product numbers",
        "supplier-admin-nav-item-create-product-group-number":"Create product number",
        "supplier-admin-nav-item-update-product-group-number":"Update product number",
        "supplier-admin-nav-item-create-terms-and-conditions": "Create terms and conditions",
        "supplier-admin-nav-item-update-terms-and-conditions": "Update terms and conditions",

        // Supplier > Reports > Home

        // Supplier > Reports > Home > Accounting > Meeting Service
        "supplier-meeting-service-header": "\n .title = Meeting Service",
        "supplier-meeting-service-table-merchant": "Merchant",
        "supplier-meeting-service-table-order-id-column": "Order ID",
        "supplier-meeting-service-order-id-label": "\n .label = Order ID",
        "supplier-meeting-service-table-booked-date-column": "Booked date",
        "supplier-meeting-service-table-delivery-time-column": "Delivery time",
        "supplier-meeting-service-table-employee-column": "Merchant",
        "supplier-meeting-service-table-status":"Status",
        "supplier-meeting-service-table-status-confirmed":"Confirmed",
        "supplier-meeting-service-table-status-canceled":"Canceled",
        "supplier-meeting-service-table-amount-column": "Amount (DKK)",
        "supplier-meeting-service-table-show-receipt": "Show receipt",
        "supplier-meeting-service-table-floating-action-bar-receipts": "\n .title = Receipts",
        "supplier-meeting-service-table-floating-action-bar-export": "\n .title = Export",
        "supplier-meeting-service-order-title":"\n .title = Order",
        "supplier-meeting-service-drawer-pending-approval-label":"\n .label = Pending approval",
        "supplier-meeting-service-invoicing-title":"\n .title = Invoicing",
        "supplier-meeting-service-drawer-invoice-status-label":" Invoice status",
        "supplier-meeting-service-drawer-invoice-status-all-label":"All",
        "supplier-meeting-service-drawer-invoice-status-sent-label":"Sent",
        "supplier-meeting-service-drawer-invoice-status-not-sent-label":"Not sent",
        "supplier-meeting-service-drawer-booked-label":"Booked",
        "supplier-meeting-service-drawer-booked-all-label":"All",
        "supplier-meeting-service-drawer-booked-booked-label":"Booked",
        "supplier-meeting-service-drawer-booked-not-booked-label":"Not booked",
        "supplier-meeting-service-booked-date-title":"\n .title = Booked date",
        "supplier-meeting-service-delivery-date-title":"\n .title = Delivery date",
        "supplier-meeting-service-merchant-title":"\n .title = Merchant",
        "supplier-meeting-service-debtor-title":"\n .title = Debtor",
        "supplier-meeting-service-end-user-title":"\n .title = End User",
        "supplier-meeting-service-payment-title":"\n .title = Payment",
        "supplier-meeting-service-drawer-from-date-label":"\n .label = From date",
        "supplier-meeting-service-drawer-to-date-label":"\n .label = To date",
        "supplier-meeting-service-drawer-bill-receivers-label":"Bill receivers",
        "supplier-meeting-service-drawer-satellites-label":"Satellites",
        "supplier-meeting-service-drawer-to-date-info-label":"\n .title = Do not use delivery date for invoicing. Use booking date instead.",

        // Supplier > Reports > Home > Accounting > POS
        "supplier-pos-table-header-title": "\n .title = POS",
        "supplier-pos-table-header-order-id": "Order ID",
        "supplier-pos-table-header-transaction-time": "Transaction time",
        "supplier-pos-table-header-merchant-name": "Merchant name",
        "supplier-pos-table-header-employee": "Creator",
        "supplier-pos-table-header-payment": "Payment method",
        "supplier-pos-table-header-payment-channel": "Channel",
        "supplier-pos-table-header-amount": "Amount (DKK)",
        "supplier-pos-table-table-button-show-receipt": "Show receipt",
        "supplier-pos-table-filters-order-title":"\n .title = Order",
        "supplier-pos-table-filters-period-title":"\n .title = Period",
        "supplier-pos-table-filters-merchant-title":"\n .title = Merchant",
        "supplier-pos-table-filters-debtor-title":"\n .title = Debtor",
        "supplier-pos-table-filters-end-user-title":"\n .title = End user",
        "supplier-pos-table-filters-payment-title":"\n .title = Payment",
        "supplier-pos-table-filters-from-date-label":"\n .label = Transaction from date",
        "supplier-pos-table-filters-to-date-label":"\n .label = Transaction to date",

        // Supplier > Reports > Home > Accounting > Subscriptions
        "supplier-subscriptions-header": "\n .title = Subscriptions",
        "supplier-subscriptions-table-order-id-column": "Order ID",
        "supplier-subscriptions-table-employee-column": "Employee",
        "supplier-subscriptions-table-subscribed-column": "Subscribed",
        "supplier-subscriptions-table-unsubscribed-column": "Unsubscribed",
        "supplier-subscriptions-table-payment-column": "Payment method",
        "supplier-subscriptions-table-amount-column": "Amount",
        "supplier-subscriptions-table-cancel-subscription": "Cancel subscription",
        "supplier-subscriptions-table-details": "Details",
        "supplier-subscriptions-table-filters-order-title":"\n .title = Order",
        "supplier-subscriptions-table-filters-period-title":"\n .title = Period",
        "supplier-subscriptions-table-filters-from-date-label":"\n .label = Valid from date",
        "supplier-subscriptions-table-filters-to-date-label":"\n .label = Valid to date",
        "supplier-subscriptions-table-filters-merchant-title":"\n .title = Merchant",
        "supplier-subscriptions-table-filters-debtor-title":"\n .title = Debtor",
        "supplier-subscriptions-table-filters-end-user-title":"\n .title = End user",
        "supplier-subscriptions-table-filters-payment-title":"\n .title = Payment",
        "supplier-subscriptions-drawer-subscription-label":"Subscription",


        // Supplier > Reports > Home > Accounting > Z-reports
        "supplier-accounting-z-reports-page-header":" \n .title = Z-reports",
        "supplier-accounting-z-reports-table-date-column":"Date",
        "supplier-accounting-z-reports-table-pos-terminal-column":"POS device",
        "supplier-accounting-z-reports-table-amount-column":"Amount",

        // Supplier > Reports > Home > Accounting > Merchant Sales
        "supplier-merchant-sales-header": "\n .title = Merchant sales",
        "supplier-merchant-sales-table-shop-type": "\n .label = Shop Type",
        "supplier-merchant-sales-table-red-no-column": "Case no.",
        "supplier-merchant-sales-table-name-column": "Name",
        "supplier-merchant-sales-table-upcoming-sales-column": "Upcoming sales ({ $currencyCode })",
        "supplier-merchant-sales-table-booked-sales-column": "Booked sales ({ $currencyCode })",
        "supplier-merchant-sales-table-floating-action-bar-export": "\n .title = Export",
        "supplier-merchant-sales-table-shop-type-input-label": "Shop type",
        "supplier-merchant-sales-table-shop-type-item-pos": "POS",
        "supplier-merchant-sales-table-shop-type-item-meeting-service": "Meeting service",
        "supplier-merchant-sales-table-shop-type-item-subscription": "Subscription",
        "supplier-merchant-sales-detailed-table-total-footer-column": "Total",
        "supplier-merchant-sales-detailed-table-sales-column": "Sales (DKK)",

        // Supplier > Reports > Home > Accounting > Customer Sales
        "supplier-customer-sales-header": "\n .title = Customer sales",
        "supplier-customer-sales-table-name-column": "Name",
        "supplier-customer-sales-table-upcoming-sales-column": "Upcoming sales ({ $currencyCode })",
        "supplier-customer-sales-table-booked-sales-column": "Booked sales ({ $currencyCode })",
        "supplier-customer-sales-table-floating-action-bar-export": "\n .title = Export",
        "supplier-customer-sales-detailed-table-total-footer-column": "Total",
        "supplier-customer-sales-detailed-table-sales-column": "Sales (DKK)",


        // Supplier > Admin > Home
        "supplier-admin-home-merchants-group": "\n .title = Merchants",
        "supplier-admin-home-merchant-card": "\n .title = Merchants\n .description = Manage merchants, which are physical sales locations.",
        "supplier-admin-home-administrators-card": "\n .title = Administrators\n .description = Manage supplier and merchant administrators.",
        "supplier-admin-home-devices-card": "\n .title = Devices\n .description = Manage devices, such as POS tablets, check-in screens and printers.",
        "supplier-admin-home-settings-group": "\n .title = Settings",
        "supplier-admin-home-payment-acquiring-card": "\n .title = Payment acquiring\n .description = Manage and check status of credit card acquiring agreements.\n .buttonText = Show",
        "supplier-admin-home-terms-and-conditions-card": "\n .title = Terms and conditions\n .description = Manage your sales terms and conditions towards your customers.",
        "supplier-admin-home-pos-settings-card": "\n .title = POS settings \n .description = Manage POS settings.",
        "supplier-admin-home-account-group":  "\n .title = Account",
        "supplier-admin-home-company-account-card":  "\n .title = Company account\n .description = Manage your company account.\n .buttonText = Show",
        "supplier-admin-home-erp-group":  "\n .title = ERP",
        "supplier-admin-home-product-numbers-card":  "\n .title = Product numbers\n .description = Manage product numbers for ERP integration.",
        "supplier-admin-home-account-gdpr-card":  "\n .title = GDPR \n .description = General Data Protection Regulation \n .buttonText = Show",
        "supplier-admin-home-acquiring-reports-group":  "\n .title = Reconciliation",
        "supplier-admin-home-bank-transfers-card":  "\n .title = Bank transfers\n .description = Report showing transfers between your acquiring accounts and bank accounts.\n .buttonText = Show",
        "supplier-admin-home-acquiring-fees":  "\n .title = Acquiring fees\n .description = Report showing fees for acquiring. Useful for reconciliation.\n .buttonText = Show",
        "supplier-admin-home-balance":  "\n .title = Balance\n .description = Report showing total sales, fees and transfers for a period.\n .buttonText = Show",

        // Supplier > Admin > Devices
        "supplier-admin-devices-page-header": "\n .title = Devices",

        // Supplier > Admin > ERP > Product Group Numbers
        "supplier-admin-erp-product-group-numbers-header": "\n .title = Product numbers",
        "supplier-admin-erp-product-group-numbers-create-new-button":"Create New",
        "supplier-admin-erp-product-group-numbers-save-button":"Save",
        "supplier-admin-erp-product-group-numbers-table-header-erp-number":"ERP no.",
        "supplier-admin-erp-product-group-numbers-table-header-name":"Name",
        "supplier-admin-erp-product-group-numbers-table-header-status":"Status",
        "supplier-admin-erp-product-group-numbers-table-active-column-active":"Active",
        "supplier-admin-erp-product-group-numbers-table-active-column-inactive":"Inactive",
        "supplier-admin-erp-product-group-numbers-table-active-filter-yes":"Active",
        "supplier-admin-erp-product-group-numbers-table-active-filter-no":"Inactive",
        "supplier-admin-erp-product-group-numbers-table-button-edit":"Edit",
        "supplier-admin-erp-product-group-numbers-table-button-delete":"Delete",
        "supplier-admin-erp-product-group-numbers-delete-entity-dialog":"\n .typeOfEntity = Product numbers",

        // Supplier > Admin > ERP > Product Group Numbers > Create/Update
        "supplier-admin-erp-product-group-numbers-create-header": "\n .title = Create product number",
        "supplier-admin-erp-product-group-numbers-update-header": "\n .title = Edit product number",
        "supplier-admin-erp-product-group-numbers-create-button":"Create",
        "supplier-admin-erp-product-group-numbers-field-code":"\n .label = ERP number *",
        "supplier-admin-erp-product-group-numbers-field-name":"\n .label = Name *",
        "supplier-admin-erp-product-group-numbers-description":"\n .label = Description\n .placeholder = Here you can explain intended usage of this product number",
        "supplier-admin-erp-product-group-numbers-required-code":"ERP number is required",
        "supplier-admin-erp-product-group-numbers-required-name":"Name is required",
        "supplier-admin-erp-product-group-numbers-aside-settings":"\n .title = Settings",
        "supplier-admin-erp-product-group-numbers-active":"Active:",
        "supplier-admin-erp-product-group-numbers-history":"\n .title = History",
        "supplier-admin-erp-product-group-numbers-aside-created":"Created:",
        "supplier-admin-erp-product-group-numbers-aside-updated":"Updated:",

        // DEVICE TABLE GENERAL
        "devices-table-header-name": "Name",
        "devices-table-header-group": "Group",
        "devices-table-header-type": "Type",
        "devices-table-header-status": "Status",
        "devices-table-button-details": "Details",
        "devices-table-button-edit": "Edit",
        "devices-table-status-column-online": "Online",
        "devices-table-status-column-offline": "Offline",
        "devices-table-header-reg": "Reg. no.",
        "devices-table-header-merchant": "Merchant",

        // DEVICE DETAILS
        "device-details-title": "Device details",
        "device-details-type-info-shop": "\n .label = Shop:",
        "device-details-type-info-device-number": "\n .label = Device number:",
        "device-details-type-info-serial-number": "\n .label = Serial number:",
        "device-details-type-info-hardware-id": "\n .label = Hardware-ID:",
        "device-details-type-info-language": "\n .label = Language:",
        "device-details-type-info-pos-mode": "\n .label = POS mode:",
        "device-details-type-info-card-terminal-acquirer-name": "\n .label = Card terminal acquirer name:",
        "device-details-status-info-title": "\n .title = Status",
        "device-details-status-info-diagnostics-title": "\n .title = Show diagnostics",
        "device-details-status-info-diagnostics-subject": "Subject",
        "device-details-status-info-diagnostics-message": "Message",
        "device-details-pin-code-info-title": "\n .title = PIN Code",
        "device-details-pin-code-info-helper": "\n .title = PIN code: \n .description = Helper: It is a long established fact that a reader will be distracted",
        "device-details-group-info-title": "\n .title = Group",
        "device-details-group-info-name": "\n .label = Name:",
        "device-details-group-info-connected-devices": "\n .title = Connected devices",
        "device-details-group-table-header-name": "Name",
        "device-details-group-table-header-type": "Type",
        "device-details-group-table-header-status": "Status",
        "device-details-device-info-title": "\n .title = Device",
        "device-details-device-info-name": "\n .label = Name:",
        "device-details-device-info-shop": "\n .label = Shop:",
        "device-details-device-info-device-number": "\n .label = Device number:",
        "device-details-identification-info-title": "\n .title = Identification",
        "device-details-identification-info-serial-number": "\n .label = Serial number:",
        "device-details-identification-info-hardware-id": "\n .label = Hardware ID:",
        "device-details-identification-info-acquirer": "\n .label = Card terminal acquirer name:",
        "device-details-settings-info-title": "\n .title = Settings",
        "device-details-settings-info-language": "\n .label = Language:",
        "device-details-settings-info-pos-mode": "\n .label = POS mode:",
        "device-details-settings-info-pin-code-info": "PIN code is used to enter protected areas in the app.",
        "device-details-history-info-title": "\n .title = History",
        "device-details-history-info-created": "\n .label = Created:",
        "device-details-history-info-edited": "\n .label = Edited:",
        "device-details-type-mode-cloud-pos": "GoPay CloudPOS",
        "device-details-type-mode-soft-pos": "GoPay SoftPOS",
        "device-details-type-mode-display": "Display",
        "device-details-type-mode-cloud-credit-card-reader": "Cloud Printer",
        "device-details-type-mode-star-cloud-printer": "Cloud Credit Card Reader",
        "device-details-type-mode-receipt-control": "Receipt Control",
        "device-details-group-table-device-type-filter-label": "Device Type",
        "device-details-group-table-device-type-filter-label-label": "\n .label = Device Type",
        "devices-table-select-filter-on-item-room-display": "Room display",
        "devices-table-select-filter-on-item-meeting-display": "Meeting display",
        "devices-table-select-filter-on-item-guest-check-in": "Guest check in",


        // Create or edit device
        "service-center-admin-organization-create-devices-title": "\n .title = Create display",
        "service-center-admin-organization-edit-devices-title": "\n .title = Edit display",
        "devices-create-device-form": "Create",
        "devices-edit-device-form": "Save",
        "devices-edit-breadcrumb": "Edit display",
        "devices-create-breadcrumb": "Create display",
        "devices-create-or-edit-form-select-template-label": "\n .label = Template *",
        "devices-create-or-edit-form-select-field-name": "Name",
        "devices-create-or-edit-form-select-field-device-number": "Device number { $required }",
        "devices-create-or-edit-form-floor-label": "\n .label = Floor",
        "devices-create-or-edit-form-select-field-room": "\n .label = Room *",
        "devices-create-or-edit-form-select-field-serial-number": "Serial number",
        "devices-create-or-edit-form-select-display-type": "\n .label = Display type",
        "devices-create-or-edit-form-type-room-details-info": "\n .title = Room displays are put up in front of meeting rooms to show if the room is currently available or occupied. It also offers a convenient way to book the room.",
        "devices-create-or-edit-form-type-meeting-details-info": "\n .title = Meeting displays are typically put up on each floor and are designed to let people now where to go for their meeting.",

        "devices-create-or-edit-form-display-type-dropdown-item-room-display": "Room display",
        "devices-create-or-edit-form-display-type-dropdown-item-meeting-display": "Meeting display",
        "devices-create-or-edit-form-display-type-dropdown-item-guest-check-in": "Guest check in",

        // Display types
        "display-types-dropdown-select-item-room-display": "Room display",

        // Supplier > Admin > POS settings
        "supplier-admin-pos-settings-page-header": "\n .title = POS settings",
        "supplier-admin-pos-settings-tab-templates": "Templates",
        "supplier-admin-pos-settings-tab-general": "General",
        "supplier-admin-pos-settings-create-button": "Create",
        "supplier-admin-pos-settings-templates-table-header-name": "Name",
        "supplier-admin-pos-settings-templates-table-header-language": "Language",
        "supplier-admin-pos-settings-templates-table-header-status": "Status",
        "supplier-admin-pos-settings-templates-table-edit-button": "Edit",
        "supplier-admin-pos-settings-templates-table-duplicate-button": "Duplicate",
        "supplier-admin-pos-settings-templates-table-delete-button": "Delete",
        "supplier-admin-pos-settings-templates-table-status-column-active":"In use",
        "supplier-admin-pos-settings-templates-table-status-column-inactive":"Not in use",
        "supplier-admin-pos-settings-templates-table-status-column-active-filter-yes": "In use",
        "supplier-admin-pos-settings-templates-table-status-column-inactive-filter-no": "Not in use",

        // Supplier > Admin > POS settings > Templates > Create / Edit
        "supplier-admin-pos-settings-create-template-page-header": "\n .title = Create template",
        "supplier-admin-pos-settings-edit-template-page-header": "\n .title = Edit template",
        "supplier-admin-pos-settings-create-submit-button": "Create",
        "supplier-admin-pos-settings-edit-submit-button": "Save",
        "supplier-admin-pos-settings-template-shortcuts": "\n .title = Shortcuts",
        "supplier-admin-pos-settings-template-name-field-label": "\n .label = Template name",
        "supplier-admin-pos-settings-template-languageCode-field-label": "\n .label = Language",
        "supplier-admin-pos-settings-lang-en": "English",
        "supplier-admin-pos-settings-lang-da": "Danish",
        "supplier-admin-pos-settings-template-button-field-label": "\n .label = Button text \n .helperText = Customize the text of the start purchase button.",
        "supplier-admin-pos-settings-template-title-field-label": "\n .label = Title",
        "supplier-admin-pos-settings-template-subtitle-field-label": "\n .label = Subtitle",
        "supplier-admin-pos-settings-template-companyLogo-field-label": "\n .label = Upload company logo:",
        "supplier-admin-pos-settings-template-companyLogo-info": "Image hints: background should be transparent. We recommend using a 180x180 px image with logo centered inside.",
        "supplier-admin-pos-settings-template-shortcuts-help-field": "Help / terms and conditions:",
        "supplier-admin-pos-settings-template-shortcuts-downloadApp-field": "Download GoPay app:",
        "supplier-admin-pos-settings-template-frontpage-layout": "Frontpage layout",
        "supplier-admin-pos-settings-template-select-theme-style": "Select theme style:",

        // Supplier > Admin > POS settings > General
        "supplier-admin-pos-settings-general-submit-button": "Save",
        "supplier-admin-pos-settings-general-defaultLanguage-field-label": "\n .label = Default language \n .helperText = Can be adjusted on each device.",
        "supplier-admin-pos-settings-general-posPrintingMode-field-label": "\n .label = Receipt print mode",
        "supplier-admin-pos-settings-general-posPrintingMode-option-qr-only": "QR code only",
        "supplier-admin-pos-settings-general-posPrintingMode-option-auto": "Automatic print",
        "supplier-admin-pos-settings-general-posPrintingMode-option-manually": "Manual print",
        "supplier-admin-pos-settings-general-info": "The print mode controls how the receipt is made available to the customer. “Automatic print” will print a paper receipt automatically whereas “Manual print” allows the user to print paper receipt or scan QR code to get a digital receipt. Choose “QR code only” if you want a paperless POS system.",
        "supplier-admin-pos-settings-general-configuration-for-supporters": "Configuration for supporters",
        "supplier-admin-pos-settings-general-configuration-for-supporters-returnToHomeScreenDelay-field-label": "\n .label = Return to home screen delay",
        "supplier-admin-pos-settings-general-configuration-for-supporters-returnToHomeAfterPurchase-field-label": "\n .label = Return to home after purchase",
        "supplier-admin-pos-settings-general-configuration-for-supporters-ms": "ms",

        // Supplier > Admin > Merchant Access
        "supplier-merchant-access-page-header": "\n .title = Merchant Access",
        "supplier-merchant-access-table-header-case-no": "Case No.",
        "supplier-merchant-access-table-header-name": "Name",
        "supplier-merchant-access-table-header-address": "Address",
        "supplier-merchant-access-table-details-no-companies": "There are no connected companies",
        "supplier-merchant-access-table-details-customers-title":"Customers:",

        // Supplier > Admin > Acquiring
        "supplier-admin-pos-acquirer-page-header": "\n .title = Payment acquiring agreement",
        "supplier-admin-pos-acquirer-adyen-question":"Who is Adyen?",
        "supplier-admin-pos-acquirer-adyen-answer":"Adyen is our credit card payment company with the status of an acquiring bank that allows you to accept credit card payments. Adyen is responsible for processing payments for your company. Before you can start accepting payment cards you must apply for an agreement with Adyen.",
        "supplier-admin-pos-acquirer-adyen-read-more":"Read more: <externalLink>{ $adyenWebsite }</externalLink>",
        "supplier-admin-pos-acquirer-status-title":"Status:",
        "supplier-admin-pos-acquirer-status-create-business-lines": "No industry codes",
        "supplier-admin-pos-acquirer-status-info-create-business-lines": "You need to select your lines of business before applying.",
        "supplier-admin-pos-acquirer-status-action-create-business-lines": "Please add one or more industry codes below.",
        "supplier-admin-pos-acquirer-status-start": "Start application",
        "supplier-admin-pos-acquirer-status-info-start": "You are now ready to begin the application with the acquirer.",
        "supplier-admin-pos-acquirer-status-action-start": "Start application below.",
        "supplier-admin-pos-acquirer-status-pending": "Pending",
        "supplier-admin-pos-acquirer-status-info-pending": "Verification is in progress.",
        "supplier-admin-pos-acquirer-status-action-pending": "Please wait for acquirer to verify your application.",
        "supplier-admin-pos-acquirer-status-invalid": "Invalid",
        "supplier-admin-pos-acquirer-status-info-invalid": "There are errors in the data provided.",
        "supplier-admin-pos-acquirer-status-action-invalid": "Please correct your application.",
        "supplier-admin-pos-acquirer-status-valid": "Approved",
        "supplier-admin-pos-acquirer-status-info-valid": "Your application has been approved.",
        "supplier-admin-pos-acquirer-status-check-valid":"You are  now ready to setup credit card payments for your merchants.",
        "supplier-admin-pos-acquirer-status-rejected": "Rejected",
        "supplier-admin-pos-acquirer-status-info-rejected": "Acquirer has verified the information, but has found reasons to refuse working with your entity.",
        "supplier-admin-pos-acquirer-start-application-button": "Start application at Adyen",
        "supplier-admin-pos-acquirer-continue-application-button": "Continue the  application at Adyen",
        "supplier-admin-pos-acquirer-status-no-payment-title": "You have no payment acquiring agreement.",
        "supplier-admin-pos-acquirer-status-no-payment-error": "No acquirers available",
        "supplier-admin-acquiring-terms-and-conditions-title": "Requirements for terms and conditions",
        "supplier-admin-acquiring-terms-and-conditions-explanation": "To proceed, you must agree to the acquirer's requirements for your <requirementsLink>Terms and Conditions of Sale</requirementsLink>. These terms and conditions must be clearly visible for your customers on your website.",
        "supplier-admin-acquiring-terms-and-conditions-template-text": "You can download our Terms and Conditions template <templateLink>here</templateLink>.",
        "supplier-admin-acquiring-terms-and-conditions-label": "\n .label = I agree to fulfill these requirements.",
        "supplier-admin-acquiring-accept-terms-dialog-title": "Accept Requirements for T&C",
        "supplier-admin-acquiring-accept-terms-dialog-description": "Are you sure you want to accept the requirements for the terms and conditions?",
        "supplier-admin-acquiring-accept-terms-dialog-button": "Accept",
        "supplier-acquiring-industry-codes-accordion-industry-codes-title": "Industry codes",
        "supplier-acquiring-industry-codes-accordion-industry-codes-info-box": "\n .description = If you apply for a canteen, select industry code 722514 - cafeterias, grill buffets.",
        "supplier-acquiring-industry-codes-table-industry-code-column": "Industry code",
        "supplier-acquiring-industry-codes-table-description-column": "Description",
        "supplier-acquiring-industry-codes-table-remove-action": "Remove",
        "supplier-acquiring-industry-codes-add-industry-code": "Add new industry code",
        "supplier-acquiring-industry-codes-info-text": "The industry codes describes your lines of business and determines what products you are allowed to sell in your shops. Some industry codes require approval from the acquirer. See all industry codes <industryCodesLink>here</industryCodesLink>.",
        "supplier-acquiring-industry-codes-confirm-delete-dialog": "\n .title = Remove industry code\n .message = Do you wish to remove the industry code { $industryCode }?\n .buttonLabelSubmit = Remove",
        "supplier-acquiring-bank-accounts-accordion-bank-accounts-title": "Bank accounts",
        "supplier-acquiring-bank-accounts-table-bank-name-column": "Bank",
        "supplier-acquiring-bank-accounts-table-account-column": "Account",
        "supplier-acquiring-bank-accounts-table-merchant-caseno-column": "Case no.",
        "supplier-acquiring-bank-accounts-table-merchant-column": "Merchant",
        "supplier-acquiring-bank-accounts-table-status-column": "Status",
        "supplier-acquiring-bank-accounts-table-remove-action": "Remove",
        "supplier-acquiring-bank-accounts-add-bank-account": "Add new bank account",
        "supplier-acquiring-bank-accounts-info-text": "If you want sales to be transfered to a separate bank account for each merchant you can add the bank account here. See <guideLink>guide</guideLink> on how to add a new bank account on the Adyen platform and afterwards connect the bank account to your merchant.",
        "supplier-acquiring-bank-accounts-status-pending": "Pending",
        "supplier-acquiring-bank-accounts-status-invalid": "Invalid",
        "supplier-acquiring-bank-accounts-status-valid": "Valid",
        "supplier-acquiring-bank-accounts-status-rejected": "Rejected",
        "supplier-acquiring-bank-accounts-confirm-delete-dialog": "\n .title = Remove bank account\n .message = Do you wish to remove the bank account { $accountIdentifier }?\n .buttonLabelSubmit = Remove",
        "supplier-acquiring-industry-codes-button-add": "Add",
        "supplier-acquiring-industry-codes-button-save": "Save",
        "supplier-acquiring-industry-codes-alert-title": " Adding new industry codes might change your payment acquiring agreement status to pending if the acquirer needs to verify.",

       // Supplier > Admin > Reconciliation
       "supplier-acquiring-reports": "Reconciliation",
       "supplier-acquiring-reports-table-booked-time-column": "Booked time",
       "supplier-acquiring-reports-table-merchant-label": "\n .label = Merchant",
       "supplier-acquiring-reports-table-adyen-account-label": "\n .label = Adyen account",
       "supplier-acquiring-reports-table-merchant-column": "Merchant",
       "supplier-acquiring-reports-table-amount-column": "Amount",

       // Supplier > Admin > Reconciliation > Fees
       "supplier-acquiring-fees-header": "\n .title = Acquiring fees",
       "supplier-acquiring-fees": "Acquiring fees",
       "supplier-acquiring-fees-table-order-id-column": "Order ID",
       "supplier-acquiring-fees-table-psp-reference-column": "PSP Reference",
       "supplier-acquiring-fees-table-available-date-column": "Available date",
       "supplier-acquiring-fees-table-type-column": "Type",
       "supplier-acquiring-fees-table-select-filter-on-label": "Filter on",
       "supplier-acquiring-fees-table-select-filter-on-label-label": "\n .label = Filter on",
        "supplier-acquiring-fees-table-select-filter-on-item-booking-date": "Booking date",
        "supplier-acquiring-fees-table-select-filter-on-item-value-date": "Available date",
       "supplier-acquiring-fees-table-type-mode-payment": "Payment",
       "supplier-acquiring-fees-table-type-mode-transfer": "Transfer",
       "supplier-acquiring-fees-table-type-mode-refund": "Refund",
       "supplier-acquiring-fees-table-number-of-transactions": "\n .title = Number of transactions",
       "supplier-acquiring-fees-table-info-banner": "\n .description = Data for this report becomes available on the next day, so you cannot see transactions for today.",

       // Supplier > Admin > Reconciliation > Bank transfers
       "supplier-acquiring-bank-transfers-header": "\n .title = Bank transfers",
       "supplier-acquiring-bank-transfers": "Bank transfers",
       "supplier-acquiring-bank-transfers-table-transfer-id-column": "Transfer ID",
       "supplier-acquiring-bank-transfers-table-available-time-column": "Available time",
       "supplier-acquiring-bank-transfers-table-bank-account-column": "Bank account",
       "supplier-acquiring-bank-transfers-table-details-menu-item": "Details",
       "supplier-acquiring-bank-transfers-table-number-of-transfers": "\n .title = Number of transfers",
       "supplier-acquiring-bank-transfers-table-info-banner": "\n .description = Data for this report becomes available on the next day, so you cannot see bank transfers for today or future transfers.",
        "supplier-acquiring-bank-transfers-table-details-table-order-id-column": "Order ID",
        "supplier-acquiring-bank-transfers-table-details-table-psp-reference-column": "PSP Reference",
        "supplier-acquiring-bank-transfers-table-details-table-booked-column": "Booked",
        "supplier-acquiring-bank-transfers-table-details-table-available-column": "Available",
        "supplier-acquiring-bank-transfers-table-details-table-gross-column": "Gross",
        "supplier-acquiring-bank-transfers-table-details-table-net-column": "Net",
        "supplier-acquiring-bank-transfers-table-details-table-fee-column": "Fee",
        "supplier-acquiring-bank-transfers-details-dialog-title": "\n .dialogTitle = Transfer details\n .subtitle = Period: { $periodStart} - { $periodEnd }",
        "supplier-acquiring-bank-transfers-details-dialog-title-no-start-date": "Agreement start",
        "supplier-acquiring-bank-transfers-details-dialog-number-of-orders": "\n .title = Number of orders",
        "supplier-acquiring-bank-transfers-details-dialog-table-gross-total": "\n .title = Gross total",
        "supplier-acquiring-bank-transfers-details-dialog-table-fee-total": "\n .title = Fee total",
        "supplier-acquiring-bank-transfers-details-dialog-table-net-total": "\n .title = Net total",

       // Supplier > Admin > Reconciliation > Balance
       "supplier-overview-header": "\n .title = Balance",
       "supplier-overview-table-amount": "Amount",
       "supplier-overview-table-account": "Account",
       "supplier-overview-table-view-details": "View details",
       "supplier-overview-balance-details-dialog": "\n .dialogTitle = Balance details\n .subtitle = Period: { $periodStart} - { $periodEnd }",
       "supplier-overview-balance-details-dialog-select-order": "Show orders",
       "supplier-overview-balance-details-dialog-select-order-label": "\n .label = Show orders",
       "supplier-overview-balance-details-dialog-select-order-mode-net-sales": "Net turnover",
       "supplier-overview-balance-details-dialog-select-order-mode-bank-transfers": "Bank transfers",
       "supplier-overview-balance-details-dialog-select-order-mode-balance": "Balance",
       "supplier-overview-balance-details-dialog-compact-view-label": "Show gross turnover and fees",
       "supplier-overview-balance-details-dialog-table-order-id-column": "Order ID",
       "supplier-overview-balance-details-dialog-table-rsp-reference-column": "PSP Reference",
       "supplier-overview-balance-details-dialog-table-booked-column": "Booked",
       "supplier-overview-balance-details-dialog-table-available-column": "Available",
       "supplier-overview-balance-details-dialog-table-gross-column": "Gross",
       "supplier-overview-balance-details-dialog-table-fee-column": "Fee",
       "supplier-overview-balance-details-dialog-table-net-column": "Net",
       "supplier-overview-balance-details-dialog-table-effective-column": "Effective amount",
       "supplier-overview-balance-details-dialog-table-type-column": "Type",
       "supplier-overview-balance-details-dialog-table-payment-type-bank-transfer": "Payout",
       "supplier-overview-balance-details-dialog-table-payment-type-previous-revenue": "Earlier",
       "supplier-overview-balance-details-dialog-table-payment-type-deferred-revenue": "Deferred revenue",
       "supplier-overview-balance-details-dialog-table-payment-type-normal-revenue": "Revenue",
       "supplier-overview-balance-details-dialog-table-payment-type-accrued-revenue": "Accrued",
       "supplier-overview-balance-details-dialog-number-of-orders": "\n .title = Number of orders",
       "supplier-overview-balance-details-dialog-table-effective-total": "\n .title = Total effective amount",
       "supplier-overview-balance-details-dialog-table-gross-total": "\n .title = Gross total",
       "supplier-overview-balance-details-dialog-table-fee-total": "\n .title = Fee total",
       "supplier-overview-balance-details-dialog-table-net-total": "\n .title = Net total",

        // Supplier > Admin > Merchants
        "supplier-admin-merchants-header": "\n .title = Merchants",
        "supplier-admin-merchants-create-button": "Create new",
        "supplier-admin-merchants-table-edit-button": "Edit",
        "supplier-admin-merchants-table-delete-button": "Delete",
        "supplier-admin-merchants-table-delete-modal-title": "merchant",
        "supplier-admin-merchants-table-reg-no-column": "Case no.",
        "supplier-admin-merchants-table-merchant-column": "Merchant",
        "supplier-admin-merchants-table-connected-shops": "Shops:",
        "supplier-admin-merchants-table-connected-customers": "Customers:",
        "supplier-admin-merchants-table-connected-devices": "Devices:",
        "supplier-admin-merchant-create-title": "\n .title = Create merchant",
        "supplier-admin-merchant-edit-title": "\n .title = Edit merchant",
        "supplier-admin-merchants-save-button": "Save",
        "create-or-edit-supplier-admin-merchant-field-caseNumber": "\n .label = Case no.\n .placeholder = Enter a Case no.\n .helperText = Your internal reference number for this merchant",
        "create-or-edit-supplier-admin-merchant-field-name": "\n .label = Name\n .placeholder = Enter merchant name",
        "create-or-edit-supplier-admin-merchant-field-street": "\n .label = Street\n .placeholder = Enter street",
        "create-or-edit-supplier-admin-merchant-field-streetNumber": "\n .label = Street no\n .placeholder = Enter street no",
        "create-or-edit-supplier-admin-merchant-field-postalCode": "\n .label = Postal code\n .placeholder = Enter postal code",
        "create-or-edit-supplier-admin-merchant-field-city": "\n .label = City\n .placeholder = Enter city",
        "create-or-edit-supplier-admin-merchant-field-country": "\n .label = Country",
        "create-or-edit-supplier-admin-merchant-contact-details-title": "\n .title = Contact details",
        "create-or-edit-supplier-admin-merchant-country-denmark-item": "Denmark",
        "create-or-edit-supplier-admin-merchant-contact-details-info": "Contact details will be public for the customers.",
        "create-or-edit-supplier-admin-merchant-field-contact-details-name": "\n .label = Name\n .placeholder = Enter name",
        "create-or-edit-supplier-admin-merchant-field-contact-details-email": "\n .label = Email\n .placeholder = Enter email",
        "create-or-edit-supplier-admin-merchant-field-contact-details-phone": "\n .label = Phone number\n .placeholder = Enter phone number",
        "create-or-edit-supplier-admin-merchant-field-is-required": "Field is required",
        "create-or-edit-supplier-admin-merchant-credit-card-payments-title": "\n .title = Credit card payments",
        "create-or-edit-supplier-admin-merchant-status-approved": "Active",
        "create-or-edit-supplier-admin-merchant-status-no-registered-bank-account": "No registered bank account",
        "create-or-edit-supplier-admin-merchant-status-no-registered-bank-account-description": "Register a bank account for your acquiring agreement <retryLink>here.</retryLink>",
        "create-or-edit-supplier-admin-merchant-status-invalid": "Agreement invalid",
        "create-or-edit-supplier-admin-merchant-status-invalid-description": "Correct your application for acquiring agreement <retryLink>here.</retryLink>",
        "create-or-edit-supplier-admin-merchant-status-pending": "Agreement pending",
        "create-or-edit-supplier-admin-merchant-status-pending-description": "Wait for acquirer to finish processing your acquiring agreement application.",
        "create-or-edit-supplier-admin-merchant-status-no-payment-setup": "No payment setup",
        "create-or-edit-supplier-admin-merchant-status-no-payment-setup-description": "Setup credit card payments for this merchant to begin receiving payments.",
        "create-or-edit-supplier-admin-merchant-status-bank-account-pending": "Bank account pending",
        "create-or-edit-supplier-admin-merchant-status-bank-account-pending-description": "Wait for acquirer to finish verifying your bank account.",
        "create-or-edit-supplier-admin-merchant-acquirer": "Acquirer:",
        "create-or-edit-supplier-admin-merchant-acquirer-type-adyen-pos": "Adyen",
        "create-or-edit-supplier-admin-merchant-acquirer-type-adyen": "Adyen",
        "create-or-edit-supplier-admin-merchant-bank-details": "Bank details:",
        "create-or-edit-supplier-admin-merchant-industry-codes": "Industry codes:",
        "create-or-edit-supplier-admin-merchant-status-action-button-setup": "Setup",
        "create-or-edit-supplier-admin-merchant-status-action-button-edit": "Edit",
        "create-or-edit-supplier-admin-merchant-dialog-title": "Credit card payment setup",
        "create-or-edit-supplier-admin-merchant-dialog-field-acquiring-agreement": "\n .label = Acquiring agreement",
        "create-or-edit-supplier-admin-merchant-dialog-field-sales-channels": "\n .label = Sales channel",
        "create-or-edit-supplier-admin-merchant-dialog-field-bank-account": "\n .label = Bank account",
        "create-or-edit-supplier-admin-merchant-dialog-field-bank-account-helper": "Select the bank account where to sales will be transfered. You will only see banks accounts which have been created in the Adyen platform. To add a new bank account see <retryLink>guide.</retryLink>",
        "create-or-edit-supplier-admin-merchant-dialog-field-industry-codes": "\n .label = Industry codes",
        "create-or-edit-supplier-admin-merchant-dialog-field-default-currency": "\n .label = Default currency",
        "create-or-edit-supplier-admin-merchant-dialog-save-button": "Save",

        //Supplier > Admin > T&C
        "supplier-admin-settings-terms-and-conditions": "\n .title = Terms and conditions",
        "supplier-admin-settings-terms-and-conditions-create-button": "Create",
        "supplier-admin-settings-terms-and-conditions-update-button": "Update",


        // TERMS AND CONDITIONS CREATE
        "supplier-terms-and-conditions-alert-title": "Terms and conditions",
        "supplier-terms-and-conditions-alert-subtitle1": "It is your own responsibility to ensure that the terms and conditions comply with the applicable requirements.",
        "supplier-terms-and-conditions-alert-subtitle2": "Read about Adyen's required T&C, which you must comply with <externalLink>here</externalLink>.",
        "supplier-terms-and-conditions-alert-subtitle3": "Download our T&C template: <externalLinkDA>Danish</externalLinkDA> | <externalLinkEN>English</externalLinkEN>.",
        "supplier-terms-and-conditions-dropdown-english": "English",
        "supplier-terms-and-conditions-dropdown-danish": "Danish",
        "supplier-terms-and-conditions-name-label": "\n .label = Name",
        "supplier-terms-and-conditions-language-label": "\n .label = Language",
        "supplier-terms-and-conditions-type-label": "\n .label = Type",
        "supplier-terms-and-conditions-dropdown-pos": "POS",
        "supplier-terms-and-conditions-type-ecom": "E-Commerce",
        "supplier-terms-and-conditions-aside-settings": "\n .title = Settings",
        "supplier-terms-and-conditions-aside-active": "Active: ",
        "supplier-terms-and-conditions-aside-history": "\n .title = History",
        "supplier-terms-and-conditions-aside-version": "Version: ",
        "supplier-terms-and-conditions-aside-created": "Created: ",
        "supplier-terms-and-conditions-aside-updated": "Updated: ",
        "terms-and-conditions-error-label-name": "Name",
        "terms-and-conditions-error-label-type": "Type",
        "terms-and-conditions-error-label-language": "Language",
        "terms-and-conditions-error-label-text": "Text",


        // TERMS AND CONDITIONS TABLE GENERAL
        "terms-and-conditions-table-header-name": "Name",
        "terms-and-conditions-table-header-language": "Language",
        "terms-and-conditions-table-header-name-type": "Type",
        "terms-and-conditions-table-header-name-status": "Status",
        "terms-and-conditions-table-button-edit":"Edit",
        "terms-and-conditions-table-button-delete":"Delete",
        "terms-and-conditions-table-button-approval":"Approval",
        "terms-and-conditions-table-status-active":"Active",
        "terms-and-conditions-table-status-inactive":"Inactive",
        "terms-and-conditions-table-status-pending":"Pending",


        "terms-and-conditions-modal-button-delete-label": "Delete",
        "terms-and-conditions-modal-question": "Are you sure you want to delete",
        "terms-and-conditions-modal-title": "Terms and conditions",


        // Supplier > Admin > Administrators
        "supplier-users-page-header": "\n .title = Administrators",
        "supplier-users-suppliers-tab-title": "Supplier administrators",
        "supplier-users-merchants-tab-title": "Merchant administrators",
        "supplier-users-table-merchant-column": "Merchant",
        "supplier-users-create-admin-button": "Create administrator",


        // Supplier > Admin > Account > Company Account
        "supplier-update-account-title":"\n .title = Supplier account",
        "supplier-update-account-update-button":"Update",
        "supplier-update-account-nav-item-home":"Home",
        "supplier-update-account-nav-item-account":"Account",
        "supplier-update-account-registration-number-label":"\n .label = Registration number",
        "supplier-update-account-error-label-registration-number":"Registration number",

        // Supplier > Admin > Account > GDPR
        "supplier-account-gdpr-title":"\n .title = GDPR",
        "supplier-account-gdpr-tab-documents":"Documents",
        "supplier-account-gdpr-tab-export":"Exports",
        "supplier-account-gdpr-export-title":"Download users",
        "supplier-account-gdpr-export-info":"\n .description = This feature enables you to export administrators and/or users from all administrative units, including supplier, merchant, company, tenant, and service center. In order to download users from other administrative units, you must register one or more email domains associated with your company. These domains will be used to identify your company's users. If your company does not have any verified domains, you will be unable to download users from other units. For assistance with domain verification, please contact our Support Team.",
        "supplier-account-gdpr-export-user-types-select-item-user": "Users",
        "supplier-account-gdpr-export-user-types-select-item-administrator": "Administrators",

        "supplier-account-gdpr-export-user-types-select-label":"\n .label = User types",
        "supplier-account-gdpr-export-user-types-select-input-label":"User types",
        "supplier-account-gdpr-export-user-deletion-period-select-input-label":"User deletion period",
        "supplier-account-gdpr-export-user-deletion-period-select-label":"\n .label = User deletion period",
        "supplier-account-gdpr-export-user-deletion-period-select-item-days-180":"180 days",
        "supplier-account-gdpr-export-user-deletion-period-select-item-days-90":"90 days",
        "supplier-account-gdpr-export-user-deletion-period-select-item-days-30":"30 days",
        "supplier-account-gdpr-export-user-deletion-period-select-item-days-7":"7 days",
        "supplier-account-gdpr-export-include-deleted-switch-label":"\n .label = Include deleted users",
        "supplier-account-gdpr-export-exported-domains-subtitle":"Verified domains being exported:",
        "supplier-account-gdpr-export-no-domains-registered":"No verified company domains have been registered.",
        "supplier-account-gdpr-export-export-button":"Export to CSV",



        // --- Support ---

        // Support > Admin > Features
        "support-admin-features-header": "\n .title = Features",
        "support-admin-features-table-header-name": "Name",
        "support-admin-features-table-header-plan": "Plan",
        "support-admin-features-table-plan-none": "None",
        "support-admin-features-table-plan-professional": "Professional",
        "support-admin-features-table-plan-enterprise": "Enterprise",
        "support-admin-features-table-header-status": "Status",
        "support-admin-features-table-header-enabled": "Enabled",
        "support-admin-features-table-action-edit": "Edit",
        "support-admin-features-status-label-new": "\n .label = NEW",
        "support-admin-features-status-label-beta": "\n .label = BETA",
        "support-admin-features-status-new": "NEW",
        "support-admin-features-status-beta": "BETA",

         // Support > Admin > Features > Edit
        "support-admin-feature-edit-header": "\n .title = Edit feature",
        "support-admin-feature-edit-save-button": "Save",
        "support-admin-feature-edit-nav-item-feature": "Edit feature",
        "support-admin-feature-edit-programmatic-id-label": "\n .label = Programmatic ID",
        "support-admin-feature-edit-name-label": "\n .label = Name",
        "support-admin-feature-edit-plan-label": "\n .label = Plan",
        "support-admin-feature-edit-status-label": "\n .label = Status",
        "support-admin-feature-edit-enabled-label": "Enabled:",
        "support-admin-feature-edit-settings-title": "\n .title = Settings",

        // Support > Admin > GDPR
        "support-nav-item-gdpr": "GDPR",
        "support-admin-gdpr-page-header": "\n .title = GDPR",
        "support-admin-gdpr-breadcrumb": "GDPR",
        "support-admin-gdpr-administrators-title": "Administrators",
        "support-admin-gdpr-user-type-label": "\n .label = User type",
        "support-admin-gdpr-user-type-select-item-merchant-admins": "Merchant admins",
        "support-admin-gdpr-user-type-select-item-supplier-admins": "Supplier admins",
        "support-admin-gdpr-user-type-select-item-company-admins": "Company admins",
        "support-admin-gdpr-user-type-select-item-company-agreement-owners": "Company agreement owners",
        "support-admin-gdpr-include-active-users": "Include active users",
        "support-admin-gdpr-include-inactive-users": "Include inactive users",
        "support-admin-gdpr-export-button": "Export contact list",
        "support-admin-gdpr-export-button-label": "Export contact list",
        "support-admin-gdpr-export-button-exporting": "Exporting...",

        // Support > Reports > Entities
        "support-entity-header-title" : "\n .title = Entities",
        "support-entity-header-menu-button-create": "Create",
        "support-entity-header-menu-button-create-supplier": "Create Supplier",
        "support-entity-header-menu-button-create-merchant": "Create Merchant",
        "support-entity-header-menu-button-create-company": "Create Company",
        "support-entity-header-menu-button-create-tenant": "Create Tenant",
        "support-entity-header-nav-item-home" : "Home",
        "support-entity-header-nav-item-entities" : "Entities",
        "support-entity-table-header-id": "ID",
        "support-entity-table-header-name": "Name",
        "support-entity-table-header-address": "Address",
        "support-entity-table-header-type": "Type",
        "support-entity-table-header-status": "Status",
        "support-entity-table-button-details": "Details",
        "support-entity-table-button-edit": "Edit",
        "support-entity-table-button-delete": "Delete",
        "support-entity-table-status-active": "Active",
        "support-entity-table-status-inactive": "Inactive",
        "support-entity-confirm-delete-entity-dialog": "\n .typeOfEntity = entity",
        "support-entity-table-cell-name-agreement-owner": "Agreement owner",
        "support-entity-table-cell-name-reg-no": "Reg. no.:",
        "support-entity-table-type-supplier": "\n .label = Supplier",
        "support-entity-table-show-inactive": "\n .label = Show inactive",
        "support-entity-table-type-merchant": "\n .label = Merchant",
        "support-entity-table-type-company": "\n .label = Company",
        "support-entity-table-type-tenant": "\n .label = Tenant",
        "support-entity-table-type-service-center": "\n .label = Service Center",
        "support-entity-table-type-user": "\n .label = User",
        "support-entity-details-connected-merchants": "\n .title = Connected merchants",
        "support-entity-details-connected-companies": "\n .title = Connected companies",
        "support-entity-details-connected-suppliers": "\n .title = Connected suppliers",
        "support-entity-details-connected-devices": "\n .title = Connected devices",
        "support-entity-details-id": "ID: { $id }",
        "support-entity-table-entity-type-label":"Entity Type",
        "support-entity-table-entity-type-select-item-all":"All",
        "support-entity-table-entity-type-select-item-supplier":"Supplier",
        "support-entity-table-entity-type-select-item-merchant":"Merchant",
        "support-entity-table-entity-type-select-item-company":"Company",
        "support-entity-table-entity-type-select-item-service-center":"Service center",
        "support-create-entity-error-label-company-invalid-type":"Invalid type",
        "support-create-entity-error-label-company-type":"Type",
        "support-create-entity-error-label-system-owner":"Agreement owner",
        "support-create-entity-error-label-company-number":"Company number",
        "support-create-entity-error-label-ean-number":"EAN number",
        "support-create-entity-error-label-invoice-type":"Invoice Type",
        "support-create-entity-error-label-invoice-email":"Email",
        "support-create-entity-error-label-attention":"Attention",
        "support-create-entity-error-label-debitot-no":"Debitor number",
        "support-create-entity-error-label-reminder-email":"Email",
        "support-create-entity-error-label-po-number":"Purchase order number",
        "support-create-entity-error-label-company-name":"Company name",
        "support-create-entity-error-label-address":"Address",
        "support-create-entity-error-label-country":"Country",
        "support-create-entity-error-label-postal-code":"Postal code",
        "support-create-entity-error-label-city":"City",
        "support-create-entity-error-label-contact-person":"Contact person",
        "support-create-entity-error-label-email":"Email",
        "support-create-entity-error-label-telephone":"Telephone",
        "support-create-entity-agreement-owner-subtitle":"Agreement owner",
        "support-create-entity-ean-number-label":"\n .label = EAN number",
        "support-create-entity-address1-label":"\n .label = Address line 1 (*)\n .placeholder = Street and street number",
        "support-create-entity-address2-label":"\n .label = Address line 2\n .placeholder = Floor, apartment no., etc.",
        "support-create-entity-postal-code-label":"\n .label = Postal code (*)",
        "support-create-entity-city-label":"\n .label = City (*)",
        "support-create-entity-contact-person-label":"\n .label = Contact person (*)",
        "support-create-entity-email-label":"\n .label = Email (*)",
        "support-create-entity-telephone-label": "\n .label = Telephone (*)",
        "support-create-entity-type-choose-label":"\n .label = Choose (*)",
        "support-create-entity-dropdown-choose-yes":"Yes",
        "support-create-entity-dropdown-choose-no":"No",
        "support-create-entity-alert-title":"\n .title = An agreement owner owns the agreement with FacilityNet and will receive related invoices. For this reason we need invoice details for agreement owners.",
        "support-create-entity-subscription-details-subtitle": "Subscription details",
        "support-create-entity-subscription-details-field-implementationDeadline": "\n .label = Deadline for implementation *",
        "support-create-entity-subscription-details-alert-title": "\n .title = This is the date by which the customer wants the system to go into production. This means onboarding, internal testing and any trial period must be completed before this date.",
        "support-create-entity-contact-details-subtitle":"Contact details",
        "support-create-entity-invoice-details-subtitle":"Invoice details",
        "support-create-entity-send-invoice-to-label":"\n .label = Send invoice to",
        "support-create-entity-dropdown-ean-number":"EAN number",
        "support-create-entity-dropdown-email":"Email",
        "support-create-entity-debitor-number-label":"\n .label = Debitor Number (*)\n .helperText = This identifies the debtor in FacilityNet accounting system.",
        "support-create-entity-invoice-email-label":"\n .label = Email (*)",
        "support-create-entity-attention-label":"\n .label = Attention (*)",
        "support-create-entity-reminder-email-label":"\n .label = Email for reminders / account statements",
        "support-create-entity-po-number-label":"\n .label = Purchase order number",
        "support-create-entity-type-label":"\n .label = Type",
        "support-create-entity-country-label":"\n .label = Country (*)",
        "support-create-entity-dropdown-country-denmark":"Denmark",
        "support-create-entity-dropdown-private-company":"Private company",
        "support-create-entity-dropdown-private-person":"Private person",
        "support-create-entity-dropdown-public-limited-company":"Public limited company",
        "support-create-entity-aside-history": "\n .title = History",
        "support-create-entity-aside-version": "Version:",
        "support-create-entity-aside-created": "Created:",
        "support-create-entity-aside-updated": "Updated:",

        // ---  Support Reports --- Messages > Email
        "support-messages-email-title": "\n .title = Email",
        "support-messages-email-subject-label":"\n .label = Email subject",
        "support-messages-email-receiver-label":"\n .label = Receiver \n .placeholder = Enter email or user id",
        "support-messages-email-table-header-receiver":"Receiver",
        "support-messages-email-table-header-subject":"Subject",
        "support-messages-email-table-header-sent-time":"Sent time",
        "support-messages-email-table-header-status":"Status",
        "support-messages-email-table-status-sent":"Sent",
        "support-messages-email-table-status-not-sent":"Not sent",
        "support-messages-email-table-cell-subject-created":"Created: { $time }",
        "support-messages-email-resend-button":"Resend",
        "support-messages-email-export-button":"Export",
        "support-messages-email-details-status-label":"Status:",
        "support-messages-email-details-created-label":"Created:",
        "support-messages-email-details-sent-time-label":"Sent time:",
        "support-messages-email-details-error-message-label":"Error message:",
        "support-messages-email-details-from-label":"From:",
        "support-messages-email-details-subject-label":"Subject:",
        "support-messages-email-details-to-label":"To:",
        "support-messages-email-details-cc-label":"CC:",
        "support-messages-email-details-bcc-label":"BCC:",
        "support-messages-email-details-resend-email-button":"Resend email",
        "support-messages-email-details-resend-email-title":"Resend email",
        "support-messages-email-details-sent-button":"Sent",
        "support-messages-email-resent-dialog-title":"Confirm to resend emails",
        "support-messages-email-resent-dialog-subtitle":"Are you sure you want to resend { $itemsAmount } emails?",
        "support-messages-email-resent-dialog-cancel-button":"No",
        "support-messages-email-resent-dialog-submit-button":"Yes",

        // ---  Support Reports --- Messages > SMS
        "support-messages-sms-title": "\n .title = SMS",
        "support-messages-sms-receiver-label":"\n .label = Receiver",
        "support-messages-sms-text-body-label":"\n .label = Text body",
        "support-messages-sms-table-header-receiver":"Receiver",
        "support-messages-sms-table-header-created":"Created",
        "support-messages-sms-table-header-sent":"Sent",
        "support-messages-sms-table-header-status":"Status",
        "support-messages-sms-table-status-sent":"Sent",
        "support-messages-sms-table-status-not-sent":"Not sent",
        "support-messages-sms-export-button":"Export",
        "support-messages-sms-details-status-label":"Status:",
        "support-messages-sms-details-id-label":"id:",
        "support-messages-sms-details-created-label":"Created:",
        "support-messages-sms-details-sent-time-label":"Sent time:",
        "support-messages-sms-details-error-message-label":"Error message:",
        "support-messages-sms-details-text-message-label":"Text message:",
        "support-messages-sms-details-from-label":"From:",
        "support-messages-sms-details-to-label":"To:",


        // ---  Support Reports --- Accounting > Subscriptions
        "support-subscriptions-header": "\n .title = Subscriptions",
        "support-subscriptions-table-order-id-column": "Order ID",
        "support-subscriptions-table-employee-column": "Employee",
        "support-subscriptions-table-subscribed-column": "Subscribed",
        "support-subscriptions-table-unsubscribed-column": "Unsubscribed",
        "support-subscriptions-table-payment-column": "Payment",
        "support-subscriptions-table-amount-column": "Amount",
        "support-subscriptions-table-cancel-subscription": "Cancel subscription",
        "support-subscriptions-table-details": "Details",
        "support-subscriptions-table-filters-merchant-title":"\n .title = Merchant",
        "support-subscriptions-table-filters-customer-title":"\n .title = Customer",
        "support-subscriptions-table-filters-payment-title":"\n .title = Payment",

        // ---  Support Reports --- Accounting > Meeting Service
        "support-accounting-meeting-service-header": "\n .title = Meeting Service",
        "support-accounting-meeting-service-table-order-id-column": "Order ID",
        "support-accounting-meeting-service-table-booked-date-column": "Booked date",
        "support-accounting-meeting-service-table-delivery-time-column": "Delivery time",
        "support-accounting-meeting-service-table-employee-column": "Creator",
        "support-accounting-meeting-service-table-status":"Status",
        "support-accounting-meeting-service-table-amount-column": "Amount (DKK)",
        "support-accounting-meeting-service-table-show-receipt": "Show receipt",
        "support-accounting-meeting-service-table-floating-action-bar-export": "\n .title = Export",


        // ---  Support Reports --> Printer Queue
        "support-printer-queue-title": "\n .title = Printer Queue",
        "support-printer-queue-merchant-label":"\n .label = Merchant",
        "support-printer-queue-order-id-label":"\n .label = Order ID",
        "support-printer-queue-table-header-id":"Id",
        "support-printer-queue-table-header-created":"Created",
        "support-printer-queue-table-header-print-at":"Print at",
        "support-printer-queue-table-header-device-name":"Device name",
        "support-printer-queue-table-header-order-id":"Order ID",
        "support-printer-queue-table-header-status":"Status",
        "support-printer-queue-table-device-group":" Group: ",
        "support-printer-queue-table-status-printed":"Printed",
        "support-printer-queue-table-status-queue":"Queue",
        "support-printer-queue-table-raw-receipt-action":"Raw receipt",
        "support-printer-details-status-label":"Status:",
        "support-printer-details-created-label":"Created:",
        "support-printer-details-printed-at-label":"Printed at:",
        "support-printer-details-device-group-subtitle":"Device group:",
        "support-printer-details-device-subtitle":"Device:",
        "support-printer-details-id-label":"ID:",
        "support-printer-details-name-label":"Name:",
        "support-printer-details-mime-type-label":"Mime type:",
        "support-printer-details-priority-label":"Priority:",
        "support-printer-details-job-token-label":"Job token:",


         // ---  Support Reports --- Orders > POS
        "support-orders-pos-title": "\n .title = POS",
        "support-orders-pos-order-id-label":"\n .label = Order ID",
        "support-orders-pos-email-label":"\n .label = Email",
        "support-orders-pos-table-header-order-id":"Order id",
        "support-orders-pos-table-header-transaction-time":"Transaction time",
        "support-orders-pos-table-header-customer":"Customer",
        "support-orders-pos-table-header-merchant":"Merchant",
        "support-orders-pos-table-header-amount":"Amount",
        "support-orders-pos-table-action-show-receipt":"Show receipt",
        "support-orders-pos-table-action-show-order-details":"Show order details",



        // --- Support entity---
        "support-create-supplier-title": "\n .title = Create supplier",
        "support-update-supplier-title": "\n .title = Update supplier",
        "support-create-supplier-create-button": "Create",
        "support-create-supplier-update-button": "Update",
        "support-create-supplier-nav-item-home": "Home",
        "support-create-supplier-nav-item-entities": "Entities",
        "support-create-supplier-nav-item-create-supplier": "Create supplier",
        "support-create-supplier-nav-item-update-supplier": "Update supplier",
        "support-create-supplier-aside-settings": "\n .title = Settings",
        "support-create-supplier-aside-active": "Active:",
        "support-create-supplier-company-number-label":"\n .label = Company number",
        "support-create-supplier-company-name-label":"\n .label = Company name",
        "support-create-subscription-status-title": "\n .title = Subscription status",
        "support-create-supplier-subscription-status": "Status",
        "support-create-supplier-subscription-status-mode-creating": "Creating",
        "support-create-supplier-subscription-status-mode-onboarding": "Onboarding",
        "support-create-supplier-subscription-status-mode-trial": "Trial",
        "support-create-supplier-subscription-status-mode-live": "LIVE",
        "support-create-supplier-subscription-status-mode-unsubscribing": "Unsubscribing",
        "support-create-supplier-subscription-status-mode-unsubscribed": "Unsubscribed",
        "support-create-supplier-subscription-status-created": "Created",
        "support-create-supplier-subscription-status-implementation-deadline": "Implementation deadline",
        "support-create-supplier-subscription-status-onboarding-email-sent": "Onboarding email sent",
        "support-create-supplier-subscription-status-trial-started": "Trial started",
        "support-create-supplier-subscription-status-subscription-started": "Subscription started",
        "support-create-supplier-subscription-status-subscription-ending": "Subscription ending",
        "support-create-supplier-subscription-status-button-mode-creating": "Send onboarding articles",
        "support-create-supplier-subscription-status-button-mode-onboarding": "Complete onboarding",
        "support-create-supplier-subscription-status-button-mode-trial": "Go live",
        "support-create-supplier-subscription-status-button-mode-live": "End subscription",
        "support-create-supplier-subscription-status-button-mode-unsubscribing": "Edit",
        "support-create-supplier-subscription-status-button-mode-unsubscribed": "Edit",
        "support-create-supplier-subscription-status-begin-onboarding-dialog": "Begin onboarding",
        "support-create-supplier-subscription-status-begin-onboarding-dialog-articles-to-send": "Articles to send",
        "support-create-supplier-subscription-status-begin-onboarding-dialog-destination": "Destination",
        "support-create-supplier-subscription-status-begin-onboarding-dialog-button-next": "Next",
        "support-create-supplier-subscription-status-begin-onboarding-dialog-existing-administrators": "Existing administrators",
        "support-create-supplier-subscription-status-begin-onboarding-dialog-extra-receivers": "Extra receivers",
        "support-create-supplier-subscription-status-begin-onboarding-dialog-button-begin": "Begin",
        "support-create-supplier-subscription-status-begin-onboarding-dialog-supplier-admin": "Supplier admin: {$adminDetails}",
        "support-create-supplier-subscription-status-begin-onboarding-dialog-kitchen-admin": "Kitchen admin: {$adminDetails}",
        "support-create-supplier-subscription-status-begin-onboarding-dialog-label-email": "\n .label = Email \n .placeholder = Receiver email",
        "support-create-supplier-subscription-status-begin-onboarding-dialog-button-add": "Add",
        "support-create-supplier-subscription-status-begin-onboarding-dialog-email-error": "Invalid email address",
        "support-create-supplier-subscription-status-begin-onboarding-dialog-administrators-error": "At least one administrator must be selected",


        // --- Support company ---
        "support-create-company-title": "\n .title = Create company",
        "support-update-company-title": "\n .title = Update company",
        "support-create-company-create-button": "Create",
        "support-create-company-update-button": "Update",
        "support-create-company-nav-item-home": "Home",
        "support-create-company-nav-item-entities": "Entities",
        "support-create-company-nav-item-create-company": "Create company",
        "support-create-company-nav-item-update-company": "Update company",
        "support-create-company-aside-settings": "\n .title = Settings",
        "support-create-company-aside-active": "Active:",
        "support-create-company-office-hotel-label":"Office hotel:",
        "support-create-company-office-hotel-helper-text":"Helper text",
        "support-create-company-company-number-label":"\n .label = Company number",
        "support-create-company-main-ean-number-label":"\n .label = Main EAN number",
        "support-create-company-company-name-label":"\n .label = Company name",
        "support-create-company-error-label-main-ean-number":"Main Ean Number",
        "support-create-company-error-label-url-identifier":"Url identifier",
        "support-create-company-aside-is-self-sign-up":"\n .title = Self sign-up",
        "support-create-company-url-identifier-label":"\n .label = Signup URL identifier\n .helperText = This is used for generating the user signup URL.",
        "support-create-company-signup-link-subtitle":"Signup link:",

        // Invoicing
        "support-reports-basis-for-invoicing-page-header": "\n .title = Basis for invoicing",
        "support-reports-invoicing-header-nav-item": "Invoicing",
        "support-reports-invoicing-header-nav-item-basis-for-invoicing": "Basis for invoicing",
        "support-reports-invoicing-table-debtor-label": "\n .label = Debtor",
        "support-reports-invoicing-table-header-product-no": "Product no.",
        "support-reports-invoicing-table-header-name": "Name",
        "support-reports-invoicing-table-header-price": "Price",
        "support-reports-invoicing-table-header-items": "Items",
        "support-reports-invoicing-table-header-total": "Total",
        "support-reports-invoicing-table-bottom-transactions": "Transactions",
        "support-reports-invoicing-table-bottom-subscriptions": "Subscriptions",
        "support-reports-invoicing-table-bottom-total": "Total",

        // Support > Reports > Health > Server Memory
        "support-reports-health-server-memory-page-header": "\n .title = Server memory",
        "support-reports-health-server-memory-table-header-memory-type": "Memory type",
        "support-reports-health-server-memory-table-header-used": "Used",
        "support-reports-health-server-memory-table-header-commited": "Comitted",
        "support-reports-health-server-memory-table-header-max": "Max",


        // Support > Reports > Health > Database health
        "support-reports-health-database-page-header": "\n .title = Database health",


        // Support > Reports > Health > Adyen
        "support-reports-health-adyen-page-header": "\n .title = Adyen",
        "support-reports-health-adyen-tab-summary": "Summary",
        "support-reports-health-adyen-tab-account-holders": "Account Holders",
        'support-reports-health-adyen-run-button':"Run",
        'support-reports-health-adyen-results':"Results:",
        'support-reports-health-adyen-api-status-unknown':"Unknown",
        'support-reports-health-adyen-api-status-ok':"Ok",
        'support-reports-health-adyen-api-status-failed':"Failed",
        'support-reports-health-adyen-summary-aside-title':"API connection test",
        'support-reports-health-adyen-summary-last-run':"Last run: {$lastRun}",
        'support-reports-health-adyen-summary-legal-entity-management':"Legal Entity Management:",
        'support-reports-health-adyen-summary-balance-platform':"Balance Platform:",
        'support-reports-health-adyen-summary-psp-platform':"PSP Platform:",
        'support-reports-health-adyen-summary-main-title':"Terminal cheatsheet",
        'support-reports-health-adyen-summary-terminal-key':"Key",
        'support-reports-health-adyen-summary-terminal-function':"Function",
        'support-reports-health-adyen-summary-terminal-key-cancel':"Cancel",
        'support-reports-health-adyen-summary-terminal-key-clear':"Clear",
        'support-reports-health-adyen-summary-terminal-key-confirm':"Confirm",
        'support-reports-health-adyen-summary-terminal-press-1':"Press 1 +",
        'support-reports-health-adyen-summary-terminal-press-5':"Press 5 +",
        'support-reports-health-adyen-summary-terminal-press-8':"Press 8 +",
        'support-reports-health-adyen-summary-terminal-press-9':"Press 9 +",
        'support-reports-health-adyen-summary-terminal-function-custom-menu':"Custom menu",
        'support-reports-health-adyen-summary-terminal-function-informational-menu':"Informational menu",
        'support-reports-health-adyen-summary-terminal-function-payments-menu':"Payments menu",
        'support-reports-health-adyen-summary-terminal-function-admin-menu':"Admin menu",


        // Support > Reports > Health > Adyen > Account Holders
        "adyen-account-holders-table-header-id": "ID",
        "adyen-account-holders-table-cell-entity-id": "Legal entity ID: {$entityId}",
        "adyen-account-holders-table-cell-entity-liable": "Liable",
        "adyen-account-holders-table-details-balance-accounts": "Balance accounts:",
        "adyen-account-holders-table-details-stores": "Stores:",
        "adyen-account-holders-table-header-supplier": "Supplier",
        "adyen-account-holders-table-header-status": "Status",
        "adyen-account-holders-table-header-status-valid": "Valid",
        "adyen-account-holders-table-header-status-invalid": "Invalid",
        "adyen-account-holders-table-header-status-pending": "Pending",
        "adyen-account-holders-table-header-updated": "Updated",


        // Support > Reports > Health > Scheduler
        "support-reports-health-scheduler-page-header": "\n .title = Scheduler",
        "support-reports-health-scheduler-page-subtitle-main-job": "Main job:",
        "support-reports-health-scheduler-page-subtitle-load-in-seconds": "Load in seconds:",
        "support-reports-health-scheduler-table-header-name": "Name",
        "support-reports-health-scheduler-table-header-cron": "Cron",
        "support-reports-health-scheduler-table-header-last-run": "Last run",
        "support-reports-health-scheduler-table-header-next-run": "Next run",
        "support-reports-health-scheduler-table-header-status": "Status",
        "support-reports-health-scheduler-table-status-active": "Active",
        "support-reports-health-scheduler-table-status-inactive": "Inactive",
        "support-reports-health-scheduler-table-status-paused": "Paused",
        "support-reports-health-scheduler-table-action-edit": "Edit",
        "support-reports-health-scheduler-table-action-pause": "Pause",
        "support-reports-health-scheduler-table-action-start": "Start",
        "support-reports-health-scheduler-table-action-stop": "Stop",


        // Support > Reports > Health > Scheduler > Edit Job
        "support-reports-health-schedule-edit-page-header": "\n .title = Edit scheduler job",
        "support-reports-health-schedule-edit-page-nav-item-edit-job":"Edit Job",
        "support-reports-health-schedule-edit-page-edit-button":"Edit",
        "support-reports-health-schedule-edit-page-start-time-label":"\n .label = Start time",
        "support-reports-health-schedule-edit-page-cron-expression-label":"\n .label = Cron expression",
        "support-reports-health-schedule-edit-page-settings-title":"\n .title = Settings",
        "support-reports-health-schedule-edit-page-settings-active-label":"Active:",
        "support-reports-health-schedule-edit-page-information-title":"\n .title = Information",
        "support-reports-health-schedule-edit-page-information-id":"ID:",
        "support-reports-health-schedule-edit-page-information-name":"Name:",
        "support-reports-health-schedule-edit-page-information-last-run":"Last run:",

        // Support > TopBar > Awaiting approval
        "awaiting-approval-popover-not-approved-item": "\n .title = Awaiting approval\n .description = Orders that need to be approved",
        "awaiting-approval-popover-to-be-booked-item": "\n .title = To be invoiced\n .description = Meeting service orders that have been bookable for 3+ days",
        "awaiting-approval-popover-tooltip": "\n .title = Order notifications",
        "awaiting-approval-popover-section-meeting-service-title": "\n .title = Meeting service",
        "awaiting-approval-popover-section-takeaway-title": "\n .title = Takeaway",
        "awaiting-approval-popover-todays-orders-item": "\n .title = Today's orders\n .description = Meeting service orders for delivery today",
        "awaiting-approval-popover-todays-takeaway-orders-item": "\n .title = Today's orders\n .description = Takeaway orders for today",

        // Support > TopBar > Instructions Dialog
        "support-instructions-dialog-title": "Instructions",
        "support-instructions-button": "Instructions",

        // Non Admin User > TopBar > Create new
        "user-create-new-menu-order-for-another-user-title": "Order on behalf of another user",
        "user-create-new-menu-order-for-another-user-subtitle": "Create a resource booking or meeting service order on behalf of another user",

        // TopBar > New button > menu
        "top-bar-new-button": "New",
        "top-bar-new-menu-resource-booking-title": "Resource booking",
        "top-bar-new-menu-resource-booking-description": "Book rooms and other resources",
        "top-bar-new-menu-meeting-service-title": "Meeting service",
        "top-bar-new-menu-meeting-service-description": "Order meeting service",
        "top-bar-new-menu-take-away-title": "Takeaway",
        "top-bar-new-menu-take-away-description": "Purchase takeaway and other goods",
        "top-bar-new-menu-make-purchase-title": "Make a purchase",
        "top-bar-new-menu-make-purchase-description": "Order lunch at the canteen",
        "top-bar-new-menu-refill-wallet-title": "Refill wallet",
        "top-bar-new-menu-refill-wallet-description": "Top up money at your digital wallet",
        "top-bar-new-menu-push-message-title": "Push message",
        "top-bar-new-menu-push-message-dialog-title": "New push message",
        "top-bar-new-menu-push-message-description": 'Send messages to your customers',

        // Navigation
        "support-nav-item-home": "Home",
        "support-nav-item-devices": "Devices",
        "support-nav-item-messages": "\n .title = Messages",
        "support-nav-item-orders-title": "\n .title = Orders",
        "support-nav-item-orders": "Orders",
        "support-nav-item-orders-pos": "POS",
        "support-nav-item-accounting-title": "\n .title = Accounting",
        "support-nav-item-accounting": "Accounting",
        "support-nav-item-subscriptions": "Subscriptions",
        "support-nav-item-accounting-meeting-service": "Meeting service",
        "support-nav-item-email": "Email",
        "support-nav-item-sms": "SMS",
        "support-nav-item-printer-queue": "Printer queue",

        // Support ADMIN DEVICES
        "support-admin-nav-item-devices": "Devices",
        "support-admin-entities-card-group": "\n .title = Entities",
        "support-admin-entities-card": "\n .title = Entities\n .description = Manage entities in the system such as suppliers, merchants and companies.",
        "support-admin-devices-page-header": "\n .title = Devices",
        "support-table-header-supplier": "Supplier",
        "support-table-header-merchant": "Merchant",

        // - reporting

        // - admin
        "support-nav-item-supplier-access": "Suppliers",
        "support-nav-item-merchant-access": "Merchants",
        "support-nav-item-entities-access": "Entities",
        "support-nav-item-features": "Features",
        "support-nav-item-invoicing": "\n .title = Invoicing",
        "support-nav-item-invoicing-basis-for-invoicing": "Basis for invoicing",
        "support-nav-item-health-title": "\n .title = Health",
        "support-nav-item-health": "Health",
        "support-nav-item-health-database": "Database health",
        "support-nav-item-health-server-memory": "Server memory",
        "support-nav-item-health-scheduler": "Scheduler",
        "support-nav-item-health-adyen": "Adyen",

        // Access
        "support-supplier-access-page-header": "\n .title = Supplier Access",
        "support-merchant-access-page-header": "\n .title = Merchant Access",


        // Page header
        "page-header-help-text": "Help guides",
        "page-header-help-status-mode-new": "New",
        "page-header-help-status-mode-beta": "Beta",
        "page-header-help-maintenance": "Sorry, the page is currently unavailable as it is undergoing maintenance.",

        // YUP validation
        "validation-title-required": "Title is required",
        "validation-body-required": "Body is required",
        "validation-type-required": "Type is required",


        // Common
        "employee-id": "Employee-id",
        "id": "id",
        "name": "Name",
        "price": "Price",
        "email": "Email",
        "amount": "Amount",
        "for": "for",
        "yes": "Yes",
        "no": "No",
        "status": "Status",
        "active": "Active",
        "inactive": "Inactive",
        "edit": "Edit",
        "delete": "Delete",

        "create": "Create",
        "save": "Save",
        "required-field": "This field is required",
        "invalid-email": "Invalid email address",

        // History block
        "history-card": "\n .title = History",
        "history-created": "Created:",
        "history-edited": "Edited:",


        // Production order
        "production-order-status-received": "Received",
        "production-order-status-confirmed": "Confirmed",
        "production-order-status-cancelled": "Cancelled",
        "production-order-status-ready": "Ready",
        "production-order-number": "ID",
        "production-order-status": "Status",
        "production-order-payment-status": "Payment method",
        "production-order-payment-channel": "Channel",
        "production-order-time": "Order time",
        "production-order-delivery-time": "Delivery time",
        "production-order-placeholder-comment": "Comment for customer",
        "production-order-show-cancelled": "Show cancelled",

        // Pos order
        "pos-order-delivery-date-title": "Delivery list - takeaway",
        "pos-order-delivery-date": "\n .label =  Delivery date:",
        "pos-order-purchase-time": "\n .label =  Purchase time:",
        "pos-order-customer": "\n .label =  Customer:",

        // Merchant > Reports > Production > Meeting service
        "meeting-service-table-approved-orders": "Approved orders",
        "meeting-service-table-unapproved-orders": "\n .label = Unapproved orders",
        "meeting-service-table-time": "Time",
        "meeting-service-table-start-date": "Start Date",
        "meeting-service-table-end-date": "End Date",
        "meeting-service-table-delivery-type": "Delivery type",
        "delivery-type-filter-all": "All",
        "delivery-type-filter-delivery": "Delivery",
        "delivery-type-filter-pick-up": "Picked up",
        "delivery-type-filter-eating-in-canteen": "Eating in canteen",
        "meeting-service-table-order-id-column": "Order ID",
        "meeting-service-table-delivery-time-column": "Delivery time",
        "meeting-service-table-delivery-location-column": "Meeting",
        "meeting-service-table-meeting-name-column": "Meeting name",
        "meeting-service-table-location-column": "Location",
        "meeting-service-table-amount-column": "Amount",
        "meeting-service-table-changes-column": "Changes",
        "meeting-service-table-changes-column-tooltip-changed": "\n .title = The order has been changed on {$date}",
        "meeting-service-table-changes-column-tooltip-unchanged": "\n .title = The order has not been changed",
        "meeting-service-table-changes-column-active-filter-yes": "Active",
        "meeting-service-table-changes-column-inactive-filter-no": "Inactive",
        "meeting-service-table-lock-column": "Lock",
        "meeting-service-table-lock-column-tooltip-open": "\n .title = The order is open for changes",
        "meeting-service-table-lock-column-tooltip-closed": "\n .title = The order is locked for changes",
        "meeting-service-table-lock-column-lock-tooltip": "\n .title = Block creator from changing this order",
        "meeting-service-table-lock-column-unlock-tooltip": "\n .title = Allow creator to change this order",
        "meeting-service-table-lock-column-active-filter-yes": "Active",
        "meeting-service-table-lock-column-inactive-filter-no": "Inactive",
        "meeting-service-table-meeting": "Delivery: {$locationName}",
        "meeting-service-table-production-slip-button": "Packing slip",
        "meeting-service-table-credit-note-button": "Credit note",
        "meeting-service-table-receipt-button": "Receipt",
        "meeting-service-table-update-button": "Edit",
        "meeting-service-table-duplicate-button": "Duplicate",
        "meeting-service-table-book-button": "Book",
        "meeting-service-table-send-message-button": "Send message",
        "meeting-service-table-delete-button": "Delete",
        "meeting-service-table-date-range-filter": "Date range",
        "meeting-service-table-floating-action-bar-read": "\n .title = Read",
        "meeting-service-table-floating-action-bar-lock-unlock": "\n .title = Lock/unlock",
        "meeting-service-table-floating-action-bar-lock": "\n .title = Lock",
        "meeting-service-table-floating-action-bar-lock-tooltip": "\n .title = Block creator from changing selected orders",
        "meeting-service-table-floating-action-bar-unlock": "\n .title = Unlock",
        "meeting-service-table-floating-action-bar-unlock-tooltip": "\n .title = Allow creator to change selected orders",
        "meeting-service-table-floating-action-bar-book": "\n .title = Book",
        "meeting-service-table-floating-action-bar-status": "\n .title = Status",
        "meeting-service-table-floating-action-bar-delete": "\n .title = Delete",
        "meeting-service-table-floating-action-bar-print": "\n .title = Print",
        "meeting-service-table-floating-action-bar-production-slip": "\n .title = Packing slip",
        "meeting-service-table-floating-action-bar-delivery-list": "\n .title = Delivery list",
        "meeting-service-table-floating-action-bar-receipt": "\n .title = Receipt",
        "meeting-service-table-floating-action-bar-export": "\n .title = Export selected",
        "meeting-service-table-toolbar-export-all": "Export all",
        "meeting-service-delete-orders-title": "Delete orders",
        "meeting-service-delete-order-title": "Delete order",
        "meeting-service-delete-orders-checkbox-label-meeting-service": "\n .label = Meeting service",
        "meeting-service-delete-orders-checkbox-label-booking": "\n .label = Cancel resource booking",
        "meeting-service-delete-orders-checkbox-label-booking-lock": "Cancel resource booking",
        "meeting-service-delete-orders-checkbox-label-meeting-service-cancel": "\n .label = Cancel meeting service",
        "meeting-service-delete-orders-checkbox-label-meeting-service-cancel-lock": "Cancel meeting service",
        "meeting-service-delete-orders-helper-merchant-cancellation-field": `.label = Cancellation message \n .placeholder = Write a reason for cancellation. This message will be sent to the customer. \n .helperText = Remaining characters: { $charsRemaining }`,
        "meeting-service-delete-orders-helper-merchant": "Note: If a resource booking is attached to the meeting service order, it will not be canceled.",
        "meeting-service-delete-orders-helper-line-one": "OBS: If a resource booking is attached to the meeting service order, you can cancel the resource booking on behalf of the creator.",
        "meeting-service-delete-orders-helper-line-two": "Be aware that if you cancel the resource booking, a possible reservation of rooms and associated AV equipment is also canceled and released to other users.",
        "meeting-service-table-order-name-column": "Order name",
        "meeting-service-book-orders-title": "Book orders",
        "meeting-service-book-orders-description": "Orders labeled 'Future' cannot be processed as the delivery date is set for a future date. For orders labeled 'Cash,' please ensure a payment date is specified for the day of payment receipt.",
        "meeting-service-table-status-column": "Status",
        "meeting-service-table-cash-payment-received-column": "Cash payment received",
        "meeting-service-book-orders-subtotal": "Subtotal",
        "meeting-service-book-orders-button": "Book",
        "meeting-service-delete-orders-button": "Delete",
        "merchant-home-meeting-service-awaiting-approval-title": "Awaiting approval",
        "filter-menu-accordion-order-status-title": "\n .title = Order Status",
        "filter-menu-accordion-companies-title": "\n .title = Companies",
        "filter-menu-accordion-checkbox-awaiting-approval": "\n .optionLabel = Awaiting approval",
        "filter-menu-accordion-checkbox-to-be-invoiced": "\n .optionLabel = To be invoiced",
        "meeting-service-table-header-date-range-button": "Date range",
        "meeting-service-table-header-period-picker-button": "Period picker",
        "meeting-service-table-lock-column-locked":"\n .title = The order has been locked by the merchant. Contact merchant for updates.",
        "meeting-service-snackbar-undo": "UNDO",
        "meeting-service-snackbar-undo-message": "{ $amount ->\n  [one] { $amount } order has been set to \n *[other] { $amount } orders have been set to \n}",
        "meeting-service-delivery-list": "Delivery list",
        "meeting-service-delivery-list-period": "Period:<dateRange>{$startLabel} - {$endLabel}</dateRange><icon />",
        "meeting-service-delivery-list-header-period": "Period: {$startLabel} - {$endLabel}",
        "meeting-service-delivery-list-orders-selected": "Orders: {$ordersLength} selected",
        "meeting-service-delivery-list-group-by-label": "Group by:",
        "meeting-service-delivery-list-group-by-location": "Delivery location",
        "meeting-service-delivery-list-group-by-time": "Delivery time",
        "meeting-service-delivery-list-group-by-item": "Group by: delivery {$value}",
        "meeting-service-delivery-list-delivery": "Delivery type:<value>{$value}</value>",
        "meeting-service-delivery-list-filter-all": "All",
        "meeting-service-delivery-list-empty": "No delivery orders for the selected criteria",
        "meeting-service-delivery-list-delivery-details-meeting-time": "\n .label = Meeting time:",
        "meeting-service-delivery-list-delivery-details-location": "\n .label = Delivery location:",
        "meeting-service-delivery-list-delivery-details-sittings": "\n .label = Sittings:",
        "meeting-service-delivery-list-contact-details-meeting-creator": "Creator:",
        "meeting-service-delivery-list-contact-details-meeting-host": "Meeting host:",
        "meeting-service-delivery-list-table-column-items": "Items",
        "meeting-service-delivery-list-table-column-products": "Products",
        "meeting-service-delivery-list-table-column-delivery-time": "Delivery time",

         // Batch modal
        "meeting-service-batch-modal-button-change-label": "Confirm",
        "meeting-service-batch-modal-button-close-label": "Close",
        "meeting-service-batch-modal-button-close-tooltip-label": "\n .label = No orders can change status",
        "meeting-service-batch-modal-warning-message": "Could not change status for orders with this icon",
        "meeting-service-batch-modal-cancellation-reason-message": "Write a reason for the cancellation. This message will be sent out to everyone on the list.",
        "meeting-service-batch-modal-customer-message": "Message to customer",
        "meeting-service-batch-modal-order-id": "Order ID",
        "meeting-service-batch-modal-delivery-time": "Delivery time",
        "meeting-service-batch-modal-order-details": "Order details",
        "meeting-service-batch-modal-from": "From",
        "meeting-service-batch-modal-to": "To",
        "meeting-service-batch-modal-batch-error": "{ $ordersCount ->\n  [one] Could not change status for { $ordersCount } order\n *[other] Could not change status for { $ordersCount } orders\n}",

        // Package slip handle PDF open
        "meeting-service-handle-pdf-open-error": "Couldn't open pdf",

        // Merchant > Reports > Production > Calendar
        "orders-for-calendar-multi-select": "\n .label = Shop type",
        "orders-for-calendar-search": "\n .label = Search \n .placeholder = Search for order id or order name",
        "production-slip-dialog-title": "Production slip",
        "production-slip-dialog-table-header-items": "Items",
        "production-slip-dialog-table-header-products": "Products",
        "production-slip-dialog-table-header-delivery-time": "Delivery time",
        "production-slip-dialog-note": "Order note",
        "production-slip-dialog-order-id": "Order ID: { $orderId }",
        "production-slip-dialog-delivery-details": "Delivery details",
        "production-slip-dialog-delivery-type": "Delivery type:",
        "production-slip-dialog-delivery-time": "Delivery time:",
        "production-slip-dialog-delivery-meeting-time": "Meeting time:",
        "production-slip-dialog-delivery-delivery-location": "Delivery location:",
        "production-slip-dialog-delivery-sittings": "Sittings:",
        "production-slip-dialog-delivery-shop": "Shop:",
        "production-slip-dialog-contact-details": "Contact details",
        "production-slip-dialog-contact-details-creator": "Creator:",
        "production-slip-dialog-contact-details-meeting-host": "Meeting host:",
        "production-slip-dialog-scan": "View production slip on mobile device",

        // Accounting customer
        "customer-accounting-show-customers-with-sales-only": "Show customers with sales only",


        // FloatingActionButton
        "floating-action-button": "Close",
        "floating-action-button-picked": "Selected items",
        "floating-action-button-order-status": "\n .title = Status",
        "floating-action-button-order-status-menu-item": "Change order status",
        "floating-action-button-receipt": "Receipt",
        "floating-action-button-print": "\n .title = Print",
        "floating-action-button-print-receipt": "\n .title = Print receipt",
        "floating-action-button-print-label": "\n .title = Print label",
        "floating-action-button-export": "\n .title = Export",


        //ChangeOrderStatusModal
        "change-order-status": "Change order status",
        "change-order-status-received": "Received",
        "change-order-status-confirmed": "Confirmed",
        "change-order-status-ready": "Ready",
        "change-order-status-cancelled": "Cancelled",
        "change-order-status-title": "Result",

        "change-order-status-received-info-text": "An order is automatically assigned the status Received, when created. If you want to roll back the status from Confirmed to Received, the customer receives a notification. Do only make a roll back in status if you set Confirmed by an accident.",
        "change-order-status-confirmed-info-text": "When an order is set to Confirmed, the customer receives a notification that the order will be processed. The customer can expect to receive his order.",
        "change-order-status-ready-info-text": "When an order is set to Ready, the customer receives a notification that the order can be picked up.",
        "change-order-status-cancelled-info-text": "When an order is set to Canceled, the customer receives a notification that the order will not be delivered. You can write a comment to the customer, why it has been cancelled.",


        //ChangeOrderStatusResponseModal
        "change-order-status-response-modal-title": "Result",
        "change-order-status-response-modal-order-id": "Order id",
        "change-order-status-response-modal-order-delivery": "Delivery date",
        "change-order-status-response-modal-order-message": "Message",
        "change-order-status-response-modal-error": "failed",
        "change-order-status-response-modal-error-aciton": "action",
        "change-order-status-response-modal-error-acitons": "actions",


        // --- Surveys List ---
        "surveys-list-header": "\n .title = Surveys",
        "surveys-list-create-button": "Create survey",
        "surveys-list-survey-table-name-column": "Name",
        "surveys-list-survey-table-start-date-column": "Start Date",
        "surveys-list-survey-table-end-date-column": "End Date",
        "surveys-list-survey-table-active-column-active": "Active",
        "surveys-list-survey-table-active-column-inactive": "Inactive",
        "surveys-list-survey-table-active-column-active-filter-yes": "Active",
        "surveys-list-survey-table-active-column-inactive-filter-no": "Inactive",
        "surveys-table-list-delete-modal-title": "survey",
        "surveys-table-list-show-ratings": "Show ratings",
        "surveys-table-list-delete-success-message": "Survey was deleted",

        // Create / edit survey
        "create-survey-header": "\n .title = Create Survey",
        "edit-survey-header": "\n .title = Edit Survey",
        "nav-item-create-survey-header": "Create Survey",
        "nav-item-edit-survey-header": "Edit Survey",
        "create-merchant-survey-save-button": "Create",
        "edit-merchant-survey-save-button": "Save",
        "create-or-edit-merchant-survey-field-name": "\n .label = Name\n .placeholder = Enter a name for the survey\n .helperText = Description is not shown to the user",
        "create-or-edit-merchant-survey-field-name-required": "Name is required",
        "create-or-edit-merchant-survey-field-description":
            "\n .label = Description\n .placeholder = Enter an optional description for your own use",
        "create-or-edit-merchant-survey-questions": "Your questions:",
        "create-or-edit-merchant-survey-questions-empty": "You have not created any questions yet.",
        "create-or-edit-merchant-survey-field-questions-minError":"You need at least one question",
        "create-or-edit-merchant-survey-add-questions-button": "Add question",
        "create-or-edit-merchant-survey-title-general": "\n .title = General",
        "create-or-edit-merchant-survey-field-active": "Active:",
        "create-or-edit-merchant-survey-field-start-date": "Start date",
        "create-or-edit-merchant-survey-field-end-date": "End date",
        "create-or-edit-merchant-survey-title-user-visibility": "\n .title = User Visibility",
        "create-or-edit-merchant-survey-field-timeOfDay": "\n .label = Time of day",
        "create-or-edit-merchant-survey-field-timeOfDay-helperText": "Determines the time of day rating card for this survey will be shown.",
        "create-or-edit-merchant-survey-field-expirationDays": "\n .label = Expiration days\n .helperText = Days until an unanswered rating card is hidden.",
        "edit-merchant-survey-success-save-message": "Survey was updated",
        "create-merchant-survey-success-save-message": "Survey created",
        "create-or-edit-merchant-survey-dialog-save-button": "Save",
        "create-or-edit-merchant-survey-dialog-title": "Add question",
        "create-or-edit-merchant-survey-dialog-field-question": "\n .label = Question",
        "create-or-edit-merchant-survey-dialog-topics-title": "Select topics:",
        "create-or-edit-merchant-survey-dialog-topics-good": "\n .label = Good topics",
        "create-or-edit-merchant-survey-dialog-topics-bad": "\n .label = Bad topics",
        "create-or-edit-merchant-survey-dialog-topics-info": "Good topics can be used by participant to select what they found particularly good. Bad topics can be used to specify what they would like to see improved.",


        // --- Company ---

        "company-home-purchases-card-group": "\n .title = Purchases",
        "company-home-purchases-period-base-3": "Last 3 days",
        "company-home-purchases-period-base-14": "Last 14 days",
        "company-home-purchases-period-base-30": "Last 30 days",
        "company-home-purchases-period-base-60": "Last 60 days",
        "company-home-purchases-period-base-180": "Last 180 days",
        "company-home-purchases-pos-purchases-title": " \n .title = POS purchases",
        "company-home-purchases-pos-orders-title": " \n .title = POS Orders",
        "company-home-purchases-meeting-service-purchases-title": " \n .title = Meeting service purchases",
        "company-home-purchases-meeting-service-orders-title": " \n .title = Meeting service orders",
        "company-home-purchases-users-title": " \n .title = Users",
        "company-home-purchases-check-in-title": " \n .title = Check-ins",


        // Company > Admin > Home
        "company-admin-home-organization-users-card":  "\n .title = Users \n .description = Manage users.",
        "company-admin-home-organization-bill-receivers-card":  "\n .title = Bill receivers \n .description = Manage bill receivers.",
        "company-admin-home-organization-user-group-card":  "\n .title = User groups \n .description = Manage user groups.",
        "company-admin-home-organization-departments-card":  "\n .title = Departments \n .description = Manage departments.",
        "company-admin-home-organization-locations-card":  "\n .title = Locations \n .description = Manage locations.",
        "company-admin-home-account-gdpr-card":  "\n .title = GDPR \n .description = General Data Protection Regulation \n .buttonText = Show",
        "company-admin-home-account-administrator-card":  "\n .title = Administrators \n .description = Manage administrators.",

        // Navigation
        "company-nav-item-home": "Home",
        "company-nav-item-accounting": "\n .title = Accounting",
        "company-nav-item-pos": "POS",
        "company-nav-item-meeting-service": "Meeting service",
        "company-nav-item-subscriptions": "Subscriptions",
        "company-nav-item-organization": "\n .title = Organization",
        "company-nav-item-users": "Users",
        "company-nav-item-admins": "Administrators",
        "company-nav-item-user-groups": "User groups",
        "company-nav-item-departments": "Departments",
        "company-nav-item-locations": "Locations",
        "company-nav-item-bill-receivers": "Bill receivers",
        "company-nav-item-account-dimensions": "Account dimensions",
        "company-nav-item-settings": "Settings",
        "company-nav-item-account-title": "\n .title = Account",
        "company-nav-item-account": "Account",
        "company-nav-item-gdpr": "GDPR",
        "company-nav-item-data-import-title": "\n .title = Data import",
        "company-nav-item-data-import": "Data import",
        "company-nav-item-id-cards": "ID cards",
        "company-nav-item-account-numbers": "Account numbers",
        "company-nav-item-import-users": "Users",
        "company-nav-item-import-bill-receivers": "Bill receivers",
        "company-nav-item-settings-title": "\n .title = Settings",
        "company-nav-item-custom-jobs": "Custom jobs",


        // Company > Admin > Organization > Departments
        "company-organization-title": "\n .title = Organization",
        "company-organization-departments-title": "Departments",
        "company-organization-departments-header": "\n .title = Departments",
        "company-organization-departments-create-button": "Create",
        "company-organization-departments-table-department-no-column": "Department no.",
        "company-organization-departments-table-name-column": "Name",
        "company-organization-departments-table-status-column": "Status",
        "company-organization-departments-table-active-column-active": "Active",
        "company-organization-departments-table-active-column-inactive": "Inactive",
        "company-organization-departments-table-active-column-active-filter-yes": "Active",
        "company-organization-departments-table-active-column-inactive-filter-no": "Inactive",
        "company-organization-departments-table-edit": "Edit",
        "company-organization-departments-table-delete": "Delete",
        "company-organization-departments-table-delete-modal-title": "department",
        "company-organization-departments-edit-title": "Edit department",
        "company-organization-departments-create-title": "Create department",
        "create-department-header": "\n .title = Create department",
        "edit-department-header": "\n .title = Edit department",
        "edit-department-save-button": "Save",
        "create-department-save-button": "Create",
        "create-or-edit-company-department-field-departmentNo": "\n .label = Department no.\n .placeholder = Enter department no.",
        "create-or-edit-company-department-field-name": "\n .label = Name\n .placeholder = Enter name",
        "create-or-edit-company-department-field-is-required": "Field is required",
        "create-or-edit-company-department-field-active": "Active",
        "create-or-edit-company-department-settings": "\n .title = Settings",
        "create-or-edit-company-department-history": "\n .title = History",

        // Company Admin Organization > User Groups
        "company-organization-user-groups-title": "User groups",
        "company-organization-user-groups-header": "\n .title = User groups",
        "company-organization-user-groups-create-button": "Create",
        "company-organization-user-groups-table-name-column": "Name",
        "company-organization-user-groups-table-domain-column": "Domain",
        "company-organization-user-groups-table-status-column": "Status",
        "company-organization-user-groups-table-active-column-active": "Active",
        "company-organization-user-groups-table-active-column-inactive": "Inactive",
        "company-organization-user-groups-table-active-column-active-filter-yes": "Active",
        "company-organization-user-groups-table-active-column-inactive-filter-no": "Inactive",
        "company-organization-user-groups-table-edit": "Edit",
        "company-organization-user-groups-table-delete": "Delete",
        "company-organization-user-groups-table-delete-modal-title": "\n .typeOfEntity = user group",
        "company-organization-user-group-edit-title": "Edit user group",
        "company-organization-user-group-create-title": "Create user group",
        "create-user-group-header": "\n .title = Create user group",
        "edit-user-group-header": "\n .title = Edit user group",
        "edit-user-group-save-button": "Save",
        "create-user-group-save-button": "Create",
        "create-or-edit-company-user-group-field-name": "\n .label = Name\n .placeholder = Enter name",
        "create-or-edit-company-user-group-field-active": "Active",
        "create-or-edit-company-user-group-settings": "\n .title = Settings",
        "create-or-edit-company-user-group-history": "\n .title = History",
        "create-or-edit-company-user-group-connected-domains": "Connected domains",
        "create-or-edit-company-user-group-connected-domains-empty": "You have not created any domains yet.",
        "create-or-edit-company-user-group-connected-domains-add-button": "\n .title = Add domain",
        "create-or-edit-company-user-group-connected-domains-table-domain": "Domain",
        "create-or-edit-company-user-group-connected-domains-table-status": "Status",
        "create-or-edit-company-user-group-connected-domains-table-status-active": "Active",
        "create-or-edit-company-user-group-connected-domains-table-status-pending": "Pending / Invitation sent",
        "create-or-edit-company-user-group-connected-domains-table-resend-invitation": "Resend invitation",
        "create-or-edit-company-user-group-connected-domains-table-delete": "Delete",
        "company-organization-user-groups-table-delete-modal-domain": "\n .typeOfEntity = domain",
        "create-or-edit-company-user-group-connected-domains-modal-add-domain": "Add domain",
        "create-or-edit-company-user-group-connected-domains-modal-resend-invitation": "Resend invitation for domain",
        "create-or-edit-company-user-group-connected-domains-modal-field-domain": "\n .label = Domain\n .placeholder = Enter domain",
        "create-or-edit-company-user-group-connected-domains-modal-field-username": "\n .label = User name\n .placeholder = Enter user name",
        "create-or-edit-company-user-group-connected-domains-modal-send-invitation": "Send invitation",
        "create-or-edit-company-user-group-connected-bill-receiver": "Bill receiver",
        "create-or-edit-company-user-group-connected-bill-receiver-empty": "You have not created bill receiver yet.",
        "create-or-edit-company-user-group-connected-bill-receiver-add-button": "\n .title = Add bill receiver",
        "create-or-edit-company-user-group-connected-bill-receiver-table-name": "Name",
        "create-or-edit-company-user-group-connected-bill-receiver-table-address": "Address",
        "create-or-edit-company-user-group-connected-bill-receiver-table-end-point": "End point",
        "create-or-edit-company-user-group-connected-bill-receiver-table-remove": "Remove",
        "create-or-edit-company-user-group-connected-bill-receiver-modal-add-bill-receiver": "\n .title = Add bill receiver",
        "create-or-edit-company-user-group-connected-bill-receiver-modal-update-bill-receiver": "\n .title = Found similar bill receivers. Are you sure you want to create a new?",
        "create-or-edit-company-user-group-connected-bill-receiver-modal-field-search": "\n .label = Search\n .placeholder = Search by name, CVR, EAN, email or address",
        "create-or-edit-company-user-group-connected-bill-receiver-modal-info-text": "Start typing to show search results",
        "create-or-edit-company-user-group-connected-bill-receiver-modal-info-warning": "You should create a new bill receiver with the same identifier (CVR, EAN, email) only if the contact details differ. For example, this may be necessary if the bill needs to be directed to a different individual.",
        "create-or-edit-company-user-group-connected-bill-receiver-modal-empty": "No search results found",
        "create-or-edit-company-user-group-connected-bill-receiver-modal-cvr": "CVR:",
        "create-or-edit-company-user-group-connected-bill-receiver-modal-ean": "EAN:",
        "create-or-edit-company-user-group-connected-bill-receiver-modal-email": "Email:",
        "create-or-edit-company-user-group-connected-bill-receiver-modal-address": "Address:",
        "create-or-edit-company-user-group-connected-bill-receiver-modal-or": "Or",
        "create-or-edit-company-user-group-connected-bill-receiver-modal-submit-button": "Choose selected bill receiver",
        "create-or-edit-company-user-group-connected-bill-receiver-modal-submit-update-button": "Update selected bill receiver",
        "create-or-edit-company-user-group-connected-bill-receiver-modal-create-button": " Create new bill receiver",
        "create-or-edit-company-user-group-connected-bill-receiver-modal-bill-found": "{ $count } bill receiver(s) already exists with the same identifier.",

        // Company > Admin > Account > GDPR
        "company-account-gdpr-title":"\n .title = GDPR",

        // Company > Admin > Data import
        "data-import-csv-field-update-key": "\n .label = Update key",
        "data-import-csv-settings": "\n .title = Settings",
        "data-import-csv-field-update-identical": "Update identical",
        "data-import-csv-field-delete-existing": "Delete existing",

        // Company > Admin > Data import > ID cards
        "company-data-import-id-cards-title": "\n .title = Import ID cards",
        "create-or-edit-company-id-cards-field-user-group": "\n .label = User group",
        "create-or-edit-company-id-cards-select-item-all": "All",
        "create-or-edit-company-id-cards-update-key-mode-initials": "Initials",
        "create-or-edit-company-id-cards-update-key-mode-email": "Email",
        "create-or-edit-company-id-cards-update-key-mode-employee-number": "Employee number",


        // Company > Admin > Data import > Account number
        "company-data-import-account-numbers-title": "\n .title = Import account numbers",
        "create-or-edit-company-account-numbers-field-accounting-dimension": "\n .label = Accounting dimension",
        "create-or-edit-company-account-numbers-select-item-all": "All",
        "create-or-edit-company-account-numbers-update-key-mode-account-number": "Account number",
        "create-or-edit-company-account-numbers-update-key-mode-account-name": "Account name",

        // Company > Admin > Data import > Users
        "company-data-import-users-title": "\n .title = Import users",
        "company-data-import-users-field-user-group": "\n .label = User group",
        "company-data-import-users-select-item-from-file": "From file",

        // Company > Admin > Data import > Bill receivers
        "company-data-import-bill-receivers-title": "\n .title = Import bill receivers",
        "company-data-import-bill-receivers-receiver-type": "\n .label = Receiver type",
        "company-data-import-bill-receivers-receiver-type-mode-private-person": "Private person / association",
        "company-data-import-bill-receivers-receiver-type-mode-public-institution": "Public institution",
        "company-data-import-bill-receivers-receiver-type-mode-private-company": "Private company",
        "company-data-import-bill-receivers-receiver-type-mode-from-file": "From file",

        // Company > Admin > Settings > Custom jobs
        "company-admin-settings-custom-jobs-title":" \n .title = Custom jobs",
        "company-admin-settings-custom-jobs-table-name":"Name",
        "company-admin-settings-custom-jobs-table-interval":"Interval",
        "company-admin-settings-custom-jobs-table-last-run":"Last run",
        "company-admin-settings-custom-jobs-table-status":"Status",
        "company-admin-settings-custom-jobs-table-action-details":"Details",
        "company-admin-settings-custom-jobs-table-action-run-job":"Run job",
        "company-admin-settings-custom-jobs-table-action-activate":"Activate",
        "company-admin-settings-custom-jobs-table-action-inactivate":"Inactivate",

        // Import result
        "import-result-title": "\n .title = Import result",
        "import-result-breadcrumb": "Result",
        "import-result-succeeded": "Import succeeded",
        "import-result-results": "Results:",
        "import-result-created": "Created:",
        "import-result-updated": "Updated:",
        "import-result-deleted": "Deleted:",

        // Company Meeting Service
        "company-meeting-service-title": "Meeting Service",
        "company-meeting-service-header": "\n .title = Meeting Service",
        "company-meeting-service-table-booked-start-date": "Book from",
        "company-meeting-service-table-booked-end-date": "Book to",
        "company-meeting-service-table-merchant": "Merchant",
        "company-meeting-service-table-order-id-column": "Order ID",
        "company-meeting-service-table-booked-date-column": "Booked date",
        "company-meeting-service-table-delivery-time-column": "Delivery time",
        "company-meeting-service-table-employee-column": "Employee",
        "company-meeting-service-table-amount-column": "Amount (DKK)",
        "company-meeting-service-table-show-receipt": "Show receipt",
        "company-meeting-service-table-floating-action-bar-receipts": "\n .title = Receipts",
        "company-meeting-service-table-floating-action-bar-export": "\n .title = Export",

        // Company Subscriptions
        "company-subscriptions-title": "Subscriptions",
        "company-subscriptions-header": "\n .title = Subscriptions",
        "company-subscriptions-table-subscription-column": "Subscription",
        "company-subscriptions-table-order-id-column": "Order ID",
        "company-subscriptions-table-employee-column": "Employee",
        "company-subscriptions-table-subscribed-column": "Subscribed",
        "company-subscriptions-table-unsubscribed-column": "Unsubscribed",
        "company-subscriptions-table-payment-column": "Payment",
        "company-subscriptions-table-amount-column": "Amount",
        "company-subscriptions-table-cancel-subscription": "Cancel subscription",
        "company-subscriptions-table-details": "Details",

        // Accounting - POS Purchases
        "accounting-pos-table-header-title": "\n .title = POS",
        "accounting-pos-table-header-nav-item-home": "Home",
        "accounting-pos-table-header-nav-item-accounting": "Accounting",
        "accounting-pos-table-header-nav-item-pos": "POS",
        "accounting-pos-table-header-order-id": "Order ID",
        "accounting-pos-table-header-transaction-time": "Transaction time",
        "accounting-pos-table-header-employee": "Employee",
        "accounting-pos-table-header-payment": "Payment",
        "accounting-pos-table-header-amount": "Amount (DKK)",
        "support-entity-table-button-show-receipt": "Show receipt",
        "accounting-pos-table-header-merchant-label":"\n .label = Merchant",
        "accounting-pos-table-footer-total-in-period":"Total in this period (DKK)",

          // Organization - Users
        "company-organization-users-page-header": "\n .title = Users",
        "company-organization-users-table-header-user-group":"User Group",
        "company-organization-users-table-header-name":"Name",
        "company-organization-users-table-header-employee-id":"Employee id",
        "company-organization-users-table-header-email":"Email",
        "company-organization-users-table-header-status":"Status",
        "company-organization-users-table-status-active":"Active",
        "company-organization-users-table-status-inactive": "Inactive",
        "company-organization-users-table-button-details": "Details",
        "company-organization-users-table-button-edit": "Edit",
        "company-organization-users-table-button-delete": "Delete",
        "company-organization-users-button-create": "Create",
        "company-admin-nav-item-organization": "Organization",
        "company-admin-nav-item-users": "Users",
        "company-organization-users-table-header-select-label-user-group": "User Group",
        "company-organization-users-table-header-select-item-all": "All",


        // Organization - Admins
        "company-organization-admins-page-header": "\n .title = Administrators",
        "company-organization-admins-table-header-name":"Name",
        "company-organization-admins-table-header-email":"Email",
        "company-organization-admins-table-header-status":"Status",
        "company-organization-admins-table-status-active":"Active",
        "company-organization-admins-table-status-inactive": "Inactive",
        "company-organization-admins-table-button-details": "Show details",
        "company-organization-admins-table-button-edit": "Edit user",
        "company-organization-admins-table-button-delete": "Delete user",
        "company-organization-admins-button-create": "Create",
        "company-admin-nav-item-admins": "Administrators",

        // Company Admin Organization Locations
        "company-organization-locations-title": "Locations",
        "company-organization-locations-header": "\n .title = Locations",
        "company-organization-locations-create-button": "Create",
        "company-organization-locations-table-name-column": "Name",
        "company-organization-locations-table-status-column": "Status",
        "company-organization-locations-table-active-column-active": "Active",
        "company-organization-locations-table-active-column-inactive": "Inactive",
        "company-organization-locations-table-active-column-active-filter-yes": "Active",
        "company-organization-locations-table-active-column-inactive-filter-no": "Inactive",
        "company-organization-locations-table-edit": "Edit",
        "company-organization-locations-table-delete": "Delete",
        "company-organization-locations-table-delete-modal-title": "location",
        "company-organization-locations-edit-title": "Edit location",
        "company-organization-locations-create-title": "Create location",
        "create-location-header": "\n .title = Create location",
        "edit-location-header": "\n .title = Edit location",
        "edit-location-save-button": "Save",
        "create-location-save-button": "Create",
        "create-or-edit-company-location-field-name": "\n .label = Name\n .placeholder = Enter name",
        "create-or-edit-company-location-field-is-required": "Field is required",
        "create-or-edit-company-location-field-active": "Active",
        "create-or-edit-company-location-settings": "\n .title = Settings",
        "create-or-edit-company-location-history": "\n .title = History",
        "create-or-edit-company-location-field-street": "\n .label = Street\n .placeholder = Enter street",
        "create-or-edit-company-location-field-streetNumber": "\n .label = Street no\n .placeholder = Enter street no",
        "create-or-edit-company-location-field-postalCode": "\n .label = Postal code\n .placeholder = Enter postal code",
        "create-or-edit-company-location-field-city": "\n .label = City\n .placeholder = Enter city",
        "create-or-edit-company-location-field-country": "\n .label = Country",
        "create-or-edit-company-location-field-country-denmark-item": "Denmark",
        "create-or-edit-company-location-field-shops": "\n .label = Connected shops",

        // Accounting - Bill receivers
        "company-accounting-bill-receivers-table-header-title": "\n .title = Bill receivers",
        "company-accounting-bill-receivers-table-header-name":"Name",
        "company-accounting-bill-receivers-table-header-endpoint":"Endpoint",
        "company-accounting-bill-receivers-table-header-debitor-id":"Debitor id",
        "company-accounting-bill-receivers-table-header-status":"Status",
        "company-accounting-bill-receivers-table-status-active":"Active",
        "company-accounting-bill-receivers-table-status-inactive": "Inactive",
        "company-accounting-bill-receivers-table-button-edit": "Edit",
        "company-accounting-bill-receivers-table-button-delete": "Delete",
        "company-accounting-bill-receivers-button-create": "Create",
        "company-accounting-bill-receivers-table-header-nav-item-home": "Home",
        "company-accounting-bill-receivers-table-header-nav-item-accounting": "Accounting",
        "company-accounting-bill-receivers-table-header-nav-item-bill-receivers": "Bill receivers",

        // Accounting - Bill receivers - Create Dialog
        "bill-receivers-create-dialog-title": "Create bill receiver",
        "bill-receivers-create-dialog-customer-type": "Customer type:",
        "bill-receivers-create-dialog-select-bill-receiver": " Select existing bill receiver:",
        "bill-receivers-create-dialog-country": "Country:",
        "bill-receivers-create-dialog-button-create": "Create",
        "bill-receivers-create-dialog-button-save": "Save",
        "bill-receivers-form-error-label-country":"Country",
        "bill-receivers-form-error-label-debtor-number":"Debtor number",
        "bill-receivers-form-error-label-address-line-1":"Address line 1",
        "bill-receivers-form-error-label-address-line-2":"Address line 2",
        "bill-receivers-form-error-label-postal-code":"Postal code",
        "bill-receivers-form-error-label-city":"City",
        "bill-receivers-form-error-label-telephone":"Telephone",
        "bill-receivers-form-error-label-name":"Name",
        "bill-receivers-form-error-label-institution-name":"Institution name",
        "bill-receivers-form-error-label-email":"Email",
        "bill-receivers-form-error-label-contact-person":"Contact person",
        "bill-receivers-form-error-label-company-name":"Company name",
        "bill-receivers-validation-ean-13-digits": "EAN number must be 13 digits",
        "bill-receivers-validation-cvr-8-digits": "CVR number must be 8 digits",
        "bill-receivers-validation-postal-code-4-digits": "Postal code must be 4 digits",
        "bill-receivers-validation-email-invalid": "Please enter a valid email address",
        "bill-receivers-validation-telephone-invalid": "Telephone must contain only digits and the characters + - ( ) and spaces",
        "bill-receivers-validation-max-length": "{ $label } must be at most { $max } characters",
        "bill-receivers-select-type":"Select type:",
        "bill-receivers-select-list-label": "Select bill receiver",
        "bill-receivers-select-label":"Select receiver:",
        "bill-receivers-select-private-person":"Private person / association",
        "bill-receivers-select-email":"Email",
        "bill-receivers-select-public-institution":"Public institution",
        "bill-receivers-select-ean-number":"EAN number",
        "bill-receivers-select-private-company":"Private company",
        "bill-receivers-select-cvr-number":"CVR number",
        "bill-receivers-company-number":"Enter company number:",
        "bill-receivers-input-search-label-number-cvr":"\n .label = CVR number",
        "bill-receivers-button-continue":"Continue",
        "bill-receivers-send-invoice":"Send invoice to:",
        "bill-receivers-select-label-input-type":"Type",
        "bill-receivers-dropdown-type":"\n .label = Type",
        "bill-receivers-select-item-email":"Email",
        "bill-receivers-select-item-ean-number":"EAN Number",
        "bill-receivers-form-label-address-1":"\n .label = Address line 1 (*)\n .placeholder = Street and street number",
        "bill-receivers-form-label-address-2":"\n .label = Address line 2\n .placeholder = Floor, apartment no., etc.",
        "bill-receivers-form-label-postal-code":"\n .label = Postal code (*)",
        "bill-receivers-form-label-city":"\n .label = City (*)",
        "bill-receivers-form-label-country":"\n .label = Country (*)",
        "bill-receivers-form-country-select-da": "Denmark",
        "bill-receivers-form-contact-person":"Contact person",
        "bill-receivers-form-label-contact-person":"\n .label = Contact person (*)",
        "bill-receivers-form-label-email":"\n .label = Email (*)",
        "bill-receivers-form-label-telephone":"\n .label = Telephone (*)",
        "bill-receivers-form-label-name":"\n .label = Name (*)",
        "bill-receivers-form-label-institution-name":"\n .label = Name (*)",
        "bill-receivers-form-label-debtor-number":"\n .label = Debtor number\n .placeholder = Identifier of debtor in your accounting system",
        "bill-receivers-form-label-company-name":"\n .label = Company name (*)",
        "bill-receivers-input-search-label-email":"\n .label = Email",
        "bill-receivers-input-search-label-ean-number":"\n .label = EAN Number",


        // --- Service center --
        "service-center-home-coming-soon-placeholder": "\n .title = Coming soon\n .body = We are working to bring you the new service center portal. In the meantime please use https://bestil-nu.net.",

        // Navigation
        "service-center-nav-item-home": "Home",

        // Navigation > Admin
        "service-center-admin-nav-item-organization-page-header": "\n .title = Organization",
        "service-center-admin-nav-item-organization": "Organization",
        "service-center-admin-nav-item-organization-resources": "Resources",
        "service-center-admin-nav-item-organization-devices": "Devices",
        "service-center-admin-nav-item-organization-devices-create": "Create devices",
        "service-center-admin-nav-item-organization-devices-edit": "Edit devices",
        "service-center-admin-nav-item-account-page-header": "\n .title = Account",
        "service-center-admin-nav-item-account-administrators": "Administrators",
        "service-center-admin-nav-item-organization-resource-crate-room": "Create room",
        "service-center-admin-nav-item-organization-resource-update-room": "Update room",
        "service-center-admin-nav-item-organization-resource-crate-car": "Create car",
        "service-center-admin-nav-item-organization-resource-update-car": "Update car",
        "service-center-admin-nav-item-organization-resource-crate-mobile-av": "Create Mobile AV",
        "service-center-admin-nav-item-organization-resource-update-mobile-av": "Update Mobile AV",

        // Service center > Admin > Home >
        "service-center-admin-home-organization-resources-card": "\n .title = Resources \n .description = Create and manage the resources that can be booked in your service center.",
        "service-center-admin-home-organization-devices-card": "\n .title = Devices \n .description = Manage your hardware devices such as room displays and info screens.",
        "service-center-admin-home-account-administrators-card": "\n .title = Administrators \n .description = Manage the administrators for your merchant.",


        // --- User --

        // Navigation
        "user-nav-item-home": "Home",
        "user-nav-item-upcoming-orders-title": "\n .title = Upcoming orders",
        "user-nav-item-upcoming-orders-purchases": "Daily purchases",
        "user-nav-item-upcoming-orders-meeting-service": "Meeting service",
        "user-nav-item-upcoming-orders-resource-bookings": "Resource bookings",
        "user-nav-item-archive-title": "\n .title = Archive" ,
        "user-nav-item-archive": "Archive",
        "user-nav-item-settings": "Settings" ,
        "user-nav-item-wallets-title": "\n .title = Wallets" ,
        "user-nav-item-wallets": "Wallets",
        "user-nav-item-wallets-refill": "Refill",
        "user-nav-item-home-label": "\n .title = Go to home dashboard" ,
        "user-nav-item-calendar-label": "\n .title = Show calendar with orders" ,
        "user-nav-item-upcoming-orders-label": "\n .title = Show upcoming orders" ,
        "user-nav-item-archive-label": "\n .title = Show archived orders" ,
        "user-nav-item-settings-label": "\n .title = Settings",

        // User > Home > Top bar
        "user-home-top-bar-tab-switcher-overview": "Overview",
        "user-home-top-bar-tab-switcher-upcoming": "Upcoming",

        // User > Home > Top bar > News drawer
        "user-home-top-bar-news-title": "\n .title = Facilitynet news",
        "user-home-top-bar-news-no-notifications": "\n .title = No messages right now\n .description = Here you will be able to read messages from the merchant and service center.",
        "user-home-top-bar-news-notification-time-type-news": "News",
        "user-home-top-bar-news-notification-time-type-info": "Information",
        "user-home-top-bar-news-notification-time-type-important": "Important",
        "user-home-top-bar-news-notification-time-type-offer": "Offer",
        "user-home-top-bar-news-notification-time-type-event": "Event",
        "user-home-top-bar-news-notification-time-type-reminder": "Reminder",
        "user-home-top-bar-news-notification-time-type-menu-change": "Menu",
        "user-home-top-bar-news-notification-time-type-feedback": "Feedback",
        "user-home-top-bar-news-notification-time-type-health": "Health",
        "user-home-top-bar-news-notification-menu-title": "Messages",

        // User > Home > Week menus
        "user-home-week-menu-title": "Week menu",
        "user-home-week-menu-no-menus-title": "No menu available",
        "user-home-week-menu-no-menus": "Unfortunately, no menus have been created this week.",
        "user-home-week-menu-no-menus-today": "No menu for this day",
        "user-home-week-menu-select-location-dialog-title": "Change location",
        "user-home-week-menu-select-location-search-filter": "\n .placeholder = Search on name, address, shop number...",
        "user-home-week-menu-select-location-dialog-kitchen-item-button": "Select",
        "user-home-week-menu-dialog-title": "Todays menu",
        "user-home-week-menu-dialog-allergens": "Allergens:",


        // User > Home >Dashboard
        "user-home-upcoming-orders": "Upcoming orders",
        "user-home-canteen": "Canteen",
        "user-home-canteen-offers": "Offers",
        "user-home-canteen-today-menu": "Today's Menu",
        "user-home-canteen-today-menu-show-menu": " Show menu signage...",
        "user-home-canteen-news": "News",
        "user-home-upcoming-meetings": "Meetings",
        "user-home-upcoming-meetings-no-meetings": "No upcoming meetings",
        "user-home-empty-offers-text": "You have no offers right now",
        "user-home-upcoming-purchases": "Purchases",
        "user-home-upcoming-purchases-load-error": "Could not load purchases",
        "user-home-upcoming-purchase-card-title-lunch": "Lunch order",
        "user-home-upcoming-purchase-card-title-take-away": "Take away",
        "user-home-upcoming-purchase-card-title-pos": "Lunch order",
        "user-home-upcoming-purchase-card-title-lunch-subscription": "Lunch subscription",
        "user-home-upcoming-purchases-no-purchases": "No upcoming purchases",
        "user-home-upcoming-meeting-service-approved": "\n .label = Approved",
        "user-home-upcoming-meeting-service-approved-tooltip":  "\n .label = The order has been approved by the merchant.",
        "user-home-upcoming-meeting-service-sittings": "{ $sittings } seats",
        "user-home-upcoming-meeting-service-attendees": "{ $attendees } participants",
        "user-home-upcoming-meeting-service-locked": "Locked",
        "user-home-upcoming-purchases-check-in-reminder": "Check-in reminder",
        "user-home-upcoming-purchases-learn-more": "View more",
        "user-home-upcoming-purchases-check-in-subtitle": "Remember to check into the canteen today.",
        "user-home-canteen-contact-canteen": "Contact canteen",
        "user-dashboard-error-offers-unavailable": "Offers is temporarily unavailable.",
        "user-dashboard-error-week-menu-unavailable": "Week menu is temporarily unavailable.",
        "user-dashboard-error-news-menu-unavailable": "News menu is temporarily unavailable.",
        "user-dashboard-error-merchant-contact-unavailable": "Merchant contact details is temporarily unavailable.",
        "user-home-canteen-news-category-company": "\n .label = Company",
        "user-home-canteen-news-category-service-center": "\n .label = Service Center",
        "user-home-canteen-news-category-kitchen": "\n .label = Kitchen",
        "user-home-canteen-news-category-no-actions":  "No actions available for order #{ $orderId }",
        "user-home-canteen-upcoming-orders-dialog-ok-button": "Ok",
        "user-home-canteen-upcoming-orders-delete-item": "Delete",
        "user-home-canteen-upcoming-orders-delete-order": "Delete order",
        "user-home-canteen-upcoming-orders-delete-order-restriction-message": "You are not allowed to delete this order",
        "user-home-canteen-upcoming-orders-refund-order": "Refund order",
        "user-home-canteen-upcoming-orders-refund-order-restriction-message": "You are not allowed to refund this order",
        "user-home-canteen-upcoming-orders-receipt-item": "Receipt",
        "user-home-canteen-upcoming-orders-edit-item": "Edit",
        "user-home-canteen-upcoming-orders-update-booking-restriction-message": "You are not allowed to update booking",
        "user-home-canteen-upcoming-orders-extend-booking-item": "Extend booking",
        "user-home-canteen-upcoming-orders-extend-booking-restriction-message": "You are not allowed to extend booking",
        "user-home-canteen-upcoming-orders-end-booking-item": "End booking",
        "user-home-canteen-upcoming-orders-end-booking-restriction-message": "You are not allowed to end booking",
        "user-home-canteen-upcoming-orders-update-meeting-service-item-meeting-service": "Update",
        "user-home-canteen-upcoming-orders-update": "Edit",
        "user-home-canteen-upcoming-orders-update-meeting-restriction-message": "You are not allowed to update this order",
        "user-home-canteen-upcoming-orders-duplicate-meeting-service-item-meeting-service": "Duplicate",
        "user-home-canteen-upcoming-orders-duplicate-meeting-service-item-resource-booking": "Duplicate meeting service",
        "user-home-canteen-upcoming-orders-end-modal-confirm": "Confirm",
        "user-home-canteen-upcoming-orders-cancel-modal-confirm": "Cancel",
        "user-home-canteen-upcoming-orders-extend-modal-title": "Extend booking",
        "user-home-canteen-upcoming-orders-extend-modal-subtitle": "Extend booking { $meetingName } to { $meetingTime }?",
        "user-home-canteen-upcoming-orders-extend-modal-max-error": "Maximum available time is { $maxAvailableMinutes } minutes.",
        "user-home-canteen-upcoming-orders-extend-input-custom-time": "\n .label = Select end time:",
        "user-home-canteen-upcoming-orders-extend-other-button": "Other",
        "user-home-canteen-upcoming-orders-delete-modal-title": "\n .typeOfEntity = meeting",
        "user-home-canteen-upcoming-orders-delete-modal-error": "Could not delete order",
        "user-home-canteen-upcoming-orders-delete-modal-booking-label": "\n .label = Delete booking",
        "user-home-canteen-upcoming-orders-delete-modal-meeting-label": "\n .label = Delete meeting service",
        "user-home-meeting-service-action-update-booking": "Update Booking",
        "user-home-meeting-service-action-edit": "Edit order",
        "user-home-meeting-service-action-end-booking": "End Booking",
        "user-home-meeting-service-action-update-meeting-service": "Update Meeting Service",
        "user-home-meeting-service-action-duplicate-meeting-service": "Duplicate Order",
        "user-home-meeting-service-description-update-booking": "Are you sure you want to update booking #{ $orderId }, { $meetingName }?",
        "user-home-meeting-service-description-end-booking": "Are you sure you want to end booking #{ $orderId }, { $meetingName }?",
        "user-home-meeting-service-description-update-meeting-service-catering": "Do you want to update order #{ $orderId }, { $meetingName } with delivery on { $deliveryDate }?",
        "user-home-meeting-service-description-update-meeting-service": "Do you want to update order #{ $orderId }, { $meetingName } for meeting on { $deliveryDate }?",
        "user-home-meeting-service-description-duplicate-meeting-service": "Do you want to duplicate order #{ $orderId }, { $meetingName } with delivery on { $deliveryDate }?",
        "user-home-meeting-service-action-confirm-modal-meeting-name": "Meeting Name:",
        "user-home-meeting-service-action-confirm-modal-delivery-date-name": "Delivery Date:",
        "user-home-meeting-service-action-confirm-modal-order-id": "Order ID:",
        "user-home-canteen-upcoming-orders-extend-success-dialog-title": "Booking was extended",
        "user-home-canteen-upcoming-orders-delete-success-dialog-title": "Booking was deleted",
        "user-home-canteen-upcoming-orders-delete-order-success-dialog-title":
            "{ $ordersCount ->\n *[one] Order was deleted\n [other] Orders were deleted\n }",
        "user-home-canteen-upcoming-orders-end-success-dialog-title": "Booking was ended",


        // User > Home > Offers
        "user-home-offers-title": "Offers",

        // User > Home > Offers
        "user-home-news-from-kitchen": "News from the kitchen",


         // User > Home > Opening hours
        "user-home-opening-hours-title": "Opening hours",
        "user-home-opening-day-1": "Mon:",
        "user-home-opening-day-2": "Tue:",
        "user-home-opening-day-3": "Wed:",
        "user-home-opening-day-4": "Thu:",
        "user-home-opening-day-5": "Fri:",

        // User > Home > Room finder
        "user-homeroom-finder-title": "Room finder",
        "user-home-room-finder-resource-type-dropdown": "\n .label = Resource type",
        "user-home-room-finder-resource-date": "\n .label = Date:",
        "user-home-room-finder-resource-duration": "\n .label = Duration:",
        "user-home-room-finder-resource-time": "Time:",
        "user-home-room-finder-resource-seats": "Seats:",
        "user-home-room-finder-resource-book-button": "Book ({ $amount })",
        "user-home-room-finder-resource-results-amount": "{ $amount } results",
        "user-home-room-finder-resource-select-button": "Select",
        "user-home-room-finder-resource-unselect-button": "Remove",
        "user-home-room-finder-go-to-timeline-button": "Go To Timeline",
        "user-home-room-finder-subtitle": "Your intelligent companion for finding resources.",
        "user-home-room-finder-find-a-room-button": "Find a room",
        "user-home-room-finder-available-rooms": "available rooms",


        // User > Upcoming orders > Meeting service
        "user-upcoming-orders-meeting-service-title": "\n .title = Meeting service",

        // User > Upcoming orders > Resource bookings
        "user-upcoming-orders-resource-booking-table-id": "Order ID",
        "user-upcoming-orders-resource-booking-table-time": "Time",
        "user-upcoming-orders-resource-booking-table-meeting": "Meeting",
        "user-upcoming-orders-resource-booking-table-visibility": "Visibility",
        "user-upcoming-orders-resource-booking-table-visibility-public": "Public",
        "user-upcoming-orders-resource-booking-table-visibility-public-tooltip": "The booking is public which means that the meeting name and attendee names are visible for co-workers.",
        "user-upcoming-orders-resource-booking-table-visibility-private": "Private",
        "user-upcoming-orders-resource-booking-table-visibility-private-tooltip": "The booking is private which means that the meeting name and attendee names are not visible to anyone.",
        "user-upcoming-orders-resource-booking-table-action-delete": "Delete",
        "user-upcoming-orders-resource-booking-table-remove-dialog": "\n .title = Remove booking\n .message = Are you sure that you want to remove booking?\n .buttonLabelSubmit = Remove",


        // User > Settings
        "user-settings-page-title": "\n .title = Settings",
        "user-settings-tab-bill-receivers": "My bill receivers",
        "user-settings-tab-guest-reception": "Guest reception",
        "user-settings-tab-calendar-sharing": "Calendar sharing",
        "user-settings-tab-access-control": "Access control",
        "user-settings-table-header-name": "Name",
        "user-settings-table-header-address": "Address",
        "user-settings-table-header-endpoint": "Endpoint",
        "user-settings-table-header-status": "Status",
        "user-settings-status-active": "Active",
        "user-settings-status-inactive": "Inactive",
        "user-settings-status-pending": "Pending",
        "user-settings-action-edit": "Edit",
        "user-settings-action-delete": "Delete",
        "user-settings-action-activate": "Activate",
        "user-settings-action-deactivate": "Deactivate",
        "user-settings-coming-soon": "Coming soon",
        "user-settings-bill-receivers-info": "\n .title = Here are your personal bill receivers, which you can select when ordering meeting service. You have the option to create a new bill receiver during the ordering process, if the selected canteen allows it.",
        "user-settings-delete-bill-receiver-dialog": "\n .typeOfEntity = bill receiver",
        "user-settings-edit-bill-receiver-dialog-title": "Edit bill receiver",
        "user-settings-edit-bill-receiver-page-header": "\n .title = Edit bill receiver",
        "user-settings-edit-bill-receiver-name-field": "\n .label = Name",
        "user-settings-edit-bill-receiver-vatnumber-field": "\n .label = VAT number",
        "user-settings-edit-bill-receiver-address-panel": "\n .title = Address",
        "user-settings-edit-bill-receiver-endpoint-panel": "\n .title = Invoice delivery",
        "user-settings-edit-bill-receiver-endpoint-type-field": "\n .label = Type",
        "user-settings-edit-bill-receiver-endpoint-value-field": "\n .label = Value",
        "user-settings-edit-bill-receiver-contact-panel": "\n .title = Contact person",
        "user-settings-edit-bill-receiver-settings-panel": "\n .title = Settings",
        "user-settings-edit-bill-receiver-active-switch": "Active",
        "user-settings-edit-bill-receiver-save-button": "Save",
        "user-nav-item-edit-bill-receiver": "Edit bill receiver",

        // User > Settings > Wallets
        "user-settings-wallets-title": "\n .title = Wallets",

        // User > Wallets > Refill
        "user-wallets-refill-title": "\n .title = Refill wallet",
        "user-wallets-refill-manual-top-up-nav-tab": "Manual top up",
        "user-wallets-refill-automatic-top-up-nav-tab": "Automatic top up",
        "user-wallets-refill-manual-type": "\n .statusLabel = Manual",
        "user-wallets-refill-automatic-type": "\n .statusLabel = Automatic",
        "user-wallets-refill-payment-success": "Order processed",
        "user-wallets-refill-payment-unexpected-error": "An unexpected error occurred",
        "user-wallets-refill-payment-timeout": "Payment timed out",
        "user-wallets-refill-payment-wait-label": "Processing Payment",
        "user-wallets-refill-payment-wait-description":  "Please wait while we process your payment. This may take a few moments.",
        "user-wallets-refill-payment-back-action-button-label": "Back to dashboard",
        "user-wallets-refill-payment-timeout-label": "Payment Timed Out",
        "user-wallets-refill-payment-timeout-description": "We haven't received confirmation from your payment provider. Please check your netbank to be sure that the payment was completed.",
        "user-wallets-refill-payment-canceled-label":  "Payment canceled",
        "user-wallets-refill-payment-canceled-description":  "You've canceled the payment process. No charges have been made to your account.",
        "user-wallets-refill-payment-failed-label": "Payment failed.",
        "user-wallets-refill-payment-failed-description": "Your payment could not be completed. Please confirm your details and try again.",

        // User > Wallets > Refill > Manual tab
        "user-wallets-refill-manual-main-amount-label": "\n .label = Amount",
        "user-wallets-refill-manual-main-amount-error":"Your wallet can't exceed { $maxBalance}. You can max refill { $maxRefillAmount }",
        "user-wallets-refill-manual-main-amount-max-error":"Maximum amount to refill is { $maxRefillAmount }",
        "user-wallets-refill-manual-main-amount-zero-error":"Amount must be greater than 0",
        "user-wallets-refill-auto-amount-max-threshold-error":"Maximum threshold is { $maxThreshold }",
        "user-wallets-refill-payment-method-error":"Payment method is required",
        "user-wallets-refill-manual-main-custom-amount-label": "\n .label = Enter amount:",
        "user-wallets-refill-manual-main-amount-amount-100": "100,00 kr",
        "user-wallets-refill-manual-main-amount-amount-300": "300,00 kr",
        "user-wallets-refill-manual-main-amount-amount-500": "500,00 kr",
        "user-wallets-refill-manual-main-amount-amount-other": "Other",
        "user-wallets-refill-manual-main-payment-method": "Payment methods:",
        "user-wallets-refill-manual-main-select-payment-method": "Select payment method",
        "user-wallets-refill-manual-main-perform-refill-button": "Confirm payment",
        "user-wallets-refill-select-card-dialog-title": "Select wallet",
        "user-wallets-refill-select-card-dialog-no-wallets": " The merchant don't offer digital wallets for your company.",
        "user-wallets-refill-select-card-balance": "Balance:",


        // User > Wallets > Refill > Auto tab
        "user-wallets-refill-auto-activate-card-title": "Activate automatic top up",
        "user-wallets-refill-auto-activate-modal-title": "Activate auto top up",
        "user-wallets-refill-auto-activate-modal-threshold-placeholder": "\n .label = Amount (DKK)",
        "user-wallets-refill-auto-activate-modal-threshold-subtitle": "When balance falls below:",
        "user-wallets-refill-auto-activate-modal-refill-subtitle": "Refill with amount:",
        "user-wallets-refill-auto-activate-modal-submit-button": "Activate auto refill",
        "user-wallets-refill-auto-activate-modal-update-button": "Update auto refill",
        "user-wallets-refill-auto-activate-modal-delete-button": "Delete auto refill",
        "user-wallets-refill-auto-activate-success-modal-subtitle": "Auto top up activated",


        // User > Archive > Drawer
        "user-archive-drawer-resource-booking": "Resource booking",
        "user-archive-drawer-meeting-service": "Meeting service",
        "user-archive-drawer-daily-purchases": "Daily purchases",
        "user-archive-drawer-refill-wallet": "Wallet top-ups",

        // User > Archive > Drawer > Transactions
        "user-archive-transactions-table-id": "Order ID",
        "user-archive-transactions-table-transaction-time": "Transaction time",
        "user-archive-transactions-table-delivery-time": "Delivery time",


         // User > Archive > Meeting service
        "user-archive-meeting-service-title": "\n .title = Meeting service",
        "user-archive-meeting-service-table-id": "Order ID",
        "user-archive-meeting-service-table-booked-date": "Booked date",
        "user-archive-meeting-service-table-delivery-time": "Delivery time",
        "user-archive-meeting-service-table-meeting": "Meeting",
        "user-archive-meeting-service-table-amount": "Amount",
        "user-archive-meeting-service-table-action-receipt": "Receipt",
        "user-archive-meeting-service-table-action-duplicate": "Duplicate",
        "user-archive-meeting-service-table-action-send-message": "Send message",
        "user-archive-meeting-service-table-filter-start-date": "Start date",
        "user-archive-meeting-service-table-filter-end-date": "End date",



        // Standard components

        // Standard components > Filter button
        "table-filters-button":"Filters",

        // Create order
        "create-order-access-denied-on-behalf-of": "You don't have access to order on behalf of chosen user.",
        "create-order-confirm-order-button": "Next",
        "create-order-book-button": "Book",
        "create-order-update-button": "Update",
        "create-order-undo-button": "\n .title = Undo all",
        "create-order-wish": "\n .title = Wish",
        "create-order-wish-dialog-title": "\n .dialogTitle = Add product wish",
        "create-order-wish-dialog-message": "If you add a product wish, your order needs to be manually approved by the merchant.",
        "create-order-wish-dialog-product-name-field": "\n .label =Product name * \n .placeholder =Enter product name:",
        "create-order-wish-dialog-product-items-field": "\n .label =Product items * \n .placeholder =Enter items:",
        "create-order-wish-dialog-product-price-field": "\n .label =Product price * \n .placeholder =Enter price (DKK):",
        "create-order-wish-dialog-submit-button": "Confirm",
        "create-order-favorite": "\n .title = View my favorite products",
        "create-order-favorite-show-all-products": "\n .title = Show all products",
        "create-order-list": "\n .title = Show a list of products",
        "create-order-grid": "\n .title = Show a grid of products",
        "create-order-products-empty": "No results",
        "create-order-product-sale-text": "Only 10 left",
        "offer-tag-good-price": "Good price",
        "offer-tag-great-offer": "Great offer",
        "offer-tag-buy-now": "Buy now",
        "offer-tag-discount": "Discount",
        "offer-tag-week-offer": "Week's offer",
        "offer-tag-day-offer": "Today's offer",
        "offer-tag-save-x-price": "Save { $amount } kr",
        "offer-tag-save-x-percentage": "{ $amount }% off",
        "offer-tag-limited-on-sale": "{ $amount } left",
        "create-order-tooltip-order-summary-button": "\n .title = View order summary",
        "create-order-order-summary-no-items": "Order summary is currently empty. Add items to your order to see the details.",
        "create-order-order-summary": "Order summary",
        "create-order-order-summary-resources": "\n .title = Resources",
        "create-order-order-summary-resources-booking-time": "Booking",
        "create-order-order-summary-meeting-services": "\n .title = Meeting services",
        "create-order-order-summary-meeting-services-delivery-time": "Delivery { $number }",
        "create-order-order-summary-meeting-services-total": "Total",
        "create-order-order-summary-meeting-services-empty": "No items added yet",
        "create-order-order-summary-meeting-services-product-item": "{$count} item",
        "create-order-order-summary-meeting-services-product-items": "{$count} items",
        "create-order-order-summary-meeting-services-product-warning-price-list-tooltip": "\n .title = The selected price list does not match the product price list — increase is not available.",
        "create-order-order-summary-meeting-services-product-warning-missing-product-tooltip": "\n .title = This product is not available in the selected shop list",
        "create-order-order-summary-meeting-services-product-price-mismatch-dialog": "\n .dialogTitle = Prices for your products have changed",
        "create-order-order-summary-meeting-services-product-price-mismatch-dialog-message": "Some products in your order have changed in price. If you continue to update the order, all items will be updated to their current price.",
        "create-order-order-summary-meeting-services-product-price-mismatch-dialog-submit-button": "Update",
        "create-order-order-summary-meeting-services-product-price-mismatch-dialog-cancel-button": "Don't update prices",
        "create-order-order-summary-meeting-services-invalid-time-card-empty-title": "Delivery without items",
        "create-order-order-summary-meeting-services-invalid-time-card-empty": "No item was added to delivery at {$time}. Please add items or remove the delivery time.",
        "create-order-order-summary-meeting-services-invalid-times-card-empty": "No items was added to delivery at {$time}. Please add items or remove the delivery times.",
        "create-order-order-summary-meeting-services-invalid-times-card-empty-button": "Ok",
        "create-order-confirm-booking-meeting-details": "Meeting details",
        "create-order-confirm-booking-update-meeting-details": "Update meeting details #{ $id }",
        "create-order-confirm-booking-dialog-add-attendees": "Add participants",
        "create-order-confirm-booking-dialog-back-button": "Back",
        "create-order-confirm-booking-meeting-information-tab": "Meeting information",
        "create-order-confirm-booking-participants-tab": "Participants",
        "create-order-confirm-booking-other-tab": "Other",
        "create-order-confirm-booking-dialog-confirm-button": "Confirm",
        "create-order-confirm-booking-dialog-submit-button": "Complete booking",
        "create-order-confirm-booking-dialog-add-attendee-button": "Add participants",
        "create-order-confirm-booking-dialog-bulk-add-attendees-drawer-button": "Add participants",
        "create-order-confirm-booking-dialog-bulk-add-attendees-button": "Copy and paste",
        "create-order-confirm-booking-dialog-bulk-add-attendees-button-tooltip": "\n .title = Add multiple participants by pasting a list of names and companies",
        "create-order-confirm-booking-dialog-bulk-add-attendees-description": "Input one name and company per line.",
        "create-order-confirm-booking-dialog-bulk-add-attendees-field": "\n .placeholder = Name, Company",
        "create-order-confirm-booking-selected-resources": "Selected resources ({ $count }):",
        "create-order-confirm-booking-booking-time": "Booking time: { $time }",
        "create-order-confirm-booking-rooms": "Rooms:",
        "create-order-confirm-booking-equipment": "AV Equipment:",
        "create-order-confirm-booking-cars": "Cars:",
        "create-order-confirm-booking-time-range-picker-from-field": "\n .label =From time:",
        "create-order-confirm-booking-time-range-picker-to-field": "\n .label =To time:",
        "create-order-confirm-booking-time-range-picker-error": "Resource is not available at this time",
        "create-order-confirm-booking-table-setup": "Table setup",
        "create-order-confirm-booking-select-setup": "Select setup",
        "create-order-confirm-booking-message-title": "Messages to service center",
        "create-order-attendees-dialog-submit-button": "Save",
        "create-order-attendees-dialog-title": "Participants",
        "create-order-note-add-button": "Add",
        "create-order-note-edit-button": "Edit",
        "create-order-note-dialog-title": "\n .dialogTitle = Order message",
        "create-order-note-dialog-alert": "\n .title = Your order notification will be visible on the order specification. You must not include personally identifiable information, such as details about your health or your religion.",
        "create-order-note-dialog-field": "\n .label = Your order message \n .helperText = Remaining characters: { $count }",
        "create-order-note-save-button": "Save",
        "create-order-extra-services": "Extra services",
        "create-order-extra-services-delivery": "\n .title = Delivery at { $time }",
        "create-order-extra-services-min-max": "Min. { $min } - Max. { $max }",
        "create-order-extra-services-add-button": "Add",
        "create-order-extra-services-remove-button": "Remove",
        "create-order-participants-add-button": "+ Add participants",
        "create-order-participants-edit-button": "Edit participants",
        "create-order-participants-count-list": "{ $count } participants",
        "create-order-participants-count-one-item": "{ $count } participant",
        "create-order-participants-dialog-name-column": "Name",
        "create-order-participants-dialog-company-column": "Company",
        "create-order-participants-dialog-email-column": "Email",
        "create-order-participants-dialog-external-internal-column": "External",
        "create-order-participants-dialog-field-name": "\n .placeholder = Participant name",
        "create-order-participants-dialog-field-company": "\n .placeholder = Company",
        "create-order-participants-dialog-field-email": "\n .placeholder = Email address",
        "create-order-add-filters-button": "Add filters",
        "create-order-add-search-input": "\n .placeholder = Search",
        "create-order-tooltip-view-button": "\n .title = Select booking view",
        "create-order-view-timeline": "Timeline",
        "create-order-view-available-time": "Available time",
        "create-order-view-room-finder": "Room Finder",
        "create-order-calendar-today-button": "Today",
        "create-order-calendar-go-to-date-button": "Go to date",
        "create-order-calendar-no-resources-message": "There are no available resources. Please adjust the filters",
        "create-order-calendar-go-to-date-label": "\n .label = Select date",
        "create-order-calendar-go-button": "Go",
        "create-order-calendar-all-day-label": "All day",
        "create-order-calendar-week-button": "Current week",
        "create-order-calendar-prev-week-button": "Previous week",
        "create-order-calendar-next-week-button": "Next week",
        "create-order-calendar-event-tooltip": "\n .title = Click to book",
        "create-order-confirm-booking-confirm-dialog": "\n .title = Confirm booking\n .message =Your booking has not been completed. Please confirm your booking before proceeding.\n .buttonLabelSubmit = Confirm\n .buttonLabelCancel=Cancel",
        "create-order-confirm-booking-confirm-no-resources-dialog": "\n .title = Booking not complete\n .message =You haven't selected any resources yet. If you leave now, your booking will not be completed.\n .buttonLabelSubmit = Select resources\n .buttonLabelCancel=Leave anyway",
        "create-order-change-time-dialog": "\n .title = Change booking time?\n .buttonLabelSubmit = Use new time\n .buttonLabelCancel=Keep original time",
        "create-order-change-time-dialog-message-top": "Your Outlook meeting request is scheduled for:",
        "create-order-change-time-dialog-message-bottom": "Do you want to change booking time to:",
        "create-order-drawer-other-location": "+ Other location",
        "create-order-drawer-delivery-location-field": "\n .label = Delivery location",
        "create-order-drawer-repeat-order": "Repeat order",
        "create-order-drawer-repeat-order-every": "Repeat every:",
        "create-order-drawer-repeat-order-every-day": "\n .label = Day",
        "create-order-drawer-repeat-order-every-week": "\n .label = Week",
        "create-order-drawer-repeat-order-on": "Repeat on:",
        "create-order-drawer-repeat-order-starts": "Starts:",
        "create-order-drawer-repeat-order-ends": "Ends:",
        "create-order-drawer-repeat-order-ends-on": "\n .label = On",
        "create-order-drawer-repeat-order-ends-after": "\n .label = After",
        "create-order-drawer-repeat-order-ends-after-times": "times",
        "create-order-drawer-repeat-order-confirm-button": "Confirm",
        "create-order-drawer-repeat-order-summary": "Occurs every { $interval }{ $days }, running from { $startDate }{ $repeatCount }{ $endDate }.",
        "create-order-drawer-repeat-order-summary-interval-day": "day",
        "create-order-drawer-repeat-order-summary-interval-days": "{ $count } days",
        "create-order-drawer-repeat-order-summary-interval-week": "week",
        "create-order-drawer-repeat-order-summary-interval-weeks": "{ $count } weeks",
        "create-order-drawer-repeat-order-summary-days-suffix": " on { $days }",
        "create-order-drawer-repeat-order-summary-repeat-count-suffix": ", { $count } times",
        "create-order-drawer-repeat-order-summary-end-date-suffix": ", ending on { $date }",
        "create-order-tooltip-resource-info-button": "\n .title = Show resource details",
        "create-order-tooltip-resource-lock-button": "\n .title = Can only be booked by selected users",
        "create-order-tooltip-resource-image-button": "\n .title = View floor plan image",
        "create-order-hover-local-event-start": "Start time: { $start }",
        "create-order-hover-local-event-end": "End time: { $end }",
        "create-order-hover-local-event-host": "Host: { $host }",
        "create-order-tabs-error": "You can't place an order",
        "create-order-tabs-error-body": "You can't place an order because your account doesn't have the required access. Please contact support if you need more information.",
        "create-order-tabs-error-dialog-close-button": "Go back",
        "create-order-tabs-error-dialog-confirm-button": "Select another user",
        "create-order-price-list-confirm-dialog": "\n .title = Remove products\n .buttonLabelSubmit = Remove",
        "create-order-price-list-confirm-dialog-message": "Are you sure that you want to remove all products from all delivery times?",
        "create-order-close-confirm-dialog": "\n .title = Discard changes \n .buttonLabelSubmit = Discard",
        "create-order-close-confirm-dialog-message": "If you click Discard, all entered information will be lost.",
        "create-order-drawer-messages-dialog-title": "\n .dialogTitle = Messages from the merchant",
        "create-order-drawer-message-read-more": "...Read more",
        "create-order-book-period-message-dialog-title": "\n .dialogTitle = You cannot click on the timeline while using `Book Period` mode",
        "create-order-book-period-message-dialog-note": "To book resources, please click on the resources from the left panel",
        "create-order-book-period-busy-message": "The selected resource is not available for the full period",
        "create-order-book-period-busy-error": "Could't check resource availability",
        "create-order-book-period-confirm-cancel-changes-dialog": "\n .title = Remove current selection\n .buttonLabelSubmit = Confirm\n .buttonLabelCancel=Cancel",
        "create-order-book-period-confirm-cancel-changes-dialog-message": "Changing the period will clear your current selection. Do you want to continue?",
        "create-order-past-booking-attempt-message": "You can't book back in time. The start time of the booking must be equal or later than current time",
        "create-order-book-period-past-booking": "Can't select a period in the past",
        "create-order-change-current-event-dialog": "\n .title = You are currently updating booking { $orderDetails } \n .message =Are you sure you want to reset changes and update another booking?\n .buttonLabelSubmit = Confirm\n .buttonLabelCancel=Cancel",
        "create-order-change-current-event-create-dialog": "\n .title = You are currently creating booking \n .message =Are you sure you want to reset changes and update another booking?\n .buttonLabelSubmit = Confirm\n .buttonLabelCancel=Cancel",
        "create-order-timeline-permission-error": "You don't have permission to update this booking as it belongs to a different user",
        "create-order-timeline-error-select": "This time slot is't available for the selected resources",
        "create-order-timeline-error-busy-or-overlap": "This resource is already busy at the selected time or buffer overlap detected!",

        "create-order-select-price-list-dialog": "Select price list",
        "create-order-empty-price-list-dialog": "No pricelist available",
        "create-order-empty-price-list-dialog-body": "Currently there are no pricelist available",
        "create-order-empty-price-list-dialog-body-message": "Please reach out to the merchant to request access to them",
        "create-order-select-price-list-no-price-lists-title": "Currently, there are no price lists available. Please reach out to the merchant to request access to them.",
        "create-order-select-price-list-no-search-results": "Your search returned no results",
        "create-order-select-price-list-favorites-section": "My favorites ({ $count })",
        "create-order-select-price-list-favorites-view-all": "View all ({ $count })",
        "create-order-no-products-dialog-title": "\n .dialogTitle = Pricelist has no products",
        "create-order-no-products-dialog-message": "Please contact the merchant to get access to the products",
        "create-order-no-longer-available-dialog-title": "\n .dialogTitle = Price list no longer available",
        "create-order-no-longer-available-dialog-message": "The price list used for this order is no longer available. Please pick another price list to continue.",
        "create-order-no-products-dialog-button-label-cancel": "Go to home",
        "create-order-no-products-dialog-button-label-submit": "Select another Pricelist",
        "create-order-products-empty-favorites-title": "You do not have any favorite items",
        "create-order-products-empty-favorites-description": "You can add favorite items so that you can complete an order more quickly. Add a favorite item by clicking on the heart icon found on the product card",
        "create-order-credit-note-overlay-title": "Credit note",
        "create-order-credit-note-overlay-message-with-order-id": "You are creating a credit note for order ID <orderIdLink>#{ $orderId }</orderIdLink>.<lineBreak></lineBreak>Please add the products you wish to credit in the cart on the right.",
        "create-order-select-price-list-external-meetings": "External meetings",
        "create-order-select-price-list-external-meetings-description": "Select this if you want to order to external",
        "create-order-on-behalf-of-dialog": "Order on behalf of",
        "create-order-on-behalf-of-dialog-description": "To create an order as an administrator, you must first select a user for whom you are placing the order.",
        "create-order-on-behalf-of-dialog-select-company-field": "\n .label = Select company",
        "create-order-on-behalf-of-dialog-select-user-field": "\n .label = Select user\n .placeholder = Enter user name:",
        "create-order-on-behalf-of-dialog-select-user-field-no-results": "No results",
        "create-order-on-behalf-of-dialog-select-company-host-field": "\n .label = Host company:",
        "create-order-on-behalf-of-dialog-select-host-field": "\n .label = Host:\n .placeholder = Enter host name:",
        "create-order-on-behalf-of-dialog-button": "Continue",
        "create-order-bill-receiver-ean": "EAN:",
        "create-order-bill-receiver-email": "E-mail:",
        "create-order-bill-receiver-contact": "Contact:",
        "create-order-bill-receiver-add-button": "+ Add bill receiver",
        "create-order-bill-receiver-autocomplete-no-options": "No options",
        "create-order-vat-included": "(VAT incl.)",
        "create-order-vat-excl": "(VAT excl.)",


        "create-order-success-dialog-resource-booking-title": "Resources booked!",
        "create-order-success-dialog-meeting-service-title": "Meeting service saved!",
        "create-order-success-dialog-description": "What do you want to do next?",
        "create-order-success-dialog-action-meeting-service": "Add meeting service to order",
        "create-order-success-dialog-action-meeting-service-update": "Update meeting service",
        "create-order-success-dialog-action-add-resource-booking": "Add resource booking",
        "create-order-success-dialog-action-update-resource-booking": "Update resource booking",
        "create-order-success-dialog-action-create-booking": "Create another booking",
        "create-order-success-dialog-action-create-meeting-service": "Create another meeting service",
        "create-order-success-dialog-action-finish": "I'm finished",
        "create-order-success-dialog-action-calendar": "Add meeting to calendar",

        // Confirm order dialog
        "confirm-order-dialog-order-error": "Failed to load packing slip with id #{ $orderId }",
        "confirm-order-dialog-order-error-description": "This order could not be processed due to missing or invalid data.",
        "confirm-order-dialog-title": "Confirm order",
        "confirm-order-dialog-title-update-order": "Update order #{ $id }",
        "confirm-order-dialog-title-credit-note-order": "Create credit note",
        "confirm-order-dialog-title-supplementary-order": "Create supplementary order",
        "confirm-order-dialog-meeting-details": "Meeting details",
        "confirm-order-dialog-meeting-time": "Meeting time:",
        "confirm-order-dialog-delivery-date": "Delivery date:",
        "confirm-order-dialog-delivery-date-time-format": "MMM d, yyyy, h:mm a",
        "confirm-order-dialog-delivery-location": "Delivery location:",
        "confirm-order-dialog-delivery-location-mode-eating-in-canteen": "Eating in canteen",
        "confirm-order-dialog-delivery-location-mode-pick-up": "Pick up",
        "confirm-order-dialog-seats": "Seats:",
        "confirm-order-dialog-merchant": "Merchant:",
        "confirm-order-timestamp-created": "Created:",
        "confirm-order-timestamp-updated": "Updated:",
        "confirm-order-dialog-contact": "Contact",
        "confirm-order-dialog-host": "Host:",
        "confirm-order-dialog-ordered-by": "Ordered by:",
        "confirm-order-dialog-bill-receiver": "Bill receiver",
        "confirm-order-dialog-bill-receiver-contact": "Contact:",
        "confirm-order-dialog-bill-receiver-contact-email": "Email:",
        "confirm-order-dialog-bill-receiver-cost-centers": "Cost centers:",
        "confirm-order-dialog-bill-receiver-meeting-type": "Meeting type:",
        "confirm-order-dialog-bill-receiver-department": "Department:",
        "confirm-order-dialog-bill-receiver-debitor": "Debitor: { $name }",
        "confirm-order-dialog-order-summary": "Order summary",
        "confirm-order-dialog-order-summary-delivery-date": "Delivery: { $date }",
        "confirm-order-dialog-order-summary-delivery-date-time": "Delivery: { $date }, { $time }",
        "confirm-order-dialog-order-summary-table-meeting-service": "Meeting service",
        "confirm-order-dialog-order-summary-table-items": "Items",
        "confirm-order-dialog-order-summary-table-amount": "Amount",
        "confirm-order-dialog-order-summary-table-amount-no-vat": "Amount",
        "confirm-order-dialog-order-summary-table-meeting-services-total": "Total",
        "confirm-order-dialog-order-summary-table-meeting-services-total-no-vat": "Total",
        "confirm-order-dialog-order-summary-table-meeting-services-vat": "VAT amounts to ({ $percentage }%)",
        "confirm-order-dialog-order-summary-table-meeting-services-total-include-vat": "Total amount incl. VAT",
        "confirm-order-dialog-repeat-order": "\n .title = Repeat order",
        "confirm-order-dialog-repeat-order-text": "Repeat order",
        "confirm-order-dialog-attendees": "\n .title = Participants",
        "confirm-order-dialog-attendees-subtitle": "{ $internalCount } internal, { $externalCount } external",
        "confirm-order-dialog-attendees-internal": "\n .title = Internal attendees:",
        "confirm-order-dialog-attendees-external": "\n .title = External attendees:",
        "confirm-order-dialog-resources": "\n .title = Resources",
        "confirm-order-dialog-back-button": "Keep editing",
        "confirm-order-dialog-next-button": "Confirm order",
        "confirm-order-dialog-booking-time": "Booking time: { $timeRange }",

        "user-order-receipt-page-share-button": "Share",
        "user-order-receipt-page-not-loaded-message": "  Order id { $orderId } could not be read. Please contact support.",
        "user-order-receipt-page-not-found-public-message": "Sorry, the order wasn't found. Please contact support at <link>{ $supportEmail }</link> if you need help.",
        "user-order-receipt-page-loading": "Loading order...",
        "user-order-receipt-page-share-modal-title": "Share receipt",
        "user-order-receipt-page-share-modal-subtitle": "Share this link to let others view the receipt.",
        "user-order-receipt-page-print-button": "Print",
        "user-order-receipt-page-header-orders-count": "Orders: {$orderCount} selected",
        "user-pos-order-receipt-page-header-orders-count": "Receipts: {$orderCount} selected",
        "merchant-receipt-dropdown-search-label": "\n .label = Search..." ,

        "create-order-delivery-times-add-button": "Add deliveries",
        "create-order-delivery-times-add-btn": "Add",
        "create-order-delivery-times-add-delivery-time-title": "Add delivery time",
        "create-order-delivery-times-update-delivery-time": "Update delivery time",
        "create-order-delivery-times-add-delivery-time": "Add delivery time:",
        "create-order-delivery-times-dialog-title-add": "Add deliveries",
        "create-order-delivery-times-dialog-title-edit": "Edit deliveries",
        "create-order-delivery-times-dialog-subtitle": "You need to select a date for the delivery.",
        "create-order-delivery-times-dialog-subtitle-example": "You can specify multiple delivery times for full-day meetings, e.g., delivery at 10:00 AM and delivery at 1:00 PM.",
        "create-order-delivery-times-dialog-delivery-date": "Delivery date",
        "create-order-delivery-times-dialog-delivery-date-details": "Delivery date:",
        "create-order-delivery-times-dialog-delivery-time-event-start": "Unfortunately you can't create a meeting service order. Merchant delivers only between {$minTime} and {$maxTime}.",
        "create-order-delivery-times-dialog-delivery-time-event-start-today": "Unfortunately you can't create a meeting service order today, because merchant do not deliver later than { $time }",
        "create-order-delivery-times-dialog-delivery-date-close-tooltip": "Merchant is closed on this date",
        "create-order-delivery-times-dialog-delivery-times": "Delivery times",
        "create-order-delivery-times-dialog-delivery-field": "\n .label = Delivery { $count }",
        "create-order-delivery-times-dialog-add-delivery-button": "+ Add delivery",
        "create-order-delivery-times-dialog-submit-button": "Confirm",
        "create-order-delivery-times-dialog-close-button": "Ok",
        "create-order-delivery-times-empty-error": "No active delivery time selected",
        "create-order-cost-centers-missing-dialog-title": "Cost centers unavailable",
        "create-order-cost-centers-missing-message": "There are no cost centers available for \"{ $dimensionName }\". Please contact your administrator to have cost centers created.",
        "create-order-delivery-location-required": "Delivery location is required",
        "create-order-multiple-deliveries-date-and-time-required": "You must select a delivery date and at least one delivery time",
        "create-order-validation-date-invalid": "{ $label } must be a valid date",
        "create-order-validation-must-be-checked": "{ $label } must be checked",
        "create-order-validation-required": "{ $label } is required",
        "create-order-validation-min": "{ $label } must be at least { $min }",
        "create-order-validation-max": "{ $label } must be at most { $max }",
        "create-order-validation-must-be-true": "{ $label } must be true",
        "create-order-validation-email-invalid": "{ $label } must be a valid email",
        "create-order-validation-format-invalid": "{ $label } is not in the correct format",
        "create-order-delivery-times-same-time-error": "The same time can't be added twice",
        "create-order-delivery-times-opening-hours-error": "The selected time is't within the business hours for this date",
        "create-order-delivery-times-past-time-error": "Delivery time can't be in the past",
        "create-order-refund-amount-exceeds-initial-error": "Credit note cannot exceed the initial amount",
        "create-order-delivery-deadline-message-dialog-title": "\n .title = Deadline has been exceeded \n .buttonLabelSubmit = Place order \n .buttonLabelCancel = Cancel order",
        "create-order-delivery-deadline-message-dialog-description": "You can still place the order, but the order needs to be approved by the staff, which means you can not expect the order to be delivered.",

        "create-order-timeline-booked-period": "Book period",
        "create-order-timeline-booked-period-start-date-time-label": "\n .label = Start time",
        "create-order-timeline-booked-period-end-date-time-label": "\n .label = End time",

        "resource-booking-chip-filter-select-booking-duration-hours": "hours",
        "resource-booking-chip-filter-select-booking-duration-minutes": "minutes",
        "resource-booking-chip-filter-select-meeting-type-title-internal-meeting": "Internal meeting",
        "resource-booking-chip-filter-select-meeting-type-title-internal-meeting-description": "The meeting is with coworkers only, no external guests.",
        "resource-booking-chip-filter-select-meeting-type-title-external-meeting": "External meeting",
        "resource-booking-chip-filter-select-meeting-type-title-external-meeting-description": "Meeting has external guests.",
        "resource-booking-chip-filter-select-title-floors": "Select floor",
        "resource-booking-chip-filter-select-title-fixedavids": "Select fixed AV-equipment",
        "resource-booking-chip-filter-select-title-meetingtype": "Select meeting type",
        "resource-booking-chip-filter-select-title-sittings": "Number of seats",
        "resource-booking-chip-filter-select-title-tablesetupids": "Select table arrangements",
        "resource-booking-chip-filter-select-title-resourcetypeids": "Select resource type",
        "resource-booking-chip-filter-select-title-servicecenterids": "Select service centers",
        "resource-booking-chip-filter-select-title-meetingduration": "Booking duration",

        // Resource details dialog
        "resource-details-dialog-service-center": "Service center",
        "resource-details-dialog-floor": "Floor",
        "resource-details-dialog-description": "Description",
        "resource-details-dialog-square-meters": "Square meters",
        "resource-details-dialog-walk-direction":"Walk direction",
        "resource-details-dialog-reserved-for": "Reserved for",
        "resource-details-dialog-reserved-for-internal": "Internal meetings",
        "resource-details-dialog-reserved-for-external": "External meetings",
        "resource-details-dialog-capacity": "Capacity",
        "resource-details-dialog-capacity-quantity": "{ $quantity } people",
        "resource-details-dialog-table-arrangement": "Table arrangement",
        "resource-details-dialog-av-equipment": "AV-equipment",


        // Service center > Navigation
        "service-center-nav-item-user-label": "\n .title = Home" ,
        "service-center-nav-item-canteen-label": "\n .title = Upcoming meetings" ,
        "service-center-nav-item-guests-label": "\n .title = Guest list" ,
        "service-center-nav-item-calendar-label": "\n .title = Calendar" ,
        "service-center-nav-item-reports-label": "\n .title = Statistics" ,
        "service-center-nav-item-settings-label": "\n .title = Administration" ,

        // Service center > Reports > Dashboard
        "service-center-reports-dashboard-check-in-button": "Check-in",
        "service-center-reports-dashboard-checked-id": "Checked in",
        "service-center-reports-dashboard-check-in-guests-button": "Guest check-in",
        "service-center-reports-dashboard-meeting-title": "Meeting",
        "service-center-reports-dashboard-search-label": "\n .label = Search" ,
        "service-center-reports-dashboard-meeting-pagination": "Results per page",
        "service-center-reports-dashboard-check-in-title": "Check-in Queue",
        "service-center-reports-dashboard-guest-check-in-title": "Guest check-in",
        "service-center-reports-dashboard-no-guests":"No guests in check-in queue",
        "service-center-reports-dashboard-news-title": "News",
        "service-center-reports-dashboard-no-news":"No news",
        "service-center-reports-dashboard-no-meeting-selected":"No meeting selected",
        "service-center-reports-dashboard-no-meetings":"There are no meetings today.",

        // Service center > Reports > Upcoming meetings
        "service-center-reports-upcoming-meetings-title": "\n .title = Upcoming meetings",

        // Service center > Reports > Dashboard > Check in modal
        "service-center-reports-dashboard-check-in-modal-title": "Guest check-in",
        "service-center-reports-dashboard-print-labels-modal-title": "Print guest labels",
        "service-center-reports-dashboard-printing-labels-modal-title": "Printing guest labels",
        "service-center-reports-dashboard-printing-labels-modal-subtitle": "Guest labels to print ({ $amount})",

        "service-center-reports-dashboard-printing-labels-of": "of",
        "service-center-reports-dashboard-printing-labels-cancel": "Cancel",
        "service-center-reports-dashboard-printing-labels-print": "Print",

        // Label printer errors
        "label-printer-error-no-labels": "No labels to print",
        "label-printer-error-cancelled": "Printing cancelled by user",
        "label-printer-error-required-fields": "Please fill in all required fields and ensure group size is at least 1",
        "label-printer-error-failed-guest-label": "Failed to print guest label",
        "label-printer-error-unknown-guest-label": "Unknown error printing guest label",
        "label-printer-error-failed-label-for": "Failed to print label for { $name }",
        "label-printer-error-printing-label-for": "Error printing label for { $name }",
        "label-printer-error-failed-group-labels": "Failed to print group labels",
        "label-printer-error-unknown-group-labels": "Unknown error printing group labels",
        "label-printer-error-failed-takeaway-labels": "Failed to print takeaway labels",
        "label-printer-error-unknown-takeaway-labels": "Unknown error printing takeaway labels",

        "service-center-reports-check-in-modal-guest-details": "Guest details",
        "service-center-reports-check-success-title": "Guest checked in",
        "service-center-reports-check-validation-error": "Please select a host and company before checking in.",
        "service-center-reports-check-in-modal-single": "Single",
        "service-center-reports-check-in-modal-group": "Group",
        "service-center-reports-check-in-modal-host-name": "\n .label = Host name",
        "service-center-reports-check-in-modal-host-company": "\n .label = Host company",
        "service-center-reports-check-in-modal-guest-name": "\n .label = Guest name",
        "service-center-reports-check-in-modal-number-of-guests": "\n .label = Number of guests",
        "service-center-reports-check-in-modal-guest-company": "\n .label = Guest company",
        "service-center-reports-check-in-modal-guests-company": "\n .label = Group name",
        "service-center-reports-check-in-modal-print-guest-card": "\n .label = Print guest card",
        "service-center-reports-check-in-modal-send-host-notification": "\n .label = Notify host",
        "service-center-reports-check-in-modal-send-host-notification-tooltip": "\n .title = Host will receive notification that the guest has been checked in.",
        "service-center-reports-check-in-modal-write-message-to-host": "\n .label = Write a message to host",
        "service-center-reports-check-in-modal-settings": "Settings",
        "service-center-reports-check-in-modal-check-in-button": "Check-in",
        "service-center-reports-check-in-modal-guest-check-in-title": "Guest check-in",
        "service-center-reports-check-in-modal-guest-check-in-subtitle": "Guests to check in ({ $amount})",

        "service-center-reports-check-in-modal-guest-details-printer-dialog-printing": "Printing label...",
        "service-center-reports-check-in-modal-guest-details-printer-not-installed-modal-title": "Chrome label printer extension is not installed",
        "service-center-reports-check-in-modal-guest-details-printer-not-installed-modal-cta-message": "Click <hereLink>here</hereLink> to open Chrome web store where you can install the extension.",
        "service-center-reports-check-in-modal-guest-details-printer-not-installed-modal-message":" To print labels, please install the Brother b-PAC Extension and reload page.",


        // Service center > Reports > Dashboard > Meetings drawer
        "service-center-reports-dashboard-meetings-drawer-user-details-dialog-name": "Name:",
        "service-center-reports-dashboard-meetings-drawer-user-details-dialog-company-name": "Company: ",
        "service-center-reports-dashboard-meetings-drawer-user-details-dialog-department-name": "Department: ",
        "service-center-reports-dashboard-meetings-drawer-user-details-dialog-email": "E-mail: ",
        "service-center-reports-dashboard-meetings-drawer-user-details-dialog-business-phone": "Phone number: ",
        "service-center-reports-dashboard-meetings-drawer-user-details-dialog-mobile-phone": "Mobile number: ",
        "service-center-reports-dashboard-meetings-drawer-meeting-time": "Meeting time: ",
        "service-center-reports-dashboard-meetings-drawer-host": "Host: ",
        "service-center-reports-dashboard-meetings-drawer-host-company": "Company: ",
        "service-center-reports-dashboard-meetings-drawer-location": "Location: ",
        "service-center-reports-dashboard-meetings-drawer-manage-all-button": "Manage all",
        "service-center-reports-dashboard-meetings-drawer-guests-title": "Guests",
        "service-center-reports-dashboard-meetings-drawer-manage-all-bulk-check-in": "Check all in",
        "service-center-reports-dashboard-meetings-drawer-manage-all-bulk-print-labels": "Print guest labels for all",
        "service-center-reports-dashboard-meetings-drawer-guests-list-checked-title": "\n .title = Checked in",
        "service-center-reports-dashboard-meetings-drawer-guests-list-not-checked-title": "\n .title = Not checked in",
        "service-center-reports-dashboard-meetings-drawer-guests-list-floating-check-action": "\n .title = Check in",
        "service-center-reports-dashboard-meetings-drawer-guests-list-floating-print-guest-action": "Print guest labels",
        "service-center-reports-dashboard-meetings-drawer-guests-list-floating-other-action":"\n .title = Other",
        "service-center-reports-dashboard-meetings-drawer-selected-guests": "Selected guests",
        "service-center-reports-dashboard-meetings-drawer-manage-meeting-dropdown-item-manage-meeting-display": "Manage meeting display",
        "service-center-reports-dashboard-meetings-drawer-manage-meeting-modal-name-field-required-error": "Name is required",
        "service-center-reports-dashboard-meetings-drawer-manage-meeting-modal-success-message": "Successfully updated meeting display",
        "service-center-reports-dashboard-meetings-drawer-manage-meeting-modal-title": "Manage meeting on displays",
        "service-center-reports-dashboard-meetings-drawer-manage-meeting-modal-meeting-name-label": "\n .label = New meeting name on displays \n .placeholder = Enter new meeting name",
        "service-center-reports-dashboard-meetings-drawer-manage-meeting-modal-switch-label": "Show as canceled",
        "service-center-reports-dashboard-meetings-drawer-manage-meeting-modal-show-on-screens-switch-label": "Show on screens",
        "service-center-reports-dashboard-meetings-drawer-manage-meeting-modal-submit-button": "Save",

        "service-center-reports-dashboard-meetings-drawer-manage-meeting-modal-alert-change-name-label": "Change meeting name:",
        "service-center-reports-dashboard-meetings-drawer-manage-meeting-modal-alert-change-name-description": " If the meeting name is not appropriate for display on meeting displays, you can edit it here. This modification will only affect the name shown on the displays.",
        "service-center-reports-dashboard-meetings-drawer-manage-meeting-modal-alert-cancel-meeting-label": "Cancel meeting:",
        "service-center-reports-dashboard-meetings-drawer-manage-meeting-modal-alert-cancel-meeting-description": " If you need to cancel a meeting while keeping it visible, you can simply mark it as canceled.",

        // Service center > Reports > Dashboard > Statistics
        "service-center-reports-statistics-page-header": "Statistics",
        "service-center-reports-statistics-occupancy-tab-title": "Occupancy",
        "service-center-reports-statistic-occupancy-table-date-range-filter": "\n .label = Date range",
        "service-center-reports-statistic-occupancy-table-resource-title": "Resource",
        "service-center-reports-statistic-occupancy-table-occupancy-rate-title": "Occupancy rate",
        "service-center-reports-statistic-occupancy-table-status-title": "Status",

        "service-center-reports-statistics-cancellations-tab-title": "Cancellations",
        "service-center-reports-statistic-cancellations-table-cancellation-rate-title": "Cancellation rate",

        "service-center-reports-statistics-booking-duration-tab-title": "Booking duration",
        "service-center-reports-statistic-booking-duration-table-number-of-bookings-title": "Bookings amount",
        "service-center-reports-statistic-booking-duration-table-average-duration-title":  "Avg. duration",

        "service-center-reports-statistics-guests-tab-title": "Guests",
        "service-center-reports-statistic-guests-table-date-title": "Date",
        "service-center-reports-statistic-guests-table-guests-title": "Guests",

        "service-center-reports-statistics-peak-hours-tab-title": "Peak hours",
        "service-center-reports-statistics-peak-hours-heat-map-title": "Peak hours",

        "service-center-reports-statistics-customer-usage-tab-title": "Customer usage",
        "service-center-reports-statistic-customer-usage-table-usage-rate-title": "Usage rate",
        "service-center-reports-statistic-customer-usage-filter-customer-label": 'Customer',

        // Service center > Reports > Dashboard > Guests
        "service-center-reports-dashboard-guests-page-header": "\n .title = Guests",
        "service-center-reports-dashboard-guests-table-guest-title": "Guest",
        "service-center-reports-dashboard-guests-table-host-title": "Host",
        "service-center-reports-dashboard-guests-table-check-in-time-title": "Check-in",
        "service-center-reports-dashboard-guests-table-check-in-time-tooltip": "Meeting start",
        "service-center-reports-dashboard-guests-table-check-out-time-title": "Checkout",
        "service-center-reports-dashboard-guests-table-host-company-title": "Host company",
        "service-center-reports-dashboard-guests-table-host-company-status": "Status",
        "service-center-reports-dashboard-guests-table-host-company-status-checked-in": "Checked in",
        "service-center-reports-dashboard-guests-table-host-company-status-checked-out": "Checked out",
        "service-center-reports-dashboard-guests-table-host-company-status-expected": "Expected",
        "service-center-reports-dashboard-guests-table-host-company-status-pending": "Pending",
        "service-center-reports-dashboard-guests-table-host-company-status-checked-in-hover-tooltip": "The guest has been checked in.",
        "service-center-reports-dashboard-guests-table-host-company-status-checked-out-hover-tooltip": "The guest has been checked out.",
        "service-center-reports-dashboard-guests-table-host-company-status-expected-hover-tooltip": "The guest has been invited but has not checked in yet.",
        "service-center-reports-dashboard-guests-table-host-company-status-pending-hover-tooltip": "The guest has completed self-check-in; however, the reception team should extend a warm welcome and provide a guest card.",
        "service-center-reports-dashboard-guests-table-floating-action-bar-guest-card": "\n .title = Guest card",
        "service-center-reports-dashboard-guests-table-date-range-filter": "Period",


        // Service center > Admin > Organization > DEVICES
        "service-center-admin-organization-devices-title": "\n .title = Devices",
        "service-center-admin-organization-devices-button-title": "Create Device",

        // Service center > Admin > Organization > Resources
        "service-center-admin-organization-resources-title": "\n .title = Resources",
        "service-center-admin-organization-resources-create-button": "Create resource",
        "service-center-admin-organization-resources-rooms-tab": "Rooms",
        "service-center-admin-organization-resources-mobile-av-equipment-tab": "AV equipment",
        "service-center-admin-organization-resources-cars-tab": "Cars",
        "service-center-admin-organization-resources-table-header-name": "Name",
        "service-center-admin-organization-resources-table-room-header-id": "Room no",
        "service-center-admin-organization-resources-table-mobile-av-header-id": "Serial no",
        "service-center-admin-organization-resources-table-cars-header-id": "Reg no",
        "service-center-admin-organization-resources-table-header-status": "Status",
        "service-center-admin-organization-resources-table-edit-item": "Edit",
        "service-center-admin-organization-resources-table-delete-item": "Delete",
        "service-center-admin-organization-resources-table-room-delete-modal-title": "room",
        "service-center-admin-organization-resources-table-mobile-av-equipment-delete-modal-title": "mobile AV equipment",
        "service-center-admin-organization-resources-table-car-delete-modal-title": "car",

        "service-center-admin-organization-resources-status-not-approved": "Not approved",
        "service-center-admin-organization-resources-status-approved": "Approved",
        "service-center-admin-organization-resources-status-rejected": "Rejected",
        "service-center-admin-organization-resources-status-preparing": "Preparing",
        "service-center-admin-organization-resources-status-delivered": "Delivered",
        "service-center-admin-organization-resources-status-to-be-booked": "To be booked",
        "service-center-admin-organization-resources-status-booked": "Booked",

        "service-center-admin-organization-resources-status-menu-not-approved": "Unapprove",
        "service-center-admin-organization-resources-status-menu-approved": "Approve",
        "service-center-admin-organization-resources-status-menu-rejected": "Reject",
        "service-center-admin-organization-resources-status-menu-preparing": "Preparing",
        "service-center-admin-organization-resources-status-menu-delivered": "Delivered",
        "service-center-admin-organization-resources-status-menu-booked": "Book",
        "service-center-admin-organization-resources-status-menu-ready": "Ready",
        "service-center-admin-organization-resources-status-menu-default": "No status",

        // Service center > Admin > Organization > Resources > Create Mobile AV
        "service-center-admin-organization-resources-create-mobile-av-title": "\n .title = Create Mobile AV",
        "service-center-admin-organization-resources-update-mobile-av-title": "\n .title = Update Mobile AV",
        "resources-create-edit-mobile-av-general-tab-error": "General tab has validation error",

        // Service center > Admin > Organization > Resources > Create car
        "service-center-admin-organization-resources-create-car-title": "\n .title = Create car",
        "service-center-admin-organization-resources-update-car-title": "\n .title = Update car",
        "resources-create-edit-car-general-tab-error": "General tab has validation error",

        // Service center > Admin > Organization > Resources > Create car > General
        "resources-create-edit-car-general-tab-general": "General",
        "resources-create-car-tab-general-registration-number-label": "\n .label = Registration number",
        "resources-create-car-tab-general-name-label": "\n .label = Name",
        "resources-create-car-tab-general-description-label": "\n .label = Description",
        "resources-create-car-tab-general-car-type-label": "\n .label = Car type",
        "resources-create-car-tab-general-location-of-keys-label": "\n .label = Location of keys",
        "resources-create-car-tab-general-parking-location-label": "\n .label = Parking location",
        "resources-create-car-tab-general-active-label": "Active:",
        "resources-create-car-tab-general-in-service-label": "In service:",
        "resources-create-car-tab-general-side-settings": "\n .title = Settings",

        // Service center > Admin > Organization > Resources > Create Mobile AV > General
        "resources-create-edit-mobile-av-general-tab-general": "General",
        "resources-create-mobile-av-tab-general-serial-number-label": "\n .label = Serial number",
        "resources-create-mobile-av-tab-general-name-label": "\n .label = Name",
        "resources-create-mobile-av-tab-general-floor-label": "\n .label = Floor",
        "resources-create-mobile-av-tab-general-description-label": "\n .label = Description",
        "resources-create-mobile-av-tab-general-storage-location-label": "\n .label = Storage location",
        "resources-create-mobile-av-tab-general-cleanup-buffer-label": "\n .label = Cleanup buffer",
        "resources-create-mobile-av-tab-general-color-code-label": "\n .label = Color code",
        "resources-create-mobile-av-tab-general-active-label": "Active:",
        "resources-create-mobile-av-tab-general-side-settings": "\n .title = Settings",


        // Service center > Admin > Organization > Resources > Create room
        "service-center-admin-organization-resources-create-room-title": "\n .title = Create room",
        "resources-create-edit-room-general-tab-error": "General tab has validation error",

        // Service center > Admin > Organization > Resources > Create room > General
        "resources-create-edit-room-general-tab-general": "General",
        "resources-create-room-tab-general-room-number-label": "\n .label = Room number",
        "resources-create-room-tab-general-name-label": "\n .label = Name",
        "resources-create-room-tab-general-description-label": "\n .label = Description",
        "resources-create-room-tab-general-seats-label": "\n .label = Seats",
        "resources-create-room-tab-general-active-label": "Active:",
        "resources-create-room-tab-general-other-location-label": "Other location:",
        "resources-create-room-tab-general-other-location-description": `\n .title = Marking a room as "Other location" will allow the user to type an ad-hoc location to hold the meeting such as their office.`,
        "resources-create-room-tab-general-meeting-display": "\n .title = Meeting display",
        "resources-create-room-tab-general-side-settings": "\n .title = Settings",
        "resources-create-room-tab-general-floor-label": "\n .label = Floor",
        "resources-create-room-tab-general-walk-direction-label": "\n .label = Walk direction",
        "resources-create-room-tab-general-walk-direction-north": "North",
        "resources-create-room-tab-general-walk-direction-east": "East",
        "resources-create-room-tab-general-walk-direction-south": "South",
        "resources-create-room-tab-general-walk-direction-west": "West",
        "resources-create-room-tab-general-color-red": "Red",
        "resources-create-room-tab-general-color-green": "Green",
        "resources-create-room-tab-general-color-blue": "Blue",
        "resources-create-room-tab-general-color-black": "Black",
        "resources-create-room-tab-general-color-light-blue": "Light blue",
        "resources-create-room-tab-general-tags-label":  "\n .label = Tags",
        "resources-create-room-tab-general-tags-info-description":  `\n .label = Create one or more tags to be used for filtering resources. For example "External meeting room", "Guest meeting room", "Conference room", "Call room" etc.`,
        "resources-create-room-tab-general-fixed-av-equipment-label":  "\n .label = Fixed AV equipment",
        "resources-create-room-tab-general-side-filter-details": "\n .title = Filter details",
        "resources-create-room-tab-general-area-label": "\n .label = Area (sqm) \n .placeholder = Area of room in sqm",
        "resources-create-room-tab-general-cleanup-buffer-label": "\n .label = Cleanup buffer",
        "resources-create-room-tab-general-color-code-label": "\n .label = Color code",
        "resources-create-room-tab-general-email-address-label": "\n .label = Email address",
        "resources-create-room-tab-general-side-integrations": "\n .title = Calendar integration",
        "resources-create-room-tab-general-side-integrations-meeting-invite": "\n .description = Used for integrating with Exchange or other calendar systems. The email address will be added to the meeting invitation by FacilityNet Outlook Add-in when booking the room.",
        "resources-create-room-tab-general-side-integrations-starleaf": "\n .description =Used for integrating with StarLeaf equipment that come with a dedicated email address used for integration.",
        "resources-create-room-tab-general-side-integrations-ews": "\n .description = Used for integrating with equipment that reads from a calendar. The calendar of the mailbox will be booked using an EWS service account when booking the room.",

        "resources-create-room-tab-general-book-using-ews": "Book using EWS",
        "resources-create-room-tab-general-add-reminder-button-label": "Add reminder",

        // Service center > Admin > Organization > Resources > Create room > Table arrangements
        "resources-create-edit-room-general-tab-table-arrangements": "Table arrangements",
        "tab-table-arrangements-standard": "Standard",
        "tab-table-arrangements-option": "Option",

        // Service center > Admin > Organization > Resources > Create room > Notifiations
        "resources-create-edit-room-general-tab-notifications": "Notifications",
        "resources-create-edit-room-general-tab-table-header-type": "Type",
        "resources-create-edit-room-general-tab-table-header-sent": "Sent",
        "resources-create-edit-room-general-tab-table-header-content": "Content",

        // Service center > Admin > Organization > Resources > Create room > Availability
        "resources-create-edit-room-general-tab-availability": "Availability",
        "tab-availability-closed-periods-title": "Unavailable period",
        "tab-availability-table-start-header": "Start",
        "tab-availability-table-end-header": "End",
        "tab-availability-table-reason-header": "Reason",
        "tab-availability-table-edit-action": "Edit",
        "tab-availability-table-delete-action": "Delete",
        "tab-availability-add-closed-period-action": "Add unavailable period",
        "tab-availability-side-daily-closing-times-title": "\n .title = Daily closing times",
        "tab-availability-side-daily-booking-times-title": "\n .title = Booking Time",
        "tab-availability-side-start-time-label": "\n .label = Start time",
        "tab-availability-side-end-time-label": "\n .label = End time",
        "tab-availability-modal-reason-label": "\n .label = Reason",
        "tab-availability-modal-title": "Add closed period",
        "tab-availability-modal-add-button": "Add",
        "tab-availability-modal-booking-time-dropdown-label": "\n .label = Booking time type",
        "tab-availability-modal-booking-time-dropdown-accept": "Accept Booking Time",
        "tab-availability-modal-booking-time-dropdown-block": "Block Booking Time",

        "tab-availability-add-reminder-dialog-title": "Add reminder",
        "tab-availability-add-reminder-edit-dialog-title": "Edit reminder",
        "tab-availability-add-reminder-dialog-field-type-label": "\n .label = Type",
        "tab-availability-add-reminder-dialog-field-time-label": "\n .label = Sent",
        "tab-availability-add-reminder-dialog-field-text-label": "\n .label = Text",
        "tab-availability-add-reminder-dialog-submit-button-label": "Add",

        "tab-availability-add-reminder-dialog-form-time-suffix-hours-before": "hours before meeting start",
        "tab-availability-add-reminder-dialog-form-time-suffix-minutes-before": "minutes before meeting start",
        "tab-availability-add-reminder-dialog-form-time-suffix-hours-after": "hours after meeting end",
        "tab-availability-add-reminder-dialog-form-time-suffix-minutes-after": "minutes after meeting end",

        "reminder-type-option-meeting-start": "Meeting start reminder",
        "reminder-type-option-first-reminder": "First  reminder",
        "reminder-type-option-preparation": "Preparation",
        "reminder-type-option-cleanup": "Cleanup",
        "reminder-type-option-custom-reminder": "Custom reminder",
        "reminder-type-option-meeting-confirmation": "Meeting confirmation",

        "integration-type-option-none": "None",
        "integration-type-option-meeting-invite": "Meeting Invite",
        "integration-type-option-ews": "EWS",
        "integration-type-option-starleaf": "Starleaf",

        // Service center > Admin > Organization > Resources > Create room > Access control
        "resources-create-edit-room-general-tab-access-control": "Access control",
        "tab-access-control-restricted-access-title": "\n .title =Restricted access",
        "tab-access-control-visible-everyone-switch":'Visible for everyone',
        "tab-access-control-reserved-for-company-title":"Reserved for company:",
        "tab-access-control-bookable-by-departments-title":"Bookable by departments:",
        "tab-access-control-select-department-select-item":"Select a department",
        "tab-access-control-add-button":"Add",


        // Service center > Admin > Account > Admins
        "service-center-admin-account-admins-page-header": "\n .title = Administrators",
        "service-center-admin-account-admins-table-header-name":"Name",
        "service-center-admin-account-admins-table-header-email":"Email",
        "service-center-admin-account-admins-table-header-status":"Status",
        "service-center-admin-account-admins-table-status-active":"Active",
        "service-center-admin-account-admins-table-status-inactive": "Inactive",
        "service-center-admin-account-admins-table-button-details": "Show details",
        "service-center-admin-account-admins-table-button-edit": "Edit user",
        "service-center-admin-account-admins-table-button-delete": "Delete user",
        "service-center-admin-account-admins-button-create": "Create",
    },
    "da-DK": {

        // Preferred hour cycle for locale
        // NOTE: Only necessary to specify if default for country/region from CLDR supplementary data used by browser Intl API is incorrect
        // See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Locale/hourCycle
        // See: https://github.com/unicode-org/cldr/blob/master/common/supplemental/supplementalData.xml#L4768
        "date-time-hour-cycle": "h23",

        // Date and time formats as Luxon format strings
        // See: https://moment.github.io/luxon/docs/manual/formatting.html#table-of-tokens
        "date-time-format-date": "dd/MM/yyyy",
        "date-time-format-day-and-date": "EEEE dd/MM",
        "date-time-format-time": "HH:mm",
        "date-time-format-time-hms": "HH:mm:ss",
        "date-time-format-date-and-time": "dd/MM/yyyy\u00A0HH:mm",
        "date-time-format-duration-hours-minutes": "h't.' m'min.'",
        "date-time-format-duration-minutes": "m'min.'",
        "date-time-format-duration-seconds": "s's'",
        "date-time-compact-period-start": "d/M-yy 'kl.' HH:mm",
        "date-time-invalid-date": "N/A",

        // Money formats
        "money-amount-unit-month": "md.",
        "money-amount-unit-year": "år",

        // User types
        "-user-type-support": "Supporter",
        "-user-type-supplier": "Kantineforpagter",
        "-user-type-merchant": "Shopejer",
        "-user-type-company": "Firmaadministrator",
        "-user-type-office-manager": "Office manager",
        "-user-type-user": "User",
        "-user-type-service-center": "Service center",


        // Shared components
        "error-boundary-modal": "\n .title = Noget gik galt\n .message = Fejlkode: { $errorCode }\n .buttonLabel = Luk vinduet",
        "query-error-boundary": "\n .title = Noget gik galt\n .message = Fejlkode: { $errorCode }\n .buttonLabel = Prøv igen",
        "confirmation-dialog-cancel": "Annuller",
        "confirmation-dialog-approve": "Godkend",
        "error-dialog-show-details-label": "Show details",
        "error-dialog-close-button": "Close",
        "error-dialog-support-request": "Please contact <supportMessage>support@facilitynet.dk</supportMessage> if the problem persists.",
        "error-route": "\n .title = Noget gik galt \n .message Denne side kan ikke vises på grund af en ukendt fejl \n .buttonLabel = Gå til forsiden",
        "time-or-date-picker-time-label": "Tid",
        "api-call-timeout-message": "Anmodningen tager længere tid end forventet",

        // authenticate common
        "-authenticate-submit-button": "Næste",

        // --- Error boundaries ---
        "app-error-boundary": "\n .title = Noget gik galt\n .buttonLabel = Luk vinduet",
        "app-error-boundary-title": "Noget gik galt",
        "app-error-boundary-button": "Luk vinduet",
        "route-error-boundary": "\n .title = Noget gik galt\n .buttonLabel = Gå til Hjem",
        "inline-error-boundary-message": "Kunne ikke rendere komponent",
        "inline-error-boundary-calendar-event-message": 'Could not parse event',
        "query-error-boundary-message": "Fejl ved indlæsning af data.",
        "query-error-boundary-no-data-message": "Ingen data.",
        "query-error-boundary-retry-button": "Prøv igen",


        // --- Language selector ---
        "language-selector-lang-en-us": "Engelsk",
        "language-selector-lang-da-dk": "Dansk",


        // --- Footer ---
        "footer-read-more": "Læs mere på <linkElem>{ $linkName }</linkElem>",


        // --- Avatar menu ---
        "avatar-menu-menu-item-help": "Hjælp",
        "avatar-menu-menu-item-news": "Facilitynet nyheder",
        "avatar-menu-menu-item-profile": "Brugerkonto",
        "avatar-menu-menu-item-archive": "Archive",
        "avatar-menu-menu-item-change-user-account": "Skift brugerkonto",
        "avatar-menu-menu-item-swift-merchant": "Swift merchant",
        "avatar-menu-menu-item-settings": "Indstillinger",
        "avatar-menu-menu-item-logout": "Log ud",


        // --- Confirm dialogs ---
        "confirm-modal-confirm-label": "Er du sikker?",
        "delete-confirm-modal-title": "Slet { $itemType }",
        "delete-confirm-modal-question": "Er du sikker på, at du vil slette '{ $itemName }'?",
        "delete-confirm-modal-button-delete": "Slet",
        "delete-confirm-modal-button-cancel": "Annuller",
        "delete-confirm-modal-button-submit": "Submit",
        "cancel-subscription-modal-title": "Opsig abonnement",
        "cancel-subscription-modal-message": "Er du sikker på, at du vil opsige abonnementet '{ $subscriptionName }' for { $customerName }?",
        "cancel-subscription-modal-label-ignore-terms": "\n .label = Med øjeblikkelig virkning",
        "cancel-subscription-modal-helper-text-ignore-terms": "Dette vil tilsidesætte abonnementsbetingelserne.",
        "cancel-subscription-modal-button-delete": "Opsig",


        // --- Not found ---
        "not-found-title": "Ikke fundet",
        "not-found-explanation": "Siden du leder efter findes ikke.",
        "not-found-path-label": "Sti:",
        "not-found-go-home-button": "Gå hjem",


        // --- Access denied ---
        "access-denied-title": "Adgang nægtet",
        "access-denied-explanation": "Din brugerprofil har ikke adgang til denne side.",
        "access-denied-required-usertype-label": "Påkrævet brugertype:",
        "access-denied-actual-usertype-label": "Din brugertype:",
        "access-denied-path-label": "Sti:",
        "access-denied-go-home-button": "Gå hjem",
        "access-denied-logout-button": "Log af",

        "access-denied-usertype-support": "{ -user-type-support }",
        "access-denied-usertype-supplier": "{ -user-type-supplier }",
        "access-denied-usertype-merchant": "{ -user-type-merchant }",
        "access-denied-usertype-company": "{ -user-type-company }",
        "access-denied-usertype-office-manager": "{ -user-type-office-manager }",
        "access-denied-usertype-unknown": "Ukendt",


        "login-email-label": "Log ind",
        "login-password-label": "Indtast dit kodeord",
        "login-email-field-label": "\n .label = Email",
        "test": "Tæææst",
        "bottom-menu-item-home": "\n .label = Hjem",
        "bottom-menu-item-profile": "\n .label = Profil",

        "confirm-email-button": "Confirm\n .loadingLabel = Confirming...",
        "confirm-email-description": "The following user accounts are all registered with the email address <email>{ $email }</email> and will be able to switch account. Make sure they all belong to you:",
        "confirm-email-title": "Confirm account access",
        "confirm-email-success-message": "You can now switch between your user accounts",
        "confirm-email-error-message": "Vi kunne ikke bekræfte din e-mailadresse",
        "confirm-email-missing-userid-or-otp": "Missing user id or otp",

        "purchases-payment-method-free": "Gratis",
        "purchases-payment-method-credit-card": "Kreditkort",
        "purchases-payment-method-one-click-payment": "Kreditkort",
        "purchases-payment-method-mobile-pay": "MobilePay",
        "purchases-payment-method-payroll-deduction": "Løntræk",
        "purchases-payment-method-lunch-registration": "Frokostordning",
        "purchases-payment-method-gopay-wallet": "GoPay Wallet",
        "purchases-payment-method-invoice": "Faktura",
        "purchases-payment-method-cash": "Kontant",
        "purchases-payment-method-gopay-account": "GoPay Wallet",
        "purchases-payment-method-refund": "Refunderet",
        "purchases-payment-method-subscribe-payment-card": "Subscribe payment card",




        // --- Error handling ---
        "api-call-error-title-unknown-error": "Ukendt fejl",
        "api-call-error-title-network-error": "Netværksfejl",
        "api-call-error-title-bad-request": "Forespørgsel afvist",
        "api-call-error-title-unauthorized": "Ugyldigt login",
        "api-call-error-title-forbidden": "Adgang nægtet",
        "api-call-error-title-not-found": "Ikke fundet",
        "api-call-error-title-conflict": "Konflikt",
        "api-call-error-title-too-many-requests": "For mange forespørgsler",
        "api-call-error-title-internal-server-error": "Intern server fejl",
        "api-call-error-title-service-unavailable": "Service ikke tilgængelig",
        "api-call-error-title-request-failed": "Forespørgsel fejlede",
        "api-call-error-unknown-error": "Ukendt fejl",
        "api-call-error-no-internet-connection": "Ingen Internet forbindelse",
        "api-call-error-could-not-reach-server": "Kunne ikke opnå forbindelse til server",
        "api-call-error-protocol-error": "Server fejl: { $responseCode } { $responseStatus }",
        "api-call-error-api-returned-error": "Uventet server fejl",
        "api-call-error-response-not-json": "Uventet svar fra server",
        "api-call-error-retry-button": "Forsøg igen",

        // --- Receipts ---

        // Page
        "receipt-title": "Receipt",

        // Payment methods
        "receipt-payment-method-free": "Gratis",
        "receipt-payment-method-credit-card": "Kreditkort",
        "receipt-payment-method-one-click-payment": "Kreditkort",
        "receipt-payment-method-mobile-pay": "MobilePay",
        "receipt-payment-method-payroll-deduction": "Løntræk",
        "receipt-payment-method-lunch-registration": "Frokostordning",
        "receipt-payment-method-gopay-account": "GoPay Wallet",
        "receipt-payment-method-invoice": "Faktura",

        // Purchase section
        "receipt-purchase-details-section": "\n .heading = Købsdetaljer",
        "receipt-purchase-payment-status-paid": "BETALT",
        "receipt-purchase-payment-status-unpaid": "EJ BETALT",
        "receipt-purchase-payment-status-invoiced": "FAKTURERET",
        "receipt-purchase-payment-status-refunded": "REFUNDERET",
        "receipt-purchase-payment-status-cancelled": "REFUNDERET",
        "receipt-purchase-address-item": "\n .label = Købssted:",
        "receipt-purchase-seller-vat-number": "CVR:\u00A0{ $vatNumber }",
        "receipt-purchase-customer-item": "\n .label = Kunde:",
        "receipt-purchase-employee-id-item": "\n .label = Medarbejder-id:",
        "receipt-purchase-company-item": "\n .label = Firmaadministrator:",
        "receipt-purchase-time-item": "\n .label = Købstidspunkt:",
        "receipt-purchase-payment-method-item": "\n .label = Betalingsmetode:",
        "receipt-purchase-order-id-item": "\n .label = Ordre-id:",
        "receipt-purchase-shop-channel-item": "\n .label = Via:",
        "receipt-purchase-receipt-error": "Kunne ikke indlæse ordre med id  #{ $orderId }",
        "receipt-purchase-receipt-error-description": "Denne ordre kunne ikke behandles på grund af manglende eller ugyldige data.",

        // Delivery section
        "receipt-delivery-details-section": "\n .heading = Levering",
        "receipt-delivery-order-type-item": "\n .label = Ordretype:",
        "receipt-order-type-catering": "Mødeforplejning",
        "receipt-order-type-lunch": "Frokost",
        "receipt-order-type-takeaway": "Takeaway",
        "receipt-order-type-refill-account": "Optankning",
        "receipt-order-type-auto-refill-account": "Automatisk tank-op tilmelding",
        "receipt-order-type-lunch-subscription": "Abonnement tilmelding",
        "receipt-order-type-subscribe-payment-card": "Tilmelding af betalingskort",
        "receipt-order-type-meeting": "Møde",
        "receipt-order-type-refund": "Refundering",
        "receipt-delivery-type-item": "\n .label = Leveringstype:",
        "receipt-delivery-type-pick-up": "Afhentning",
        "receipt-delivery-time-item": "\n .label = Leveringstid:",
        "receipt-delivery-comment-item": "\n .label = Kommentar:",

        // Order details section
        "receipt-order-details-buyerparty-private": "Privatkøb",
        "receipt-order-details-buyerparty-company": "Firmakøb",
        "receipt-order-details-payment-method-item": "\n .label = Betalingsmetode:",
        "receipt-order-details-vat-total": "\n .label = Moms udgør (25%):",

        // Subscription details section
        "receipt-subscription-details-section": "\n .heading = Abonnement",
        "receipt-subscription-details-subscription-id": "\n .label = Abonnements-id:",
        "receipt-subscription-details-subscription-name": "\n .label = Abonnementsnavn:",
        "receipt-subscription-details-subscription-valid-from": "\n .label = Gældende fra:",
        "receipt-subscription-details-subscription-valid-to": "\n .label = Gælder til:",
        "receipt-subscription-details-subscription-price": "\n .label = Abonnementspris:",

        // Actions section
        "receipt-actions-forward-receipt-button": "Send kvittering",
        "receipt-actions-cancel-order-button": "Refunder bestilling",
        "receipt-actions-confirm-cancel-dialog": "\n .description = Du er ved at refundere denne bestilling. Er du sikker?\n .confirmLabel = Ja\n .cancelLabel = Nej\n .loadingDescription = Refunderer bestilling...",
        "receipt-actions-cancel-disabled-dialog": "\n .title = Refundering ikke tilgængelig\n .message = Denne funktion er endnu ikke klar. Den vil komme senere.\n .buttonLabel = Forstået",
        "receipt-actions-cancel-unavailable-dialog": "\n .buttonLabel = Forstået",

        "receipt-order-label": "Receipt #{ $orderId }, { $orderDate }",

        // Forward receipt
        "receipt-forward-receipt-dialog": "\n .title = { $receipts -> \n *[one] Send kvittering \n [other] Send kvitteringer \n } \n .cancelButtonLabel = Annuller\n .submitButtonLabel = Send\n .submitButtonLoadingLabel = Sender...",
        "receipt-forward-receipt-email-field": "\n .label = E-mail adresse",
        "receipt-forward-receipt-email-field-is-required": "E-mail adresse skal udfyldes",
        "receipt-forward-receipt-email-field-must-be-valid": "Ugyldig e-mail adresse",


        // --- Login domain ---

        // login auth flow hook
        "auth-flow-authentication-result-server-error": "Client expected authentication complete but server said: { $action }.",
        "auth-flow-authentication-unexpected-server-error":  `Unexpected authentication action { $action } in API response`,

        // Create password page
        "create-password-required": "Feltet er påkrævet",
        "create-password-password-invalid-for-policy": "Kodeord overholder ikke password politik",
        "create-password-new-required": "Feltet er påkrævet",
        "create-password-matching": "Kodeordene stemmer ikke overens",
        "create-password-title": "Nyt kodeord",
        "create-password-new-password-field": "\n .label = Nyt kodeord",
        "create-password-submit-button": "Nulstil adgangskode",
        "create-password-confirm-password-field": "\n .label = Bekræft kodeord",

        // Forgot password page
        "forgot-password-username-required": "Brugernavn er påkrævet",
        "forgot-password-username-title": "Glemt Kodeord",
        "forgot-password-username-invalid": "Brugernavn er ikke gyldigt",
        "forgot-password-button-label": "Næste",
        "forgot-password-enter-username-field": "\n .label = Indtast dit brugernavn",


        // SignInWithActivationCode page
        "sign-in-with-activation-code-min-length": "Aktivationskoden skal være minimum 6 tegn langt",
        "sign-in-with-activation-code-required": "Aktivationskoden er påkrævet",
        "sign-in-with-activation-code-title": "Indtast din aktiveringskode",
        "sign-in-with-activation-code-field-label": " \n Activation code",
        "sign-in-with-activation-code-submit-button": "Næste",

        // SignInWithPassword page
        "sign-in-with-password-required": "Kodeord er påkrævet",
        "sign-in-with-password-title": "Indtast dit kodeord",
        "sign-in-with-password-field-label": "\n Kodeord",
        "sign-in-with-password-submit-button": "Log ind",
        "sign-in-with-password-reset-password-link": "Glemt kodeord",

        // SignInWithUsername page
        "sign-in-with-username-min-length": "Brugernavnet skal være på minimum 3 tegn",
        "sign-in-with-username-required": "Brugernavn er påkrævet",
        "sign-in-with-username-title": "Log ind",
        "sign-in-with-username-subtitle": " Welcome to Facilitynet",
        "sign-in-with-username-field-label": "\n .label = Username\n .placeholder = Indtast dit brugernavn",
        "sign-in-with-username-remember-me": "Husk mig",
        "sign-in-with-username-submit-button": "Næste",
        "sign-in-with-username-reset-password-link": "Glemt kodeord?",

        // StartPageLayout
        "start-page-layout-title": "Din portal til mødeplanlægning og kantineydelser",
        "start-page-layout-sub-title-1": "Accepter betalinger med POS og mobiltelefon",
        "start-page-layout-sub-title-2": "Få indsigt i salgstal med Facilitynet Manager",
        "start-page-layout-sub-title-3": "Bedre kommunikation mellem køkken og kunder",
        "start-page-layout-login-button-label": "Log in",

        // Login Layout
        "login-layout-card-title": "Facilitynet Manager",
        "login-layout-card-subtitle": "Canteen management made easy",
        "auto-login-title":"Logger dig ind...",
        "auto-login-description":"Vent venligst mens vi automatisk logger dig ind.",
        "auto-login-error-title":" otp token ikke fundet",
        "auto-login-error-description":"  Du har modtaget et ugyldigt link. Kontakt venligst support.",

        // Invitation
        "invitation-title": "Create your passwords to Facilitynet",
        "invitation-username-rules": "Brugernavn skal være på mindst 3 tegn.",
        "invitation-password-rules": "Adgangskode skal være på mindst 8 tegn og indeholde et lille bogstav, et stort bogstav og et tal.",
        "invitation-usertype-support": "{ -user-type-support }",
        "invitation-usertype-supplier": "{ -user-type-supplier }",
        "invitation-usertype-merchant": "{ -user-type-merchant }",
        "invitation-usertype-company": "{ -user-type-company }",
        "invitation-usertype-office-manager": "{ -user-type-office-manager }",
        "invitation-usertype-unknown": "Ukendt brugertype",
        "invitation-field-username": "\n .label = Brugernavn",
        "invitation-field-password": "\n .label = Adgangskode",
        "invitation-field-repeat-password": "\n .label = Gentag adgangskode",
        "invitation-submit-button": "Aktiver konto\n .loadingLabel = Aktiverer...",
        "invitation-field-username-required": "Brugernavn skal udfyldes",
        "invitation-field-username-min-chars": "Brugernavn skal være på mindst { $minChars } tegn",
        "invitation-field-password-required": "Adgangskode skal udfyldes",
        "invitation-field-password-invalid-for-policy": "Kodeord overholder ikke password politikken",
        "invitation-field-password-min-chars": "Adgangskode skal være på mindst { $minChars } tegn",
        "invitation-field-password-contain-lowercase": "Adgangskode skal indeholde et lille bogstav",
        "invitation-field-password-contain-uppercase": "Adgangskode skal indeholde et stort bogstav",
        "invitation-field-password-contain-number": "Adgangskode skal indeholde et tal",
        "invitation-field-repeatPassword-required": "Dette felt skal udfyldes",
        "invitation-field-repeatPassword-match-password": "Kodeord stemmer ikke overens",

        // Confirm account change
        "confirm-account-change-confirming-email-message": "Bekræfter e-mailadresse...",
        "confirm-account-change-login-button": "Log ind",
        "confirm-account-change-failure-message": "Kunne ikke bekræfte e-mailadressen",

        // Id Card Signup
        "id-card-signup-title": "Complete registration",
        "id-card-signup-description": "Please complete the registration process. Once you have registered your ID card, you can use it to purchase food in the canteen by simply scanning it at the POS screen.",
        "id-card-signup-subscription": "Select subscription",
        "id-card-signup-next-button": "Next",
        "id-card-signup-back-button": "Back",
        "id-card-signup-field-company": "\n .label = Your company:\n .placeholder = Select the company you work for",
        "id-card-signup-field-user-group": "\n .label = Your user group:\n .placeholder = Select user group",
        "id-card-signup-field-name": "\n .label = Your name (*):\n .placeholder = Enter your full name",
        "id-card-signup-field-mobile-number": "\n .label = Your phone:\n .placeholder = Enter your mobile number (optional)",
        "id-card-signup-field-mobile-number-invalid": "Invalid mobile number",
        "id-card-signup-field-name-max-length": "Name cannot exceed 50 characters",
        "id-card-signup-companies-error": "Failed to load companies. Please try again.",
        "id-card-activation-generic-error": "Failed to load companies. Please try again.",
        "id-card-signup-no-subscriptions": "An error occurred while activating your card. Please try again.",
        "id-card-signup-using-company": "Your company: ",
        "id-card-signup-using-user-group": "Your user group: ",
        "id-card-signup-using-user-name": "User name: ",
        "id-card-signup-complete": "Congratulation",
        "id-card-signup-complete-description": "Your card has now been subscribed and you can start using it.",
        "id-card-signup-complete-learn-more": "Learn more:",
        "id-card-signup-complete-learn-more-link": "How to I use Facilitynet payment solution?",

        // Activate account
        "activation-account-username-title": "Aktiver konto",
        "activation-account-username-subtitle": "For at bruge Facilitynet, skal du aktivere din konto nedenfor",
        "activation-account-username-button": "Aktiver",
        "activation-account-username-field": "\n .label = Indtast din e-mail-adresse:",
        "activation-account-password-title": "Create password",
        "activation-account-password-new-password-field": "\n .label = Enter password",
        "activation-account-password-button": "Create password",

        // select company
        "authenticate-select-company-header-reason-multiple-companies-for-domain": "Vælg firma",
        "authenticate-select-company-header-reason-multiple-accounts-for-username": "Vælg brugerkonto",
        "authenticate-select-company-reason-message-multiple-companies-for-domain": "Vi var ikke i stand til at bestemme dit firma automatisk, da dit e-mail domæne <duplicateValue>{ $duplicateValue }</duplicateValue> optræder flere steder i vores system.",
        "authenticate-select-company-reason-message-multiple-accounts-for-username": "Vi fandt flere konti i vores system med e-mail adressen <duplicateValue>{ $duplicateValue }</duplicateValue>.",
        "authenticate-select-company-action-message-multiple-companies-for-domain": "Vælg lokation (firma), som du ønsker at oprette din konto under:",
        "authenticate-select-company-action-message-multiple-accounts-for-username": "Vælg venligst den brugerkonto, som du ønsker at logge ind med.",
        "authenticate-select-company-show-list-button": "Vis valgmuligheder",
        "authenticate-select-company-submit-button": "{ -authenticate-submit-button }\n .loadingLabel = Gemmer...",
        "authenticate-select-company-form-error-message": "Please select a company",
        "authenticate-select-company-company-group-unknown-uid": "Unknown Company UID",
        "authenticate-select-company-company-group-unknown-name": "Unknown Name",
        "authenticate-select-company-company-group-unknown-address": "Unknown Address",
        "authenticate-select-company-no-companies-available": "Ingen firmaer tilgængelige",

        // Public > Self Sign Up
        "self-sign-up-title": "Sign Up",
        "self-sign-up-description": "Please complete the registration process. Once you have finished signing up, you can use account",
        "self-sign-up-field-company": "\n .label = Your company:\n .placeholder = Select the company you work for",
        "self-sign-up-field-user-group": "\n .label = Your user group:\n .placeholder = Select user group",
        "self-sign-up-field-name": "\n .label = Your name (*):\n .placeholder = Enter your full name",
        "self-sign-up-field-email": "\n .label = Email (*):\n .placeholder = Enter your email",
        "self-sign-up-field-mobile-number": "\n .label = Your phone:\n .placeholder = Enter your mobile number (optional)",
        "self-sign-up-complete-button": "Sign Up",
        "self-sign-up-field-email-invalid": "Invalid email address",
        "self-sign-up-congratulation-title": "Congratulation",
        "self-sign-up-congratulation-message": "Vi har sendt et aktiveringslink til din email adresse.",
        "self-sign-up-error-message": "Something went wrong. Please try again.",
        "self-sign-up-confirm-dialog": "\n .title = Bekræft detaljer\n .message = Er du sikker på, at du vil oprette din konto med de angivne oplysninger?\n .buttonLabelSubmit = Bekræft\n .buttonLabelCancel = Annuller",
        "self-sign-up-confirm-company": "\n .label = Firma:",
        "self-sign-up-confirm-user-group": "\n .label = Brugergruppe:",
        "self-sign-up-confirm-name": "\n .label = Dit navn:",
        "self-sign-up-confirm-email": "\n .label = Din e-mail:",
        "self-sign-up-confirm-mobile-number": "\n .label = Din telefon:",


         // Booking > Confirm Booking
        'confirm-booking-complete': "Congratulation",
        'confirm-booking-failed': "Failed",
        'confirm-booking-loading': "Loading...",

        // ExportButton
        "export-button-export-text": "Eksport",
        "export-button-export-all": "Eksporter alle",
        "export-button-export-all-with-filter": "Eksporter alt med filter",
        "export-button-export-selected": "Eksporter valgte",
        "export-button-export-selected-rows": "Eksporter valgte rækker",
        "export-button-export-as-csv-title": "\n .title = Hent som CSV-fil",
        "export-button-export-as-pdf-title": "\n .title = Hent som PDF-fil",
        "export-button-print": "Udskriv",
        "export-button-remove-print-title": "\n .title = Fjern fra printerkø",



        // Export
        "export-period": "Periode",

        // print
        "print-queued": "Din anmodning er i kø",


        // --- ContextDisplay ---
        "context-display-org-unit-supplier": "\n .label = Forpagter:",
        "context-display-org-unit-merchant": "\n .label = Salgssted:",
        "context-display-org-unit-tenant": "\n .label = Lejer:",
        "context-display-org-unit-company": "\n .label = Firma:",
        "context-display-org-unit-user": "\n .label = Bruger:",
        "context-display-org-unit-service-center": "\n .label = Service center:",



        // --- Environment dropdown ---
        "env-dropdown-menu-header": "Skift miljø til:",
        "env-dropdown-title-admin-support":"Administration",
        "env-dropdown-title-reports-support":"Dashboard",
        "env-dropdown-title-admin-supplier":"Administration",
        "env-dropdown-title-reports-supplier":"Dashboard",
        "env-dropdown-title-admin-merchant":"Administration",
        "env-dropdown-title-reports-merchant":"Produktion",
        "env-dropdown-title-accounting-merchant":"Regnskab",
        "env-dropdown-title-admin-company":"Administration",
        "env-dropdown-title-reports-company":"Dashboard",
        "env-dropdown-title-admin-office-manager":"Administration",
        "env-dropdown-title-reports-office-manager":"Dashboard",
        "env-dropdown-title-reports-service-center":"Dashboard",
        "env-dropdown-title-admin-service-center":"Administration",
        "env-dropdown-subtitle-admin-support":"Administrer entiteter og brugere.",
        "env-dropdown-subtitle-reports-support":"Se systemrapporter.",
        "env-dropdown-subtitle-admin-supplier":"Administrer salgssteder og globale indstillinger.",
        "env-dropdown-subtitle-reports-supplier":"Se tværgående rapporter over regnskabstal.",
        "env-dropdown-subtitle-admin-merchant":"Administrer produkter, shops og kundekommunikation.",
        "env-dropdown-subtitle-reports-merchant":"Se driftsoverblik og produktionstal.",
        "env-dropdown-subtitle-admin-company":"Administrer organisationsdata, brugere og administratorer.",
        "env-dropdown-subtitle-reports-company":"Se regnskabstal.",
        "env-dropdown-subtitle-admin-office-manager":"Administrer brugere og administratorer.",
        "env-dropdown-subtitle-reports-office-manager":"Se regnskabstal.",
        "env-dropdown-subtitle-reports-service-center":"Service center rapporter",
        "env-dropdown-subtitle-admin-service-center":"Service center administration",
        "env-dropdown-subtitle-accounting-merchant":"Vis regnskabsrapporter.",


        // --- API components ---
        "api-query-table-fetch-error-message": "Fejl ved indlæsning af data",
        "api-query-autocomplete": "\n .loadingText = Indlæser data...",
        "api-query-autocomplete-fetch-error-message": "Fejl ved indlæsning af data. <retryLink>Prøv igen</retryLink>",

        // Top Bar
        "help-tooltip-text": "\n .title = Vis hjælp",
        "notifications-tooltip-text": "\n .title = Vis beskeder",
        "new-order-tooltip-text": "\n .title = Opret ny ordre",
        "qa-env-warning-part-one": "You are in QA environment. This is not intended for customers. Please use",
        "qa-env-warning-part-two": "instead.",

        // Top Bar > Help
        "help-dialog-search-title": "Hello, how can we help you?",
        "help-dialog-search":"\n .placeholder = Search for articles...",
        "help-dialog-support": "\n .title = Support",
        "help-dialog-email-support": "\n .title = Email support \n .description = If you still need help, you can email us here.",
        "help-dialog-chat-support": "\n .title = Chat support \n .description = For quick questions, you can chat with our customer support team.",
        "help-dialog-troubleshooting": "\n .title = Troubleshooting",
        "help-dialog-troubleshooting-pos-screen": "\n .title = POS screen \n .description = Get help for your POS screen, receipt printer and credit card terminal.",
        "help-dialog-troubleshooting-check-in-screen": "\n .title = Check in screen \n .description = Get help for your check in screen and receipt printer.",
        "help-breadcrumb": "Help",
        "help-dialog-troubleshooting-breadcrumb": "Troubleshooting",
        "help-dialog-troubleshooting-printer-not-working": "\n .title = Printer not working",
        "help-dialog-troubleshooting-credit-card-terminal-not-working": "\n .title = Credit card terminal not working",
        "help-dialog-troubleshooting-pos-screen-not-working": "\n .title = POS screen not working",
        "help-dialog-troubleshooting-check-in-screen-not-working": "\n .title = Check-in screen not working",
        "help-dialog-troubleshooting-start-up-backup-terminal": "\n .title = Start up backup terminal",
        "help-dialog-training": "\n .title = Training",
        "help-dialog-training-education-center": "\n .title = Education Center \n .description = In the Education Center you can view Get Started guides and other training material.",
        "help-dialog-training-guide-button": "View Guide",
        "consent-dialog": "\n .title = Tillad chat \n .message = Vi benytter Intercom til vores chat support. Hvis du godkender, deler vi nedenstående oplysninger med Intercom. \n .skipLabel = Ikke nu \n .consentLabel = Tillad",
        "consent-dialog-personal-information": "Personoplysninger",
        "consent-dialog-pii-category-contact-info": "Kontaktinformation",
        "consent-dialog-pii-category-identifiers": "Identifikation",
        "consent-dialog-pii-category-purchases": "Køb",
        "consent-dialog-pii-category-user-content": "Brugerindhold",
        "consent-dialog-privacy-policy": "Privatliv",
        "consent-dialog-view-company-privacy-policy": "Se firmaets privatlivspolitik",
        "consent-dialog-pii-item-name": "Navn",
        "consent-dialog-pii-item-email-address": "E-mail",
        "consent-dialog-pii-item-phone-number": "Telefonnummer",
        "consent-dialog-pii-item-user-id": "Bruger id",
        "consent-dialog-pii-item-device-id": "Device id",
        "consent-dialog-pii-item-customer-support": "Kundeservice",
        "consent-dialog-pii-item-purchase-history": "Købshistorik",
        "intercom-error-dialog": "\n .title = Chat fejlede\n .message = Der opstod en fejl under indlæsning af chatten. Du kan i stedet sende en e-mail til support.\n .buttonLabel = Forstået",
        "intercom-loading-dialog": "\n .description = Chatten indlæser...",

        //ControlKitchen page
        "control-kitchen-checked-in-yes-chip": "Ja",
        "control-kitchen-checked-in-no-chip": "Nej",
        "control-kitchen-column-check-in-time": "Indtjekning tid",
        "control-kitchen-column-id": "Medarbejder-id",
        "control-kitchen-column-name": "Navn",
        "control-kitchen-column-items": "Antal",
        "control-kitchen-column-order-details": "Ordre",
        "control-kitchen-checked-in": "Indtjekket",
        "control-kitchen-checked-in-sub-title": "Dagens kontrolkode:",
        "control-kitchen-last-updated": "Sidst opdateret: {$lastUpdated}",
        "control-kitchen-refresh": "Opdater siden",
        "control-kitchen-receipt": "Kvittering",
        "control-kitchen-date-label": "Købsdato",
        "control-kitchen-date-delivery-label": "Leveringsdato",
        "control-kitchen-datetime-from-label": "Fra",
        "control-kitchen-datetime-to-label": "Til",
        "control-kitchen-period-label": "Periode",
        "control-kitchen-check-in-type": "Type",
        "control-kitchen-checked-in-filter-all": "Alle",
        "control-kitchen-checked-in-filter-checked-in": "Indtjekket",
        "control-kitchen-checked-in-filter-not-checked-in": "Ikke tjekket ind",


        // News folder
        "news-published": "Udgivet: {$date}",
        "news-implemented": "Implementeret: {$date}",
        "news-created": "Oprettet: {$date}",
        "news-updated": "Opdateret: {$date}",
        "news-gopay": "Facilitynet nyheder",
        "news-roadmap": "Roadmap",
        "news-new-features": "New features",
        "news-new-load-error": "Error loading roadmap features",
        "news-start-date": "Startdato",
        "news-end-date": "Slutdato",
        "news-type": "Type",
        "news-bug-fix": "Fejlrettelse",
        "news-new-feature": "Ny funktion",
        "news-upcoming": "Kommende",
        "news-all": "Alle",
        "news-current-news": "Aktuelle nyheder",
        "news-archive-news": "Arkiv",
        "news-create-new-button": "Opret nyhed",
        "news-draft-type": "Kladde",
        "news-published-type": "Udgivet",
        "news-schedule-type": "Planlagt",
        "news-expired-type": "Udløbet",
        "news-edit": "Rediger",
        "news-delete": "Slet",
        "news-default-error-message": "Noget gik galt",
        "news-archive-title": "Titel",
        "news-archive-expiration-date": "Udløber",
        "news-archive-active-status": "Status",
        "merchant-news-header": "\n .title = Kundenyheder",
        "news-no-news-title": "Ingen nyheder",
        "news-no-roadmap-title": "No roadmaps",
        "news-no-news-body": "Opret din første nyhed ",
        "news-no-news-here-link": "her",
        "news-gopay-read-more": "Læs mere",
        "news-table-delete-success-message": "Article deleted",
        "create-news-header": "\n .title = Opret nyhed",
        "edit-news-header": "\n .title = Rediger nyhed",
        "nav-item-create-news-header": "Opret nyhed",
        "nav-item-edit-news-header": "Rediger nyhed",
        "create-news-save-button": "Opret",
        "edit-news-save-button": "Gem",

        // Office folder
        "office-period-total": "I alt for perioden: {$periodTotal}",
        "office-transation-period-total": "Samlede transaktioner for perioden: {$transactionPeriodTotal}",
        "office-purchase-time": "Tid",
        "office-purchase-name": "Navn",
        "office-purchase-payment-details": "Betalingsmetode",
        "office-purchase-payment-channel": "Kanal",
        "office-purchase-amount": "Beløb",
        "office-purchase-receipt": "Kvittering",
        "office-last-updated": "Sidst opdateret: {$lastUpdated}",
        "office-refresh": "Opdater siden",

        "office-meeting-service-title": "Mødeforplejning",
        "office-meeting-service-header": "\n .title = Mødeforplejning",
        "office-meeting-service-table-booked-start-date": "Booked start date",
        "office-meeting-service-table-booked-end-date": "Booked end date",
        "office-meeting-service-table-merchant": "Salgssted",
        "office-meeting-service-table-order-id-column": "Ordre ID",
        "office-meeting-service-table-booked-date-column": "Bogføringsdato",
        "office-meeting-service-table-delivery-time-column": "Leveringstid",
        "office-meeting-service-table-creator-column": "Bestiller",
        "office-meeting-service-table-amount-column": "Beløb (DKK)",
        "office-meeting-service-table-show-receipt": "Show receipt",
        "office-meeting-service-table-floating-action-bar-receipts": "\n .title = Receipts",
        "office-meeting-service-table-floating-action-bar-export": "\n .title = Export",


        // --- Profile page ---
        "profile-user-account-id": "ID:",
        "profile-administrator-for": "Administrator for",
        "profile-hosted-by": "Udlejet af",
        "profile-hosted-by-office-hotel": "Kontorhotel",
        "profile-actions": "Genveje",
        "profile-settings-card": "Indstillinger",
        "profile-password-card": "Adgangskode",
        "profile-actions-change-password": "Skift kodeord",
        "profile-actions-edit-profile": "Ret profil",
        "profile-actions-delete-account": "Slet brugerkonto",
        "profile-security": "Sikkerhed",
        "profile-security-manage-admins": "Kan administrere andre administratorer:",
        "profile-security-manage-admins-yes": "Ja",
        "profile-security-manage-admins-no": "Nej",
        "profile-security-ip-address-allowlist": "IP-adresse allowlist:",
        "profile-roles": "Dine roller",
        "profile-user-info": "Brugerkonto",
        "profile-user-type": "Brugertype",
        "profile-username": "Brugernavn:",
        "profile-email": "E-mail:",
        "profile-phone-number": "Telefonnummer:",
        "profile-mobil-number": "Mobilnummer:",
        "profile-name": "Navn:",
        "profile-page-header": "\n .title = Brugerkonto",
        "profile-nav-item-home": "Hjem",
        "profile-user-type-info-mode-supplier": "“Som leverandør-administrator kan du få adgang til og administrere salgssteder og administratorer på vegne af din virksomhed. For hvert salgssted kan du gøre alt, hvad en salgssteds-administrator kan gøre. Derudover kan du styre delte indstillinger og se tværgående rapporter.",
        "profile-user-type-info-mode-merchant": "Som salgssteds-administrator kan du administrere shops og produkter under dit salgssted. Du har også adgang til detaljerede regnskabsrapporter og produktionsoversigter, hvor du kan administrere og opfylde kundeordrer.",
        "profile-user-type-info-mode-company": "Som virksomheds-administrator kan du administrere brugere og integrationer for din virksomhed. Du kan også se regnskabsrapporter for ordrer foretaget af virksomhedens medarbejdere.",
        "profile-user-type-info-mode-office-manager": "Som office manager kan du administrere brugere og integrationer for din lejer. Du kan også se regnskabsrapporter for ordrer foretaget af virksomhedens medarbejdere.",
        "profile-user-type-info-mode-support": "Som supporter kan du administrere brugere, hardwareenheder og entiteter for hele systemet. Du kan også slå nødvendige oplysninger op om ordrer, brugere og enheder for at håndtere support tickets.",
        "profile-user-type-info-mode-user": "As a user you can make orders in the system and view your previous orders.",
        "profile-roles-mode-agreement-owner": "Aftaleejer",
        "profile-roles-mode-bookkeeper": "Bogholder",
        "profile-roles-mode-dpo": "DPO",
        "profile-roles-mode-it-administrator": "IT administrator",
        "profile-roles-mode-news-subscriber": "Nyhedsabonnent",
        "profile-roles-mode-system-operation-subscriber": "System-meddelelsesabonnent",
        "profile-roles-read-more": "Læs om administratorroller",
        "profile-roles-no-roles": "Du har ingen roller",

        // --- Profile page > Change password ---
        "profile-change-password-page-header": "\n .title = Skift kodeord",
        "profile-change-password": "Skift kodeord",
        "profile-change-password-profile": "Profil",
        "profile-change-password-profile-currentPassword": "\n .label = Nuværende kodeord",
        "profile-change-password-profile-newPassword": "\n .label = Nyt kodeord",
        "profile-change-password-profile-confirmPassword": "\n .label = Bekræft kodeord",
        "profile-change-password-profile-match-password": "Kodeord stemmer ikke overens",
        "profile-change-password-password-policy": "\n .title = Kodeordspolitik",
        "profile-change-password-default-policy": "Facilitynet default policy",
        "profile-change-password-info": "Kontakt venligst support for at definere eller ændre politikken for din organisation.",
        "profile-change-password-submit-button": "Opdatere adgangskode",

        // --- Change User Account > Dialog ---
        "change-user-account-dialog-title": "Skift brugerkonto",
        "change-user-account-dialog-pending-state-email-has-been-sent": "An email has been sent. Please check you email inbox.",
        "change-user-account-dialog-pending-state-pending-approval": "Afventer godkendelse...",
        "change-user-account-dialog-confirm-email-subtitle": "Før du kan skifte mellem dine brugerkonti, skal du bekræfte, at du ejer e-mailkontoen <element>{ $email }</element>.",
        "change-user-account-dialog-click-below-subtitle": "Klik på knappen nedenfor for at sende mig et bekræftelseslink:",
        "change-user-account-dialog-send-confirmation-button": "Send bekræftelseslink",
        "change-user-account-dialog-empty-content-subtitle": "No other user accounts were found with the email:",
        "change-user-account-dialog-users-list-available-accounts-subtitle": "You have { $totalUserAccounts } other user accounts with the e-mail: { $email }",
        "change-user-account-dialog-users-list-swift-to-another-account": "Swift to another account below:",

        // User Types
        "profile-usertype-support": "{ -user-type-support }",
        "profile-usertype-supplier": "{ -user-type-supplier }",
        "profile-usertype-merchant": "{ -user-type-merchant }",
        "profile-usertype-company": "{ -user-type-company }",
        "profile-usertype-office-manager": "{ -user-type-office-manager }",
        "profile-usertype-user": "{ -user-type-user }",
        "profile-usertype-service-center": "{ -user-type-service-center }",




        // --- Settings page ---
        "settings-page-header": "\n .title = Indstillinger",
        "settings-title": "Indstillinger",
        "settings-nav-item-home": "Hjem",
        "settings-language-setting": "Sprog",
        "settings-social-media-label": "Sociale medier",
        "settings-social-media-text": "Følg os på LinkedIn",


        // --- Admin home card ---
        "admin-home-card-show-all-button": "Vis alle",


        // Back Button
        "back-button-label": "Tilbage",

        //AvatarMenu
        "avatar-menu-tooltip": "Åbn indstillinger",


        // ArticleSettingsPanel
        "article-settings-panel-settings-title": "\n .title = Visning",
        "article-settings-panel-published": "\n .label = Publiceret",
        "article-settings-panel-schedule-for": "\n .label = Udgivelsesdato",
        "article-settings-panel-expires": "\n .label = Udløbsdato",

        // CardDropdownMenu

        // ImageUploader
        "image-uploader-button-label": "Upload billede",
        "image-uploader-drag-and-drop": "Træk og slip eller Gennemse",
        "image-uploader-max-file-size-exceeded": "Filen er større end grænsen på { $maxFileSize }.",
        "image-previewer-button-label": "Upload nyt billede",
        "image-previewer-button-delete": "Slet",




        // CreateOrEditMerchantArticle
        "create-or-edit-merchant-article-mode-normal-article": "Normal artikel",
        "create-or-edit-merchant-article-mode-external-article": "Ekstern artikel",
        "create-or-edit-merchant-article-mode-product-news": "Produkt nyheder",
        "create-or-edit-merchant-article-title": "\n .label = Titel",
        "create-or-edit-merchant-article-body": `\n .placeholder = Beskrivelse\n .helperText = Resterende tegn: { $charsRemaining }`,
        "create-or-edit-merchant-article-body-too-long": `Du har overskredet det maksimale antal tegn: { $charsLimit }`,
        "create-or-edit-merchant-article-product-id": "\n .label = Produkt id",
        "create-or-edit-merchant-article-info-label-draft": "\n .label = Artiklen er et udkast. Den vil ikke være synlig for brugerne, før du udgiver den.",
        "create-or-edit-merchant-article-info-label-schedule": "\n .label = Artiklen er planlagt til publicering den: { $date }",
        "create-or-edit-merchant-article-type": "\n .label = Artikel type",
        "create-or-edit-merchant-article-delete": "artikel",
        "news-create-image-field-label": "\n .label = Upload billede",

        // CreateAndPublishSplitButton
        "create-and-publish-split-button-create-draft": "Kladde",
        "create-and-publish-split-button-publish": "Udgiv",
        "create-and-publish-split-button-save": "Gem",
        "create-and-publish-split-button-unpublish": "Fjern",
        "create-and-publish-split-button-cancel-publication": "Annuller udgivelsen publication",
        "create-and-publish-split-button-republish": "Genudgiv",


        "table-summary-box-total-period": "\n .title = Total i denne periode",
        "table-summary-box-number-of-orders": "\n .title = Antal ordrer",
        "table-summary-box-number-of-subscriptions": "\n .title = Number of subscriptions",

        // --- Office manager ---

        // Navigation
        "tenant-nav-item-home": "Hjem",

        // - reporting
        "tenant-nav-item-accounting": "\n .title = Regnskab",
        "tenant-nav-item-pos": "POS",
        "tenant-nav-item-meeting-service": "Mødeforplejning",
        "tenant-nav-item-subscriptions": "Abonnementer",

        // - admin
        "tenant-nav-item-users": "Brugere",
        "tenant-nav-item-organization-page-header":"\n .title = Organization",
        "tenant-nav-item-administrators": "Administrators",

        // Reporting pages

        // Home
        "tenant-reports-home-placeholder": "\n .title = Office manager dashboard kommer snart\n .body = Dit dashboard vil vise en oversigt over vigtige nøgletal, så du altid har et godt overblik over dine medarbejderes køb.",

        // Purchases
        "tenant-purchases-header": "\n .title = POS",
        "tenant-subscriptions-header": "\n .title = Abonnementer",

        // Admin pages

        // Home
        "office-manager-home-user-card-group": "\n .title = Brugere",
        "office-manager-home-user-admin-placeholder": "Kommer snart. Her vil du kunne styre brugere og administratorer under din organisation.",
        "office-manager-home-user-card": "  \n .title = Brugere\n .description = Administrer brugere for din organisation",
        "office-manager-home-admin-card": "  \n .title = Administratorer\n .description = Administrer jeres administratorer",
        "office-manager-home-card-show-all": "Vis alle",
        "office-manager-users-header": "\n .title = Brugere",
        "office-manager-users-tab-users": "Brugere",
        "office-manager-users-tab-admins": "Administratorer",
        "office-manager-users-table-id-column": "Medarbejder-id",
        "office-manager-users-table-name-column": "Navn",
        "office-manager-users-table-email-column": "E-mail",
        "office-manager-users-table-status-column": "Status",
        "office-manager-users-table-status-column-active": "Aktiv",
        "office-manager-users-table-status-column-inactive": "Inaktiv",
        "office-manager-user-show-details": "Vis detaljer",
        "office-manager-user-edit": "Ret bruger",
        "office-manager-user-delete": "Slet bruger",
        "office-manager-user-delete-title": "bruger",
        "office-manager-users-create-user-button": "Opret bruger",
        "office-manager-users-create-admin-button": "Opret administrator",
        "office-manager-user-details-dialog-title": "Brugerdetaljer",
        "office-manager-settings-panel": "\n .title = Indstillinger",
        "office-manager-settings-send-invitation": "Send email invitation",
        "office-manager-settings-disable-sync": "Frakobl synkroniseringsjob",
        "office-manager-settings-disable-sync-text": "Hvis frakoblet, vil denne bruger blive ignoreret af brugersynkroniseringsjob.",

        // show user details dialog
        "user-details-user-id": "Bruger-id:",
        "user-details-employee-id": "Medarbejder-id:",
        "user-details-name": "Navn:",
        "user-details-role-type-news-subscriber" : "Nyhedsabonnent",
        "user-details-role-type-system-operation-subscriber" : "System status-abonnent",
        "user-details-email": "E-mail:",
        "user-details-mobile": "Mobilnr.:",
        "user-details-phone": "Tlfnr.:",
        "user-details-role": "Brugerroller:",
        "user-details-settings-title": "Indstillinger",
        "user-details-sync-jobs": "Frakoblet synkroniseringsjob:",
        "user-details-sync-jobs-ignored": "JA",
        "user-details-sync-jobs-included": "NEJ",
        "user-details-security-title": "Sikkerhed",
        "user-details-security-settings-yes": "JA",
        "user-details-security-settings-no": "NEJ",
        "user-details-security-manage-admins": "Kan administrere andre administratorer:",
        "user-details-security-ip-address": "Tilladte IP-adresser:",
        "user-details-history-title": "Historik",
        "user-details-history-created": "Oprettet:",
        "user-details-history-edited": "Sidst ændret:",

        //Create user form
        "office-manager-create-user-form": "Opret",
        "office-manager-edit-user-form": "Gem",
        "office-manager-create-user-form-title": "Opret bruger",
        "office-manager-edit-user-form-title": "Ret bruger",
        "office-manager-create-user-home-breadcrumb": "Hjem",
        "office-manager-create-user-users-breadcrumb": "Konto",
        "office-manager-create-user-create-breadcrumb": "Opret bruger",
        "office-manager-create-user-edit-breadcrumb": "Ret bruger",
        "office-manager-create-administrator-breadcrumb":"Opret administrator",
        "office-manager-edit-administrator-breadcrumb":"Ret administrator",
        "office-manager-create-admin-form-title": "\n .title = Opret administrator",
        "office-manager-edit-admin-form-title": "\n .title = Ret administrator",
        "office-manager-create-user-field-id": "\n .label = Medarbejder-id",
        "office-manager-create-user-field-name": "\n .label = Navn",
        "office-manager-create-user-field-email": "\n .label = E-mail",
        "office-manager-create-user-field-mobile": "\n .label = Mobilnr.",
        "office-manager-create-user-field-phone": "\n .label = Tlfnr.",
        "office-manager-create-user-field-active": "Aktiv",
        "office-manager-security-panel": "\n .title = Sikkerhed",
        "office-manager-security-manage-admins": "Kan administrere andre admins",
        "office-manager-security-ip-field": " \n .label = Whitelist IP-addresse\n .helperText = Brugeren har kun adgang til at logge på fra denne IP-addresse. Hvis du vil registrere flere IP-adresser, skal du adskille dem med komma.",
        "office-manager-create-user-required-field-empty": "Dette felt er påkrævet",
        "office-manager-create-user-invalid-email-address": "Ugyldig e-mailadresse",
        "office-manager-create-user-invalid-phone-number": "Ugyldigt telefonnummer",

        // Create or edit room
        "resource-room-create-form-title": "\n .title = Create room",
        "resource-room-edit-form-title": "\n .title = Edit room",
        "resource-room-create-required-field-empty": "This field is required",
        "resource-room-create-user-home-breadcrumb": "Home",
        "resource-room-create-user-users-breadcrumb": "Users",
        "resource-room-create-room-breadcrumb":"Create room",
        "resource-room-edit-room-breadcrumb":"Edit room",


        // Purchases page
        "tenant-pos-title": "POS",
        "tenant-purchases-tab-orders": "\n .title = Ordrer",
        "tenant-purchases-tab-subscriptions-details": "Detaljer",
        "tenant-purchases-tab-subscriptions-cancel": "Opsig",

        //Admin roles field
        "tenant-admin-roles-field-label": "Tildel roller",
        "tenant-admin-role-agreement-owner": "System-ejer",
        "tenant-admin-role-dpo": "GDPR-ansvarlig",
        "tenant-admin-role-it-administrator": "IT administrator",
        "tenant-admin-role-bookkeeper": "Bogholder",
        "tenant-admin-role-news-subscriber": "Nyhedsabonnent",
        "tenant-admin-role-system-operation-subscriber": "Systemdrift abonnent",


        // Survey Page
        "survey-header": "\n .title = Brugertilfredshed",
        "survey-tab-overview": "Overblik",
        "survey-tab-ratings": "Alle bedømmelser",
        "survey-tab-ratings-no-survey-data": "Ingen data tilgængelige",
        "survey-tab-overview-no-surveys": "Ingen undersøgelser defineret endnu.",
        "survey-tab-overview-no-questions": "Ingen spørgsmål defineret for denne undersøgelse.",
        "survey-tab-ratings-good-topics-card": "\n .title = Tilfredse med\n .datasetLabel = Bedømmelser",
        "survey-tab-ratings-bad-topics-card": "\n .title = Utilfredse med\n .datasetLabel = Bedømmelser",
        "survey-tab-overview-trend-card": "\n .title = Udvikling af tilfredshed\n .scoreLabel = Gennemsnitsscore\n .votesLabel = Antal bedømmelser",
        "survey-tab-comment": "Kommentar",
        "survey-tab-surveys": "Brugerundersøgelser",
        "survey-period-select": "\n .label = Periode",
        "survey-period-today": "I dag",
        "survey-period-last-day": "Sidste døgn",
        "survey-period-last-week": "Sidste uge",
        "survey-period-last-month": "Sidste måned",
        "survey-period-last-quarter": "Sidste kvartal",
        "survey-period-last-year": "Sidste år",

        // All rating
        "all-rating-time": "Tid",
        "all-rating-question": "Spørgsmål",
        "all-rating-score": "Score",
        "all-rating-topics": "Emner",
        "all-rating-comment": "Kommentar",

        // SelectSurvey
        "select-survey": "\n .label = Brugerundersøgelse",

        // --- Smiley summary card ---
        "survey-smiley-summary-card": "\n .title = Samlet score",
        "survey-smiley-summary-card-overall-score-label": "Score: { $averageScore }",

        // --- Survey participation card ---
        "survey-participation-card": "\n .title = Deltagelse",
        "survey-participation-card-participants-label": "Deltagere",
        "survey-participation-card-non-participants-label": "Ikke deltagende",
        "survey-participation-card-participation-label": "Procentdel",
        "survey-participation-card-participation-breakdown": "{ $ratings } besvarelser af { $orders } køb",

        // --- Survey smiley distribution card ---
        "survey-smiley-distribution-card": "\n .title = Tilfredshed",
        "survey-smiley-distribution-card-votes-label": "Bedømmelser",
        "smiley-label-bad": "Meget dårlig",
        "smiley-label-poor": "Ringe",
        "smiley-label-medium": "Middel",
        "smiley-label-good": "God",
        "smiley-label-excellent": "Fremragende",


        // Production
        "production-meeting-service-breadcrumb": "Mødeforplejning",
        "production-planning-breadcrumb": "Planlægning",
        "production-pos-purchases-breadcrumb": "POS køb",
        "production-takeaway-page-header": "\n .title = Takeaway",
        "production-takeaway-breadcrumb": "Takeaway",
        "production-transactions-print-label": "Print etiket",
        "production-table-toolbar-banner-unprinted-receipts-message": "Kvitteringer er ikke udskrevet på cloudprinteren.",
        "production-table-toolbar-banner-show-button": "Vis",
        "production-table-toolbar-banner-showing-unprinted-message": "Viser ikke-udskrevne ordrer.",
        "production-table-toolbar-banner-clear-filter-button": "Ryd filter",
        "production-planning-page-header": "\n .title = Planlægning",
        "production-meeting-service-page-header": "\n .title = Mødeforplejning",
        "production-pos-purchases-page-header": "\n .title = POS køb",
        "production-tab-production-list": "Produktionsliste",
        "production-tab-pos-transactions": "POS transaktioner",
        "production-tab-orders": "Produktion {$amount}",
        "planning-tab-takeaway": "Takeaway",
        "planning-tab-calendar": "Kalender",
        "planning-tab-not-approved": "Afventer godkendelse {$amount}",
        "planning-tab-to-be-booked": "Skal bogføres {$amount}",
        "meeting-service-refresh": "Opdater",
        "planning-tabs-placeholder": "\n .title = Kommer snart \n .body = Vi arbejder på at levere denne funktion til dig.",
        "production-list-no-result": "Ingen resultater",
        "production-orders-action-bar-confirm-queue-remove-dialog": "\n .title = Fjern fra printerkø\n .message = Er du sikker på at du vil fjerne de valgte kvitteringer fra printerkøen?\n .buttonLabelSubmit = Fjern",
        "production-orders-action-bar-confirm-print-dialog": "\n .title = Udskriv kvitteringer\n .message = Er du sikker på, at du vil udskrive de valgte kvitteringer?\n .buttonLabelSubmit = Udskriv",
        "production-meeting-service-shortcuts-button": "Genveje",
        "production-meeting-service-shortcut-booked-orders": "Bogførte ordrer",

        // Production package slip
        "production-package-slip-order-error": "Kunne ikke indlæse følgeseddel med id #{ $orderId }",
        "production-package-slip-order-error-description": "Denne ordre kunne ikke behandles på grund af manglende eller ugyldige data.",
        "production-package-slip-order-id-number": "Ordre ID: {$orderId}",
        "production-package-slip-section-delivery-details-title": "Leveringsdetaljer",
        "production-package-slip-section-delivery-details-type": "Leveringstype:",
        "production-package-slip-section-delivery-details-time": "Leveringstid:",
        "production-package-slip-section-delivery-details-meeting-time": "Mødetid:",
        "production-package-slip-section-delivery-details-location": "Leveringssted:",
        "production-package-slip-section-delivery-details-sittings": "Kuverter:",
        "production-package-slip-section-delivery-details-merchant": "Leverandør:",
        "production-package-slip-section-contact-details-title": "Kontaktoplysninger",
        "production-package-slip-section-contact-details-meeting-creator": "\n .label = Opretter:",
        "production-package-slip-section-contact-details-meeting-host": "\n .label = Mødevært:",
        "production-package-slip-table-column-items": "Antal",
        "production-package-slip-table-column-products": "Produkter",
        "production-package-slip-table-column-delivery-time": "Leveringstid",
        "production-package-slip-section-note-title": "Note",
        "production-package-slip-section-header-slip-title": "Følgeseddel",
        "production-package-slip-section-header-digital-slip-title": "Digital seddel",
        "production-package-slip-header-orders-count": "Følgesedler: {$orderCount} valgt",

        // Production credit note
        "production-credit-note-dialog-title": "\n .dialogTitle = Create credit note",
        "production-credit-note-credit-info": "\n .title = A credit note is used to reverser parts of a booked order.",
        "production-credit-note-debit-info": "\n .title = A supplementary order is used to add items to an order that is already booked.",
        "production-credit-note-table-column-order-id": "Order ID",
        "production-credit-note-table-column-type": "Type",
        "production-credit-note-table-column-booked": "Booked",
        "production-credit-note-table-column-amount": "Amount (DKK)",
        "production-credit-note-table-column-type-cell-original-order": "Original order",
        "production-credit-note-table-column-type-cell-credit": "Credit note",
        "production-credit-note-table-column-type-cell-debit": "Supplementary order",
        "production-credit-note-button-next": "Next",
        "production-credit-note-button-cancel": "Cancel",
        "production-credit-note-select-label": "Create",

        // Accounting
        "accounting-header": "\n .title = Regnskab",
        "accounting-product-sales-page-header": "\n .title = Produktsalg",
        "merchant-nav-item-accounting-product-sales": "Produktsalg",
        "accounting-orders-page-header": "\n .title = Ordrer",
        "merchant-nav-item-accounting-orders": "Ordrer",
        "accounting-subscriptions-page-header": "\n .title = Abonnementer",
        "merchant-nav-item-accounting-subscriptions": "Abonnementer",
        "accounting-cash-register-page-header": "\n .title = Balance",
        "merchant-nav-item-accounting-cash-register": "Balance",
        "accounting-customers-page-header": "\n .title = Kunder",
        "merchant-nav-item-accounting-customers": "Kunder",
        "accounting-customer-balance-page-header": "\n .title = Brugersaldo",
        "merchant-nav-item-accounting-customer-balance": "Brugersaldo",
        "merchant-nav-item-accounting-z-report": "Z-rapport",
        "merchant-nav-item-accounting-custom-reports": "Custom reports",
        "merchant-accounting-z-reports-table-date-range-filter": "\n .label = Date range",

        "accounting-product-sales-breadcrumb-title": "Produktsalg",
        "accounting-orders-breadcrumb-title": "Ordrer",
        "accounting-subscriptions-breadcrumb-title": "Abonnementer",
        "accounting-cash-register-breadcrumb-title": "Balance",
        "accounting-customers-breadcrumb-title": "Kunder",
        "accounting-customer-balance-breadcrumb-title": "Brugersaldo",
        "accounting-customers-button-expand-all": "Udvid alle",
        "accounting-customers-button-collapse-all": "Luk alle",

        "accounting-orders-tab-transactions": "Transaktioner",
        "accounting-orders-tab-refill": "Tank-op",
        "accounting-orders-tab-meetingService": "Mødeforplejning",
        "transactions-table-list-refund": "Refund\n .title = Refund\n .message = Er du sikker på, at du vil refundere ordre #{ $orderId } ({ $amount })?\n .buttonLabelSubmit = Bekræft\n .buttonLabelCancel = Annuller",
        "transactions-table-list-refund-success-dialog-title": "Ordre blev refunderet",
        "transactions-table-list-refund-error-message": "Kunne ikke refundere ordre. Prøv venligst igen.",
        "transactions-table-list-message-customer": "Message customer",

        "filter-menu-title": "Filtre",
        "filter-menu-clear-all-button": "Fjern alle",
        "filter-menu-clear-button": "Fjern",

        "filter-menu-accordion-shops-title": "\n .title = Shops",
        "filter-menu-accordion-customers-title": "\n .title = Customers",
        "filter-menu-accordion-transactions-order-details-title": "\n .title = Order details",
        "filter-menu-accordion-transactions-order-number": "\n .label = Order number \n .placeholder = Search by order no...",
        "filter-menu-accordion-transactions-user": "\n .label = User \n .placeholder = Enter id or email",

        "standard-email-filter-label": "\n .label = E-mail",
        "standard-email-filter-error-message": "Invalid email address",
        "standard-id-filter-order-id-label": "\n .label = Ordre ID",
        "standard-id-filter-employee-id-label": "\n .label = Medarbejder ID",
        "standard-id-filter-only-numbers-error-message": "Must contain only numbers",
        "standard-last-4-numbers-filter": "\n .label = Kreditkort, sidste 4 cifre",
        "standard-last-4-numbers-filter-error-message": "Only last 4 numbers",
        "standard-payment-method-input-label": "Betalingsmetode",
        "standard-payment-method-item-credit-card": "Credit card",
        "standard-payment-method-item-contant": "Contant",
        "standard-payment-method-item-invoicing": "Invoicing",
        "standard-payment-method-item-wallet": "Wallet",
        "standard-payment-method-item-free": "Free",
        "standard-merchants-filter-label": "Merchants",
        "standard-merchants-shops-filter-label": "Shops",



        "standard-start-date-picker": "\n .label = Startdato",
        "standard-end-date-picker": "\n .label = Slutdato",
        "standard-period-date-picker": "Periode",

        "table-select-data-type-filter-on-label": "Filtrer på",
        "table-select-data-type-filter-on-label-label": "\n .label = Filtrer på",
        "table-select-data-type-filter-on-item-order-date": "Ordredato",
        "table-select-data-type-filter-on-item-delivery-date": "Leveringsdato",

        "table-select-date-period-filter-by-label": "Periode",
        "table-select-date-period-filter-by-label-label": "\n .label = Periode",
        "table-select-date-period-filter-by-all": "Alle",
        "table-select-date-period-filter-by-today": "I dag",
        "table-select-date-period-filter-by-yesterday": "I går",
        "table-select-date-period-filter-by-tomorrow": "I morgen",
        "table-select-date-period-filter-by-this-week": "Denne uge",
        "table-select-date-period-filter-by-this-month": "Denne måned",

        "table-select-resource-type-filter-by-label": "Ressourcetype",
        "table-select-resource-type-filter-by-label-label": "\n .label = Ressourcetype",
        "table-select-resource-type-filter-by-all": "Alle",
        "table-select-resource-type-filter-by-room": "Room",
        "table-select-resource-type-filter-by-mobile-av": "Mobile av",
        "table-select-resource-type-filter-by-car": "Car",

        "standard-order-type-filter-mode-all": "Alle",
        "standard-order-type-filter-mode-pos": "POS",
        "standard-order-type-filter-mode-meeting-service": "Mødeforplejning",
        "standard-order-type-filter-mode-resource-booking": "Resource booking",
        "standard-order-type-filter-mode-internal": "Internal",
        "standard-order-type-filter-mode-external": "External",

        // Accounting > Orders > Meeting service
        "accounting-orders-meeting-service-receipt": "Receipt",
        "accounting-orders-meeting-service-table-startDate-date-picker": "\n .label = Booked start date",
        "accounting-orders-meeting-service-table-endDate-date-picker": "\n .label = Booked end date",
        "accounting-orders-meeting-service-table-number": "Ordre-id",
        "accounting-orders-meeting-service-table-ref": "Ref.",
        "accounting-orders-meeting-service-table-booked-date": "Bogføringsdato",
        "accounting-orders-meeting-service-table-delivery-date": "Leveringsdato",
        "accounting-orders-meeting-service-table-creator": "Ordregiver",
        "accounting-orders-meeting-service-table-status": "Status",
        "accounting-orders-meeting-service-table-amount": "Beløb",
        "filter-menu-accordion-booked-date-title": "\n .title = Bogføringsdato",
        "filter-menu-accordion-delivery-date-title": "\n .title = Delivery date",
        "filter-menu-accordion-order-details-title": "\n .title = Order details",
        "filter-menu-accordion-meeting-service-start-date-picker": "\n .label = Start date",
        "filter-menu-accordion-meeting-service-end-date-picker": "\n .label = End date",
        "filter-menu-accordion-meeting-service-order-number": "\n .label = Order number \n .placeholder = Search by order no...",
        "filter-menu-accordion-meeting-service-customer": "\n .label = Kunde \n .placeholder = Name of customer...",
        "accounting-orders-meeting-service-payment-type-credit": "Kreditnota",
        "accounting-orders-meeting-service-payment-type-debit": "",

        // Accounting subscription
        "accounting-subscription-title": "Abonnement",
        "accounting-subscription-name": "Navn",
        "accounting-subscription-subscribed": "Tilmeldt",
        "accounting-subscription-unsubscribed": "Afmeldt",
        "accounting-subscription-payment-method": "Betalingsmetode",
        "accounting-subscription-amount": "Beløb",
        "accounting-subscription-cancel": "Opsig abonnement",
        "accounting-subscription-cancel-true": "Dit abonnement er blevet opsagt",

        // Accounting product sale
        "accounting-product-sale-product-code": "Produktkode",
        "accounting-product-sale-product": "Produkt",
        "accounting-product-sale-product-quantity": "Antal",
        "accounting-product-sale-product-amount": "Beløb",
        "accounting-product-sale-export-empty": "No sales for this period.",
         "accounting-product-sale-date-range-label": "\n .label = Period",

        // Accounting balance
        "accounting-amount": "Beløb",
        "accounting-amount-no-sales": "Intet salg i perioden",


        // Accounting debtors
        "accounting-debtors-export-items-label": "Antal",
        "accounting-debtors-export-amount-label": "Beløb",
        "accounting-debtors-export-subtotal-label": "Subtotal",
        "accounting-debtors-export-failed": "Kunne ikke eksportere debitorer",
        "accounting-debtors-export-account-total": "Kontototal",
        "accounting-debtors-export-subtotal": "Subtotal",
        "accounting-customers-export-sales-summary": "Customer sales summary",
        "accounting-customers-export-payroll": "Customer payroll files (ZIP file)",


        // Merchant > Reports > Accounting > Z-report
        "merchant-accounting-z-reports-page-header": "\n .title = Z-rapport",
        "merchant-accounting-z-reports-table-date-column": "Dato",
        "merchant-accounting-z-reports-table-pos-terminal-column": "POS enhed",
        "merchant-accounting-z-reports-table-amount-column": "Beløb",

        // Merchant > Reports > Accounting > Z-report
        "merchant-accounting-custom-reports-page-header": "\n .title = Custom reports",
        "merchant-accounting-custom-reports-table-name-column": "Navn",
        "merchant-accounting-custom-reports-table-interval-column": "Interval",
        "merchant-accounting-custom-reports-table-last-run-column": "Last run",
        "merchant-accounting-custom-reports-table-status-column": "Status",
        "merchant-accounting-custom-reports-table-button-details": "Details",
        "merchant-accounting-custom-reports-table-button-download-report": "Download report",
        "merchant-accounting-custom-reports-table-button-activate": "Activate",
        "merchant-accounting-custom-reports-table-button-deactivate": "Deactivate",
        "merchant-accounting-custom-reports-confirm-modal-question": "Are you sure you want to { $status} '{ $itemName }'?",
        "merchant-accounting-custom-reports-run-modal-form-title": "Download report",
        "merchant-accounting-custom-reports-run-modal-form-subtitle-name": "Name:",
        "merchant-accounting-custom-reports-run-modal-form-subtitle": "Payroll deduction",
        "merchant-accounting-custom-reports-run-modal-form-startDate-date-picker": "\n .label = Start date",
        "merchant-accounting-custom-reports-run-modal-form-endDate-date-picker": "\n .label = End date",
        "merchant-accounting-custom-reports-run-form-save-button": "Download",


        // SelectCustomer
        "select-customer": "\n .label = Kunde",
        "select-debtor": "\n .label = Verksomhed",
        "select-customer-all": "Alle",

        // SelectShop
        "select-shop": "Shop",
        "select-shop-label": "\n .label = Shop",
        "select-shop-all": "Alle",

        // SelectWeek
        "select-week": "Vælg uge",
        "select-week-week": "Uge",

        // Select Kitchen
        "control-kitchen-mode-delivery-time": "Leveringstids visning",
        "control-kitchen-mode-purchase-time": "Købstid visning",
        "control-kitchen-mode-period-report": "Perioderapport",

        // Merchant > Reports > Menu Planning
        "merchant-menu-planning-header": "\n .title = Menuplanlægning",
        "merchant-menu-planning-tab-calendar": "Calendar",
        "merchant-menu-planning-tab-menus": "Menus",
        "merchant-menu-planning-tab-digital-signage": "Digital signage",
        "merchant-menu-planning-table-startDate-date-picker": "\n .label = Startdato",
        "merchant-menu-planning-table-endDate-date-picker": "\n .label = Slutdato",
        "merchant-menu-planning-table-week-select": "\n .label = Uge",
        "merchant-menu-planning-table-week-select-option": "Uge { $countOfWeek } ({ $startDate } - { $endDate })",
        "merchant-menu-planning-table-date-column": "Date",
        "merchant-menu-planning-table-dish": "Ret { $counter }:",
        "merchant-menu-planning-table-price": "Pris: { $price }",
        "merchant-menu-planning-table-allergens": "Allergener: { $allergens }",
        "merchant-menu-planning-table-type-mode-digital-signage": "Digital signage",
        "merchant-menu-planning-table-type-mode-web-menu": "Web menu",
        "merchant-menu-planning-table-type-recurring": "Recurring",
        "merchant-menu-planning-table-status-column": "Status",
        "merchant-menu-planning-table-active-column-active": "Aktiv",
        "merchant-menu-planning-table-active-column-inactive": "Inaktiv",
        "merchant-menu-planning-table-active-column-active-filter-yes": "Aktiv",
        "merchant-menu-planning-table-active-column-inactive-filter-no": "Inaktiv",
        "merchant-menu-planning-table-dishes-count": "Antal retter",
        "merchant-menu-planning-table-recurrence": "Gentagelse",
        "merchant-menu-planning-table-create-button": "Opret menu",
        "merchant-menu-planning-table-week-menu-rss-button": "Week menu as RSS",
        "merchant-menu-planning-table-week-menu-atom-button": "Week menu as Atom",
        "merchant-menu-planning-table-menu-item-edit": "Rediger",
        "merchant-menu-planning-table-menu-item-set-inactive": "Deaktiver",
        "merchant-menu-planning-table-menu-item-set-active": "Aktiver",
        "merchant-menu-planning-table-menu-item-delete": "Slet",
        "merchant-menu-planning-confirm-delete-shop-dialog": "\n .typeOfEntity = menu",
        "merchant-menu-planning-dialog-create-title": "Opret menu",
        "merchant-menu-planning-dialog-edit-title": "Tilret menu",
        "merchant-menu-planning-dialog-max-dishes": "Available dish signs: { $countOfDishes }",
        "merchant-menu-planning-dialog-add-marketing-details-button": "\n .title = + Tilføj marketing detaljer",
        "merchant-menu-planning-dialog-add-dish-button": "Tilføj ret",
        "merchant-menu-planning-dialog-add-recurrence-button": "\n .title = + Tilføj gentagelse",
        "merchant-menu-planning-dialog-remove-recurrence-button": "\n .title = Fjern gentagelse",
        "merchant-menu-planning-dialog-create-submit-button": "Opret",
        "merchant-menu-planning-dialog-save-submit-button": "Gem",
        "merchant-menu-planning-dialog-dish": "Ret { $countOfDish }",
        "merchant-menu-planning-dialog-publishDate-date-picker": "\n .label = Publish date",
        "merchant-menu-planning-dialog-recurrence": "Gentagelse",
        "merchant-menu-planning-dialog-name-of-dish-field": "\n .label = Navn på retten *",
        "merchant-menu-planning-dialog-brief-field": "\n .label = Kort beskrivelse \n .placeholder = Short description, max. 80 characters including space.",
        "merchant-menu-planning-dialog-marketing-tag-field": "\n .label = Marketing tag \n .helperText = Eksempelvis: Dagens tilbud, Discount",
        "merchant-menu-planning-dialog-from-date-picker": "\n .label = Fra dato",
        "merchant-menu-planning-dialog-to-date-picker": "\n .label = Til dato",
        "merchant-menu-planning-dialog-currency-field": "\n .label = Valuta",
        "merchant-menu-planning-dialog-price-field": "\n .label = Pris",
        "merchant-menu-planning-dialog-upload-image": "\n .label = Upload billede",
        "merchant-menu-planning-week-day-monday": "Mandag",
        "merchant-menu-planning-week-day-tuesday": "Tirsdag",
        "merchant-menu-planning-week-day-wednesday": "Onsdag",
        "merchant-menu-planning-week-day-thursday": "Torsdag",
        "merchant-menu-planning-week-day-friday": "Fredag",
        "merchant-menu-planning-week-day-saturday": "Lørdag",
        "merchant-menu-planning-week-day-sunday": "Søndag",
        "merchant-menu-planning-dialog-signageTypes-label": "Publicér til:",
        "merchant-menu-planning-dialog-signageTypes-mode-web-menu": "Web menu",
        "merchant-menu-planning-dialog-signageTypes-mode-buffet-sign": "Buffet skilt",
        "merchant-menu-planning-dialog-signageTypes-mode-day-menu-sign": "Dagens menu skilt",
        "merchant-menu-planning-dialog-signageTypes-min-error": "Please select at least one signage type",
        "merchant-menu-planning-digital-signage-card-serial-no": "Serialno:",
        "merchant-menu-planning-digital-signage-card-device-id": "Device ID:",
        "merchant-menu-planning-digital-signage-card-device-name": "Device name:",
        "merchant-menu-planning-digital-signage-card-last-update": "Last updated:",
        "merchant-menu-planning-digital-signage-card-battery-status": "Battery status:",
        "merchant-menu-planning-digital-signage-card-battery-status-0": "Undefined",
        "merchant-menu-planning-digital-signage-card-battery-status-1": "Unknown",
        "merchant-menu-planning-digital-signage-card-battery-status-2": "Good",
        "merchant-menu-planning-digital-signage-card-battery-status-3": "Poor",
        "merchant-menu-planning-digital-signage-card-battery-status-4": "Poor chiller",
        "merchant-menu-planning-digital-signage-card-battery-status-5": "Replace",
        "merchant-menu-planning-digital-signage-card-battery-status-6": "Replace chiller",
        "merchant-menu-planning-digital-signage-card-status-code": "Status code:",
        "merchant-menu-planning-digital-signage-card-status-code--99": "Unknown",
        "merchant-menu-planning-digital-signage-card-status-code--10": "Failed Cleansing",
        "merchant-menu-planning-digital-signage-card-status-code--2": "Failed System Configuration",
        "merchant-menu-planning-digital-signage-card-status-code--1": "Failed Network Configuration",
        "merchant-menu-planning-digital-signage-card-status-code-0": "Not Configured",
        "merchant-menu-planning-digital-signage-card-status-code-1": "Network Configured",
        "merchant-menu-planning-digital-signage-card-status-code-2": "Failed Communication",
        "merchant-menu-planning-digital-signage-card-status-code-3": "Low Battery",
        "merchant-menu-planning-digital-signage-card-status-code-4": "Current Page Design Not Found",
        "merchant-menu-planning-digital-signage-card-status-code-5": "Current Page Product Not Found",
        "merchant-menu-planning-digital-signage-card-status-code-6": "Current Page Failed Update",
        "merchant-menu-planning-digital-signage-card-status-code-7": "Alternate Page Design Not Found",
        "merchant-menu-planning-digital-signage-card-status-code-8": "Alternate Page Product Not Found",
        "merchant-menu-planning-digital-signage-card-status-code-9": "Alternate Page Failed Update",
        "merchant-menu-planning-digital-signage-card-status-code-10": "Ok",
        "merchant-menu-planning-digital-signage-card-status-code-11": "Failed Health Check",
        "merchant-menu-planning-digital-signage-card-status-code-12": "Low Temperature",
        "merchant-menu-planning-digital-signage-card-status-code-20": "Image Overwritten",
        "merchant-menu-planning-digital-signage-card-status-code-50": "Preconfigured",
        "merchant-menu-planning-digital-signage-card-status-code-99": "Queued",
        "merchant-menu-planning-digital-signage-empty": "No digital signage devices found",
        "merchant-menu-planning-digital-signage-dialog-title": "Digital sign",
        "merchant-menu-planning-digital-signage-menu-details": "Details",
        "merchant-menu-planning-digital-signage-menu-clear-sign": "Clear sign",
        "merchant-menu-planning-color-field-label": "\n .label = Color",

        // --- Merchant ---

        // Navigation
        "merchant-nav-item-home": "Hjem",

        //  - reporting
        "merchant-nav-item-production": "\n .title = Produktion",
        "merchant-nav-item-menu-planning": "Menuplanlægning",
        "merchant-nav-item-purchase-control": "Købskontrol",
        "merchant-nav-item-survey": "Brugertilfredshed",
        "merchant-nav-item-accounting": "Regnskab",
        "merchant-nav-item-accounting-page-header": "\n .title = Regnskab",
        "merchant-nav-item-production-planning": "Planlægning",
        "merchant-nav-item-production-takeaway": "Takeaway",
        "merchant-nav-item-production-meeting-service": "Mødeforplejning",
        "merchant-nav-item-production-pos-purchases": "POS køb",

        //  - admin
        "merchant-nav-item-settings-page-header": "\n .title = Indstillinger",
        "merchant-nav-item-settings-header": "Indstillinger",
        "merchant-nav-item-customer-access": "Kundeadgang",
        "merchant-nav-item-id-cards": "ID-kort",
        "merchant-nav-item-custom-jobs":"Tilpassede jobs",
        "merchant-nav-item-merchant-news": "Kundenyheder",
        "merchant-nav-item-messaging": "Push-beskeder",
        "merchant-nav-item-news": "Kundenyheder",
        "merchant-nav-item-users": "Administratorer",
        "merchant-nav-item-shops": "Shops",
        "merchant-nav-item-payment-links": "Betalingslinks",
        "merchant-nav-item-products": "Produkter",
        "merchant-nav-item-product-create": "Opret produkt",
        "merchant-nav-item-extra-service-create": "Opret ekstra service",
        "merchant-nav-item-extra-service-edit": "Ret ekstra service",
        "merchant-nav-item-product-update": "Ret produkt",
        "merchant-nav-item-product-groups": "Produktgrupper",
        "merchant-nav-item-extra-services": "Ekstra services",
        "merchant-nav-item-product-group-create": "Opret produktgruppe",
        "merchant-nav-item-product-group-update": "Ret produktgruppe",
        "merchant-nav-item-price-lists": "Prislister",
        "merchant-nav-item-price-list-create": "Opret prisliste",
        "merchant-nav-item-price-list-edit": "Ret prisliste",
        "merchant-nav-item-surveys": "Brugerundersøgelser",
        "merchant-nav-item-devices": "Hardware enheder",
        "merchant-nav-item-communication-page-header":"\n .title = Kommunikation",
        "merchant-nav-item-communication-header":"Kommunikation",
        "merchant-nav-item-group-products":"\n .title = Produkter",
        "merchant-nav-item-products-header":"Produkter",
        "merchant-nav-item-group-shops":"\n .title = Shops",
        "merchant-nav-item-offers":"Tilbud",
        "merchant-nav-item-vat-codes":"Momskoder",
        "merchant-nav-item-create-vat-code":"Opret momskode",
        "merchant-nav-item-edit-vat-code":"Ret momskode",
        "merchant-nav-item-group-organization":"\n .title = Organisation",
        "merchant-nav-item-group-account":"\n .title = Konto",
        "merchant-nav-item-billing":"Regninger",
        "merchant-nav-item-account":"Konto",
        "merchant-nav-item-merchant-account":"Virksomhedskonto",
        "merchant-nav-item-delivery-locations":"Leveringslokationer",
        "merchant-nav-item-sales-accounts": "Salgskonti",
        "merchant-nav-item-live-dashboard": "Live dashboard",

        // Admin home
        "merchant-admin-home-products-group": "\n .title = Produkter",
        "merchant-admin-home-communication-group": "\n .title = Kommunikation",
        "merchant-admin-home-customers-group": "\n .title = Kunder",
        "merchant-admin-home-settings-group": "\n .title = Indstillinger",
        "merchant-admin-home-shop": "\n .title = Shops\n .description = Sælg dine produkter i shops med individuel branding.",
        "merchant-admin-home-payment-links": "\n .title = Betalingslinks \n .description = Opret et unikt betalinhslink til gæster eller kursister.",
        "merchant-admin-home-customers-card": "\n .title = Kundeadgang\n .description = Administrer dine kunders adgang til systemet",
        "merchant-admin-home-merchant-news-card": "\n .title = Kundenyheder\n .description = Publicer nyheder for salgsstedet til dine kunder.",
        "merchant-admin-home-admin-card": "\n .title = Administratorer\n .description = Styr administratorer for dit salgssted.",
        "merchant-admin-home-products": "\n .title = Produkter\n .description = Tilføj og vedligehold produkter for dine shops.",
        "merchant-admin-home-product-groups": "\n .title = Produktgrupper\n .description = Inddel dine produkter i grupper og styr synligheden af grupper i løbet af dagen.",
        "merchant-admin-home-extra-services": "\n .title = Ekstra services\n .description = Tilføj og vedligehold produkter for dine shops.",
        "merchant-admin-home-price-list": "\n .title = Prislister\n .description = Brug prislister til at udbyde differentierede produkter og priser til dine kunder.",
        "merchant-admin-home-merchant-surveys": "\n .title = Brugerundersøgelser\n .description = Hold øje med kundetilfredshed ved at oprette brugerundersøgelser.",
        "merchant-admin-home-devices-card": "\n .title = Hardware enheder\n .description = Vis hardware enheder, såsom skærme, printere og kreditkort terminaler.",
        "merchant-admin-home-offers-card": "\n .title = Tilbud\n .description = Administrer dine tilbud",
        "merchant-admin-home-vat-codes-card": "\n .title = Momskoder\n .description = Administrer momskoder",
        "merchant-admin-home-id-cards-card": "\n .title = ID-kort\n .description = Vis dine kunders ID-kort til POS betaling.",
        "merchant-admin-home-account-group": "\n .title = Konto",
        "merchant-admin-home-merchant-account-card": "\n .title = Virksomhedskonto\n .description = Opdater din virksomheds stamoplysninger\n .buttonText = Vis",
        "merchant-admin-home-delivery-locations-card": "\n .title = Leveringslokationer\n .description = Administrer leveringslokationer, hvor kunder kan hente ordrer.",
        "merchant-admin-home-sales-accounts-card": "\n .title = Salgskonti \n .description = Opret salgskonti til kontering af salget.",


        // Merchant > Admin > Settings > Custom jobs
        "merchant-admin-settings-custom-jobs-title":" \n .title = Tilpassede jobs",
        "merchant-admin-settings-custom-jobs-table-name":"Navn",
        "merchant-admin-settings-custom-jobs-table-interval":"Interval",
        "merchant-admin-settings-custom-jobs-table-last-run":"Sidste kørsel",
        "merchant-admin-settings-custom-jobs-table-status":"Status",
        "merchant-admin-settings-custom-jobs-table-action-details":"Detaljer",
        "merchant-admin-settings-custom-jobs-table-action-run-job":"Kør job",
        "merchant-admin-settings-custom-jobs-table-action-activate":"Aktiver",
        "merchant-admin-settings-custom-jobs-table-action-inactivate":"Deaktiver",

        // Messages
        "messages-list-header": "\n .title = Push-beskeder",
        "messages-list-create-button": "Opret besked",
        "merchant-nav-item-messages": "Push-beskeder",
        "messages-table-subject-column" : "Emne",
        "messages-table-publish-time-column": "Udgivelsesdato",
        "messages-table-edit-button": "Rediger",
        "messages-table-delete-button": "Slet",
        "messages-table-delete-modal-title": "besked",
        "messages-table-delete-success-message": "Besked slettet",
        "messages-table-update-delete-dialog-title": "Besked kan ikke opdateres eller slettes",
        "messages-table-update-delete-dialog-description": "Besked kan ikke opdateres eller slettes fordi den er blevet publiceret.",
        "messages-table-update-delete-dialog-button": "Luk",

        // create / edit messages
        "create-message-header": "\n .title = Opret besked",
        "edit-message-header": "\n .title = Ret besked",
        "nav-item-create-message-header": "Opret besked",
        "nav-item-edit-message-header": "Ret besked",
        "create-message-save-button": "Opret",
        "edit-message-save-button": "Gem",
        "create-or-edit-message-info": "\n .title = Send korte vigtige beskeder til brugerne, f.eks. om lukkedage, arrangementer eller lignende. Beskeder vil være synlige for alle brugere, der er forbundet til dine shops.",
        "create-or-edit-message-field-subject": "\n .label = Overskrift \n .placeholder = Tilføj et fængende emne, som brugerne har lyst til at læse * \n .helperText = Tilføj et fængende emne, som brugerne har lyst til at læse",
        "create-or-edit-message-dialog-field-subject-label": "Overskrift:",
        "create-or-edit-message-field-title-page": "\n .label = Overskrift\n .placeholder = Overskrift\n .helperText =Tilføj et fængende emne, som brugerne har lyst til at læse",
        "create-or-edit-message-dialog-field-message-label": "Besked:",
        "create-or-edit-message-field-message": "\n .label = Besked\n .placeholder = Indtast en besked *\n .helperText = Resterende tegn: { $charsRemaining }",
        "create-or-edit-message-settings": "\n .title = Indstillinger",
        "create-or-edit-message-field-publishDate": "\n .label = Udgiv:",
        "create-or-edit-message-field-publish-title": "Udgiv:",
        "create-or-edit-message-accordion-title": "Indstillinger",
        "create-or-edit-message-field-publishDate-page": "\n .label = Udgiv",
        "create-or-edit-message-field-publishDate-helperText": "Bestemmer hvornår beskeden bliver synlig for brugerne.",
        "create-or-edit-message-field-title-required": "Overskrift er påkrævet",
        "create-or-edit-message-field-body-required": "Besked er påkrævet",
        "create-or-edit-message-field-body-too-long": `Du har overskredet maks. antal tegn: { $charsLimit }`,
        "create-or-edit-message-field-channels-required": "Vælg mindst én kanal",
        "create-or-edit-message-field-channel-type-mode-in-app": "App besked",
        "create-or-edit-message-field-channel-type-description-mode-in-app": "Send som besked på web og i app",
        "create-or-edit-message-field-channel-type-mode-push": "Push notifikation",
        "create-or-edit-message-field-channel-type-description-mode-push": "Send som mobil push notifikation",
        "create-or-edit-message-field-channel-type-mode-sms": "SMS besked",
        "create-or-edit-message-field-channel-type-description-mode-sms": "Send som SMS besked",
        "create-or-edit-message-field-channel-type-mode-email": "E-mail",
        "create-or-edit-message-field-channel-type-description-mode-email": "Send som e-mail",
        "create-or-edit-message-field-channel-type-mode-in-app-card": "App kort",
        "create-or-edit-message-field-channel-type-description-mode-in-app-card": "Vises som kort i GoPay appen",
        "create-or-edit-message-field-tag": "\n .label = Emne: \n .placeholder = Vælg et emne *",
        "create-or-edit-message-dialog-topic-label": "Emne:",
        "create-or-edit-message-dialog-topic-placeholder": "Vælg et emne *",
        "create-or-edit-message-field-tag-page": "\n .label = Emne",
        "create-or-edit-message-field-tag-mode-info": "Info",
        "create-or-edit-message-field-tag-description-mode-info": "Til generelle oplysninger om kantinen, åbningstider, madudvalg, eller procedurer.",
        "create-or-edit-message-field-tag-mode-important": "Vigtigt",
        "create-or-edit-message-field-tag-description-mode-important": "For kritiske beskeder, som f.eks. ændringer i åbningstider, sundheds- og sikkerhedsoplysninger eller andre presserende meddelelser.",
        "create-or-edit-message-field-tag-mode-offer": "Tilbud",
        "create-or-edit-message-field-tag-description-mode-offer": "For tilbud, rabatter, kampagner eller særlige arrangementer.",
        "create-or-edit-message-field-tag-mode-menu-change": "Menu",
        "create-or-edit-message-field-tag-description-mode-menu-change": "For at informere brugerne om ændringer i dagens menu, nye retter eller sæsonbestemte tilbud.",
        "create-or-edit-message-field-tag-mode-event": "Arrangement",
        "create-or-edit-message-field-tag-description-mode-event": "For kommende begivenheder, såsom temadage, madfestivaler eller specielle begivenheder i kantinen.",
        "create-or-edit-message-field-tag-mode-reminder": "Påmindelse",
        "create-or-edit-message-field-tag-description-mode-reminder": "For at minde brugerne om vigtige datoer eller frister, f.eks. tilmelding til arrangementer eller til at bestille mad i forvejen.",
        "create-or-edit-message-field-tag-mode-feedback": "Feedback",
        "create-or-edit-message-field-tag-description-mode-feedback": "For opfordringer til at give feedback på mad og service, eller undersøgelser om brugertilfredshed.",
        "create-or-edit-message-field-tag-mode-news": "Nyhed",
        "create-or-edit-message-field-tag-description-mode-news": "For opdateringer om kantinens aktiviteter, tiltag eller ændringer i drift, som kan være af interesse for brugerne.",
        "create-or-edit-message-field-tag-mode-health": "Sundhed",
        "create-or-edit-message-field-tag-description-mode-health": "For oplysninger om sunde valg, ernæringstips eller allergeninformationer relateret til menuen.",
        "create-or-edit-message-field-tag-mode-social": "Fællesskab",
        "create-or-edit-message-field-tag-description-mode-social": "For at fremme fællesskabsinitiativer, temadage, sociale arrangementer.",
        "create-or-edit-message-field-tag-required": "Emne er påkrævet",
        "create-message-success-dialog-title": "Beskeden er oprettet",
        "create-message-success-dialog-view-archive": "Se meddelelsesarkiv",
        "create-message-success-dialog-close-button": "Luk",
        "create-message-success-dialog-view-list-button": "Gå til beskeder",

        // Customer access
        "merchant-customer-access-header": "\n .title = Kundeadgang",
        "merchant-customer-access-customers-table-name-column": "Navn",
        "merchant-customer-access-customers-table-active-column": "Status",
        "merchant-customer-access-customers-table-domains-column": "Domæner",
        "merchant-customer-access-customers-table-active-filter-yes": "Aktive",
        "merchant-customer-access-customers-table-active-filter-no": "Inaktive",
        "merchant-customer-access-customers-table-active-column-active": "Aktiv",
        "merchant-customer-access-customers-table-active-column-inactive": "Inaktiv",

        // Merchant account > Swift dialog
        "merchant-account-swift-dialog-title":"Skift salgssted",
        "merchant-account-swift-dialog-subtitle":"Du har adgang til følgende salgssteder. Vælg et for at skifte.",
        "merchant-account-swift-dialog-empty-title":"Du har ikke adgang til andre salgssteder.",

        // Merchant home
        "merchant-home-today-card-group": "\n .title = POS salg\n .subtitle = i dag",
        "merchant-home-todays-control-code": "Dagens kontrolkode",
        "merchant-home-todays-offers": "Dagens tilbud",
        "merchant-home-number-of-orders": "\n .title = Ordrer",
        "merchant-home-turnover": "\n .title = Omsætning",
        "merchant-home-avg-amount": "\n .title = Gns. beløb",
        "merchant-home-subscriptions": "\n .title = Abonnementer",
        "merchant-home-statistics-card-group": "\n .title = Statistik",
        "merchant-home-checkin-card": "\n .title = Check-in skærm",
        "merchant-home-checkin-card-participants": "Tjekket ind ({ $checkedIn })",
        "merchant-home-checkin-card-none-participants": "Ikke tjekket ind ({ $notCheckedIn })",
        "merchant-home-checkin-card-participation-percentage": "Procent",
        "merchant-home-survey-card-empty": "\n .title = Tilfredshed",
        "merchant-home-meeting-service-card-group": "\n .title = Mødeforplejning\n .subtitle = i dag",
        "merchant-home-meeting-service-number-of-orders-card": "\n .title = Antal ordrer",
        "merchant-home-meeting-service-awaiting-approval-card": "\n .title = Til godkendelse",
        "merchant-home-meeting-service-ready-for-invoicing-card": "\n .title = Til fakturering",
        "merchant-home-meeting-service-ready-for-invoicing-card-description": "&gt; {$overdueDays} days ago",
        "merchant-home-meeting-service-delivery-planning-card": "\n .title = Leveringsplanlægning",
        "merchant-home-meeting-service-delivery-planning-delivery": "Levering",
        "merchant-home-meeting-service-delivery-planning-picked-up": "Afhentning",
        "merchant-home-meeting-service-delivery-planning-eating-in-canteen": "Spiser i kantinen",
        "merchant-home-meeting-service-next-deliveries-card": "\n .title = {$numberOfOrders} næste leveringer",
        "merchant-home-meeting-service-table-name-column": "Kunde",
        "merchant-home-meeting-service-table-delivery-column": "Levering",
        "merchant-home-views-button": "Live Dashboards",
        "merchant-home-views-dialog-title": "Live Dashboards",
        "merchant-home-views-dialog-subtitle": "Vælg et dashboard nedenfor:",
        "merchant-home-views-dialog-conference": "Messe",
        "merchant-home-views-dialog-conference-live-sales-part-1": "Live",
        "merchant-home-views-dialog-conference-live-sales-part-2": "salg",
        "merchant-home-views-dialog-conference-orders": "Ordrer",
        "merchant-home-views-dialog-conference-turnover": "Omsætning",
        "merchant-home-views-dialog-conference-avg-price": "Gns. pris",
        "merchant-home-views-dialog-conference-free-riders": "Gratister",
        "merchant-home-views-dialog-conference-satisfaction": "Tilfredshed",
        "merchant-home-statistics-pos-turnover-card": "\n .title = POS-salg",
        "merchant-home-statistics-pos-orders-card": "\n .title = POS-ordrer",
        "merchant-home-statistics-number-of-users-card": "\n .title = Antal brugere",
        "merchant-home-statistics-period-base-3": "Sidste 3 dage",
        "merchant-home-statistics-period-base-14": "Sidste 14 dage",
        "merchant-home-statistics-period-base-30": "Sidste 30 dage",
        "merchant-home-statistics-period-base-60": "Sidste 60 dage",
        "merchant-home-statistics-period-base-180": "Sidste 180 dage",
        "merchant-home-statistics-compared-to-last-period": "i forhold til sidste periode",

        // Merchant home tooltips
        "merchant-home-todays-control-code-tooltip": "\n .title = Koden vises på købsbeviset (app) og på den udskrevne kvittering",
        "merchant-home-todays-offers-tooltip": "\n .title = Antal tilbud der er aktive for i dag",
        "merchant-home-number-of-orders-tooltip": "\n .title = Antal POS ordrer i dag",
        "merchant-home-turnover-tooltip": "\n .title = Dagens totalbeløb for POS salg",
        "merchant-home-avg-amount-tooltip": "\n .title = Gennemsnitligt ordrerbeløb for dagens ordrer",
        "merchant-home-subscriptions-tooltip": "\n .title = Dagens aktive frokostabonnementer",

        // Merchant home statistics tooltips
        "merchant-home-statistics-check-in-card-tooltip": "\n .title = Viser hvor mange kunder, der husker at scanne deres købsbevis på tjek-ind skærmen i forhold til hvor mange, der glemmer det",
        "merchant-home-statistics-pos-turnover-card-tooltip": "\n .title = Viser POS salg for den valgte periode op mod salget for forrige periode",
        "merchant-home-statistics-pos-orders-card-tooltip": "\n .title = Viser antal POS ordrer for den valgte periode op mod ordrer for forrige periode",
        "merchant-home-statistics-number-of-users-card-tooltip": "\n .title = Viser antallet af nye brugere for valgte periode op mod nye brugere for forrige periode",
        "merchant-home-statistics-meeting-orders-card-tooltip": "\n .title = Antal mødeforplejningsordrer for i dag",
        "merchant-home-statistics-meeting-orders-approval-card-tooltip": "\n .title = Totalt antal mødeforplejningsordrer, der afventer godkendelse",
        "merchant-home-statistics-meeting-orders-invoicing-card-tooltip": "\n .title = Totalt antal mødeforplejningsordrer, der afventer at blive bogført, som blev leveret for mere end [X] dage siden",
        "merchant-home-statistics-next-deliveries-card-tooltip": "\n .title  =De næste 5 leveringer for i dag",
        "merchant-home-statistics-meeting-distribution-chart-tooltip": "\n .title = Viser fordelingen af mødeforplejningsordrer i løbet af dagen",

        // Merchant Account
        "merchant-update-account-page-header": "\n .title = Konto for salgssted",
        "merchant-update-account-save-button": "Gem",
        "merchant-update-account-opening-hours-title":"\n .title = Åbningstider",
        "merchant-update-account-opening-hours-action-button-add":"Tilføj",
        "merchant-update-account-opening-hours-action-button-edit":"Ret",
        "merchant-update-account-opening-hours-empty-text":"Åbningstider ikke sat",
        "merchant-update-account-opening-hours-dialog-title":"Åbningstider",
        "merchant-update-account-opening-hours-dialog-save-button":"Gem",
        "merchant-update-account-opening-hours-dialog-before-start-error":"Lukketid før åbningstid",
        "merchant-update-account-opening-hours-dialog-closed-time-select-from":"\n .label = Fra",
        "merchant-update-account-opening-hours-dialog-time-select-to":"\n .label = Til",
        "merchant-update-account-opening-hours-dialog-closed":"Lukket",
        "merchant-update-account-opening-hours-day-monday": "Mandag",
        "merchant-update-account-opening-hours-day-tuesday": "Tirsdag",
        "merchant-update-account-opening-hours-day-wednesday": "Onsdag",
        "merchant-update-account-opening-hours-day-thursday": "Torsdag",
        "merchant-update-account-opening-hours-day-friday": "Fredag",
        "merchant-update-account-opening-hours-day-saturday": "Lørdag",
        "merchant-update-account-opening-hours-day-sunday": "Søndag",



        //Merchant reports
        "merchant-reports-id-cards-title": "\n .title = ID-kort",
        "merchant-reports-id-cards-nav-item-home": "Hjem",
        "merchant-reports-id-cards-nav-item-id-cars": "ID-kort",

        // Merchant ID table
        "merchant-id-cards-table-card-number": "Kortnummer",
        "merchant-id-cards-table-card-type": "Kort type",
        "merchant-id-cards-table-user": "Bruger",
        "merchant-id-cards-table-company": "Firma",
        "merchant-id-cards-table-status": "Status",
        "merchant-id-cards-table-card-type-select-label": "\n .label = Kort type",
        "merchant-id-cards-table-company-select-label": "\n .label = Firma",
        "merchant-id-cards-table-card-type-select-item-wallet":"Wallet",
        "merchant-id-cards-table-card-type-select-item-company-credit":"Firmakredit",
        "merchant-id-cards-table-card-type-select-item-tickets":"Klippekort",
        "merchant-id-cards-table-card-type-select-item-unlimited-tickets":"Ubegrænset klippekort",
        "merchant-id-cards-table-card-type-select-item-tickets-unlimited":"Ubegrænsede klip",
        "merchant-id-cards-table-card-type-select-item-top-up": "Optankning",
        "merchant-id-cards-table-card-type-select-item-payroll-deduction": "Løntræk",


        // Merchant ID Cards Dialog
        "merchant-id-cards-dialog-title": "ID-kort detaljer",
        "merchant-id-cards-dialog-status": "Status:",
        "merchant-id-cards-dialog-card-name": "Kort navn:",
        "merchant-id-cards-dialog-card-type": "Kort type:",
        "merchant-id-cards-dialog-card-type-top-up": "Wallet",
        "merchant-id-cards-dialog-card-type-wallet": "Wallet",
        "merchant-id-cards-dialog-card-type-company-credit": "Firmakredit",
        "merchant-id-cards-dialog-card-type-tickets": "Klippekort",
        "merchant-id-cards-dialog-card-type-tickets-unlimited": "Ubegrænset klippekort",
        "merchant-id-cards-dialog-card-type-payroll-deduction": "Løntræk",
        "merchant-id-cards-dialog-validated": "Valideret:",
        "merchant-id-cards-dialog-expiry": "Udløb:",
        "merchant-id-cards-dialog-payment-method": "Betalingsmetode:",
        "merchant-id-cards-dialog-user-id": "Bruger ID:",
        "merchant-id-cards-dialog-employee-id": "Medarbejder ID:",
        "merchant-id-cards-dialog-name": "Navn:",
        "merchant-id-cards-dialog-email": "E-mail:",
        "merchant-id-cards-dialog-mobile": "Mobil:",
        "merchant-id-cards-dialog-phone": "Telefon:",

        "id-cars-table-button-details": "Detaljer",
        "id-cars-filter-card-title":"\n .title = Kort",
        "id-cars-filter-debtor-title":"\n .title = Debitor",
        "id-cars-filter-end-user-title":"\n .title = Slutbruger",
        "id-cars-filter-card-number-label":"\n .label = Kortnummer\n .placeholder = Søg på kortnummer",
        "id-cars-filter-switch-label":"\n .label = Inkluder inaktive kort",
        "id-cars-filter-debtor-label":"\n .label = Debitor",
        "id-cars-filter-email-label":"\n .label = E-mail",
        "id-cars-filter-employee-id-label":"\n .label = Medarbejder ID",

        "merchant-production": "Produktion",

        // Merchant > Admin > Shops > Products
        "products-page-header": "\n .title = Produkter",
        "products-tab-all-products": "Alle produkter",
        "products-tab-sort-products": "Sorter produkter",
        "products-table-info-box": "Vælg en shop for at fortsætte",
        "products-table-show-inactive": "\n .label = Vis deaktiverede",
        "products-page-table-price-list-label": "\n .label = Prisliste",
        "products-name-column": "Navn",
        "products-price-column": "Pris",
        "products-status-column": "Status",
        "products-create-product-button": "Opret produkt",
        "products-edit-product-menu-item": "Rediger",
        "products-delete-product-menu-item": "Slet",
        "products-confirm-delete-product-dialog": "\n .typeOfEntity = produkt",
        "product-offer-chip": "Tilbud",

        // Merchant > Admin > Extra Services
        "extra-services-page-header": "\n .title = Ekstra services",
        "extra-services-create-service-button": "Opret ny",
        "extra-services-services-column": "Services",
        "extra-services-min-price-column": "Min. pris",
        "extra-services-max-price-column": "Maks. pris",
        "extra-services-price-per-seat-column": "Pris pr. kuvert",
        "extra-services-status-column": "Status",

        // Merchant > Admin > Extra Services > Create / Edit
        "extra-services-create-page-header": "\n .title = Opret ekstra service",
        "extra-services-create-active-switch": "Aktiv:",
        "extra-services-create-mandatory": "Tilføj altid til ordre",
        "extra-services-create-mandatory-without-pickup": "Tilføj ved afhentning",
        "extra-services-create-meeting-location-required-switch": "Mødested påkrævet:",
        "extra-services-create-meeting-time-required-switch": "Mødetid påkrævet:",
        "extra-services-create-price-field-label": "\n .label = Pris",
        "extra-services-create-min-price-field-label": "\n .label = Min. pris",
        "extra-services-create-max-price-field-label": "\n .label = Maks. pris",
        "extra-services-create-price-per-seat-field-label": "\n .label = Pris pr. kuvert",
        "extra-services-create-currency-field-label": "\n .label = Valuta",
        "extra-services-create-service-description-field":  "\n .label = Beskrivelse",
        "extra-services-create-service-description-field-max-length": "Beskrivelse kan ikke overstige { $maxLength } tegn",
        "extra-services-create-service-name-field":  "\n .label = Navn*",
        "extra-services-create-service-type-field":  "\n .label = Service type",
        "extra-services-create-service-pricing-type-field":  "\n .label = Pris type",
        "extra-services-create-panel-pricing": "\n .label = Prissætning",
        "extra-services-create-settings-panel": "\n .title = Indstillinger",
        "extra-services-create-service-time-panel": "\n .title = Tilgængelige tider",
        "extra-services-create-form-type-dropdown-item-pickup-fee": "Afhentningsgebyr",
        "extra-services-create-form-type-dropdown-item-eat-in-canteen-fee": "Gebyr for spisning i kantine",
        "extra-services-create-form-type-dropdown-item-delivery-fee": "Leveringsgebyr",
        "extra-services-create-form-type-dropdown-item-table-setting-fee": "Bordopstillingsgebyr",
        "extra-services-create-form-type-dropdown-item-cleanup-fee": "Afrydningsgebyr",
        "extra-services-create-form-type-dropdown-item-out-of-opening-hours-fee": "Uden for åbningstid gebyr",
        "extra-services-create-form-type-dropdown-item-other": "Andet",
        "extra-services-create-form-pricing-type-dropdown-item-per-seat": "Pr. kuvert",
        "extra-services-create-form-pricing-type-dropdown-item-flat-fee": "Fast gebyr",
        "extra-services-create-when-add-to-order-field": "\n .label = Handling",
        "extra-services-create-when-add-to-order-no-action": "Ingen handlinger valgt",
        "extra-services-create-form-action-dropdown-item-add-always": "Tilføj altid",
        "extra-services-create-form-action-dropdown-item-add-when-pick-up": "Tilføj ved afhentning",
        "extra-services-create-form-action-dropdown-item-add-when-delivered": "Tilføj ved levering",

        // Merchant > Admin > Shops > Products > Create / Edit
        "product-create-page-header": "\n .title = Opret produkt",
        "product-create-submit-button": "Opret",
        "product-edit-page-header": "\n .title = Ret produkt",
        "product-edit-submit-button": "Gem",
        "product-create-shops-field-label": "\n .label = Shops",
        "product-create-group-field-label": "\n .label = Produktgruppe",
        "product-create-number-field-label": "\n .label = Produktnummer",
        "product-create-name-field-label": "\n .label = Navn",
        "product-create-price-field-label": "\n .label = Pris",
        "product-create-currency-field-label": "\n .label = Valuta",
        "product-create-description-field-label": "\n .label = Beskrivelse",
        "product-create-panel-access": "\n .title = Adgang",
        "product-create-panel-access-shop-alert-title": "\n .title = En shop repræsenterer et virtuelt eller fysisk salgssted, såsom webshops i GoPay appen eller shoppen knyttet til POS skærme i en kantine. En bruger som IKKE er tilknyttet en prisliste vil se produkter, der er direkte tilknyttet shops her.",
        "product-create-panel-access-price-list-alert-title": "\n .title = Prislister kan bruges til at tilbyde differentiet produktudvalg eller priser til forskellige brugergrupper. Flere prislister kan tilknyttes samme shop for at kunne tilbyde forskelligt udvalg. En bruger vil altid se én prisliste - eller - produkterne direkte tilknyttet shoppen. Hvilken prisliste der vises, afhænger af brugergruppen eller - i tilfælde af POS skærmen - ID-kort abonnementet.",
        "product-create-panel-description": "\n .title = Beskrivelse",
        "product-create-image-field-label": "\n .label = Billede",
        "create-image-file-support": "Understøttede filtyper: { $supportedFileTypes }. Maksimum størrelse: { $maxSize }",
        "product-create-general-panel": "\n .title = Generelt",
        "product-create-active-switch": "Aktiv:",
        "product-create-product-description-panel": "\n .title = Produktbeskrivelse",
        "product-create-product-description-marketing-tag-field": "\n .label = Marketing tag\n .helperText = Eksempler: 'Tilbud', 'CO2', 'Varm ret', 'Vegetarisk'",
        "product-create-product-description-allergens-field": "\n .label = Allergener",
        "product-create-availability-panel": "\n .title = Tilgængelighed",
        "product-create-availability-from-date-picker": "\n .label = Fra dato",
        "product-create-availability-to-date-picker": "\n .label = Til dato",
        "product-create-availability-preorder-switch": "Tillad ikke forudbestilling:",
        "product-create-availability-info": "Kunder kan forudbestille produkter ud i fremtiden i GoPay app'en, medmindre du slår det fra her.",
        "product-create-deadline-panel": "\n .title = Deadline",
        "product-create-deadline-purchases-subtitle": "Køb:",
        "product-create-deadline-cancellation-subtitle": "Afbestilling:",
        "product-create-deadline-day-field": "\n .label = Dag",
        "product-create-deadline-day-limit-day-before": "Dagen før",
        "product-create-deadline-day-limit-x-days-before": "{ $daysBefore } dage før",
        "product-create-deadline-time-picker": "\n .label = Tid",
        "product-create-barcode-panel": "\n .title = ERP numre",
        "product-create-barcode-field-label": "\n .label = Stregkode",
        "product-create-offer-panel": "\n .title = Tilbud",
        "product-create-offer-discount-percentage": "Procentrabat:",
        "product-create-offer-discount-price": "Tilbudspris:",
        "product-create-offer-items-in-stock": "Antal varer på lager:",
        "product-create-offer-available-from": "Tilgængeligt fra:",
        "product-create-offer-available-to": "Tilgængeligt til:",
        "product-create-offer-edit-button": "Ret",
        "product-create-offer-create-button": "Opret",
        "product-create-offer-dialog-create-title": "Opret tilbud",
        "product-create-offer-dialog-edit-title": "Ret tilbud",
        "product-create-offer-dialog-normal-price": "Normal pris:",
        "product-create-offer-dialog-price-adjustment-field": "\n .label = Prisjustering",
        "product-create-offer-dialog-price-adjustment-option-none": "Ingen",
        "product-create-offer-dialog-price-adjustment-option-discount-price": "Nedsat pris",
        "product-create-offer-dialog-price-adjustment-option-discount-percentage": "Rabatprocent",
        "product-create-offer-dialog-adjust-price-field": "\n .label = Ny pris",
        "product-create-offer-dialog-items-field": "\n .label = Antal varer udbudt pr. dag",
        "product-create-offer-dialog-percentage-field": "\n .label = Procentsats",
        "product-create-offer-dialog-available-offer-period": "Tilbudsperiode",
        "product-create-offer-dialog-available-from-date-picker": "\n .label = Tilgængeligt fra",
        "product-create-offer-dialog-available-to-date-picker": "\n .label = Tilgængeligt til",
        "product-create-offer-dialog-marketing-tag-label": "Marketing tag:",
        "product-create-offer-dialog-marketing-tag-mode-old-new-price-new": "25,00 kr",
        "product-create-offer-dialog-marketing-tag-mode-old-new-price-old": "35,00 kr",
        "product-create-offer-dialog-marketing-tag-mode-old-new-price": "25,00 kr 35,00 kr",
        "product-create-offer-dialog-marketing-tag-mode-save-x": "Spar [x] %",
        "product-create-offer-dialog-marketing-tag-mode-limited-on-sale": "Spar [x] kr",
        "product-create-offer-dialog-marketing-tag-mode-great-offer": "Godt tilbud",
        "product-create-offer-dialog-marketing-tag-mode-buy-now": "Køb nu",
        "product-create-offer-dialog-marketing-tag-mode-good-price": "God pris",
        "product-create-offer-dialog-marketing-tag-mode-discount": "Discount",
        "product-create-offer-dialog-marketing-tag-mode-week-offer": "Ugens tilbud",
        "product-create-offer-dialog-marketing-tag-mode-day-offer": "Dagens tilbud",
        "product-create-offer-dialog-save-button": "Gem",
        "product-create-add-price-list-button": "Tilføj til prisliste",
        "product-create-add-to-price-list": "Tilføj til prisliste",
        "product-create-price-list-step-one": "Vælg prisliste",
        "product-create-price-list-step-two": "Sæt pris",
        "product-create-price-list-table-name-column": "Navn",
        "product-create-price-list-table-status-column": "Status",
        "product-create-price-list-table-active-column-active": "Aktiv",
        "product-create-price-list-table-active-column-inactive": "Inaktiv",
        "product-create-price-list-table-active-column-active-filter-yes": "Aktiv",
        "product-create-price-list-table-active-column-inactive-filter-no": "Inaktiv",
        "product-create-price-list-table-currency": "Valuta:",
        "product-create-price-list-table-vat": "Moms:",
        "product-create-price-list-table-connected-shops": "Tilknyttede shops:",
        "product-create-price-list-table-connected-customers": "Tilknyttede kunder:",
        "product-create-price-list-table-vat-code": "Momskode:",
        "product-create-price-list-table-select-button": "Vælg",
        "product-create-price-list-selected-price-list": "Valgt prisliste:",
        "product-create-price-list-price-field-label": "\n .label = Pris",
        "product-create-price-list-add-button": "Tilføj",
        "product-create-payment-panel": "\n .title = Betaling",
        "product-create-payment-price-switch": "Skjul pris:",
        "product-create-delivery-panel": "\n .title = Levering",
        "product-create-delivery-deliveryDetails-field": "\n .label = Afhentningssted",
        "product-create-item-limits-panel": "\n .title = Begrænsning på antal varer",
        "product-create-item-limits-max-field": "Maks. dagligt antal varer pr. person:",
        "product-create-item-limits-max-info": "Dette bestemmer, hvor mange varer af denne type, en kunde kan bestille pr. dag.",
        "product-create-item-limits-min-field": "Min. antal varer pr. ordre:",
        "product-create-item-limits-min-info": "Dette bestemmer, hvor minimum antal varer af denne type, en kunde skal tilføje til en ordre.",
        "product-create-item-limits-error": "Enten maks. dagligt antal varer eller min. antal varer pr. ordre skal udfyldes",
        "product-create-item-limits-min-error": "Min. antal produkter pr. ordre skal være tom eller >= 2",
        "product-create-item-limits-max-error": "Maks. antal daglige produkter skal være tom eller >= 1",


        // Product groups
        "product-groups-page-header-title": "\n .title = Produktgrupper",
        "product-groups-create-button": "Opret gruppe",
        "create-product-group-create-button": "Opret",
        "create-product-group-save-button": "Gem",
        "product-group-page-title-create": "\n .title = Opret produktgruppe",
        "product-group-page-title-update": "\n .title = Ret produktgruppe",
        "product-group-delete": "produktgruppe",
        "product-group-delete-success-message": "Produktgruppen er slettet",
        "product-group-code-column-header": "ERP-nr.",
        "product-group-name-column-header": "Navn",
        "product-group-status-column-header": "Status",

        // Merchant > Shops > Product groups > Create / Edit
        "product-group-form-name-field": "\n .label = Navn",
        "product-group-form-code-field": "\n .label = ERP-nummer",
        "product-group-form-code-field-helper-text": "ERP-numre bruges i forbindelse med integration til et regnskabssystem. De vedligeholdes på leverandørniveau.",
        "product-group-form-code-field-helper-text-no-items": "Ingen tilgængelige produktgruppekoder for leverandør",
        "product-group-form-settings-panel": "\n .title = Indstillinger",
        "product-group-form-active-switch": "Aktiv:",
        "product-group-form-pin-code-required-switch": "Kræver PIN-kode:",
        "product-group-form-pin-code-required-explanation": "Det kræver en personale PIN-kode for at købe produkter i denne gruppe. PIN-koden er tilgængelig i detaljer for hardware enheden.",
        "product-group-form-limited-availability-panel-title": "\n .title = Tilgængelig i tidsrum \n .offContent = Produkter i denne grupper er altid tilgængelige for køb",
        "product-group-form-start-time-picker": "\n .label = Fra klokken",
        "product-group-form-end-time-picker": "\n .label = Til klokken",
        "product-group-form-week-day-monday": "Mandag",
        "product-group-form-week-day-tuesday": "Tirsdag",
        "product-group-form-week-day-wednesday": "Onsdag",
        "product-group-form-week-day-thursday": "Torsdag",
        "product-group-form-week-day-friday": "Fredag",
        "product-group-form-week-day-saturday": "Lørdag",
        "product-group-form-week-day-sunday": "Søndag",
        "product-group-form-end-time-picker-min-error-label": "Skal være større end 'Fra klokken'",


        // Merchant > Admin > Shops > Price lists
        "price-lists-header": "\n .title = Prislister",
        "price-lists-create-button": "Opret ny",
        "price-list-vat-code": "Momskode",
        "price-list-currency": "Valuta",
        "price-list-shops": "Tilkoblede shops",
        "price-list-company": "Tilkoblede firmaer",
        "price-list-no-result": "Der er ingen prislister. Opret din første prisliste",
        "price-list-delete": "prisliste",
        "price-list-delete-success-message": "Prisliste slettet",

        // Merchant > Admin > Shops > Price lists > Create / Edit
        "create-price-list-page-header": "\n .title = Opret prisliste",
        "edit-price-list-page-header":"\n .title = Ret prisliste",
        "create-price-list-save-button": "Gem",
        "create-price-list-create-button": "Opret",
        "create-price-list-tab-general": "Generelt",
        "create-price-list-tab-customers": "Kunder",
        "create-price-list-tab-products": "Produkter",
        "create-price-list-tab-pos": "POS",
        "create-price-list-required-name": "Navn er påkrævet",
        "create-price-list-required-shops": "Du skal knytte prislisten til en eller flere shops",
        "create-price-list-required-price-adjustment": "Prisjustering er påkrævet",
        "create-price-list-required-currency-code": "Valuta er påkrævet",
        "create-price-list-required-percentage": "Procentsats er påkrævet",
        "create-price-list-max-percentage":"Procentssats kan ikke være mere end 100",
        "create-or-edit-price-list-field-name":"\n .label = Navn",
        "create-or-edit-price-list-field-shops":"\n .label = Shops",
        "create-or-edit-price-list-field-aside-settings": "\n .title = Indstillinger",
        "create-or-edit-price-list-field-active":"Aktiv:",
        "create-or-edit-price-list-field-message-to-customers":"\n .label = Besked til kunder",
        "create-or-edit-price-list-aside-pricing":"\n .title = Prissætning",
        "create-or-edit-price-list-field-vat-code":"\n .label = Momskode",
        "create-or-edit-price-list-field-currency-code":"\n .label = Valuta",
        "create-or-edit-price-list-field-dropdown-dkk":"DKK",
        "create-or-edit-price-list-field-price-adjustment":"\n .label = Prisjustering",
        "create-or-edit-price-list-field-dropdown-none":"Ingen",
        "create-or-edit-price-list-field-dropdown-discount": "Rabat",
        "create-or-edit-price-list-field-dropdown-increase": "Prisstigning",
        "create-or-edit-price-list-field-internal-note":"\n .placeholder = Internt notat",
        "create-or-edit-price-list-field-percentage":"Procentsats (%):",
        "create-or-edit-price-list-customer-table-header-name":"Navn",
        "create-or-edit-price-list-customer-table-header-user-group":"Brugergruppe",
        "create-or-edit-price-list-customer-table-button-remove":"Fjern",
        "create-or-edit-price-list-customer-table-button-details":"Detaljer",
        "create-or-edit-price-list-customer-subtitle":"Hvis ingen kunder er tilføjet her, har alle kunder adgang til prislisten.",
        "create-or-edit-price-list-customer-table-title":"Kunder med adgang",
        "create-or-edit-price-list-customer-button-add-customer":"Tilføj kunde",
        "create-or-edit-price-list-customer-table-empty-state":"Alle kunder har adgang",
        "create-or-edit-price-list-general-tab-error":"Der er valideringsfejl under fanebladet Generelt",
        "create-or-edit-price-list-customer-tab-error":"Der er valideringsfejl under fanebladet Kunder",
        "create-or-edit-price-list-products-tab-error":"Der er valideringsfejl under fanebladet Produkter",
        "create-or-edit-price-list-pos-tab-error":"Der er valideringsfejl under fanebladet POS",
        "create-or-edit-price-list-customer-table-add-customers-title":"Tilføj kunder",
        "create-or-edit-price-list-customer-table-add-button":"Tilføj",
        "create-or-edit-price-list-products-table-title":"Produkter",
        "create-or-edit-price-list-products-table-header-name":"Navn",
        "create-or-edit-price-list-products-table-header-product-no":"Produktnr.",
        "create-or-edit-price-list-products-table-header-normal-price":"Normalpris",
        "create-or-edit-price-list-products-table-header-adjusted-price":"Tilpasset pris",
        "create-or-edit-price-list-products-table-header-status":"Status",
        "create-or-edit-price-list-products-table-status-active":"Aktiv",
        "create-or-edit-price-list-products-table-status-inactive":"Inaktiv",
        "create-or-edit-price-list-pos-table-title":"ID kort abonnementer",
        "create-or-edit-price-list-pos-info-description":"\n .description = Der skal altid være en standard prisliste for POS systemet. Standard prislisten vil blive vist, hvis et ID-kort scannes, som ikke er tildelt en anden prisliste.",
        "create-or-edit-price-list-pos-is-default-price-list":"Standard prisliste",
        "create-or-edit-price-list-pos-table-type":"Type",
        "create-or-edit-price-list-pos-table-description":"Beskrivelse",

        // Merchant > Admin > Shops > Shops
        "shops-page-header": "\n .title = Shops",
        "shops-table-case-column": "Sagsnr.",
        "shops-table-name-column": "Navn",
        "shops-table-type-column": "Type",
        "shops-table-status-column": "Status",
        "shops-table-status-column-active": "Aktiv",
        "shops-table-status-column-inactive": "Inaktiv",
        "shops-table-status-column-demo": "Demo",
        "shops-table-status-column-active-filter-active": "Aktiv",
        "shops-table-status-column-inactive-filter-inactive": "Inaktiv",
        "shops-table-status-column-demo-filter-demo": "Demo",
        "shops-table-create-button": "Opret shop",
        "shops-table-menu-item-edit": "Rediger",
        "shops-table-menu-item-delete": "Slet",
        "shops-confirm-delete-shop-dialog": "\n .typeOfEntity = shop",

        // Merchant > Admin > Shops > Shops > Create - Edit shop
        "merchant-shop-create-header": "\n .title = Opret shop",
        "merchant-shop-edit-header": "\n .title = Ret shop",
        "merchant-shop-create-breadcrumb": "Opret shop",
        "merchant-shop-edit-breadcrumb": "Ret shop",
        "merchant-shop-create-button": "Opret",
        "merchant-shop-save-button": "Gem",
        "merchant-create-edit-shop-tab-general": "Generelt",
        "merchant-create-edit-shop-tab-settings": "Indstillinger",
        "merchant-shop-form-field-name": "\n .label = Navn \n .helperText = Shoppens navn vil være synlig for dine kunder.",
        "merchant-shop-form-field-type": "\n .label = Type",
        "merchant-shop-form-field-type-helperText": "Vælg typen af shop.",
        "merchant-shop-form-field-type-mode-meeting-service": "Mødeforplejning",
        "merchant-shop-form-field-type-mode-take-away": "Take away",
        "merchant-shop-form-field-type-mode-lunch": "GoPay",
        "merchant-shop-form-field-type-mode-pos": "POS",
        "merchant-shop-form-field-type-mode-subscription": "Abonnement",
        "merchant-shop-form-hardware-packages": "Vælg hardware pakker",
        "merchant-shop-form-hardware-packages-info": "\n .description = Dit valg af produkter nedenfor vil ikke resultere i et køb. Du vil efterfølgende modtage et tilbud, som du kan redigere.",
        "merchant-shop-form-hardware-packages-tablet-size": "Tablet størrelse:",
        "merchant-shop-form-hardware-packages-color": "Farve:",
        "merchant-shop-form-payment-methods": "Tilgængelige betalingsmetoder",
        "merchant-shop-form-make-shop-public": "\n .title = Offentlig shop \n .offContent = Denne shop er kun tilgængelig for inviterede firmaer.",
        "merchant-shop-form-make-shop-public-info": "\n .description = En offentlig shop er tilgængelig for alle.",
        "merchant-shop-form-make-shop-public-title": "Del følgende med dine kunder",
        "merchant-shop-form-make-shop-public-description": "For at betale som gæst, skal man enten skanne en QR kode eller indtaste shopnummer for at tilgå shoppen. Læs mere om offentlige shops <externalLink>her</externalLink>.",
        "merchant-shop-form-make-shop-public-number": "Shopnummer:",
        "merchant-shop-form-make-shop-public-url": "Direkte offentligt URL:",
        "merchant-shop-form-make-shop-public-qr-code": "- eller brugerne kan skanne denne QR kode på deres mobil",
        "merchant-shop-form-make-shop-public-offContent": "Gem for at se deleoplysninger.",
        "merchant-shop-form-field-isVisibleForAppUsers": "\n .label = Gør shoppen synlig for interne brugere i GoPay mobilappen",
        "merchant-shop-form-general": "\n .title = Generelt",
        "merchant-shop-form-field-active": "Aktiv:",
        "merchant-shop-form-field-demo": "Demo:",
        "merchant-shop-form-erp": "\n .title = ERP",
        "merchant-shop-form-field-case-number": "\n .label = Sagsnummer \n .helperText = Sagsnummeret bruges til at importere salgstal i din organisations ERP-system.",
        "merchant-shop-form-internal-note": "\n .title = Intern note",
        "merchant-shop-form-field-internal-note": "\n .label = Intern note:",
        "merchant-shop-form-posDetails-defaultLanguage-field-label": "\n .label = Default sprog",
        "merchant-shop-form-posDetails-defaultLanguage-lang-en": "Engelsk",
        "merchant-shop-form-posDetails-defaultLanguage-lang-da": "Dansk",
        "merchant-shop-form-check-in": "Tjek ind",
        "merchant-shop-form-check-in-qr-code-on-receipt": "Vis tjek-ind QR kode på kvittering",
        "merchant-shop-form-accept-multiple-check-ins": "Tillad flere tjek-ind",
        "merchant-shop-form-deadline": "\n .title = Deadline \n .offContent = Deadline er ikke aktiveret",
        "merchant-shop-form-purchases": "Køb:",
        "merchant-shop-form-cancellation": "Afbestilling:",
        "merchant-shop-form-deadline-day-field": "\n .label = Dag",
        "merchant-shop-form-deadline-day-limit-day-before": "Dagen før",
        "merchant-shop-form-deadline-day-limit-x-days-before": "{ $daysBefore } dage før",
        "merchant-shop-form-deadline-time-picker": "\n .label = Tid",
        "merchant-shop-form-posDetails-configuration-for-supporters": "\n .title = Indstillinger for supportere",
        "merchant-shop-form-posDetails-configuration-for-supporters-returnToHomeScreenDelay-field-label": "\n .label = Vend tilbage til Hjem ventetid",
        "merchant-shop-form-posDetails-configuration-for-supporters-returnToHomeAfterPurchase-field-label": "\n .label = Vend tilbage til Hjem efter køb",
        "merchant-shop-form-posDetails-configuration-for-supporters-ms": "ms",

        // Merchant > Admin > Shops > Offers
        "offers-page-header": "\n .title = Offers",
        "offers-table-name-column": "Product name",
        "offers-table-price-column": "Normal price",
        "offers-table-discount-price-column": "Discount price",
        "offers-table-valid-from-column": "Valid from",
        "offers-table-expires-column": "Expires",
        "offers-table-status-column": "Status",
        "offers-table-edit-menu-item": "Rediger",
        "offers-table-remove-offer-menu-item": "Remove offer",

        // Merchant > Admin > Shops > VAT Codes
        "merchant-vat-codes-header": "\n .title = VAT codes",
        "merchant-vat-codes-create-button": "Opret",
        "merchant-vat-codes-save-button": "Gem",
        "merchant-vat-codes-delete-entity-dialog": "\n .typeOfEntity = VAT code",
        "merchant-vat-codes-table-header-vat-code":"VAT code",
        "merchant-vat-codes-table-header-name":"Navn",
        "merchant-vat-codes-table-header-percentage":"Percentage",
        "merchant-vat-codes-table-button-edit":"Rediger",
        "merchant-vat-codes-table-button-delete":"Slet",

        // Merchant > Admin > Shops > Create/Edit VAT Codes
        "merchant-vat-codes-create-header": "\n .title = Create VAT code",
        "merchant-vat-codes-edit-header": "\n .title = Edit Create VAT code",
        "merchant-vat-codes-create-edit-field-code":"\n .label = Code(*)",
        "merchant-vat-codes-create-edit-field-name":"\n .label = Name(*)",
        "merchant-vat-codes-create-edit-vat-percentage-amount":"\n .label = VAT percentage(*)",
        "merchant-vat-codes-create-edit-required-name": "Name is required",
        "merchant-vat-codes-create-edit-required-code": "Code is required",
        "merchant-vat-codes-create-edit-required-vat-percentage-amount": "VAT percentage is required",
        "merchant-vat-codes-create-edit-type-error-vat-percentage-amount": "VAT percentage must be a number",

        // Merchant > Admin > Shops > Delivery locations
        "merchant-delivery-locations-header": "\n .title = Delivery locations",
        "merchant-delivery-locations-create-button-link": "Create delivery location",
        "merchant-delivery-locations-delete-entity-dialog": "\n .typeOfEntity = delivery location",
        "merchant-delivery-locations-table-header-name": "Navn",
        "merchant-delivery-locations-table-header-status": "Status",
        "merchant-delivery-locations-table-active-column-active": "Active",
        "merchant-delivery-locations-table-active-column-inactive": "Inactive",
        "merchant-delivery-locations-table-active-column-active-filter-yes": "Active",
        "merchant-delivery-locations-table-active-column-inactive-filter-no": "Inactive",
        "merchant-delivery-locations-table-button-edit": "Rediger",
        "merchant-delivery-locations-table-button-delete": "Slet",

        // Merchant > Admin > Shops > Delivery locations
        "merchant-delivery-location-create-header": "\n .title = Create delivery location",
        "merchant-delivery-location-edit-header": "\n .title = Edit delivery location",
        "merchant-delivery-location-create-breadcrumb": "Create delivery location",
        "merchant-delivery-location-edit-breadcrumb": "Edit delivery location",
        "merchant-delivery-location-form-field-name": "\n .label = Name *",
        "merchant-delivery-location-form-start-time-picker": "\n .label = From time",
        "merchant-delivery-location-form-end-time-picker": "\n .label = End time",
        "merchant-delivery-location-form-end-time-picker-min-error-label": "Should be greater than 'From time'",
        "merchant-delivery-location-form-settings": "\n .title = Settings",
        "merchant-delivery-location-form-field-active": "Active:",
        "merchant-delivery-locations-create-button": "Opret",
        "merchant-delivery-locations-save-button": "Gem",

        // Merchant > Admin > Shops > Payment links
        "payment-links-page-header": "\n .title = Betalingslinks",
        "payment-links-table-name-column": "Navn",
        "payment-links-table-shop-column": "Shop",
        "payment-links-table-valid-from-column": "Gældende fra",
        "payment-links-table-valid-to-column": "Gælder til",
        "payment-links-table-create-button": "Opret ny",
        "payment-links-table-menu-item-edit": "Rediger",
        "payment-links-table-menu-item-delete": "Slet",
        "payment-links-confirm-delete-dialog": "\n .typeOfEntity = betalingslinks",

        // Merchant > Admin > Shops > Payment links > Create / Edit
        "payment-links-create-page-header": "\n .title = Create payment link",
        "payment-links-create-page": "Create payment link",
        "payment-links-form-create-submit-button": "Opret",
        "payment-links-edit-page-header": "\n .title = Edit payment link",
        "payment-links-edit-page": "Edit payment link",
        "payment-links-form-edit-submit-button": "Gem",
        "payment-links-form-public-title-label": "\n .label = Title *",
        "payment-links-form-description-label": "\n .label = Beskrivelse",
        "payment-links-form-public-shop-field-label": "\n .label = Public shop *",
        "payment-links-form-sales-account-field-label": "\n .label = Sales account",
        "payment-links-form-hasPasswordProtection-switch": "Password protected",
        "payment-links-form-password-field-label": "\n .label = Password \n .helperText = Protect your link with a password if the shop supports invoicing as a payment method.",
        "payment-links-form-general-panel": "\n .title = Generelt",
        "payment-links-form-active-switch": "Aktiv:",
        "payment-links-form-availability-panel": "\n .title = Validity period \n .offContent = Valid indefinitely",
        "payment-links-form-availability-from-date-picker": "\n .label = Startdato",
        "payment-links-form-availability-to-date-picker": "\n .label = Slutdato",
        "payment-links-form-availability-error-picker": "Start date and End date must be filled in",

        // Merchant > Admin > Setting > Sales accounts
        "sales-accounts-page-header": "\n .title = Salgskonti",
        "sales-accounts-table-name-column": "Navn",
        "sales-accounts-table-number-column": "Nummer",
        "sales-accounts-table-create-button": "Opret ny",
        "sales-accounts-table-menu-item-edit": "Rediger",
        "sales-accounts-table-menu-item-delete": "Slet",
        "sales-accounts-confirm-delete-dialog": "\n .typeOfEntity = salgskonti",

        // Merchant > Admin > Setting > Sales accounts > Create / Edit
        "sales-accounts-create-page-header": "\n .title = Create sales account",
        "sales-accounts-create-page": "Create sales account",
        "sales-accounts-form-create-submit-button": "Opret",
        "sales-accounts-edit-page-header": "\n .title = Edit sales account",
        "sales-accounts-edit-page": "Edit sales account",
        "sales-accounts-form-edit-submit-button": "Gem",
        "sales-accounts-form-public-name-label": "\n .label = Navn * \n .placeholder = Enter a name for the sales account",
        "sales-accounts-form-number-label": "\n .label = Nummer * \n .placeholder = Enter account number from ERP system",
        "sales-accounts-form-general-panel": "\n .title = Generelt",
        "sales-accounts-form-active-switch": "Aktiv:",

        // ADMIN DEVICES
        "merchant-admin-devices-page-header": "\n .title = Devices",


        // Merchant users
        "merchant-admin-users-create-admin-button": "Opret administrator",
        "merchant-admin-users-page-title": "\n .title = Administratorer",


        // --- Supplier ---

        // Supplier > Navigation
        "supplier-nav-item-home": "Hjem",
        "supplier-nav-item-accounting-title": "\n .title = Regnskab",
        "supplier-nav-item-accounting": "Regnskab",
        "supplier-nav-item-pos": "POS",
        "supplier-nav-item-meeting-service": "Mødeforplejning",
        "supplier-nav-item-subscriptions": "Abonnementer",
        "supplier-nav-item-z-reports": "Z-rapport",
        "supplier-nav-item-merchant-sales": "Salgssted salg",
        "supplier-nav-item-customer-sales": "Kundesalg",
        "supplier-nav-item-balance": "Balance",

        // Supplier > Navigation > Reports
        "supplier-nav-item-merchant-access": "Salgssteder",

        // Supplier > Navigation > Admin
        "supplier-nav-item-merchants-page-header":"\n .title = Salgssteder",
        "supplier-nav-item-settings-page-header":"\n .title = Indstillinger",
        "supplier-nav-item-account-page-header":"\n .title = Konto",
        "supplier-nav-item-erp-page-header":"\n .title = ERP",
        "supplier-nav-item-acquiring-reports-page-header":"\n .title = Afstemning",
        "supplier-admin-nav-item-merchants": "Salgssteder",
        "supplier-admin-nav-item-merchants-create": "Opret salgssted",
        "supplier-admin-nav-item-merchants-edit": "Rediger salgssted",
        "supplier-admin-nav-item-administrators": "Administratorer",
        "supplier-admin-nav-item-admins": "Administratorer",
        "supplier-admin-nav-item-devices": "Enheder",
        "supplier-admin-nav-item-settings": "Indstillinger",
        "supplier-admin-nav-item-acquiring": "Kortindløsning",
        "supplier-admin-nav-item-terms-and-conditions": "Handelsbetingelser",
        "supplier-admin-nav-item-pos-settings":"POS instillinger",
        "supplier-admin-nav-item-pos-settings-template-create": "Create template",
        "supplier-admin-nav-item-pos-settings-template-edit": "Edit template",
        "supplier-admin-nav-item-company-account":"Virksomhedskonto",
        "supplier-admin-nav-item-account-gdpr":"GDPR",
        "supplier-admin-nav-item-erp":"ERP",
        "supplier-admin-nav-item-acquiring-fees": "Indløsningsgebyrer",
        "supplier-admin-nav-item-bank-transfers":"Bankoverførsler",
        "supplier-admin-nav-item-product-numbers":"Produktnumre",
        "supplier-admin-nav-item-create-product-group-number":"Opret produktnummer",
        "supplier-admin-nav-item-update-product-group-number":"Ret produktnummer",
        "supplier-admin-nav-item-create-terms-and-conditions": "Opret handelsbetingelser",
        "supplier-admin-nav-item-update-terms-and-conditions": "Rediger handelsbetingelser",

        // Supplier > Reports > Home

        // Supplier > Reports > Home > Accounting > Meeting Service
        "supplier-meeting-service-header": "\n .title = Meeting Service",
        "supplier-meeting-service-table-merchant": "Salgssted",
        "supplier-meeting-service-table-order-id-column": "Ordre ID",
        "supplier-meeting-service-order-id-label": "\n .label = Ordre ID",
        "supplier-meeting-service-table-booked-date-column": "Bogføringsdato",
        "supplier-meeting-service-table-delivery-time-column": "Leveringstid",
        "supplier-meeting-service-table-employee-column": "Salgsted",
        "supplier-meeting-service-table-status":"Status",
        "supplier-meeting-service-table-status-confirmed":"Confirmed",
        "supplier-meeting-service-table-status-canceled":"Canceled",
        "supplier-meeting-service-table-amount-column": "Beløb (DKK)",
        "supplier-meeting-service-table-show-receipt": "Show receipt",
        "supplier-meeting-service-table-floating-action-bar-receipts": "\n .title = Receipts",
        "supplier-meeting-service-table-floating-action-bar-export": "\n .title = Export",
        "supplier-meeting-service-order-title":"\n .title = Ordre",
        "supplier-meeting-service-drawer-pending-approval-label":"\n .label = Pending approval",
        "supplier-meeting-service-invoicing-title":"\n .title = Invoicing",
        "supplier-meeting-service-drawer-invoice-status-label":" Invoice status",
        "supplier-meeting-service-drawer-invoice-status-all-label":"All",
        "supplier-meeting-service-drawer-invoice-status-sent-label":"Sent",
        "supplier-meeting-service-drawer-invoice-status-not-sent-label":"Not sent",
        "supplier-meeting-service-drawer-booked-label":"Booked",
        "supplier-meeting-service-drawer-booked-all-label":"All",
        "supplier-meeting-service-drawer-booked-booked-label":"Booked",
        "supplier-meeting-service-drawer-booked-not-booked-label":"Not booked",
        "supplier-meeting-service-booked-date-title":"\n .title = Bogføringsdato",
        "supplier-meeting-service-delivery-date-title":"\n .title = Delivery date",
        "supplier-meeting-service-merchant-title":"\n .title = Salgssted",
        "supplier-meeting-service-debtor-title":"\n .title = Debitor",
        "supplier-meeting-service-end-user-title":"\n .title = Slutbruger",
        "supplier-meeting-service-payment-title":"\n .title = Betaling",
        "supplier-meeting-service-drawer-from-date-label":"\n .label = From date",
        "supplier-meeting-service-drawer-to-date-label":"\n .label = To date",
        "supplier-meeting-service-drawer-bill-receivers-label":"Bill receivers",
        "supplier-meeting-service-drawer-satellites-label":"Satellites",
        "supplier-meeting-service-drawer-to-date-info-label": "\n .title = Brug ikke leveringsdato til fakturering. Brug i stedet bogføringsdato.",

        // Supplier > Reports > Home > Accounting > POS
        "supplier-pos-table-header-title": "\n .title = POS",
        "supplier-pos-table-header-order-id": "Ordre ID",
        "supplier-pos-table-header-transaction-time": "Transaktionstid",
        "supplier-pos-table-header-merchant-name": "Merchant name",
        "supplier-pos-table-header-employee": "Ordreafgiver",
        "supplier-pos-table-header-payment": "Betalingsmetode",
        "supplier-pos-table-header-payment-channel": "Kanal",
        "supplier-pos-table-header-amount": "Beløb (DKK)",
        "supplier-pos-table-table-button-show-receipt": "Show receipt",
        "supplier-pos-table-filters-order-title":"\n .title = Ordre",
        "supplier-pos-table-filters-period-title":"\n .title = Periode",
        "supplier-pos-table-filters-merchant-title":"\n .title = Salgssted",
        "supplier-pos-table-filters-debtor-title":"\n .title = Debitor",
        "supplier-pos-table-filters-end-user-title":"\n .title = Slutbruger",
        "supplier-pos-table-filters-payment-title":"\n .title = Betaling",
        "supplier-pos-table-filters-from-date-label":"\n .label = Transaktion fra dato",
        "supplier-pos-table-filters-to-date-label":"\n .label = Transaktion til dato",


        // Supplier > Reports > Home > Accounting > Subscriptions
        "supplier-subscriptions-header": "\n .title = Abonnementer",
        "supplier-subscriptions-table-order-id-column": "Ordre ID",
        "supplier-subscriptions-table-employee-column": "Medarbejder",
        "supplier-subscriptions-table-subscribed-column": "Tilmeldt",
        "supplier-subscriptions-table-unsubscribed-column": "Frameldt",
        "supplier-subscriptions-table-payment-column": "Betalingsmetode",
        "supplier-subscriptions-table-amount-column": "Beløb",
        "supplier-subscriptions-table-cancel-subscription": "Cancel subscription",
        "supplier-subscriptions-table-details": "Details",
        "supplier-subscriptions-table-filters-order-title":"\n .title = Ordre",
        "supplier-subscriptions-table-filters-period-title":"\n .title = Periode",
        "supplier-subscriptions-table-filters-from-date-label":"\n .label = Valid from date",
        "supplier-subscriptions-table-filters-to-date-label":"\n .label = Valid to date",
        "supplier-subscriptions-table-filters-merchant-title":"\n .title = Salgssted",
        "supplier-subscriptions-table-filters-debtor-title":"\n .title = Debitor",
        "supplier-subscriptions-table-filters-end-user-title":"\n .title = Slutbruger",
        "supplier-subscriptions-table-filters-payment-title":"\n .title = Betaling",
        "supplier-subscriptions-drawer-subscription-label":"Abonnement",

        // Supplier > Reports > Home > Accounting > Z-reports
        "supplier-accounting-z-reports-page-header":" \n .title = Z-rapport",
        "supplier-accounting-z-reports-table-date-column":"Dato",
        "supplier-accounting-z-reports-table-pos-terminal-column":"POS enhed",
        "supplier-accounting-z-reports-table-amount-column":"Beløb",


        // Supplier > Reports > Home > Accounting > Merchant Sales
        "supplier-merchant-sales-header": "\n .title = Salgssted salg",
        "supplier-merchant-sales-table-shop-type": "\n .label = Shop Type",
        "supplier-merchant-sales-table-red-no-column": "Reg. nr.",
        "supplier-merchant-sales-table-name-column": "Navn",
        "supplier-merchant-sales-table-upcoming-sales-column": "Kommende salg ({ $currencyCode })",
        "supplier-merchant-sales-table-booked-sales-column": "Bogført salg ({ $currencyCode })",
        "supplier-merchant-sales-table-floating-action-bar-export": "\n .title = Export",
        "supplier-merchant-sales-table-shop-type-input-label": "Shop type",
        "supplier-merchant-sales-table-shop-type-item-pos": "POS",
        "supplier-merchant-sales-table-shop-type-item-meeting-service": "Mødeforplejning",
        "supplier-merchant-sales-table-shop-type-item-subscription": "Abonnement",
        "supplier-merchant-sales-detailed-table-total-footer-column": "Total",
        "supplier-merchant-sales-detailed-table-sales-column": "Sales (DKK)",


        // Supplier > Reports > Home > Accounting > Customer Sales
        "supplier-customer-sales-header": "\n .title = Kundesalg",
        "supplier-customer-sales-table-name-column": "Navn",
        "supplier-customer-sales-table-upcoming-sales-column": "Kommende salg ({ $currencyCode })",
        "supplier-customer-sales-table-booked-sales-column": "Bogført salg ({ $currencyCode })",
        "supplier-customer-sales-table-floating-action-bar-export": "\n .title = Export",
        "supplier-customer-sales-detailed-table-total-footer-column": "Total",
        "supplier-customer-sales-detailed-table-sales-column": "Sales (DKK)",



        // Supplier > Admin > Home
        "supplier-admin-home-merchants-group": "\n .title = Salgssteder",
        "supplier-admin-home-merchant-card": "\n .title = Salgssteder\n .description = Håndter salgssteder, som er fysiske salgslokationer, f.eks. kantiner.",
        "supplier-admin-home-administrators-card": "\n .title = Administratorer\n .description = Styring af administratorer",
        "supplier-admin-home-devices-card": "\n .title = Enheder\n .description = Styr jeres hardware enheder, såsom POS tablets, check-in skærme og printere.",
        "supplier-admin-home-settings-group": "\n .title = Indstillinger",
        "supplier-admin-home-payment-acquiring-card": "\n .title = Kortindløsning\n .description = Styr og check status på kreditkort indløsningsaftaler.\n .buttonText = Vis",
        "supplier-admin-home-terms-and-conditions-card": "\n .title = Handelsbetingelser\n .description = Administrer jeres handelsbetingelser, som vises for kunderne.",
        "supplier-admin-home-pos-settings-card": "\n .title = POS indstillinger \n .description = Styr POS indstillinger.",
        "supplier-admin-home-account-group":  "\n .title = Konto",
        "supplier-admin-home-company-account-card":  "\n .title = Firmakonto\n .description = Administrer jeres firmakonto.\n .buttonText = Vis",
        "supplier-admin-home-erp-group":  "\n .title = ERP",
        "supplier-admin-home-product-numbers-card":  "\n .title = Produktnumre\n .description = Administrer produktnumre for ERP integration.",
        "supplier-admin-home-account-gdpr-card":  "\n .title = GDPR\n .description = Databeskyttelsesforordningen\n .buttonText = Show",
        "supplier-admin-home-acquiring-reports-group":  "\n .title = Afstemning",
        "supplier-admin-home-bank-transfers-card":  "\n .title = Bankoverførsler\n .description = Rapport over overførsler mellem jeres indløser-konti og bankkonti.\n .buttonText = Vis",
        "supplier-admin-home-acquiring-fees":  "\n .title = Indløsningsgebyrer\n .description = Rapport over indløsningsgebyrer. Brugbart til afstemning.\n .buttonText = Vis",
        "supplier-admin-home-balance":  "\n .title = Balance\n .description = Rapport, der viser totaler for salg, gebyrer og bankoverførsler for en periode.\n .buttonText = Vis",


        // SUPPLIER ADMIN DEVICES
        "supplier-admin-devices-page-header": "\n .title = Enheder",

        // Supplier > Admin > ERP > Product Group Numbers
        "supplier-admin-erp-product-group-numbers-header": "\n .title = Produktnumre",
        "supplier-admin-erp-product-group-numbers-create-new-button":"Opret nyt",
        "supplier-admin-erp-product-group-numbers-save-button":"Gem",
        "supplier-admin-erp-product-group-numbers-table-header-erp-number":"ERP nr.",
        "supplier-admin-erp-product-group-numbers-table-header-name":"Navn",
        "supplier-admin-erp-product-group-numbers-table-header-status":"Status",
        "supplier-admin-erp-product-group-numbers-table-active-column-active":"Aktiv",
        "supplier-admin-erp-product-group-numbers-table-active-column-inactive":"Inaktiv",
        "supplier-admin-erp-product-group-numbers-table-active-filter-yes":"Aktiv",
        "supplier-admin-erp-product-group-numbers-table-active-filter-no":"Inaktiv",
        "supplier-admin-erp-product-group-numbers-table-button-edit":"Rediger",
        "supplier-admin-erp-product-group-numbers-table-button-delete":"Slet",
        "supplier-admin-erp-product-group-numbers-delete-entity-dialog":"\n .typeOfEntity = Produktnumre",

        // Supplier > Admin > ERP > Product Group Numbers > Create/Update
        "supplier-admin-erp-product-group-numbers-create-header": "\n .title = Opret produktnummer",
        "supplier-admin-erp-product-group-numbers-update-header": "\n .title = Ret produktnummer",
        "supplier-admin-erp-product-group-numbers-create-button":"Opret",
        "supplier-admin-erp-product-group-numbers-field-code":"\n .label = ERP-nummer *",
        "supplier-admin-erp-product-group-numbers-field-name":"\n .label = Navn *",
        "supplier-admin-erp-product-group-numbers-description":"\n .label = Beskrivelse\n .placeholder = Her kan du forklare den tilsigtede brug af dette produktnummer.",
        "supplier-admin-erp-product-group-numbers-required-code":"ERP-nummer er påkrævet",
        "supplier-admin-erp-product-group-numbers-required-name":"Navn er påkrævet",
        "supplier-admin-erp-product-group-numbers-aside-settings":"\n .title = Indstillinger",
        "supplier-admin-erp-product-group-numbers-active":"Aktiv:",
        "supplier-admin-erp-product-group-numbers-history":"\n .title = Historik",
        "supplier-admin-erp-product-group-numbers-aside-created":"Oprettet:",
        "supplier-admin-erp-product-group-numbers-aside-updated":"Ændret:",

        // DEVICE TABLE GENERAL
        "devices-table-header-name": "Navn",
        "devices-table-header-group": "Gruppe",
        "devices-table-header-type": "Type",
        "devices-table-header-status": "Status",
        "devices-table-button-details": "Detaljer",
        "devices-table-button-edit": "Edit",
        "devices-table-status-column-online": "Online",
        "devices-table-status-column-offline": "Offline",
        "devices-table-header-reg": "Reg. nr.",
        "devices-table-header-merchant": "Salgssted",

        // DEVICE DETAILS
        "device-details-title": "Enhedsdetaljer",
        "device-details-type-info-shop": "\n .label = Shop:",
        "device-details-type-info-device-number": "\n .label = Enhedsnummer:",
        "device-details-type-info-serial-number": "\n .label = Serienummer:",
        "device-details-type-info-hardware-id": "\n .label = Hardware-ID:",
        "device-details-type-info-language": "\n .label = Sprog:",
        "device-details-type-info-pos-mode": "\n .label = POS tilstand:",
        "device-details-type-info-card-terminal-acquirer-name": "\n .label = Kreditkort terminal indløser name:",
        "device-details-status-info-title": "\n .title = Status",
        "device-details-status-info-diagnostics-title": "\n .title = Vis diagnostics",
        "device-details-status-info-diagnostics-subject": "Emne",
        "device-details-status-info-diagnostics-message": "Besked",
        "device-details-pin-code-info-title": "\n .title = PIN kode",
        "device-details-pin-code-info-helper": "\n .title = PIN kode: \n .description = PIN koden bruges til at opnå adgang til administrationsmenuer på enheden.",
        "device-details-group-info-title": "\n .title = Gruppe",
        "device-details-group-info-name": "\n .label = Navn:",
        "device-details-group-info-connected-devices": "\n .title = Forbundne enheder",
        "device-details-group-table-header-name": "Navn",
        "device-details-group-table-header-type": "Type",
        "device-details-group-table-header-status": "Status",
        "device-details-device-info-title": "\n .title = Device",
        "device-details-device-info-name": "\n .label = Name:",
        "device-details-device-info-shop": "\n .label = Shop:",
        "device-details-device-info-device-number": "\n .label = Device number:",
        "device-details-identification-info-title": "\n .title = Identification",
        "device-details-identification-info-serial-number": "\n .label = Serial number:",
        "device-details-identification-info-hardware-id": "\n .label = Hardware ID:",
        "device-details-identification-info-acquirer": "\n .label = Card terminal acquirer name:",
        "device-details-settings-info-title": "\n .title = Settings",
        "device-details-settings-info-language": "\n .label = Language:",
        "device-details-settings-info-pos-mode": "\n .label = POS mode:",
        "device-details-settings-info-pin-code-info": "PIN code is used to enter protected areas in the app.",
        "device-details-history-info-title": "\n .title = Historik",
        "device-details-history-info-created": "\n .label = Oprettet:",
        "device-details-history-info-edited": "\n .label = Redigeret:",
        "device-details-type-mode-cloud-pos": "GoPay CloudPOS",
        "device-details-type-mode-soft-pos": "GoPay SoftPOS",
        "device-details-type-mode-display": "Display",
        "device-details-type-mode-cloud-credit-card-reader": "Cloud Printer",
        "device-details-type-mode-star-cloud-printer": "Cloud Credit Card Reader",
        "device-details-type-mode-receipt-control": "Receipt Control",
        "device-details-group-table-device-type-filter-label": "Device Type",
        "device-details-group-table-device-type-filter-label-label": "\n .label = Device Type",
         "devices-table-select-filter-on-item-room-display": "Room display",
        "devices-table-select-filter-on-item-meeting-display": "Meeting display",
        "devices-table-select-filter-on-item-guest-check-in": "Guest check in",

        // Create or edit device
        "service-center-admin-organization-create-devices-title": "\n .title = Create display",
        "service-center-admin-organization-edit-devices-title": "\n .title = Edit display",
        "devices-create-device-form": "Create",
        "devices-edit-device-form": "Save",
        "devices-edit-breadcrumb": "Edit display",
        "devices-create-breadcrumb": "Create display",
        "devices-create-or-edit-form-select-template-label": "\n .label = Template *",
        "devices-create-or-edit-form-select-field-name": "Name",
        "devices-create-or-edit-form-select-field-device-number": "Device number { $required }",
        "devices-create-or-edit-form-floor-label": "\n .label = Floor",
        "devices-create-or-edit-form-select-field-room": "\n .label = Room *",
        "devices-create-or-edit-form-select-field-serial-number": "Serial number",
        "devices-create-or-edit-form-select-display-type": "\n .label = Display type",
        "devices-create-or-edit-form-type-room-details-info": "\n .title = Room displays are put up in front of meeting rooms to show if the room is currently available or occupied. It also offers a convenient way to book the room.",
        "devices-create-or-edit-form-type-meeting-details-info": "\n .title = Meeting displays are typically put up on each floor and are designed to let people now where to go for their meeting.",


        "devices-create-or-edit-form-display-type-dropdown-item-room-display": "Room display",
        "devices-create-or-edit-form-display-type-dropdown-item-meeting-display": "Meeting display",
        "devices-create-or-edit-form-display-type-dropdown-item-guest-check-in": "Guest check in",

        // Display types
        "display-types-dropdown-select-item-room-display": "Room display",

        // Supplier > Admin > POS settings
        "supplier-admin-pos-settings-page-header": "\n .title = POS indstillinger",
        "supplier-admin-pos-settings-tab-templates": "Templates",
        "supplier-admin-pos-settings-tab-general": "General",
        "supplier-admin-pos-settings-create-button": "Opret",
        "supplier-admin-pos-settings-templates-table-header-name": "Navn",
        "supplier-admin-pos-settings-templates-table-header-language": "Language",
        "supplier-admin-pos-settings-templates-table-header-status": "Status",
        "supplier-admin-pos-settings-templates-table-edit-button": "Rediger",
        "supplier-admin-pos-settings-templates-table-duplicate-button": "Duplicate",
        "supplier-admin-pos-settings-templates-table-delete-button": "Slet",
        "supplier-admin-pos-settings-templates-table-status-column-active":"In use",
        "supplier-admin-pos-settings-templates-table-status-column-inactive":"Not in use",
        "supplier-admin-pos-settings-templates-table-status-column-active-filter-yes": "In use",
        "supplier-admin-pos-settings-templates-table-status-column-inactive-filter-no": "Not in use",

        // Supplier > Admin > POS settings > Templates > Create / Edit
        "supplier-admin-pos-settings-create-template-page-header": "\n .title = Create template",
        "supplier-admin-pos-settings-edit-template-page-header": "\n .title = Edit template",
        "supplier-admin-pos-settings-create-submit-button": "Opret",
        "supplier-admin-pos-settings-edit-submit-button": "Gem",
        "supplier-admin-pos-settings-template-shortcuts": "\n .title = Shortcuts",
        "supplier-admin-pos-settings-template-name-field-label": "\n .label = Template name",
        "supplier-admin-pos-settings-template-languageCode-field-label": "\n .label = Language",
        "supplier-admin-pos-settings-lang-en": "Engelsk",
        "supplier-admin-pos-settings-lang-da": "Dansk",
        "supplier-admin-pos-settings-template-button-field-label": "\n .label = Button text \n .helperText = Customize the text of the start purchase button.",
        "supplier-admin-pos-settings-template-title-field-label": "\n .label = Title",
        "supplier-admin-pos-settings-template-subtitle-field-label": "\n .label = Subtitle",
        "supplier-admin-pos-settings-template-companyLogo-field-label": "\n .label = Upload company logo:",
        "supplier-admin-pos-settings-template-companyLogo-info": "Image hints: background should be transparent. We recommend using a 180x180 px image with logo centered inside.",
        "supplier-admin-pos-settings-template-shortcuts-help-field": "Help / terms and conditions:",
        "supplier-admin-pos-settings-template-shortcuts-downloadApp-field": "Download GoPay app:",
        "supplier-admin-pos-settings-template-frontpage-layout": "Frontpage layout",
        "supplier-admin-pos-settings-template-select-theme-style": "Select theme style:",

        // Supplier > Admin > POS settings > General
        "supplier-admin-pos-settings-general-submit-button": "Gem",
        "supplier-admin-pos-settings-general-defaultLanguage-field-label": "\n .label = Default language \n .helperText = Can be adjusted on each device.",
        "supplier-admin-pos-settings-general-posPrintingMode-field-label": "\n .label = Receipt print mode",
        "supplier-admin-pos-settings-general-posPrintingMode-option-qr-only": "QR code only",
        "supplier-admin-pos-settings-general-posPrintingMode-option-auto": "Automatic print",
        "supplier-admin-pos-settings-general-posPrintingMode-option-manually": "Manual print",
        "supplier-admin-pos-settings-general-info": "The print mode controls how the receipt is made available to the customer. “Automatic print” will print a paper receipt automatically whereas “Manual print” allows the user to print paper receipt or scan QR code to get a digital receipt. Choose “QR code only” if you want a paperless POS system.",
        "supplier-admin-pos-settings-general-configuration-for-supporters": "Configuration for supporters",
        "supplier-admin-pos-settings-general-configuration-for-supporters-returnToHomeScreenDelay-field-label": "\n .label = Return to home screen delay",
        "supplier-admin-pos-settings-general-configuration-for-supporters-returnToHomeAfterPurchase-field-label": "\n .label = Return to home after purchase",
        "supplier-admin-pos-settings-general-configuration-for-supporters-ms": "ms",

        // Merchant Access
        "supplier-merchant-access-page-header": "\n .title = Salgssteder",
        "supplier-merchant-access-table-header-case-no": "Sagsnr.",
        "supplier-merchant-access-table-header-name": "Navn",
        "supplier-merchant-access-table-header-address": "Adresse",
        "supplier-merchant-access-table-details-no-companies": "There are no connected companies",
        "supplier-merchant-access-table-details-customers-title":"Kunder:",

        // Supplier > Admin > Acquiring
        "supplier-admin-pos-acquirer-page-header": "\n .title = Kreditkort indløsningsaftale",
        "supplier-admin-pos-acquirer-adyen-question": "Hvem er Adyen?",
        "supplier-admin-pos-acquirer-adyen-answer": "Adyen er vores indløser med status af indløsende bank, som giver dig mulighed for at modtage kreditkort betalinger. Adyen er ansvarlig for behandling af betalinger for dit firma. Før du kan modtage betaling med kreditkort, skal du ansøge om en indløsningsaftale hos Adyen.",
        "supplier-admin-pos-acquirer-adyen-read-more": "Læs mere: <externalLink>{ $adyenWebsite }</externalLink>",
        "supplier-admin-pos-acquirer-status-title":"Status:",
        "supplier-admin-pos-acquirer-status-create-business-lines": "Ingen industrikoder",
        "supplier-admin-pos-acquirer-status-info-create-business-lines": "Du skal oplyse dine forretningsområder, før du kan ansøge.",
        "supplier-admin-pos-acquirer-status-action-create-business-lines": "Tilføj venligst en eller flere industrikoder nedenfor.",
        "supplier-admin-pos-acquirer-status-start": "Start ansøgning",
        "supplier-admin-pos-acquirer-status-info-start": "Du er nu klar til at påbegynde ansøgning hos indløser.",
        "supplier-admin-pos-acquirer-status-action-start": "Start ansøgningen hos indløseren nedenfor.",
        "supplier-admin-pos-acquirer-status-pending": "Under behandling",
        "supplier-admin-pos-acquirer-status-info-pending": "Din ansøgning behandles af indløseren.",
        "supplier-admin-pos-acquirer-status-action-pending": "Afvent venligst godkendelse.",
        "supplier-admin-pos-acquirer-status-invalid": "Fejl i ansøgning",
        "supplier-admin-pos-acquirer-status-info-invalid": "Der er fejl i de oplyste informationer.",
        "supplier-admin-pos-acquirer-status-action-invalid": "Ret venligst din ansøgning.",
        "supplier-admin-pos-acquirer-status-valid": "Godkendt",
        "supplier-admin-pos-acquirer-status-info-valid": "Din ansøgning er blevet godkendt.",
        "supplier-admin-pos-acquirer-status-check-valid":"Du er nu klar til at sætte kreditkortbetalinger op for dine salgssteder.",
        "supplier-admin-pos-acquirer-status-rejected": "Afvist",
        "supplier-admin-pos-acquirer-status-info-rejected": "Indløseren har verificeret oplysningerne, men har fundet grund til ikke at indgå samarbejde med jeres organisation.",
        "supplier-admin-pos-acquirer-start-application-button": "Start ansøgning hos Adyen",
        "supplier-admin-pos-acquirer-continue-application-button": "Fortsæt ansøgning hos Adyen",
        "supplier-admin-pos-acquirer-status-no-payment-title": "Du har ingen indløsningsaftale for kreditkort.",
        "supplier-admin-pos-acquirer-status-no-payment-error": "Ingen tilgængelige indløsere",
        "supplier-admin-acquiring-terms-and-conditions-title": "Krav til salgsbetingelser",
        "supplier-admin-acquiring-terms-and-conditions-explanation": "For at fortsætte, skal du acceptere indløserens krav til jeres <requirementsLink>salgsbetingelser</requirementsLink>. Disse salgsbetingelser skal fremgå tydeligt for jeres kunder på jeres hjemmeside.",
        "supplier-admin-acquiring-terms-and-conditions-template-text": "Du kan hente vores skabelon for salgsbetingelser <templateLink>her</templateLink>.",
        "supplier-admin-acquiring-terms-and-conditions-label": "\n .label = Jeg accepterer at opfylde disse krav.",
        "supplier-admin-acquiring-accept-terms-dialog-title": "Accepter salgsbetingelser",
        "supplier-admin-acquiring-accept-terms-dialog-description": "Er du sikker på, at du vil acceptere at opfylde disse krav til salgsbetingelser?",
        "supplier-admin-acquiring-accept-terms-dialog-button": "Accepter",
        "supplier-acquiring-industry-codes-accordion-industry-codes-title": "Industrikoder",
        "supplier-acquiring-industry-codes-accordion-industry-codes-info-box": "\n .description = If you apply for a canteen, select industry code 722514 - cafeterias, grill buffets.",
        "supplier-acquiring-industry-codes-table-industry-code-column": "Industrikode",
        "supplier-acquiring-industry-codes-table-description-column": "Beskrivelse",
        "supplier-acquiring-industry-codes-table-remove-action": "Fjern",
        "supplier-acquiring-industry-codes-add-industry-code": "Tilføj ny industrikode",
        "supplier-acquiring-industry-codes-info-text": "Industrikoder beskriver jeres forretningsområder og dermed hvilke typer varer, I må sælge i jeres shops. Nogle industrikoder kræver godkendelse af indløseren. Se alle industrikoder <industryCodesLink>her</industryCodesLink>.",
        "supplier-acquiring-industry-codes-confirm-delete-dialog": "\n .title = Fjern industrikode\n .message = Ønsker du at fjerne industrikoden { $industryCode }?\n .buttonLabelSubmit = Fjern",
        "supplier-acquiring-bank-accounts-accordion-bank-accounts-title": "Bankkonti",
        "supplier-acquiring-bank-accounts-table-bank-name-column": "Bank",
        "supplier-acquiring-bank-accounts-table-account-column": "Konto",
        "supplier-acquiring-bank-accounts-table-merchant-caseno-column": "Sagsnr.",
        "supplier-acquiring-bank-accounts-table-merchant-column": "Salgssted",
        "supplier-acquiring-bank-accounts-table-status-column": "Status",
        "supplier-acquiring-bank-accounts-table-remove-action": "Fjern",
        "supplier-acquiring-bank-accounts-add-bank-account": "Tilføj ny bankkonto",
        "supplier-acquiring-bank-accounts-info-text": "Hvis du ønsker salg overført til en separat bankkonto pr. salgssted, kan du tilføje ekstra bankkonti her. Se <guideLink>guide</guideLink> om, hvordan du tilføjer en ny bankkonto hos indløseren og efterfølgende forbinder den med et salgssted.",
        "supplier-acquiring-bank-accounts-status-pending": "Under behandling",
        "supplier-acquiring-bank-accounts-status-invalid": "Ugyldige oplysninger",
        "supplier-acquiring-bank-accounts-status-valid": "Valideret",
        "supplier-acquiring-bank-accounts-status-rejected": "Afvist",
        "supplier-acquiring-bank-accounts-confirm-delete-dialog": "\n .title = Fjern bankkonto\n .message = Ønsker du at fjerne bankkontoen { $accountIdentifier }?\n .buttonLabelSubmit = Fjern",
        "supplier-acquiring-industry-codes-button-add": "Tilføj",
        "supplier-acquiring-industry-codes-button-save": "Gem",
        "supplier-acquiring-industry-codes-alert-title": " Adding new industry codes might change your payment acquiring agreement status to pending if the acquirer needs to verify.",

        // Supplier > Admin > Reconciliation
       "supplier-acquiring-reports": "Afstemning",
       "supplier-acquiring-reports-table-booked-time-column": "Bogført tid",
       "supplier-acquiring-reports-table-merchant-label": "\n .label = Salgssted",
       "supplier-acquiring-reports-table-adyen-account-label": "\n .label = Adyen konto",
       "supplier-acquiring-reports-table-merchant-column": "Salgssted",
       "supplier-acquiring-reports-table-amount-column": "Beløb",

       // Supplier > Admin > Reconciliation > Fees
       "supplier-acquiring-fees-header": "\n .title = Indløsningsgebyrer",
       "supplier-acquiring-fees": "Indløsningsgebyrer",
       "supplier-acquiring-fees-table-order-id-column": "Ordre ID",
       "supplier-acquiring-fees-table-psp-reference-column": "PSP reference",
       "supplier-acquiring-fees-table-available-date-column": "Tilgængelig dato",
       "supplier-acquiring-fees-table-type-column": "Type",
        "supplier-acquiring-fees-table-select-filter-on-label": "Filtrer på",
        "supplier-acquiring-fees-table-select-filter-on-label-label": "\n .label = Filtrer på",
        "supplier-acquiring-fees-table-select-filter-on-item-booking-date": "Bogføringsdato",
        "supplier-acquiring-fees-table-select-filter-on-item-value-date": "Tilgængelig dato",
       "supplier-acquiring-fees-table-type-mode-payment": "Betaling",
       "supplier-acquiring-fees-table-type-mode-transfer": "Overførsel",
       "supplier-acquiring-fees-table-type-mode-refund": "Refundering",
       "supplier-acquiring-fees-table-number-of-transactions": "\n .title = Antal transaktioner",
        "supplier-acquiring-fees-table-info-banner": "\n .description = Data for denne rapport bliver tilgængelig dagen efter, så du kan ikke se transaktioner for i dag.",

       // Supplier > Admin > Reconciliation > Bank transfers
       "supplier-acquiring-bank-transfers-header": "\n .title = Bankoverførsler",
       "supplier-acquiring-bank-transfers": "Bankoverførsler",
       "supplier-acquiring-bank-transfers-table-transfer-id-column": "Overførsels-ID",
       "supplier-acquiring-bank-transfers-table-available-time-column": "Tilgængelig tid",
       "supplier-acquiring-bank-transfers-table-bank-account-column": "Bankkonto",
        "supplier-acquiring-bank-transfers-table-details-menu-item": "Details",
       "supplier-acquiring-bank-transfers-table-number-of-transfers": "\n .title = Antal overførsler",
       "supplier-acquiring-bank-transfers-table-info-banner": "\n .description = Data for denne rapport bliver tilgængelig dagen efter, så du kan ikke se bankoverførsler for i dag eller kommende overførsler.",
        "supplier-acquiring-bank-transfers-table-details-table-order-id-column": "Order ID",
        "supplier-acquiring-bank-transfers-table-details-table-psp-reference-column": "PSP Reference",
        "supplier-acquiring-bank-transfers-table-details-table-booked-column": "Booked",
        "supplier-acquiring-bank-transfers-table-details-table-available-column": "Available",
        "supplier-acquiring-bank-transfers-table-details-table-gross-column": "Gross",
        "supplier-acquiring-bank-transfers-table-details-table-net-column": "Net",
        "supplier-acquiring-bank-transfers-table-details-table-fee-column": "Fee",
        "supplier-acquiring-bank-transfers-details-dialog-title": "\n .dialogTitle = Transfer details\n .subtitle = Period: { $periodStart} - { $periodEnd }",
        "supplier-acquiring-bank-transfers-details-dialog-title-no-start-date": "Aftalestart",
        "supplier-acquiring-bank-transfers-details-dialog-number-of-orders": "\n .title = Number of orders",
        "supplier-acquiring-bank-transfers-details-dialog-table-gross-total": "\n .title = Gross total",
        "supplier-acquiring-bank-transfers-details-dialog-table-fee-total": "\n .title = Fee total",
        "supplier-acquiring-bank-transfers-details-dialog-table-net-total": "\n .title = Net total",

       // Supplier > Admin > Reconciliation > Balance
       "supplier-overview-header": "\n .title = Balance",
       "supplier-overview-table-amount": "Beløb",
       "supplier-overview-table-account": "Konto",
       "supplier-overview-table-view-details": "Vis detaljer",
       "supplier-overview-balance-details-dialog": "\n .dialogTitle = Balance detaljer\n .subtitle = Periode: { $periodStart} - { $periodEnd }",
       "supplier-overview-balance-details-dialog-select-order": "Vis ordrer",
       "supplier-overview-balance-details-dialog-select-order-label": "\n .label = Vis ordrer",
       "supplier-overview-balance-details-dialog-select-order-mode-net-sales": "Netto omsætning",
       "supplier-overview-balance-details-dialog-select-order-mode-bank-transfers": "Bankoverførsler",
       "supplier-overview-balance-details-dialog-select-order-mode-balance": "Balance",
       "supplier-overview-balance-details-dialog-compact-view-label": "Vis brutto omsætning og gebyrer",
       "supplier-overview-balance-details-dialog-table-order-id-column": "Ordre ID",
       "supplier-overview-balance-details-dialog-table-rsp-reference-column": "PSP reference",
       "supplier-overview-balance-details-dialog-table-booked-column": "Bogført",
       "supplier-overview-balance-details-dialog-table-available-column": "Tilgængelig",
       "supplier-overview-balance-details-dialog-table-gross-column": "Brutto",
       "supplier-overview-balance-details-dialog-table-fee-column": "Gebyr",
       "supplier-overview-balance-details-dialog-table-net-column": "Netto",
       "supplier-overview-balance-details-dialog-table-effective-column": "Effektivt beløb",
       "supplier-overview-balance-details-dialog-table-type-column": "Type",
       "supplier-overview-balance-details-dialog-table-payment-type-bank-transfer": "Bankpostering",
       "supplier-overview-balance-details-dialog-table-payment-type-previous-revenue": "Tidligere indbetalt",
       "supplier-overview-balance-details-dialog-table-payment-type-deferred-revenue": "Forskudt gebyr",
       "supplier-overview-balance-details-dialog-table-payment-type-normal-revenue": "Bankpostering",
       "supplier-overview-balance-details-dialog-table-payment-type-accrued-revenue": "Tilgodehavende",
       "supplier-overview-balance-details-dialog-number-of-orders": "\n .title = Antal ordrer",
       "supplier-overview-balance-details-dialog-table-effective-total": "\n .title = Total effektivt beløb",
       "supplier-overview-balance-details-dialog-table-gross-total": "\n .title = Brutto total",
       "supplier-overview-balance-details-dialog-table-fee-total": "\n .title = Gebyr total",
       "supplier-overview-balance-details-dialog-table-net-total": "\n .title = Netto total",

        // Supplier > Admin > Merchants
        "supplier-admin-merchants-header": "\n .title = Salgssteder",
        "supplier-admin-merchants-create-button": "Opret salgssted",
        "supplier-admin-merchants-table-edit-button": "Rediger",
        "supplier-admin-merchants-table-delete-button": "Slet",
        "supplier-admin-merchants-table-delete-modal-title": "salgssted",
        "supplier-admin-merchants-table-reg-no-column": "Reg. nr.",
        "supplier-admin-merchants-table-merchant-column": "Salgssted",
        "supplier-admin-merchants-table-connected-shops": "Shops:",
        "supplier-admin-merchants-table-connected-customers": "Kunder:",
        "supplier-admin-merchants-table-connected-devices": "Hardware enheder:",
        "supplier-admin-merchant-create-title": "\n .title = Opret salgssted",
        "supplier-admin-merchant-edit-title": "\n .title = Ret salgssted",
        "supplier-admin-merchants-save-button": "Gem",
        "create-or-edit-supplier-admin-merchant-field-caseNumber": "\n .label = Reg no.\n .placeholder = Enter a Reg no.\n .helperText = Jeres interne reference nummer for dette salgssted",
        "create-or-edit-supplier-admin-merchant-field-name": "\n .label = Name\n .placeholder = Enter merchant name",
        "create-or-edit-supplier-admin-merchant-field-street": "\n .label = Street\n .placeholder = Enter street",
        "create-or-edit-supplier-admin-merchant-field-streetNumber": "\n .label = Street no\n .placeholder = Enter street no",
        "create-or-edit-supplier-admin-merchant-field-postalCode": "\n .label = Postal code\n .placeholder = Enter postal code",
        "create-or-edit-supplier-admin-merchant-field-city": "\n .label = City\n .placeholder = Enter city",
        "create-or-edit-supplier-admin-merchant-field-country": "\n .label = Country",
        "create-or-edit-supplier-admin-merchant-contact-details-title": "\n .title = Contact details",
        "create-or-edit-supplier-admin-merchant-country-denmark-item": "Denmark",
        "create-or-edit-supplier-admin-merchant-contact-details-info": "Contact details will be public for the customers.",
        "create-or-edit-supplier-admin-merchant-field-contact-details-name": "\n .label = Name\n .placeholder = Enter name",
        "create-or-edit-supplier-admin-merchant-field-contact-details-email": "\n .label = Email\n .placeholder = Enter email",
        "create-or-edit-supplier-admin-merchant-field-contact-details-phone": "\n .label = Phone number\n .placeholder = Enter phone number",
        "create-or-edit-supplier-admin-merchant-field-is-required": "Field is required",
        "create-or-edit-supplier-admin-merchant-credit-card-payments-title": "\n .title = Credit card payments",
        "create-or-edit-supplier-admin-merchant-status-approved": "Active",
        "create-or-edit-supplier-admin-merchant-status-no-registered-bank-account": "No registered bank account",
        "create-or-edit-supplier-admin-merchant-status-no-registered-bank-account-description": "Register a bank account for your acquiring agreement <retryLink>here.</retryLink>",
        "create-or-edit-supplier-admin-merchant-status-invalid": "Agreement invalid",
        "create-or-edit-supplier-admin-merchant-status-invalid-description": "Correct your application for acquiring agreement <retryLink>here.</retryLink>",
        "create-or-edit-supplier-admin-merchant-status-pending": "Agreement pending",
        "create-or-edit-supplier-admin-merchant-status-pending-description": "Wait for acquirer to finish processing your acquiring agreement application.",
        "create-or-edit-supplier-admin-merchant-status-no-payment-setup": "No payment setup",
        "create-or-edit-supplier-admin-merchant-status-no-payment-setup-description": "Setup credit card payments for this merchant to begin receiving payments.",
        "create-or-edit-supplier-admin-merchant-status-bank-account-pending": "Bank account pending",
        "create-or-edit-supplier-admin-merchant-status-bank-account-pending-description": "Wait for acquirer to finish verifying your bank account.",
        "create-or-edit-supplier-admin-merchant-acquirer": "Acquirer:",
        "create-or-edit-supplier-admin-merchant-acquirer-type-adyen-pos": "Adyen",
        "create-or-edit-supplier-admin-merchant-acquirer-type-adyen": "Adyen",
        "create-or-edit-supplier-admin-merchant-bank-details": "Bank details:",
        "create-or-edit-supplier-admin-merchant-industry-codes": "Industry codes:",
        "create-or-edit-supplier-admin-merchant-status-action-button-setup": "Setup",
        "create-or-edit-supplier-admin-merchant-status-action-button-edit": "Rediger",
        "create-or-edit-supplier-admin-merchant-dialog-title": "Credit card payment setup",
        "create-or-edit-supplier-admin-merchant-dialog-field-acquiring-agreement": "\n .label = Acquiring agreement",
        "create-or-edit-supplier-admin-merchant-dialog-field-sales-channels": "\n .label = Sales channel",
        "create-or-edit-supplier-admin-merchant-dialog-field-bank-account": "\n .label = Bank account",
        "create-or-edit-supplier-admin-merchant-dialog-field-bank-account-helper": "Select the bank account where to sales will be transfered. You will only see banks accounts which have been created in the Adyen platform. To add a new bank account see <retryLink>guide.</retryLink>",
        "create-or-edit-supplier-admin-merchant-dialog-field-industry-codes": "\n .label = Industry codes",
        "create-or-edit-supplier-admin-merchant-dialog-field-default-currency": "\n .label = Default currency",
        "create-or-edit-supplier-admin-merchant-dialog-save-button": "Gem",

        // Supplier > Admin > T&C
        "supplier-admin-settings-terms-and-conditions": "\n .title = Terms and conditions",
        "supplier-admin-settings-terms-and-conditions-create-button": "Opret",
        "supplier-admin-settings-terms-and-conditions-update-button": "Update",

        // TERMS AND CONDITIONS CREATE
        "supplier-terms-and-conditions-alert-title": "Terms and conditions",
        "supplier-terms-and-conditions-alert-subtitle1": "It is your own responsibility to ensure that the terms and conditions comply with the applicable requirements.",
        "supplier-terms-and-conditions-alert-subtitle2": "Read about Adyen's required T&C, which you must comply with <externalLink>here</externalLink>.",
        "supplier-terms-and-conditions-alert-subtitle3": "Download our T&C template: <externalLinkDA>Danish</externalLinkDA> | <externalLinkEN>English</externalLinkEN>.",
        "supplier-terms-and-conditions-dropdown-english": "English",
        "supplier-terms-and-conditions-dropdown-danish": "Danish",
        "supplier-terms-and-conditions-name-label": "\n .label = Name",
        "supplier-terms-and-conditions-language-label": "\n .label = Language",
        "supplier-terms-and-conditions-type-label": "\n .label = Type",
        "supplier-terms-and-conditions-dropdown-pos": "POS",
        "supplier-terms-and-conditions-type-ecom": "E-Commerce",
        "supplier-terms-and-conditions-aside-settings": "\n .title = Settings",
        "supplier-terms-and-conditions-aside-active": "Active: ",
        "supplier-terms-and-conditions-aside-history": "\n .title = History",
        "supplier-terms-and-conditions-aside-version": "Version: ",
        "supplier-terms-and-conditions-aside-created": "Created: ",
        "supplier-terms-and-conditions-aside-updated": "Updated: ",
        "terms-and-conditions-error-label-name": "Navn",
        "terms-and-conditions-error-label-type": "Type",
        "terms-and-conditions-error-label-language": "Language",
        "terms-and-conditions-error-label-text": "Text",

        // TERMS AND CONDITIONS TABLE GENERAL
        "terms-and-conditions-table-header-name": "Navn",
        "terms-and-conditions-table-header-language": "Language",
        "terms-and-conditions-table-header-name-type": "Type",
        "terms-and-conditions-table-header-name-status": "Status",
        "terms-and-conditions-table-button-edit":"Rediger",
        "terms-and-conditions-table-button-delete":"Slet",
        "terms-and-conditions-table-button-approval":"Approval",
        "terms-and-conditions-table-status-active":"Active",
        "terms-and-conditions-table-status-inactive":"Inactive",
        "terms-and-conditions-table-status-pending":"Pending",

        "terms-and-conditions-modal-button-delete-label": "Slet",
        "terms-and-conditions-modal-question": "Are you sure you want to delete",
        "terms-and-conditions-modal-title": "Terms and conditions",

        // Supplier > Admin > Administrators
        "supplier-users-page-header": "\n .title = Administratorer",
        "supplier-users-suppliers-tab-title": "Leverandør administratorer",
        "supplier-users-merchants-tab-title": "Salgssted administratorer",
        "supplier-users-table-merchant-column": "Salgssted",
        "supplier-users-create-admin-button": "Opret administrator",

        // Supplier > Admin > Account > Company Account
        "supplier-update-account-title":"\n .title = Supplier account",
        "supplier-update-account-update-button":"Update",
        "supplier-update-account-nav-item-home":"Home",
        "supplier-update-account-nav-item-account":"Account",
        "supplier-update-account-registration-number-label":"\n .label = Registration number",
        "supplier-update-account-error-label-registration-number":"Registration number",


        // Supplier > Admin > Account > GDPR
        "supplier-account-gdpr-title":"\n .title = GDPR",
        "supplier-account-gdpr-tab-documents":"Dokumenter",
        "supplier-account-gdpr-tab-export":"Eksport",
        "supplier-account-gdpr-export-title":"Brugereksport",
        "supplier-account-gdpr-export-info":"\n .description = Denne funktion gør det muligt at eksportere administratorer og/eller brugere fra alle administrative enheder, herunder leverandør, salgssted, virksomhed, lejer og servicecenter. For at downloade brugere fra andre administrative enheder skal du registrere et eller flere e-maildomæner, der er tilknyttet din virksomhed. Disse domæner vil blive brugt til at identificere din virksomheds brugere. Hvis din virksomhed ikke har nogen verificerede domæner, vil du ikke kunne downloade brugere fra andre enheder. For hjælp med domæneverifikation, kontakt venligst vores supportteam.",
        "supplier-account-gdpr-export-user-types-select-item-user": "Bestillere",
        "supplier-account-gdpr-export-user-types-select-item-administrator": "Administratorer",
        "supplier-account-gdpr-export-user-types-select-label":"\n .label = Brugertyper",
        "supplier-account-gdpr-export-user-types-select-input-label":"Brugertyper",
        "supplier-account-gdpr-export-user-deletion-period-select-input-label":"User deletion period",
        "supplier-account-gdpr-export-user-deletion-period-select-label":"\n .label = User deletion period",
        "supplier-account-gdpr-export-user-deletion-period-select-item-days-180":"180 days",
        "supplier-account-gdpr-export-user-deletion-period-select-item-days-90":"90 days",
        "supplier-account-gdpr-export-user-deletion-period-select-item-days-30":"30 days",
        "supplier-account-gdpr-export-user-deletion-period-select-item-days-7":"7 days",
        "supplier-account-gdpr-export-include-deleted-switch-label":" \n .label = Inkluder slettede",
        "supplier-account-gdpr-export-exported-domains-subtitle":"Domæner til eksport",
        "supplier-account-gdpr-export-no-domains-registered":"Ingen verificerede domæner for virksomheden er blevet registreret.",
        "supplier-account-gdpr-export-export-button":"Eksportér til CSV",

        // --- Support ---

        // Support > Admin > Features
        "support-admin-features-header": "\n .title = Features",
        "support-admin-features-table-header-name": "Name",
        "support-admin-features-table-header-plan": "Plan",
        "support-admin-features-table-plan-none": "None",
        "support-admin-features-table-plan-professional": "Professional",
        "support-admin-features-table-plan-enterprise": "Enterprise",
        "support-admin-features-table-header-status": "Status",
        "support-admin-features-table-header-enabled": "Enabled",
        "support-admin-features-table-action-edit": "Edit",
        "support-admin-features-status-label-new": "\n .label = NEW",
        "support-admin-features-status-label-beta": "\n .label = BETA",
        "support-admin-features-status-new": "NEW",
        "support-admin-features-status-beta": "BETA",


        // Support > Admin > Features > Edit
        "support-admin-feature-edit-header": "\n .title = Edit feature",
        "support-admin-feature-edit-save-button": "Save",
        "support-admin-feature-edit-nav-item-feature": "Edit feature",
        "support-admin-feature-edit-programmatic-id-label": "\n .label = Programmatic ID",
        "support-admin-feature-edit-name-label": "\n .label = Name",
        "support-admin-feature-edit-plan-label": "\n .label = Plan",
        "support-admin-feature-edit-status-label": "\n .label = Status",
        "support-admin-feature-edit-enabled-label": "Enabled:",
        "support-admin-feature-edit-settings-title": "\n .title = Settings",

        // Support > Admin > GDPR
        "support-nav-item-gdpr": "GDPR",
        "support-admin-gdpr-page-header": "\n .title = GDPR",
        "support-admin-gdpr-breadcrumb": "GDPR",
        "support-admin-gdpr-administrators-title": "Administratorer",
        "support-admin-gdpr-user-type-label": "\n .label = Brugertype",
        "support-admin-gdpr-user-type-select-item-merchant-admins": "Merchant administratorer",
        "support-admin-gdpr-user-type-select-item-supplier-admins": "Supplier administratorer",
        "support-admin-gdpr-user-type-select-item-company-admins": "Company administratorer",
        "support-admin-gdpr-user-type-select-item-company-agreement-owners": "Company agreement ejere",
        "support-admin-gdpr-include-active-users": "Inkluder aktive brugere",
        "support-admin-gdpr-include-inactive-users": "Inkluder inaktive brugere",
        "support-admin-gdpr-export-button": "Eksporter kontaktliste",
        "support-admin-gdpr-export-button-label": "Eksporter kontaktliste",
        "support-admin-gdpr-export-button-exporting": "Eksporterer...",

        // Support > Reports > Entities
        "support-entity-header-title" : "\n .title = Entities",
        "support-entity-header-menu-button-create": "Opret",
        "support-entity-header-menu-button-create-supplier": "Create Supplier",
        "support-entity-header-menu-button-create-merchant": "Create Merchant",
        "support-entity-header-menu-button-create-company": "Create Company",
        "support-entity-header-menu-button-create-tenant": "Create Tenant",
        "support-entity-header-nav-item-home" : "Home",
        "support-entity-header-nav-item-entities" : "Entities",
        "support-entity-table-header-id": "ID",
        "support-entity-table-header-name": "Navn",
        "support-entity-table-header-address": "Address",
        "support-entity-table-header-type": "Type",
        "support-entity-table-header-status": "Status",
        "support-entity-table-button-details": "Details",
        "support-entity-table-button-edit": "Rediger",
        "support-entity-table-button-delete": "Slet",
        "support-entity-table-status-active": "Active",
        "support-entity-table-status-inactive": "Inactive",
        "support-entity-confirm-delete-entity-dialog": "\n .typeOfEntity = entity",
        "support-entity-table-cell-name-agreement-owner": "Agreement owner",
        "support-entity-table-cell-name-reg-no": "Reg. no.:",
        "support-entity-table-type-supplier": "\n .label = Supplier",
        "support-entity-table-show-inactive": "\n .label = Show inactive",
        "support-entity-table-type-merchant": "\n .label = Salgssted",
        "support-entity-table-type-company": "\n .label = Company",
        "support-entity-table-type-tenant": "\n .label = Tenant",
        "support-entity-table-type-service-center": "\n .label = Service Center",
        "support-entity-table-type-user": "\n .label = User",
        "support-entity-details-connected-merchants": "\n .title = Connected merchants",
        "support-entity-details-connected-companies": "\n .title = Connected companies",
        "support-entity-details-connected-suppliers": "\n .title = Connected suppliers",
        "support-entity-details-connected-devices": "\n .title = Connected devices",
        "support-entity-details-id": "ID: { $id }",
        "support-entity-table-entity-type-label":"Entity Type",
        "support-entity-table-entity-type-select-item-all":"All",
        "support-entity-table-entity-type-select-item-supplier":"Supplier",
        "support-entity-table-entity-type-select-item-merchant":"Salgssted",
        "support-entity-table-entity-type-select-item-company":"Company",
        "support-entity-table-entity-type-select-item-service-center":"Service center",
        "support-create-entity-error-label-company-invalid-type":"Invalid type",
        "support-create-entity-error-label-company-type":"Type",
        "support-create-entity-error-label-system-owner":"Agreement owner",
        "support-create-entity-error-label-company-number":"Company number",
        "support-create-entity-error-label-ean-number":"EAN number",
        "support-create-entity-error-label-invoice-type":"Invoice Type",
        "support-create-entity-error-label-invoice-email":"Email",
        "support-create-entity-error-label-attention":"Attention",
        "support-create-entity-error-label-debitot-no":"Debitor number",
        "support-create-entity-error-label-reminder-email":"Email",
        "support-create-entity-error-label-po-number":"Purchase order number",
        "support-create-entity-error-label-company-name":"Company name",
        "support-create-entity-error-label-address":"Address",
        "support-create-entity-error-label-country":"Country",
        "support-create-entity-error-label-postal-code":"Postal code",
        "support-create-entity-error-label-city":"City",
        "support-create-entity-error-label-contact-person":"Contact person",
        "support-create-entity-error-label-email":"Email",
        "support-create-entity-error-label-telephone":"Telephone",
        "support-create-entity-agreement-owner-subtitle":"Agreement owner",
        "support-create-entity-ean-number-label":"\n .label = EAN number",
        "support-create-entity-address1-label":"\n .label = Address line 1 (*)\n .placeholder = Street and street number",
        "support-create-entity-address2-label":"\n .label = Address line 2\n .placeholder = Floor, apartment no., etc.",
        "support-create-entity-postal-code-label":"\n .label = Postal code (*)",
        "support-create-entity-city-label":"\n .label = City (*)",
        "support-create-entity-contact-person-label":"\n .label = Contact person (*)",
        "support-create-entity-email-label":"\n .label = Email (*)",
        "support-create-entity-telephone-label": "\n .label = Telephone (*)",
        "support-create-entity-type-choose-label":"\n .label = Choose(*)",
        "support-create-entity-dropdown-choose-yes":"Yes",
        "support-create-entity-dropdown-choose-no":"No",
        "support-create-entity-alert-title":"\n .title = An agreement owner owns the agreement with FacilityNet and will receive related invoices. For this reason we need invoice details for agreement owners.",
        "support-create-entity-subscription-details-subtitle": "Subscription details",
        "support-create-entity-subscription-details-field-implementationDeadline": "\n .label = Deadline for implementation *",
        "support-create-entity-subscription-details-alert-title": "\n .title = This is the date by which the customer wants the system to go into production. This means onboarding, internal testing and any trial period must be completed before this date.",
        "support-create-entity-contact-details-subtitle":"Contact details",
        "support-create-entity-invoice-details-subtitle":"Invoice details",
        "support-create-entity-send-invoice-to-label":"\n .label = Send invoice to",
        "support-create-entity-dropdown-ean-number":"EAN number",
        "support-create-entity-dropdown-email":"Email",
        "support-create-entity-debitor-number-label":"\n .label = Debitor Number (*)\n .helperText = This identifies the debtor in FacilityNet accounting system.",
        "support-create-entity-invoice-email-label":"\n .label = Email (*)",
        "support-create-entity-attention-label":"\n .label = Attention (*)",
        "support-create-entity-reminder-email-label":"\n .label = Email for reminders / account statements",
        "support-create-entity-po-number-label":"\n .label = Purchase order number",
        "support-create-entity-type-label":"\n .label = Type",
        "support-create-entity-country-label":"\n .label = Country (*)",
        "support-create-entity-dropdown-country-denmark":"Denmark",
        "support-create-entity-dropdown-private-company":"Private company",
        "support-create-entity-dropdown-private-person":"Private person",
        "support-create-entity-dropdown-public-limited-company":"Public limited company",
        "support-create-entity-aside-history": "\n .title = History",
        "support-create-entity-aside-version": "Version:",
        "support-create-entity-aside-created": "Created:",
        "support-create-entity-aside-updated": "Updated:",

        // Invoicing
        "support-reports-basis-for-invoicing-page-header": "\n .title = Basis for invoicing",
        "support-reports-invoicing-header-nav-item": "Invoicing",
        "support-reports-invoicing-header-nav-item-basis-for-invoicing": "Basis for invoicing",
        "support-reports-invoicing-table-debtor-label": "\n .label = Debtor",
        "support-reports-invoicing-table-header-product-no": "Product no.",
        "support-reports-invoicing-table-header-name": "Navn",
        "support-reports-invoicing-table-header-price": "Price",
        "support-reports-invoicing-table-header-items": "Items",
        "support-reports-invoicing-table-header-total": "Total",
        "support-reports-invoicing-table-bottom-transactions": "Transactions",
        "support-reports-invoicing-table-bottom-subscriptions": "Subscriptions",
        "support-reports-invoicing-table-bottom-total": "Total",

        // Support > Reports > Health > Server Memory
        "support-reports-health-server-memory-page-header": "\n .title = Server memory",
        "support-reports-health-server-memory-table-header-memory-type": "Memory type",
        "support-reports-health-server-memory-table-header-used": "Used",
        "support-reports-health-server-memory-table-header-commited": "Commited",
        "support-reports-health-server-memory-table-header-max": "Max",

        // Support > Reports > Health > Scheduler
        "support-reports-health-scheduler-page-header": "\n .title = Scheduler",
        "support-reports-health-scheduler-page-subtitle-main-job": "Main job:",
        "support-reports-health-scheduler-page-subtitle-load-in-seconds": "Load in seconds:",
        "support-reports-health-scheduler-table-header-name": "Name",
        "support-reports-health-scheduler-table-header-cron": "Cron",
        "support-reports-health-scheduler-table-header-last-run": "Last run",
        "support-reports-health-scheduler-table-header-next-run": "Next run",
        "support-reports-health-scheduler-table-header-status": "Status",
        "support-reports-health-scheduler-table-status-active": "Active",
        "support-reports-health-scheduler-table-status-inactive": "Inactive",
        "support-reports-health-scheduler-table-status-paused": "Paused",
        "support-reports-health-scheduler-table-action-edit": "Edit",
        "support-reports-health-scheduler-table-action-pause": "Pause",
        "support-reports-health-scheduler-table-action-start": "Start",
        "support-reports-health-scheduler-table-action-stop": "Stop",

        // Support > Reports > Health > Scheduler > Edit Job
        "support-reports-health-schedule-edit-page-header": "\n .title = Edit scheduler job",
        "support-reports-health-schedule-edit-page-nav-item-edit-job":"Edit Job",
        "support-reports-health-schedule-edit-page-edit-button":"Edit",
        "support-reports-health-schedule-edit-page-start-time-label":"\n .label = Start time",
        "support-reports-health-schedule-edit-page-cron-expression-label":"\n .label = Cron expression",
        "support-reports-health-schedule-edit-page-settings-title":"\n .title = Settings",
        "support-reports-health-schedule-edit-page-settings-active-label":"Active:",
        "support-reports-health-schedule-edit-page-information-title":"\n .title = Information",
        "support-reports-health-schedule-edit-page-information-id":"ID:",
        "support-reports-health-schedule-edit-page-information-name":"Name:",
        "support-reports-health-schedule-edit-page-information-last-run":"Last run:",

        // Support > Reports > Health > Database health
        "support-reports-health-database-page-header": "\n .title = Database health",

        // Support > Reports > Health > Adyen
        "support-reports-health-adyen-page-header": "\n .title = Adyen",
        "support-reports-health-adyen-tab-summary": "Summary",
        "support-reports-health-adyen-tab-account-holders": "Account Holders",
        'support-reports-health-adyen-run-button':"Run",
        'support-reports-health-adyen-results':"Results:",
        'support-reports-health-adyen-api-status-unknown':"Unknown",
        'support-reports-health-adyen-api-status-ok':"Ok",
        'support-reports-health-adyen-api-status-failed':"Failed",
        'support-reports-health-adyen-summary-aside-title':"API connection test",
        'support-reports-health-adyen-summary-last-run':"Last run: {$lastRun}",
        'support-reports-health-adyen-summary-legal-entity-management':"Legal Entity Management:",
        'support-reports-health-adyen-summary-balance-platform':"Balance Platform:",
        'support-reports-health-adyen-summary-psp-platform':"PSP Platform:",
        'support-reports-health-adyen-summary-main-title':"Terminal cheatsheet",
        'support-reports-health-adyen-summary-terminal-key':"Key",
        'support-reports-health-adyen-summary-terminal-function':"Function",
        'support-reports-health-adyen-summary-terminal-key-cancel':"Cancel",
        'support-reports-health-adyen-summary-terminal-key-clear':"Clear",
        'support-reports-health-adyen-summary-terminal-key-confirm':"Confirm",
        'support-reports-health-adyen-summary-terminal-press-1':"Press 1 +",
        'support-reports-health-adyen-summary-terminal-press-5':"Press 5 +",
        'support-reports-health-adyen-summary-terminal-press-8':"Press 8 +",
        'support-reports-health-adyen-summary-terminal-press-9':"Press 9 +",
        'support-reports-health-adyen-summary-terminal-function-custom-menu':"Custom menu",
        'support-reports-health-adyen-summary-terminal-function-informational-menu':"Informational menu",
        'support-reports-health-adyen-summary-terminal-function-payments-menu':"Payments menu",
        'support-reports-health-adyen-summary-terminal-function-admin-menu':"Admin menu",


        // Support > Reports > Health > Adyen > Account Holders
        "adyen-account-holders-table-header-id": "ID",
        "adyen-account-holders-table-cell-entity-id": "Legal entity ID: {$entityId}",
        "adyen-account-holders-table-cell-entity-liable": "Liable",
        "adyen-account-holders-table-details-balance-accounts": "Balance accounts:",
        "adyen-account-holders-table-details-stores": "Stores:",
        "adyen-account-holders-table-header-supplier": "Supplier",
        "adyen-account-holders-table-header-status": "Status",
        "adyen-account-holders-table-header-status-valid": "Valid",
        "adyen-account-holders-table-header-status-invalid": "Invalid",
        "adyen-account-holders-table-header-status-pending": "Pending",
        "adyen-account-holders-table-header-updated": "Updated",

        // Support > TopBar > Awaiting approval
        "awaiting-approval-popover-not-approved-item": "\n .title = Til godkendelse\n .description = Ordrer, der skal godkendes",
        "awaiting-approval-popover-to-be-booked-item": "\n .title = Til fakturering\n .description = Mødeforplejningsordrer, der har været fakturerbare i 3+ dage",
        "awaiting-approval-popover-tooltip": "\n .title = Ordrenotifikationer",
        "awaiting-approval-popover-section-meeting-service-title": "\n .title = Mødeforplejning",
        "awaiting-approval-popover-section-takeaway-title": "\n .title = Takeaway",
        "awaiting-approval-popover-todays-orders-item": "\n .title = Dagens ordrer\n .description = Mødeforplejningsordrer til levering i dag",
        "awaiting-approval-popover-todays-takeaway-orders-item": "\n .title = Dagens ordrer\n .description = Takeaway ordrer for i dag",

        // Support > TopBar > Instructions Dialog
        "support-instructions-dialog-title": "Instructions",
        "support-instructions-button": "Instructions",

        // Non Admin User > TopBar > Create new
        "user-create-new-menu-order-for-another-user-title": "Order on behalf of another user",
        "user-create-new-menu-order-for-another-user-subtitle": "Create a resource booking or meeting service order on behalf of another user",

        // TopBar > New button > menu
        "top-bar-new-button": "Ny",
        "top-bar-new-menu-resource-booking-title": "Ressourcebooking",
        "top-bar-new-menu-resource-booking-description": "Book lokaler og andre ressourcer",
        "top-bar-new-menu-meeting-service-title": "Mødeforplejning",
        "top-bar-new-menu-meeting-service-description": "Bestil mødeforplejning",
        "top-bar-new-menu-take-away-title": "Takeaway",
        "top-bar-new-menu-take-away-description": "Køb takeaway og andre varer",
        "top-bar-new-menu-make-purchase-title": "Foretag et køb",
        "top-bar-new-menu-make-purchase-description": "Bestil frokost i kantinen",
        "top-bar-new-menu-refill-wallet-title": "Genopfyld wallet",
        "top-bar-new-menu-refill-wallet-description": "Fyld penge på din digitale wallet",
        "top-bar-new-menu-push-message-title": "Push-besked",
        "top-bar-new-menu-push-message-dialog-title": "Ny push-besked",
        "top-bar-new-menu-push-message-description": 'Send beskeder til dine kunder',


        // ---  Support Reports --- Messages > Email
        "support-messages-email-title": "\n .title = Email",
        "support-messages-email-subject-label":"\n .label = Email subject",
        "support-messages-email-receiver-label":"\n .label = Receiver \n .placeholder = Enter email or user id",
        "support-messages-email-table-header-receiver":"Receiver",
        "support-messages-email-table-header-subject":"Subject",
        "support-messages-email-table-header-sent-time":"Sent time",
        "support-messages-email-table-header-status":"Status",
        "support-messages-email-table-status-sent":"Sent",
        "support-messages-email-table-status-not-sent":"Not sent",
        "support-messages-email-table-cell-subject-created":"Created: { $time }",
        "support-messages-email-resend-button":"Resend",
        "support-messages-email-export-button":"Eksport",
        "support-messages-email-details-status-label":"Status:",
        "support-messages-email-details-created-label":"Created:",
        "support-messages-email-details-sent-time-label":"Sent time:",
        "support-messages-email-details-error-message-label":"Error message:",
        "support-messages-email-details-from-label":"From:",
        "support-messages-email-details-subject-label":"Subject:",
        "support-messages-email-details-to-label":"To:",
        "support-messages-email-details-cc-label":"CC:",
        "support-messages-email-details-bcc-label":"BCC:",
        "support-messages-email-details-resend-email-button":"Resend email",
        "support-messages-email-details-resend-email-title":"Resend email",
        "support-messages-email-details-sent-button":"Sent",
        "support-messages-email-resent-dialog-title":"Confirm to resend emails",
        "support-messages-email-resent-dialog-subtitle":"Are you sure you want to resend { $itemsAmount } emails?",
        "support-messages-email-resent-dialog-cancel-button":"No",
        "support-messages-email-resent-dialog-submit-button":"Yes",


        // ---  Support Reports --- Messages > SMS
        "support-messages-sms-title": "\n .title = SMS",
        "support-messages-sms-receiver-label":"\n .label = Receiver",
        "support-messages-sms-text-body-label":"\n .label = Text body",
        "support-messages-sms-table-header-receiver":"Receiver",
        "support-messages-sms-table-header-created":"Created",
        "support-messages-sms-table-header-sent":"Sent",
        "support-messages-sms-table-header-status":"Status",
        "support-messages-sms-table-status-sent":"Sent",
        "support-messages-sms-table-status-not-sent":"Not sent",
        "support-messages-sms-export-button":"Eksport",
        "support-messages-sms-details-status-label":"Status:",
        "support-messages-sms-details-id-label":"id:",
        "support-messages-sms-details-created-label":"Created:",
        "support-messages-sms-details-sent-time-label":"Sent time:",
        "support-messages-sms-details-error-message-label":"Error message:",
        "support-messages-sms-details-text-message-label":"Text message:",
        "support-messages-sms-details-from-label":"From:",
        "support-messages-sms-details-to-label":"To:",



         // ---  Support Reports --- Accounting > Subscriptions
        "support-subscriptions-header": "\n .title = Subscriptions",
        "support-subscriptions-table-order-id-column": "Ordre ID",
        "support-subscriptions-table-employee-column": "Medarbejder",
        "support-subscriptions-table-subscribed-column": "Tilmeldt",
        "support-subscriptions-table-unsubscribed-column": "Frameldt",
        "support-subscriptions-table-payment-column": "Payment",
        "support-subscriptions-table-amount-column": "Beløb",
        "support-subscriptions-table-cancel-subscription": "Cancel subscription",
        "support-subscriptions-table-details": "Details",
        "support-subscriptions-table-filters-merchant-title":"\n .title = Salgssted",
        "support-subscriptions-table-filters-customer-title":"\n .title = Customer",
        "support-subscriptions-table-filters-payment-title":"\n .title = Payment",

        // ---  Support Reports --- Accounting > Meeting Service
        "support-accounting-meeting-service-header": "\n .title = Meeting Service",
        "support-accounting-meeting-service-table-order-id-column": "Ordre ID",
        "support-accounting-meeting-service-table-booked-date-column": "Bogføringsdato",
        "support-accounting-meeting-service-table-delivery-time-column": "Leveringstid",
        "support-accounting-meeting-service-table-employee-column": "Bestiller",
        "support-accounting-meeting-service-table-status":"Status",
        "support-accounting-meeting-service-table-amount-column": "Beløb (DKK)",
        "support-accounting-meeting-service-table-show-receipt": "Show receipt",
        "support-accounting-meeting-service-table-floating-action-bar-export": "\n .title = Export",

        // ---  Support Reports --> Printer Queue
        "support-printer-queue-title": "\n .title = Printer Queue",
        "support-printer-queue-merchant-label":"\n .label = Salgssted",
        "support-printer-queue-order-id-label":"\n .label = Ordre ID",
        "support-printer-queue-table-header-id":"Id",
        "support-printer-queue-table-header-created":"Created",
        "support-printer-queue-table-header-print-at":"Print at",
        "support-printer-queue-table-header-device-name":"Device name",
        "support-printer-queue-table-header-order-id":"Ordre ID",
        "support-printer-queue-table-header-status":"Status",
        "support-printer-queue-table-device-group":" Group: ",
        "support-printer-queue-table-status-printed":"Printed",
        "support-printer-queue-table-status-queue":"Queue",
        "support-printer-queue-table-raw-receipt-action":"Raw receipt",
        "support-printer-details-status-label":"Status:",
        "support-printer-details-created-label":"Created:",
        "support-printer-details-printed-at-label":"Printed at:",
        "support-printer-details-device-group-subtitle":"Device group:",
        "support-printer-details-device-subtitle":"Device:",
        "support-printer-details-id-label":"ID:",
        "support-printer-details-name-label":"Name:",
        "support-printer-details-mime-type-label":"Mime type:",
        "support-printer-details-priority-label":"Priority:",
        "support-printer-details-job-token-label":"Job token:",

        // ---  Support Reports --- Orders > POS
        "support-orders-pos-title": "\n .title = POS",
        "support-orders-pos-order-id-label":"\n .label = Ordre ID",
        "support-orders-pos-email-label":"\n .label = Email",
        "support-orders-pos-table-header-order-id":"Ordre ID",
        "support-orders-pos-table-header-transaction-time":"Transaktionstid",
        "support-orders-pos-table-header-customer":"Customer",
        "support-orders-pos-table-header-merchant":"Salgssted",
        "support-orders-pos-table-header-amount":"Beløb",
        "support-orders-pos-table-action-show-receipt":"Show receipt",
        "support-orders-pos-table-action-show-order-details":"Show order details",


        // --- Support entity---
        "support-create-supplier-title": "\n .title = Create supplier",
        "support-update-supplier-title": "\n .title = Update supplier",
        "support-create-supplier-create-button": "Opret",
        "support-create-supplier-update-button": "Update",
        "support-create-supplier-nav-item-home": "Home",
        "support-create-supplier-nav-item-entities": "Entities",
        "support-create-supplier-nav-item-create-supplier": "Create supplier",
        "support-create-supplier-nav-item-update-supplier": "Update supplier",
        "support-create-supplier-aside-settings": "\n .title = Settings",
        "support-create-supplier-aside-active": "Active:",
        "support-create-supplier-company-number-label":"\n .label = Company number",
        "support-create-supplier-company-name-label":"\n .label = Company name",
        "support-create-subscription-status-title": "\n .title = Subscription status",
        "support-create-supplier-subscription-status": "Status",
        "support-create-supplier-subscription-status-mode-creating": "Creating",
        "support-create-supplier-subscription-status-mode-onboarding": "Onboarding",
        "support-create-supplier-subscription-status-mode-trial": "Trial",
        "support-create-supplier-subscription-status-mode-live": "LIVE",
        "support-create-supplier-subscription-status-mode-unsubscribing": "Unsubscribing",
        "support-create-supplier-subscription-status-mode-unsubscribed": "Unsubscribed",
        "support-create-supplier-subscription-status-created": "Created",
        "support-create-supplier-subscription-status-implementation-deadline": "Implementation deadline",
        "support-create-supplier-subscription-status-onboarding-email-sent": "Onboarding email sent",
        "support-create-supplier-subscription-status-trial-started": "Trial started",
        "support-create-supplier-subscription-status-subscription-started": "Subscription started",
        "support-create-supplier-subscription-status-subscription-ending": "Subscription ending",
        "support-create-supplier-subscription-status-button-mode-creating": "Send onboarding articles",
        "support-create-supplier-subscription-status-button-mode-onboarding": "Complete onboarding",
        "support-create-supplier-subscription-status-button-mode-trial": "Go live",
        "support-create-supplier-subscription-status-button-mode-live": "End subscription",
        "support-create-supplier-subscription-status-button-mode-unsubscribing": "Rediger",
        "support-create-supplier-subscription-status-button-mode-unsubscribed": "Rediger",
        "support-create-supplier-subscription-status-begin-onboarding-dialog": "Begin onboarding",
        "support-create-supplier-subscription-status-begin-onboarding-dialog-articles-to-send": "Articles to send",
        "support-create-supplier-subscription-status-begin-onboarding-dialog-destination": "Destination",
        "support-create-supplier-subscription-status-begin-onboarding-dialog-button-next": "Next",
        "support-create-supplier-subscription-status-begin-onboarding-dialog-existing-administrators": "Existing administrators",
        "support-create-supplier-subscription-status-begin-onboarding-dialog-extra-receivers": "Extra receivers",
        "support-create-supplier-subscription-status-begin-onboarding-dialog-button-begin": "Begin",
        "support-create-supplier-subscription-status-begin-onboarding-dialog-supplier-admin": "Supplier admin: {$adminDetails}",
        "support-create-supplier-subscription-status-begin-onboarding-dialog-kitchen-admin": "Kitchen admin: {$adminDetails}",
        "support-create-supplier-subscription-status-begin-onboarding-dialog-label-email": "\n .label = Email \n .placeholder = Receiver email",
        "support-create-supplier-subscription-status-begin-onboarding-dialog-button-add": "Tilføj",
        "support-create-supplier-subscription-status-begin-onboarding-dialog-email-error": "Ugyldig e-mailadresse",
        "support-create-supplier-subscription-status-begin-onboarding-dialog-administrators-error": "At least one administrator must be selected",


        // --- Support company ---
        "support-create-company-title": "\n .title = Create company",
        "support-update-company-title": "\n .title = Update company",
        "support-create-company-create-button": "Opret",
        "support-create-company-update-button": "Update",
        "support-create-company-nav-item-home": "Home",
        "support-create-company-nav-item-entities": "Entities",
        "support-create-company-nav-item-create-company": "Create company",
        "support-create-company-nav-item-update-company": "Update company",
        "support-create-company-aside-settings": "\n .title = Settings",
        "support-create-company-aside-active": "Active:",
        "support-create-company-office-hotel-label":"Office hotel:",
        "support-create-company-office-hotel-helper-text":"Helper text",
        "support-create-company-company-number-label":"\n .label = Company number",
        "support-create-company-main-ean-number-label":"\n .label = Main EAN number",
        "support-create-company-company-name-label":"\n .label = Company name",
        "support-create-company-error-label-main-ean-number":"Main Ean Number",
        "support-create-company-error-label-url-identifier":"Url identifier",
        "support-create-company-aside-is-self-sign-up":"\n .title = Self sign-up",
        "support-create-company-url-identifier-label":"\n .label = Signup URL identifier\n .helperText = This is used for generating the user signup URL.",
        "support-create-company-signup-link-subtitle":"Signup link:",

        // Navigation
        "support-nav-item-devices": "Devices",

        // Support ADMIN DEVICES
        "support-admin-nav-item-devices": "Devices",
        "support-admin-entities-card-group": "\n .title = Entities",
        "support-admin-entities-card": "\n .title = Entities\n .description = Administrer entiteter i systemet, såsom leverandører, salgssteder og firmaer.",
        "support-admin-devices-page-header": "\n .title = Devices",
        "support-table-header-supplier": "Supplier",
        "support-table-header-merchant": "Salgssted",

        // Access
        "support-nav-item-home": "Hjem",
        "support-nav-item-supplier-access": "Kantineforpagtere",
        "support-nav-item-merchant-access": "Kantiner",
        "support-nav-item-entities-access": "Entities",
        "support-nav-item-features": "Features",
        "support-nav-item-invoicing": "\n .title = Invoicing",
        "support-nav-item-invoicing-basis-for-invoicing": "Basis for invoicing",
        "support-nav-item-health-title": "\n .title = Health",
        "support-nav-item-health": "Health",
        "support-nav-item-health-database": "Database health",
        "support-nav-item-health-server-memory": "Server memory",
        "support-nav-item-health-scheduler": "Scheduler",
        "support-nav-item-health-adyen": "Adyen",

        "support-supplier-access-page-header": "\n .title = Kantineforpagtere",
        "support-merchant-access-page-header": "\n .title = Kantiner",
        "support-nav-item-messages": "\n .title = Messages",
        "support-nav-item-orders-title": "\n .title = Orders",
        "support-nav-item-orders": "Orders",
        "support-nav-item-orders-pos": "POS",
        "support-nav-item-accounting-title": "\n .title = Accounting",
        "support-nav-item-accounting": "Accounting",
        "support-nav-item-subscriptions": "Subscriptions",
        "support-nav-item-accounting-meeting-service": "Mødeforplejning",
        "support-nav-item-email": "Email",
        "support-nav-item-sms": "SMS",
        "support-nav-item-printer-queue": "Printer queue",


        // Page header
        "page-header-help-text": "Hjælpeguides",
        "page-header-help-status-mode-new": "Ny",
        "page-header-help-status-mode-beta": "Beta",
        "page-header-help-maintenance": "Beklager, siden er i øjeblikket utilgængelig, da den er under vedligeholdelse.",


        // YUP validation
        "validation-title-required": "Titel er påkrævet",
        "validation-body-required": "Skal udfyldes",
        "validation-type-required": "Type er påkrævet",




        // Common
        "employee-id": "Medarbejderid",
        "id": "id",
        "name": "Navn",
        "price": "Price",
        "email": "Email",
        "amount": "Beløb",
        "for": "for",
        "yes": "Ja",
        "no": "nej",
        "status": "Status",
        "active": "Aktiv",
        "inactive": "Inaktiv",
        "edit": "Rediger",
        "delete": "Slet",
        "create": "Opret",
        "save": "Gem",
        "required-field": "Dette felt er påkrævet",
        "invalid-email": "Ugyldig e-mailadresse",

        // History block
        "history-card": "\n .title = Historik",
        "history-created": "Oprettet:",
        "history-edited": "Sidst ændret:",

        // Production order
        "production-order-status-received": "Modtaget",
        "production-order-status-confirmed": "Bekræftet",
        "production-order-status-cancelled": "Cancelled",
        "production-order-status-ready": "Klar",
        "production-order-number": "ID",
        "production-order-status": "Status",
        "production-order-payment-status": "Betalingsmetode",
        "production-order-payment-channel": "Kanal",
        "production-order-time": "Tid",
        "production-order-delivery-time": "Leveringstid",
        "production-order-placeholder-comment": "Kommentar til kunden",
        "production-order-show-cancelled": "Vis annulleret",

        // Pos order
        "pos-order-delivery-date-title": "Leveringsliste - takeaway",
        "pos-order-delivery-date": "\n .label =  Leveringsdato:",
        "pos-order-purchase-time": "\n .label =  Købstid:",
        "pos-order-customer": "\n .label =  Kunde:",

        // Merchant > Reports > Production > Meeting service
        "meeting-service-table-approved-orders": "Approved orders",
        "meeting-service-table-unapproved-orders": "\n .label = Unapproved orders",
        "meeting-service-table-time": "Time",
        "meeting-service-table-start-date": "Start Date",
        "meeting-service-table-end-date": "End Date",
        "meeting-service-table-delivery-type": "Leveringstype",
        "delivery-type-filter-all": "Alle",
        "delivery-type-filter-delivery": "Levering",
        "delivery-type-filter-pick-up": "Afhentning",
        "delivery-type-filter-eating-in-canteen": "Spisning i kantinen",
        "meeting-service-table-order-id-column": "Ordre ID",
        "meeting-service-table-delivery-time-column": "Leveringstid",
        "meeting-service-table-delivery-location-column": "Møde",
        "meeting-service-table-meeting-name-column": "Meeting name",
        "meeting-service-table-location-column": "Location",
        "meeting-service-table-amount-column": "Beløb",
        "meeting-service-table-changes-column": "Changes",
        "meeting-service-table-changes-column-tooltip-changed": "\n .title = The order has been changed on {$date}",
        "meeting-service-table-changes-column-tooltip-unchanged": "\n .title = The order has not been changed",
        "meeting-service-table-changes-column-active-filter-yes": "Active",
        "meeting-service-table-changes-column-inactive-filter-no": "Inactive",
        "meeting-service-table-lock-column": "Lås",
        "meeting-service-table-lock-column-tooltip-open": "\n .title = The order is open for changes",
        "meeting-service-table-lock-column-tooltip-closed": "\n .title = The order is locked for changes",
        "meeting-service-table-lock-column-lock-tooltip": "\n .title = Blokér for at bestiller kan ændre denne ordre",
        "meeting-service-table-lock-column-unlock-tooltip": "\n .title = Tillad bestiller at ændre denne ordre",
        "meeting-service-table-lock-column-active-filter-yes": "Active",
        "meeting-service-table-lock-column-inactive-filter-no": "Inactive",
        "meeting-service-table-meeting": "Delivery: {$locationName}",
        "meeting-service-table-production-slip-button": "Følgeseddel",
        "meeting-service-table-credit-note-button": "Kreditnota",
        "meeting-service-table-receipt-button": "Kvittering",
        "meeting-service-table-update-button": "Rediger",
        "meeting-service-table-duplicate-button": "Duplikér",
        "meeting-service-table-book-button": "Bogfør",
        "meeting-service-table-send-message-button": "Send besked",
        "meeting-service-table-delete-button": "Slet",
        "meeting-service-table-date-range-filter": "Datointerval",
        "meeting-service-table-floating-action-bar-read": "\n .title = Læst",
        "meeting-service-table-floating-action-bar-lock-unlock": "\n .title = Lås/oplås",
        "meeting-service-table-floating-action-bar-lock": "\n .title = Lås",
        "meeting-service-table-floating-action-bar-lock-tooltip": "\n .title = Blokér for at bestiller kan ændre valgte ordrer",
        "meeting-service-table-floating-action-bar-unlock": "\n .title = Oplås",
        "meeting-service-table-floating-action-bar-unlock-tooltip": "\n .title = Tillad bestiller at ændre valgte ordrer",
        "meeting-service-table-floating-action-bar-book": "\n .title = Bogfør",
        "meeting-service-table-floating-action-bar-status": "\n .title = Status",
        "meeting-service-table-floating-action-bar-delete": "\n .title = Slet",
        "meeting-service-table-floating-action-bar-print": "\n .title = Udskriv",
        "meeting-service-table-floating-action-bar-production-slip": "\n .title = Følgeseddel",
        "meeting-service-table-floating-action-bar-delivery-list": "\n .title = Leveringsliste",
        "meeting-service-table-floating-action-bar-receipt": "\n .title = Kvittering",
        "meeting-service-table-floating-action-bar-export": "\n .title = Eksporter valgte",
        "meeting-service-table-toolbar-export-all": "Eksporter alle",
        "meeting-service-delete-orders-title": "Slet ordrer",
        "meeting-service-delete-order-title": "Slet ordre",
        "meeting-service-delete-orders-checkbox-label-meeting-service": "\n .label = Mødeforplejning",
        "meeting-service-delete-orders-checkbox-label-booking": "\n .label = Cancel resource booking",
        "meeting-service-delete-orders-checkbox-label-booking-lock": "Cancel resource booking",
        "meeting-service-delete-orders-checkbox-label-meeting-service-cancel": "\n .label = Cancel meeting service",
        "meeting-service-delete-orders-checkbox-label-meeting-service-cancel-lock": "Cancel meeting service",
        "meeting-service-delete-orders-helper-merchant-cancellation-field": `.label = Cancellation message \n .placeholder = Write a reason for cancellation. This message will be sent to the customer. \n .helperText = Remaining characters: { $charsRemaining }`,
        "meeting-service-delete-orders-helper-merchant": "Note: If a resource booking is attached to the meeting service order, it will not be canceled.",
        "meeting-service-delete-orders-helper-line-one": "OBS: If a resource booking is attached to the meeting service order, you can cancel the resource booking on behalf of the creator.",
        "meeting-service-delete-orders-helper-line-two": "Be aware that if you cancel the resource booking, a possible reservation of rooms and associated AV equipment is also canceled and released to other users.",
        "meeting-service-table-order-name-column": "Order name",
        "meeting-service-book-orders-title": "Book orders",
        "meeting-service-book-orders-description": "Orders labeled 'Future' cannot be processed as the delivery date is set for a future date. For orders labeled 'Cash,' please ensure a payment date is specified for the day of payment receipt.",
        "meeting-service-table-status-column": "Status",
        "meeting-service-table-cash-payment-received-column": "Cash payment received",
        "meeting-service-book-orders-subtotal": "Subtotal",
        "meeting-service-book-orders-button": "Book",
        "meeting-service-delete-orders-button": "Slet",
        "merchant-home-meeting-service-awaiting-approval-title": "Til godkendelse",
        "filter-menu-accordion-order-status-title": "\n .title = Order Status",
        "filter-menu-accordion-companies-title": "\n .title = Companies",
        "filter-menu-accordion-checkbox-awaiting-approval": "\n .optionLabel = Til godkendelse",
        "filter-menu-accordion-checkbox-to-be-invoiced": "\n .optionLabel = To be invoiced",
        "meeting-service-table-header-date-range-button": "Datointerval",
        "meeting-service-table-header-period-picker-button": "Periodevælger",
        "meeting-service-table-lock-column-locked":"\n .title = The order has been locked by the merchant. Contact merchant for updates.",
        "meeting-service-snackbar-undo": "UNDO",
        "meeting-service-snackbar-undo-message": "{ $amount ->\n  [one] { $amount } ordre er blevet \n *[other] { $amount } ordrer er blevet \n}",
        "meeting-service-delivery-list": "Leveringsliste",
        "meeting-service-delivery-list-period": "Periode:<dateRange>{$startLabel} - {$endLabel}</dateRange><icon />",
        "meeting-service-delivery-list-header-period": "Periode: {$startLabel} - {$endLabel}",
        "meeting-service-delivery-list-orders-selected": "Ordrer: {$ordersLength} valgt",
         "meeting-service-delivery-list-group-by-label": "Gruppér efter:",
        "meeting-service-delivery-list-group-by-location": "Leveringssted",
        "meeting-service-delivery-list-group-by-time": "Leveringstid",
        "meeting-service-delivery-list-group-by-item": "Group by: delivery {$value}",
        "meeting-service-delivery-list-delivery": "Leveringstype:<value>{$value}</value>",
        "meeting-service-delivery-list-filter-all": "Alle",
        "meeting-service-delivery-list-empty": "Ingen leveringsordrer for de valgte kriterier",
        "meeting-service-delivery-list-delivery-details-meeting-time": "\n .label = Mødetid:",
        "meeting-service-delivery-list-delivery-details-location": "\n .label = Leveringssted:",
        "meeting-service-delivery-list-delivery-details-sittings": "\n .label = Siddepladser:",
        "meeting-service-delivery-list-contact-details-meeting-creator": "Oprettet af:",
        "meeting-service-delivery-list-contact-details-meeting-host": "Mødeansvarlig:",
        "meeting-service-delivery-list-table-column-items": "Antal",
        "meeting-service-delivery-list-table-column-products": "Produkter",
        "meeting-service-delivery-list-table-column-delivery-time": "Leveringstid",

        // Batch modal
        "meeting-service-batch-modal-button-change-label": "Confirm",
        "meeting-service-batch-modal-button-close-label": "Close",
        "meeting-service-batch-modal-button-close-tooltip-label": "\n .label = No orders can change status",
        "meeting-service-batch-modal-warning-message": "Could not change status for orders with this icon",
        "meeting-service-batch-modal-cancellation-reason-message": "Write a reason for the cancellation. This message will be sent out to everyone on the list.",
        "meeting-service-batch-modal-customer-message": "Message to customer",
        "meeting-service-batch-modal-order-id": "Order ID",
        "meeting-service-batch-modal-delivery-time": "Delivery time",
        "meeting-service-batch-modal-order-details": "Order details",
        "meeting-service-batch-modal-from": "From",
        "meeting-service-batch-modal-to": "To",
        "meeting-service-batch-modal-batch-error": "{ $ordersCount ->\n  [one] Could not change status for { $ordersCount } order\n *[other] Could not change status for { $ordersCount } orders\n}",

        // Package slip handle PDF open
        "meeting-service-handle-pdf-open-error": "Couldn't open pdf",

        // Merchant > Reports > Production > Calendar
        "orders-for-calendar-multi-select": "\n .label = Shop type",
        "orders-for-calendar-search": "\n .label = Search \n .placeholder = Search for order id or order name",
        "production-slip-dialog-title": "Følgeseddel",
        "production-slip-dialog-table-header-items": "Antal",
        "production-slip-dialog-table-header-products": "Produkter",
        "production-slip-dialog-table-header-delivery-time": "Leveringstid",
        "production-slip-dialog-note": "Ordrenotat",
        "production-slip-dialog-order-id": "Ordre-ID: { $orderId }",
        "production-slip-dialog-delivery-details": "Leveringsdetaljer",
        "production-slip-dialog-delivery-type": "Leveringstype:",
        "production-slip-dialog-delivery-time": "Leveringstidspunkt:",
        "production-slip-dialog-delivery-meeting-time": "Mødetidspunkt:",
        "production-slip-dialog-delivery-delivery-location": "Leveringssted:",
        "production-slip-dialog-delivery-sittings": "Kuverter:",
        "production-slip-dialog-delivery-shop": "Butik:",
        "production-slip-dialog-contact-details": "Kontaktoplysninger",
        "production-slip-dialog-contact-details-creator": "Bestiller:",
        "production-slip-dialog-contact-details-meeting-host": "Mødevært:",
        "production-slip-dialog-scan": "Se følgeseddel på mobilenhed",

        // Accounting customer
        "customer-accounting-show-customers-with-sales-only": "Vis kun kunder med salg",


        // FloatingActionButton
        "floating-action-button": "Luk",
        "floating-action-button-picked": "Valgte emner",
        "floating-action-button-order-status": "\n .title = Status",
        "floating-action-button-order-status-menu-item": "Skift ordrestatus",
        "floating-action-button-receipt": "Kvittering",
        "floating-action-button-print": "\n .title = Print",
        "floating-action-button-print-receipt": "\n .title = Print receipt",
        "floating-action-button-print-label": "\n .title = Print label",
        "floating-action-button-export": "\n .title = Eksport",

        //ChangeOrderStatusModal
        "change-order-status": "Skift ordrestatus",
        "change-order-status-received": "Modtaget",
        "change-order-status-confirmed": "Bekræftet",
        "change-order-status-ready": "Klar",
        "change-order-status-cancelled": "Annuller",
        "change-order-status-title": "Resultat",

        "change-order-status-received-info-text": "En ordre får automatisk tildelt status Modtaget, når den oprettes. Hvis du ønsker at ændre status fra Bekræftet til Modtaget, så vil bestiller modtage en notifikation. Rul kun status tilbage fra Bekræftet til Modtaget, hvis du ved en fejl har sat status til Bekræftet.",
        "change-order-status-confirmed-info-text": "Når en ordre sættes til Bekræftet, så modtager bestiller en notifikation at ordren behandles. Bestiller kan forvente at modtage sin ordre.",
        "change-order-status-ready-info-text": "Når en ordre sættes til Klar, så modtager bestiller en notifikation at ordren kan hentes.",
        "change-order-status-cancelled-info-text": "Når en ordre sættes til Annulleret, så modtager bestiller en notifikation at ordren ikke leveres. Du kan skrive en kommentar til bestilleren, hvorfor den annulleres.",


        //ChangeOrderStatusResponseModal
        "change-order-status-response-modal-title": "Resultat",
        "change-order-status-response-modal-order-id": "Ordre-id",
        "change-order-status-response-modal-order-delivery": "Leveringsdato",
        "change-order-status-response-modal-order-message": "Besked",
        "change-order-status-response-modal-error": "fejlede",
        "change-order-status-response-modal-error-aciton": "handling",
        "change-order-status-response-modal-error-acitons": "handlinger",


        // --- Surveys List ---
        "surveys-list-header": "\n .title = Surveys",
        "surveys-list-create-button": "Create survey",
        "surveys-list-survey-table-name-column": "Navn",
        "surveys-list-survey-table-start-date-column": "Startdato",
        "surveys-list-survey-table-end-date-column": "Slutdato",
        "surveys-list-survey-table-active-column-active":"Aktiv",
        "surveys-list-survey-table-active-column-inactive":"Inaktiv",
        "surveys-list-survey-table-active-column-active-filter-yes": "Active",
        "surveys-list-survey-table-active-column-inactive-filter-no": "Inactive",
        "surveys-table-list-delete-modal-title": "survey",
        "surveys-table-list-show-ratings": "Show ratings",
        "surveys-table-list-delete-success-message": "Survey was deleted",

        // Create / edit survey
        "create-survey-header": "\n .title = Create Survey",
        "edit-survey-header": "\n .title = Edit Survey",
        "nav-item-create-survey-header": "Create Survey",
        "nav-item-edit-survey-header": "Edit Survey",
        "create-merchant-survey-save-button": "Opret",
        "edit-merchant-survey-save-button": "Gem",
        "create-or-edit-merchant-survey-field-name": "\n .label = Name\n .placeholder = Enter a name for the survey\n .helperText = Description is not shown to the user",
        "create-or-edit-merchant-survey-field-name-required": "Name is required",
        "create-or-edit-merchant-survey-field-description":
            "\n .label = Description\n .placeholder = Enter an optional description for your own use",
        "create-or-edit-merchant-survey-questions": "Your questions:",
        "create-or-edit-merchant-survey-questions-empty": "You have not created any questions yet.",
        "create-or-edit-merchant-survey-field-questions-minError":"You need at least one question",
        "create-or-edit-merchant-survey-add-questions-button": "Add question",
        "create-or-edit-merchant-survey-title-general": "\n .title = Generelt",
        "create-or-edit-merchant-survey-field-active": "Aktiv:",
        "create-or-edit-merchant-survey-field-start-date": "Start date",
        "create-or-edit-merchant-survey-field-end-date": "End date",
        "create-or-edit-merchant-survey-title-user-visibility": "\n .title = User Visibility",
        "create-or-edit-merchant-survey-field-timeOfDay": "\n .label = Time of day",
        "create-or-edit-merchant-survey-field-timeOfDay-helperText": "Determines the time of day rating card for this survey will be shown.",
        "create-or-edit-merchant-survey-field-expirationDays": "\n .label = Expiration days\n .helperText = Days until an unanswered rating card is hidden.",
        "edit-merchant-survey-success-save-message": "Survey was updated",
        "create-merchant-survey-success-save-message": "Survey created",
        "create-or-edit-merchant-survey-dialog-save-button": "Gem",
        "create-or-edit-merchant-survey-dialog-title": "Add question",
        "create-or-edit-merchant-survey-dialog-field-question": "\n .label = Question",
        "create-or-edit-merchant-survey-dialog-topics-title": "Select topics:",
        "create-or-edit-merchant-survey-dialog-topics-good": "\n .label = Good topics",
        "create-or-edit-merchant-survey-dialog-topics-bad": "\n .label = Bad topics",
        "create-or-edit-merchant-survey-dialog-topics-info": "Good topics can be used by participant to select what they found particularly good. Bad topics can be used to specify what they would like to see improved.",


        // --- Company ---

        // Company > Reports > Home
        "company-home-purchases-card-group": "\n .title = Purchases",
        "company-home-purchases-period-base-3": "Last 3 days",
        "company-home-purchases-period-base-14": "Last 14 days",
        "company-home-purchases-period-base-30": "Last 30 days",
        "company-home-purchases-period-base-60": "Last 60 days",
        "company-home-purchases-period-base-180": "Last 180 days",
        "company-home-purchases-pos-purchases-title": " \n .title = POS purchases",
        "company-home-purchases-pos-orders-title": " \n .title = POS Orders",
        "company-home-purchases-meeting-service-purchases-title": " \n .title = Meeting service purchases",
        "company-home-purchases-meeting-service-orders-title": " \n .title = Meeting service orders",
        "company-home-purchases-users-title": " \n .title = Users",
        "company-home-purchases-check-in-title": " \n .title = Check-ins",


        // Company > Admin > Home
        "company-admin-home-organization-users-card":  "\n .title = Users \n .description = Manage users.",
        "company-admin-home-organization-bill-receivers-card":  "\n .title = Bill receivers \n .description = Manage bill receivers.",
        "company-admin-home-organization-user-group-card":  "\n .title = User groups \n .description = Manage user groups.",
        "company-admin-home-organization-departments-card":  "\n .title = Departments \n .description = Manage departments.",
        "company-admin-home-organization-locations-card":  "\n .title = Locations \n .description = Manage locations.",
        "company-admin-home-account-gdpr-card":  "\n .title = GDPR \n .description = Databeskyttelsesforordningen \n .buttonText = Show",
        "company-admin-home-account-administrator-card":  "\n .title = Administrators \n .description = Manage administrators.",

        // Navigation
        "company-nav-item-home": "Hjem",
        "company-nav-item-accounting": "\n .title = Accounting",
        "company-nav-item-pos": "POS",
        "company-nav-item-meeting-service": "Mødeforplejning",
        "company-nav-item-subscriptions": "Subscriptions",
        "company-nav-item-organization": "\n .title = Organization",
        "company-nav-item-users": "Users",
        "company-nav-item-admins":"Administratorer",
        "company-nav-item-user-groups": "User groups",
        "company-nav-item-departments": "Departments",
        "company-nav-item-locations": "Locations",
        "company-nav-item-bill-receivers": "Bill receivers",
        "company-nav-item-account-dimensions": "Account dimensions",
        "company-nav-item-settings": "Settings",
        "company-nav-item-account-title": "\n .title = Account",
        "company-nav-item-account": "Account",
        "company-nav-item-gdpr": "GDPR",
        "company-nav-item-data-import-title": "\n .title = Data import",
        "company-nav-item-data-import": "Data import",
        "company-nav-item-id-cards": "ID cards",
        "company-nav-item-account-numbers": "Account numbers",
        "company-nav-item-import-users": "Users",
        "company-nav-item-import-bill-receivers": "Bill receivers",
        "company-nav-item-settings-title": "\n .title = Settings",
        "company-nav-item-custom-jobs": "Custom jobs",

        // Company > Admin > Organization > Departments
        "company-organization-title": "\n .title = Organization",
        "company-organization-departments-title": "Departments",
        "company-organization-departments-header": "\n .title = Departments",
        "company-organization-departments-create-button": "Opret",
        "company-organization-departments-table-department-no-column": "Department no.",
        "company-organization-departments-table-name-column": "Navn",
        "company-organization-departments-table-status-column": "Status",
        "company-organization-departments-table-active-column-active": "Active",
        "company-organization-departments-table-active-column-inactive": "Inactive",
        "company-organization-departments-table-active-column-active-filter-yes": "Active",
        "company-organization-departments-table-active-column-inactive-filter-no": "Inactive",
        "company-organization-departments-table-edit": "Edit",
        "company-organization-departments-table-delete": "Slet",
        "company-organization-departments-table-delete-modal-title": "department",
        "company-organization-departments-edit-title": "Edit department",
        "company-organization-departments-create-title": "Create department",
        "create-department-header": "\n .title = Create department",
        "edit-department-header": "\n .title = Edit department",
        "edit-department-save-button": "Gem",
        "create-department-save-button": "Opret",
        "create-or-edit-company-department-field-departmentNo": "\n .label = Department no.\n .placeholder = Enter department no.",
        "create-or-edit-company-department-field-name": "\n .label = Name\n .placeholder = Enter name",
        "create-or-edit-company-department-field-is-required": "Field is required",
        "create-or-edit-company-department-field-active": "Active",
        "create-or-edit-company-department-settings": "\n .title = Settings",
        "create-or-edit-company-department-history": "\n .title = History",

        // Company Admin Organization > User Groups
        "company-organization-user-groups-title": "User groups",
        "company-organization-user-groups-header": "\n .title = User groups",
        "company-organization-user-groups-create-button": "Opret",
        "company-organization-user-groups-table-name-column": "Navn",
        "company-organization-user-groups-table-domain-column": "Domain",
        "company-organization-user-groups-table-status-column": "Status",
        "company-organization-user-groups-table-active-column-active": "Active",
        "company-organization-user-groups-table-active-column-inactive": "Inactive",
        "company-organization-user-groups-table-active-column-active-filter-yes": "Active",
        "company-organization-user-groups-table-active-column-inactive-filter-no": "Inactive",
        "company-organization-user-groups-table-edit": "Edit",
        "company-organization-user-groups-table-delete": "Slet",
        "company-organization-user-groups-table-delete-modal-title": "\n .typeOfEntity = user group",
        "company-organization-user-group-edit-title": "Edit user group",
        "company-organization-user-group-create-title": "Create user group",
        "create-user-group-header": "\n .title = Create user group",
        "edit-user-group-header": "\n .title = Edit user group",
        "edit-user-group-save-button": "Gem",
        "create-user-group-save-button": "Opret",
        "create-or-edit-company-user-group-field-name": "\n .label = Name\n .placeholder = Enter name",
        "create-or-edit-company-user-group-field-active": "Active",
        "create-or-edit-company-user-group-settings": "\n .title = Settings",
        "create-or-edit-company-user-group-history": "\n .title = History",
        "create-or-edit-company-user-group-connected-domains": "Connected domains",
        "create-or-edit-company-user-group-connected-domains-empty": "You have not created any domains yet.",
        "create-or-edit-company-user-group-connected-domains-add-button": "\n .title = Add domain",
        "create-or-edit-company-user-group-connected-domains-table-domain": "Domain",
        "create-or-edit-company-user-group-connected-domains-table-status": "Status",
        "create-or-edit-company-user-group-connected-domains-table-status-active": "Active",
        "create-or-edit-company-user-group-connected-domains-table-status-pending": "Pending / Invitation sent",
        "create-or-edit-company-user-group-connected-domains-table-resend-invitation": "Resend invitation",
        "create-or-edit-company-user-group-connected-domains-table-delete": "Slet",
        "company-organization-user-groups-table-delete-modal-domain": "\n .typeOfEntity = domain",
        "create-or-edit-company-user-group-connected-domains-modal-add-domain": "Add domain",
        "create-or-edit-company-user-group-connected-domains-modal-resend-invitation": "Resend invitation for domain",
        "create-or-edit-company-user-group-connected-domains-modal-field-domain": "\n .label = Domain\n .placeholder = Enter domain",
        "create-or-edit-company-user-group-connected-domains-modal-field-username": "\n .label = User name\n .placeholder = Enter user name",
        "create-or-edit-company-user-group-connected-domains-modal-send-invitation": "Send invitation",
        "create-or-edit-company-user-group-connected-bill-receiver": "Bill receiver",
        "create-or-edit-company-user-group-connected-bill-receiver-empty": "You have not created bill receiver yet.",
        "create-or-edit-company-user-group-connected-bill-receiver-add-button": "\n .title = Add bill receiver",
        "create-or-edit-company-user-group-connected-bill-receiver-table-name": "Navn",
        "create-or-edit-company-user-group-connected-bill-receiver-table-address": "Address",
        "create-or-edit-company-user-group-connected-bill-receiver-table-end-point": "End point",
        "create-or-edit-company-user-group-connected-bill-receiver-table-remove": "Remove",
        "create-or-edit-company-user-group-connected-bill-receiver-modal-add-bill-receiver": "\n .title = Add bill receiver",
        "create-or-edit-company-user-group-connected-bill-receiver-modal-update-bill-receiver": "\n .title = Found similar bill receivers. Are you sure you want to create a new?",
        "create-or-edit-company-user-group-connected-bill-receiver-modal-field-search": "\n .label = Search\n .placeholder = Search by name, CVR, EAN, email or address",
        "create-or-edit-company-user-group-connected-bill-receiver-modal-info-text": "Start typing to show search results",
        "create-or-edit-company-user-group-connected-bill-receiver-modal-info-warning": "You should create a new bill receiver with the same identifier (CVR, EAN, email) only if the contact details differ. For example, this may be necessary if the bill needs to be directed to a different individual.",
        "create-or-edit-company-user-group-connected-bill-receiver-modal-empty": "No search results found",
        "create-or-edit-company-user-group-connected-bill-receiver-modal-cvr": "CVR:",
        "create-or-edit-company-user-group-connected-bill-receiver-modal-ean": "EAN:",
        "create-or-edit-company-user-group-connected-bill-receiver-modal-email": "Email:",
        "create-or-edit-company-user-group-connected-bill-receiver-modal-address": "Address:",
        "create-or-edit-company-user-group-connected-bill-receiver-modal-or": "Or",
        "create-or-edit-company-user-group-connected-bill-receiver-modal-submit-button": "Choose selected bill receiver",
        "create-or-edit-company-user-group-connected-bill-receiver-modal-submit-update-button": "Update selected bill receiver",
        "create-or-edit-company-user-group-connected-bill-receiver-modal-create-button": "Create new bill receiver",
        "create-or-edit-company-user-group-connected-bill-receiver-modal-bill-found": "{ $count } bill receiver(s) already exists with the same identifier.",

        // Company > Admin > Account > GDPR
        "company-account-gdpr-title":"\n .title = GDPR",

        // Company > Admin > Data import
        "data-import-csv-field-update-key": "\n .label = Update key",
        "data-import-csv-settings": "\n .title = Settings",
        "data-import-csv-field-update-identical": "Update identical",
        "data-import-csv-field-delete-existing": "Delete existing",

        // Company > Admin > Data import > ID cards
        "company-data-import-id-cards-title": "\n .title = Import ID cards",
        "create-or-edit-company-id-cards-field-user-group": "\n .label = User group",
        "create-or-edit-company-id-cards-select-item-all": "All",
        "create-or-edit-company-id-cards-update-key-mode-initials": "Initials",
        "create-or-edit-company-id-cards-update-key-mode-email": "Email",
        "create-or-edit-company-id-cards-update-key-mode-employee-number": "Employee number",


        // Company > Admin > Data import > Account number
        "company-data-import-account-numbers-title": "\n .title = Import account numbers",
        "create-or-edit-company-account-numbers-field-accounting-dimension": "\n .label = Accounting dimension",
        "create-or-edit-company-account-numbers-select-item-all": "All",
        "create-or-edit-company-account-numbers-update-key-mode-account-number": "Account number",
        "create-or-edit-company-account-numbers-update-key-mode-account-name": "Account name",

        // Company > Admin > Data import > Users
        "company-data-import-users-title": "\n .title = Import users",
        "company-data-import-users-field-user-group": "\n .label = User group",
        "company-data-import-users-select-item-from-file": "From file",

        // Company > Admin > Data import > Bill receivers
        "company-data-import-bill-receivers-title": "\n .title = Import bill receivers",
        "company-data-import-bill-receivers-receiver-type": "\n .label = Receiver type",
        "company-data-import-bill-receivers-receiver-type-mode-private-person": "Private person / association",
        "company-data-import-bill-receivers-receiver-type-mode-public-institution": "Public institution",
        "company-data-import-bill-receivers-receiver-type-mode-private-company": "Private company",
        "company-data-import-bill-receivers-receiver-type-mode-from-file": "From file",

        // Company > Admin > Settings > Custom jobs
        "company-admin-settings-custom-jobs-title":" \n .title = Custom jobs",
        "company-admin-settings-custom-jobs-table-name":"Name",
        "company-admin-settings-custom-jobs-table-interval":"Interval",
        "company-admin-settings-custom-jobs-table-last-run":"Last run",
        "company-admin-settings-custom-jobs-table-status":"Status",
        "company-admin-settings-custom-jobs-table-action-details":"Details",
        "company-admin-settings-custom-jobs-table-action-run-job":"Run job",
        "company-admin-settings-custom-jobs-table-action-activate":"Activate",
        "company-admin-settings-custom-jobs-table-action-inactivate":"Inactivate",

        // Import result
        "import-result-title": "\n .title = Import result",
        "import-result-breadcrumb": "Result",
        "import-result-succeeded": "Import succeeded",
        "import-result-results": "Results:",
        "import-result-created": "Created:",
        "import-result-updated": "Updated:",
        "import-result-deleted": "Deleted:",

        // Company Meeting Service
        "company-meeting-service-title": "Mødeforplejning",
        "company-meeting-service-header": "\n .title = Mødeforplejning",
        "company-meeting-service-table-booked-start-date": "Bogført fra",
        "company-meeting-service-table-booked-end-date": "Bogført til",
        "company-meeting-service-table-merchant": "Salgssted",
        "company-meeting-service-table-order-id-column": "Ordre ID",
        "company-meeting-service-table-booked-date-column": "Bogføringsdato",
        "company-meeting-service-table-delivery-time-column": "Leveringstid",
        "company-meeting-service-table-employee-column": "Medarbejder",
        "company-meeting-service-table-amount-column": "Beløb (DKK)",
        "company-meeting-service-table-show-receipt": "Show receipt",
        "company-meeting-service-table-floating-action-bar-receipts": "\n .title = Receipts",
        "company-meeting-service-table-floating-action-bar-export": "\n .title = Export",

        // Company Subscriptions
        "company-subscriptions-title": "Abonnementer",
        "company-subscriptions-header": "\n .title = Abonnementer",
        "company-subscriptions-table-subscription-column": "Abonnement",
        "company-subscriptions-table-order-id-column": "Ordre ID",
        "company-subscriptions-table-employee-column": "Medarbejder",
        "company-subscriptions-table-subscribed-column": "Tilmeldt",
        "company-subscriptions-table-unsubscribed-column": "Frameldt",
        "company-subscriptions-table-payment-column": "Betaling",
        "company-subscriptions-table-amount-column": "Beløb",
        "company-subscriptions-table-cancel-subscription": "Cancel subscription",
        "company-subscriptions-table-details": "Details",

        // Accounting - POS Purchases
        "accounting-pos-table-header-title": "\n .title = POS",
        "accounting-pos-table-header-nav-item-home": "Home",
        "accounting-pos-table-header-nav-item-accounting": "Accounting",
        "accounting-pos-table-header-nav-item-pos": "POS",
        "accounting-pos-table-header-order-id": "Ordre ID",
        "accounting-pos-table-header-transaction-time": "Transaktionstid",
        "accounting-pos-table-header-employee": "Medarbejder",
        "accounting-pos-table-header-payment": "Betaling",
        "accounting-pos-table-header-amount": "Beløb (DKK)",
        "support-entity-table-button-show-receipt": "Show receipt",
        "accounting-pos-table-header-merchant-label":"\n .label = Salgssted",
        "accounting-pos-table-footer-total-in-period":"Total in this period (DKK)",

                // Organization - Users
        "company-organization-users-page-header": "\n .title = Users",
        "company-organization-users-table-header-user-group":"User Group",
        "company-organization-users-table-header-name":"Navn",
        "company-organization-users-table-header-employee-id":"Employee id",
        "company-organization-users-table-header-email":"Email",
        "company-organization-users-table-header-status":"Status",
        "company-organization-users-table-status-active":"Active",
        "company-organization-users-table-status-inactive": "Inactive",
        "company-organization-users-table-button-details": "Details",
        "company-organization-users-table-button-edit": "Edit",
        "company-organization-users-table-button-delete": "Slet",
        "company-organization-users-button-create": "Opret",
        "company-admin-nav-item-organization": "Organization",
        "company-admin-nav-item-users": "Users",
        "company-organization-users-table-header-select-label-user-group": "User Group",
        "company-organization-users-table-header-select-item-all": "All",


        // Organization - Admins
        "company-organization-admins-page-header": "\n .title = Administrators",
        "company-organization-admins-table-header-name":"Navn",
        "company-organization-admins-table-header-email":"Email",
        "company-organization-admins-table-header-status":"Status",
        "company-organization-admins-table-status-active":"Active",
        "company-organization-admins-table-status-inactive": "Inactive",
        "company-organization-admins-table-button-details": "Show details",
        "company-organization-admins-table-button-edit": "Edit user",
        "company-organization-admins-table-button-delete": "Delete user",
        "company-organization-admins-button-create": "Opret",
        "company-admin-nav-item-admins": "Administrators",

        // Company Admin Organization Locations
        "company-organization-locations-title": "Locations",
        "company-organization-locations-header": "\n .title = Locations",
        "company-organization-locations-create-button": "Opret",
        "company-organization-locations-table-name-column": "Navn",
        "company-organization-locations-table-status-column": "Status",
        "company-organization-locations-table-active-column-active": "Active",
        "company-organization-locations-table-active-column-inactive": "Inactive",
        "company-organization-locations-table-active-column-active-filter-yes": "Active",
        "company-organization-locations-table-active-column-inactive-filter-no": "Inactive",
        "company-organization-locations-table-edit": "Edit",
        "company-organization-locations-table-delete": "Slet",
        "company-organization-locations-table-delete-modal-title": "location",
        "company-organization-locations-edit-title": "Edit location",
        "company-organization-locations-create-title": "Create location",
        "create-location-header": "\n .title = Create location",
        "edit-location-header": "\n .title = Edit location",
        "edit-location-save-button": "Gem",
        "create-location-save-button": "Opret",
        "create-or-edit-company-location-field-name": "\n .label = Name\n .placeholder = Enter name",
        "create-or-edit-company-location-field-is-required": "Field is required",
        "create-or-edit-company-location-field-active": "Active",
        "create-or-edit-company-location-settings": "\n .title = Settings",
        "create-or-edit-company-location-history": "\n .title = History",
        "create-or-edit-company-location-field-street": "\n .label = Street\n .placeholder = Enter street",
        "create-or-edit-company-location-field-streetNumber": "\n .label = Street no\n .placeholder = Enter street no",
        "create-or-edit-company-location-field-postalCode": "\n .label = Postal code\n .placeholder = Enter postal code",
        "create-or-edit-company-location-field-city": "\n .label = City\n .placeholder = Enter city",
        "create-or-edit-company-location-field-country": "\n .label = Country",
        "create-or-edit-company-location-field-country-denmark-item": "Denmark",
        "create-or-edit-company-location-field-shops": "\n .label = Connected shops",

        // Accounting - Bill receivers
        "company-accounting-bill-receivers-table-header-title": "\n .title = Bill receivers",
        "company-accounting-bill-receivers-table-header-name":"Navn",
        "company-accounting-bill-receivers-table-header-endpoint":"Endpoint",
        "company-accounting-bill-receivers-table-header-debitor-id":"Debitor id",
        "company-accounting-bill-receivers-table-header-status":"Status",
        "company-accounting-bill-receivers-table-status-active":"Active",
        "company-accounting-bill-receivers-table-status-inactive": "Inactive",
        "company-accounting-bill-receivers-table-button-edit": "Edit",
        "company-accounting-bill-receivers-table-button-delete": "Slet",
        "company-accounting-bill-receivers-button-create": "Opret",
        "company-accounting-bill-receivers-table-header-nav-item-home": "Home",
        "company-accounting-bill-receivers-table-header-nav-item-accounting": "Accounting",
        "company-accounting-bill-receivers-table-header-nav-item-bill-receivers": "Bill receivers",

        // Accounting - Bill receivers - Create Dialog
        "bill-receivers-create-dialog-title": "Opret fakturamodtager",
        "bill-receivers-create-dialog-customer-type": "Kundetype:",
        "bill-receivers-create-dialog-select-bill-receiver": "Vælg eksisterende fakturamodtager:",
        "bill-receivers-create-dialog-country": "Land:",
        "bill-receivers-create-dialog-button-create": "Opret",
        "bill-receivers-create-dialog-button-save": "Gem",
        "bill-receivers-form-error-label-country":"Land",
        "bill-receivers-form-error-label-debtor-number":"Debitornummer",
        "bill-receivers-form-error-label-address-line-1":"Adresselinje 1",
        "bill-receivers-form-error-label-address-line-2":"Adresselinje 2",
        "bill-receivers-form-error-label-postal-code":"Postnummer",
        "bill-receivers-form-error-label-city":"By",
        "bill-receivers-form-error-label-telephone":"Telefon",
        "bill-receivers-form-error-label-name":"Navn",
        "bill-receivers-form-error-label-institution-name":"Institutionsnavn",
        "bill-receivers-form-error-label-email":"E-mail",
        "bill-receivers-form-error-label-contact-person":"Kontaktperson",
        "bill-receivers-form-error-label-company-name":"Firmanavn",
        "bill-receivers-validation-ean-13-digits": "EAN-nummer skal være 13 cifre",
        "bill-receivers-validation-cvr-8-digits": "CVR-nummer skal være 8 cifre",
        "bill-receivers-validation-postal-code-4-digits": "Postnummer skal være 4 cifre",
        "bill-receivers-validation-email-invalid": "Indtast venligst en gyldig e-mailadresse",
        "bill-receivers-validation-telephone-invalid": "Telefon må kun indeholde cifre samt tegnene + - ( ) og mellemrum",
        "bill-receivers-validation-max-length": "{ $label } må højst være { $max } tegn",
        "bill-receivers-select-type":"Vælg type:",
        "bill-receivers-select-label":"Vælg modtager:",
        "bill-receivers-select-list-label": "Vælg fakturamodtager",
        "bill-receivers-select-private-person":"Privatperson / forening",
        "bill-receivers-select-email":"E-mail",
        "bill-receivers-select-public-institution":"Offentlig institution",
        "bill-receivers-select-ean-number":"EAN-nummer",
        "bill-receivers-select-private-company":"Privat virksomhed",
        "bill-receivers-select-cvr-number":"CVR-nummer",
        "bill-receivers-company-number":"Indtast CVR-nummer:",
        "bill-receivers-input-search-label-number-cvr":"\n .label = CVR-nummer",
        "bill-receivers-button-continue":"Fortsæt",
        "bill-receivers-send-invoice":"Send faktura til:",
        "bill-receivers-select-label-input-type":"Type",
        "bill-receivers-dropdown-type":"\n .label = Type",
        "bill-receivers-select-item-email":"E-mail",
        "bill-receivers-select-item-ean-number":"EAN-nummer",
        "bill-receivers-form-label-address-1":"\n .label = Adresselinje 1 (*)\n .placeholder = Vejnavn og husnummer",
        "bill-receivers-form-label-address-2":"\n .label = Adresselinje 2\n .placeholder = Etage, lejlighed nr., osv.",
        "bill-receivers-form-label-postal-code":"\n .label = Postnummer (*)",
        "bill-receivers-form-label-city":"\n .label = By (*)",
        "bill-receivers-form-label-country":"\n .label = Land (*)",
        "bill-receivers-form-country-select-da": "Danmark",
        "bill-receivers-form-contact-person":"Kontaktperson",
        "bill-receivers-form-label-contact-person":"\n .label = Kontaktperson (*)",
        "bill-receivers-form-label-email":"\n .label = E-mail (*)",
        "bill-receivers-form-label-telephone":"\n .label = Telefon (*)",
        "bill-receivers-form-label-name":"\n .label = Navn (*)",
        "bill-receivers-form-label-institution-name":"\n .label = Navn (*)",
        "bill-receivers-form-label-debtor-number":"\n .label = Debitornummer\n .placeholder = Identifikator for debitor i dit regnskabssystem",
        "bill-receivers-form-label-company-name":"\n .label = Firmanavn (*)",
        "bill-receivers-input-search-label-email":"\n .label = E-mail",
        "bill-receivers-input-search-label-ean-number":"\n .label = EAN-nummer",

        // --- Service center --
        "service-center-home-coming-soon-placeholder": "\n .title = Kommer snart\n .body = Vi arbejder på at levere den nye service center portal til dig. Benyt venligst https://bestil-nu.net for nu.",

        // Navigation
        "service-center-nav-item-home": "Hjem",

        // Navigation > Admin
        "service-center-admin-nav-item-organization-page-header": "\n .title = Organization",
        "service-center-admin-nav-item-organization": "Organization",
        "service-center-admin-nav-item-organization-resources": "Resources",
        "service-center-admin-nav-item-organization-devices": "Devices",
        "service-center-admin-nav-item-organization-devices-create": "Create devices",
        "service-center-admin-nav-item-organization-devices-edit": "Edit devices",
        "service-center-admin-nav-item-account-page-header": "\n .title = Account",
        "service-center-admin-nav-item-account-administrators": "Administrators",
        "service-center-admin-nav-item-organization-resource-crate-room": "Create room",
        "service-center-admin-nav-item-organization-resource-update-room": "Update room",
        "service-center-admin-nav-item-organization-resource-crate-car": "Create car",
        "service-center-admin-nav-item-organization-resource-update-car": "Update car",
        "service-center-admin-nav-item-organization-resource-crate-mobile-av": "Create Mobile AV",
        "service-center-admin-nav-item-organization-resource-update-mobile-av": "Update Mobile AV",


        // Service center > Admin > Home >
        "service-center-admin-home-organization-resources-card": "\n .title = Resources \n .description = Create and manage the resources that can be booked in your service center.",
        "service-center-admin-home-organization-devices-card": "\n .title = Devices \n .description = Manage your hardware devices such as room displays and info screens.",
        "service-center-admin-home-account-administrators-card": "\n .title = Administrators \n .description = Manage the administrators for your merchant.",

        // --- User --

        // Navigation
        "user-nav-item-home": "Hjem",
        "user-nav-item-upcoming-orders-title": "\n .title = Kommende ordrer",
        "user-nav-item-upcoming-orders-purchases": "Daglige køb",
        "user-nav-item-upcoming-orders-meeting-service": "Mødeforplejning",
        "user-nav-item-upcoming-orders-resource-bookings": "Ressourcebookinger",
        "user-nav-item-archive-title": "\n .title = Arkiv" ,
        "user-nav-item-archive": "Arkiv",
        "user-nav-item-settings": "Settings",
        "user-nav-item-wallets-title": "\n .title = Wallets" ,
        "user-nav-item-wallets": "Wallets",
        "user-nav-item-wallets-refill": "Refill",
        "user-nav-item-home-label": "\n .title = Gå til hjem-dashboard" ,
        "user-nav-item-calendar-label": "\n .title = Vis kalender med ordrer" ,
        "user-nav-item-upcoming-orders-label": "\n .title = Vis kommende ordrer" ,
        "user-nav-item-archive-label": "\n .title = Vis arkiverede ordrer" ,
        "user-nav-item-settings-label": "\n .title = Indstillinger",


        // User > Home > Top bar
        "user-home-top-bar-tab-switcher-overview": "Oversigt",
        "user-home-top-bar-tab-switcher-upcoming": "Kommende",

        // User > Home > Top bar > News drawer
        "user-home-top-bar-news-title": "\n .title = Facilitynet nyheder",
        "user-home-top-bar-news-no-notifications": "\n .title = Ingen beskeder lige nu\n .description = Her kan du læse beskeder fra salgsstedet og servicecentret.",
        "user-home-top-bar-news-notification-time-type-news": "Nyhed",
        "user-home-top-bar-news-notification-time-type-info": "Information",
        "user-home-top-bar-news-notification-time-type-important": "Vigtigt",
        "user-home-top-bar-news-notification-time-type-offer": "Tilbud",
        "user-home-top-bar-news-notification-time-type-event": "Arrangement",
        "user-home-top-bar-news-notification-time-type-reminder": "Påmindelse",
        "user-home-top-bar-news-notification-time-type-menu-change": "Menu",
        "user-home-top-bar-news-notification-time-type-feedback": "Feedback",
        "user-home-top-bar-news-notification-time-type-health": "Sundhed",
        "user-home-top-bar-news-notification-menu-title": "Beskeder",


        // User > Home > Week menus
        "user-home-week-menu-title": "Ugens menu",
        "user-home-week-menu-no-menus-title": "Ingen menu tilgængelig",
        "user-home-week-menu-no-menus": "Desværre er der ikke blevet oprettet nogen menuer denne uge.",
        "user-home-week-menu-no-menus-today": "Ingen menu for denne dag",
        "user-home-week-menu-select-location-dialog-title": "Skift lokation",
        "user-home-week-menu-select-location-search-filter": "\n .placeholder = Søg på navn, adresse, butiksnummer...",
        "user-home-week-menu-select-location-dialog-kitchen-item-button": "Vælg",
        "user-home-week-menu-dialog-title": "Dagens menu",
        "user-home-week-menu-dialog-allergens": "Allergener:",


        // User > Home >Dashboard
        "user-home-upcoming-orders": "Kommende ordrer",
        "user-home-canteen": "Kantine",
        "user-home-canteen-offers": "Tilbud",
        "user-home-canteen-today-menu": "Dagens menu",
        "user-home-canteen-today-menu-show-menu": " Vis menu skilt...",
        "user-home-canteen-news": "Nyheder",
        "user-home-upcoming-meetings": "Møder",
        "user-home-upcoming-meetings-no-meetings": "Ingen kommende møder",
        "user-home-empty-offers-text": "Du har ingen tilbud lige nu",
        "user-home-upcoming-purchases": "Køb",
        "user-home-upcoming-purchases-load-error": "Kunne ikke indlæse køb",
        "user-home-upcoming-purchase-card-title-lunch": "Frokostordre",
        "user-home-upcoming-purchase-card-title-take-away": "Take away",
        "user-home-upcoming-purchase-card-title-pos": "Frokostordre",
        "user-home-upcoming-purchase-card-title-lunch-subscription": "Frokostabonnement",
        "user-home-upcoming-purchases-no-purchases": "Ingen kommende køb",
        "user-home-upcoming-meeting-service-approved": "\n .label = Godkendt",
        "user-home-upcoming-meeting-service-approved-tooltip":  "\n .label = Ordren er blevet godkendt af salgsstedet.",
        "user-home-upcoming-meeting-service-sittings": "{ $sittings } pladser",
        "user-home-upcoming-meeting-service-attendees": "{ $attendees } deltagere",
        "user-home-upcoming-meeting-service-locked": "Låst",
        "user-home-upcoming-purchases-check-in-reminder": "Check-in påmindelse",
        "user-home-upcoming-purchases-learn-more": "Se mere",
        "user-home-upcoming-purchases-check-in-subtitle": "Husk at checke ind i kantinen i dag.",
        "user-home-canteen-contact-canteen": "Kontakt kantine",
        "user-dashboard-error-offers-unavailable": "Tilbuddet er midlertidigt utilgængeligt.",
        "user-dashboard-error-week-menu-unavailable": "Ugentlig menu er midlertidigt utilgængelig.",
        "user-dashboard-error-news-menu-unavailable": "Nyhedsmenu er midlertidigt utilgængelig.",
        "user-dashboard-error-merchant-contact-unavailable": "Kontaktoplysninger til forhandler er midlertidigt utilgængelige.",
        "user-home-canteen-news-category-company": "\n .label = Company",
        "user-home-canteen-news-category-service-center": "\n .label = Service Center",
        "user-home-canteen-news-category-kitchen": "\n .label = Kitchen",
        "user-home-canteen-news-category-no-actions":  "No actions available for order #{ $orderId }",
        "user-home-canteen-upcoming-orders-dialog-ok-button": "Ok",
        "user-home-canteen-upcoming-orders-delete-item": "Slet",
        "user-home-canteen-upcoming-orders-delete-order": "Slet ordre",
        "user-home-canteen-upcoming-orders-delete-order-restriction-message": "Du har ikke tilladelse til at slette denne ordre",
        "user-home-canteen-upcoming-orders-refund-order": "Refunder ordre",
        "user-home-canteen-upcoming-orders-refund-order-restriction-message": "Du har ikke tilladelse til at refundere denne ordre",
        "user-home-canteen-upcoming-orders-receipt-item": "Kvittering",
        "user-home-canteen-upcoming-orders-edit-item": "Rediger",
        "user-home-canteen-upcoming-orders-update-booking-restriction-message": "Du har ikke tilladelse til at opdatere booking",
        "user-home-canteen-upcoming-orders-extend-booking-item": "Forlæng booking",
        "user-home-canteen-upcoming-orders-extend-booking-restriction-message": "Du har ikke tilladelse til at forlænge booking",
        "user-home-canteen-upcoming-orders-end-booking-item": "Afslut booking",
        "user-home-canteen-upcoming-orders-end-booking-restriction-message": "Du har ikke tilladelse til at afslutte booking",
        "user-home-canteen-upcoming-orders-update-meeting-service-item-meeting-service": "Opdater",
        "user-home-canteen-upcoming-orders-update": "Rediger",
        "user-home-canteen-upcoming-orders-update-meeting-restriction-message": "Du har ikke tilladelse til at opdatere denne ordre",
        "user-home-canteen-upcoming-orders-duplicate-meeting-service-item-meeting-service": "Dupliker",
        "user-home-canteen-upcoming-orders-duplicate-meeting-service-item-resource-booking": "Dupliker mødeforplejning",
        "user-home-canteen-upcoming-orders-end-modal-confirm": "Confirm",
        "user-home-canteen-upcoming-orders-cancel-modal-confirm": "Cancel",
        "user-home-canteen-upcoming-orders-extend-modal-title": "Extend booking",
        "user-home-canteen-upcoming-orders-extend-modal-subtitle": "Extend booking { $meetingName } to { $meetingTime }?",
        "user-home-canteen-upcoming-orders-extend-modal-max-error": "Maximum available time is { $maxAvailableMinutes } minutes.",
        "user-home-canteen-upcoming-orders-extend-input-custom-time": "\n .label =  Select end time:",
        "user-home-canteen-upcoming-orders-extend-other-button": "Other",
        "user-home-canteen-upcoming-orders-delete-modal-title": "\n .typeOfEntity = meeting",
        "user-home-canteen-upcoming-orders-delete-modal-error": "Kunne ikke slette ordre",
        "user-home-canteen-upcoming-orders-delete-modal-booking-label": "\n .label = Slet booking",
        "user-home-canteen-upcoming-orders-delete-modal-meeting-label": "\n .label = Slet mødeforplejning",
        "user-home-meeting-service-action-update-booking": "Opdater booking",
        "user-home-meeting-service-action-edit": "Rediger ordre",
        "user-home-meeting-service-action-end-booking": "Afslut booking",
        "user-home-meeting-service-action-update-meeting-service": "Opdater mødeforplejning",
        "user-home-meeting-service-action-duplicate-meeting-service": "Dupliker ordre",
        "user-home-meeting-service-description-update-booking": "Er du sikker på, at du vil opdatere booking #{ $orderId }, { $meetingName }?",
        "user-home-meeting-service-description-end-booking": "Er du sikker på, at du vil afslutte booking #{ $orderId }, { $meetingName }?",
        "user-home-meeting-service-description-update-meeting-service-catering": "Vil du opdatere ordre #{ $orderId }, { $meetingName } med levering den { $deliveryDate }?",
        "user-home-meeting-service-description-update-meeting-service": "Vil du opdatere ordre #{ $orderId }, { $meetingName } til møde den { $deliveryDate }?",
        "user-home-meeting-service-description-duplicate-meeting-service": "Vil du duplikere ordre #{ $orderId }, { $meetingName } med levering den { $deliveryDate }?",
        "user-home-meeting-service-action-confirm-modal-meeting-name": "Mødenavn:",
        "user-home-meeting-service-action-confirm-modal-delivery-date-name": "Leveringsdato:",
        "user-home-meeting-service-action-confirm-modal-order-id": "Ordre ID:",
        "user-home-canteen-upcoming-orders-extend-success-dialog-title": "Booking blev forlænget",
        "user-home-canteen-upcoming-orders-delete-success-dialog-title": "Booking blev slettet",
        "user-home-canteen-upcoming-orders-delete-order-success-dialog-title":
            "{ $ordersCount ->\n *[one] Ordre blev slettet\n [other] Ordrer blev slettet\n }",
        "user-home-canteen-upcoming-orders-end-success-dialog-title": "Booking blev afsluttet",

        // User > Home > Offers
        "user-home-offers-title": "Tilbud",

        // User > Home > Offers
        "user-home-news-from-kitchen": "Nyheder fra køkkenet",

        // User > Home > Opening hours
        "user-home-opening-hours-title": "Åbningstider",
        "user-home-opening-day-1": "Man:",
        "user-home-opening-day-2": "Tir:",
        "user-home-opening-day-3": "Ons:",
        "user-home-opening-day-4": "Tor:",
        "user-home-opening-day-5": "Fre:",

         // User > Home > Room finder
        "user-homeroom-finder-title": "Rumfinder",
        "user-home-room-finder-resource-type-dropdown": "\n .label = Ressourcetype",
        "user-home-room-finder-resource-date": "\n .label = Dato:",
        "user-home-room-finder-resource-duration": "\n .label = Varighed:",
        "user-home-room-finder-resource-seats": "Pladser:",
        "user-home-room-finder-resource-time": "Tid:",
        "user-home-room-finder-resource-book-button": "Book ({ $amount })",
        "user-home-room-finder-resource-results-amount": "{ $amount } resultater",
        "user-home-room-finder-resource-select-button": "Vælg",
        "user-home-room-finder-resource-unselect-button": "Fjern",
        "user-home-room-finder-go-to-timeline-button": "Gå til tidslinje",
        "user-home-room-finder-subtitle": "Din intelligente følgesvend til at finde ressourcer.",
        "user-home-room-finder-find-a-room-button": "Find et rum",
        "user-home-room-finder-available-rooms": "tilgængelige rum",


        // User > Upcoming orders > Meeting service
        "user-upcoming-orders-meeting-service-title": "\n .title = Mødeforplejning",

        // User > Upcoming orders > Resource bookings
        "user-upcoming-orders-resource-booking-table-id": "Ordre ID",
        "user-upcoming-orders-resource-booking-table-time": "Tid",
        "user-upcoming-orders-resource-booking-table-meeting": "Møde",
        "user-upcoming-orders-resource-booking-table-visibility": "Synlighed",
        "user-upcoming-orders-resource-booking-table-visibility-public": "Offentlig",
        "user-upcoming-orders-resource-booking-table-visibility-public-tooltip": "The booking is public which means that the meeting name and attendee names are visible for co-workers.",
        "user-upcoming-orders-resource-booking-table-visibility-private": "Privat",
        "user-upcoming-orders-resource-booking-table-visibility-private-tooltip": "The booking is private which means that the meeting name and attendee names are not visible to anyone.",
        "user-upcoming-orders-resource-booking-table-action-delete": "Slet",
        "user-upcoming-orders-resource-booking-table-remove-dialog": "\n .title = Fjern booking\n .message = Er du sikker på, at du vil fjerne booking?\n .buttonLabelSubmit = Fjern",


        // User > Settings
        "user-settings-page-title": "\n .title = Indstillinger",
        "user-settings-tab-bill-receivers": "Regningsmodtagere",
        "user-settings-tab-guest-reception": "Gæstemodtagelse",
        "user-settings-tab-calendar-sharing": "Kalenderdeling",
        "user-settings-tab-access-control": "Adgangskontrol",
        "user-settings-table-header-name": "Navn",
        "user-settings-table-header-address": "Adresse",
        "user-settings-table-header-endpoint": "Endepunkt",
        "user-settings-table-header-status": "Status",
        "user-settings-status-active": "Aktiv",
        "user-settings-status-inactive": "Inaktiv",
        "user-settings-status-pending": "Afventer",
        "user-settings-action-edit": "Rediger",
        "user-settings-action-delete": "Slet",
        "user-settings-action-activate": "Aktivér",
        "user-settings-action-deactivate": "Deaktivér",
        "user-settings-coming-soon": "Kommer snart",
        "user-settings-bill-receivers-info": "\n .title = Her er dine personlige regningsmodtagere, som du kan vælge, når du bestiller mødeservice. Du har mulighed for at oprette en ny regningsmodtagere under bestillingsprocessen, hvis den valgte kantine tillader det.",
        "user-settings-delete-bill-receiver-dialog": "\n .typeOfEntity = regningsmodtagere",
        "user-settings-edit-bill-receiver-dialog-title": "Rediger regningsmodtagere",
        "user-settings-edit-bill-receiver-page-header": "\n .title = Rediger regningsmodtagere",
        "user-settings-edit-bill-receiver-name-field": "\n .label = Navn",
        "user-settings-edit-bill-receiver-vatnumber-field": "\n .label = CVR-nummer",
        "user-settings-edit-bill-receiver-address-panel": "\n .title = Adresse",
        "user-settings-edit-bill-receiver-endpoint-panel": "\n .title = Faktureringsmetode",
        "user-settings-edit-bill-receiver-endpoint-type-field": "\n .label = Type",
        "user-settings-edit-bill-receiver-endpoint-value-field": "\n .label = Værdi",
        "user-settings-edit-bill-receiver-contact-panel": "\n .title = Kontaktperson",
        "user-settings-edit-bill-receiver-settings-panel": "\n .title = Indstillinger",
        "user-settings-edit-bill-receiver-active-switch": "Aktiv",
        "user-settings-edit-bill-receiver-save-button": "Gem",
        "user-nav-item-edit-bill-receiver": "Rediger regningsmodtagere",

        // User > Settings > Wallets
        "user-settings-wallets-title": "\n .title = Wallets",

        // User > Wallets > Refill
        "user-wallets-refill-title": "\n .title = Refill wallet",
        "user-wallets-refill-manual-top-up-nav-tab": "Manual top up",
        "user-wallets-refill-automatic-top-up-nav-tab": "Automatic top up",
        "user-wallets-refill-manual-type": "\n .statusLabel = Manual",
        "user-wallets-refill-automatic-type": "\n .statusLabel = Automatic",
        "user-wallets-refill-payment-success": "Order processed",
        "user-wallets-refill-payment-unexpected-error": "An unexpected error occurred",
        "user-wallets-refill-payment-timeout": "Payment timed out",
        "user-wallets-refill-payment-wait-label": "Processing Payment",
        "user-wallets-refill-payment-wait-description":  "Please wait while we process your payment. This may take a few moments.",
        "user-wallets-refill-payment-back-action-button-label": "Back to dashboard",
        "user-wallets-refill-payment-timeout-label": "Payment Timed Out",
        "user-wallets-refill-payment-timeout-description": "We haven't received confirmation from your payment provider. Please check your netbank to be sure that the payment was completed.",
        "user-wallets-refill-payment-canceled-label":  "Payment canceled",
        "user-wallets-refill-payment-canceled-description":  "You've canceled the payment process. No charges have been made to your account.",
        "user-wallets-refill-payment-failed-label": "Payment failed.",
        "user-wallets-refill-payment-failed-description": "Your payment could not be completed. Please confirm your details and try again.",

        // User > Wallets > Refill > Manual tab
        "user-wallets-refill-manual-main-amount-label": "\n .label = Amount",
        "user-wallets-refill-manual-main-amount-error":"Your wallet can't exceed { $maxBalance}. You can max refill { $maxRefillAmount }",
        "user-wallets-refill-manual-main-amount-max-error":"Maximum amount to refill is { $maxRefillAmount }",
        "user-wallets-refill-manual-main-amount-zero-error":"Amount must be greater than 0",
        "user-wallets-refill-auto-amount-max-threshold-error":"Maximum threshold is { $maxThreshold }",
        "user-wallets-refill-payment-method-error":"Payment method is required",
        "user-wallets-refill-manual-main-custom-amount-label": "\n .label = Enter amount:",
        "user-wallets-refill-manual-main-amount-amount-100": "100,00 kr",
        "user-wallets-refill-manual-main-amount-amount-300": "300,00 kr",
        "user-wallets-refill-manual-main-amount-amount-500": "500,00 kr",
        "user-wallets-refill-manual-main-amount-amount-other": "Other",
        "user-wallets-refill-manual-main-payment-method": "Payment methods:",
        "user-wallets-refill-manual-main-select-payment-method": "Select payment method",
        "user-wallets-refill-manual-main-perform-refill-button": "Confirm payment",
        "user-wallets-refill-select-card-dialog-title": "Select wallet",
        "user-wallets-refill-select-card-dialog-no-wallets": " The merchant don't offer digital wallets for your company.",
        "user-wallets-refill-select-card-balance": "Balance:",


        // User > Wallets > Refill > Auto tab
        "user-wallets-refill-auto-activate-card-title": "Activate automatic top up",
        "user-wallets-refill-auto-activate-modal-title": "Activate auto top up",
        "user-wallets-refill-auto-activate-modal-threshold-placeholder": "\n .label = Amount (DKK)",
        "user-wallets-refill-auto-activate-modal-threshold-subtitle": "When balance falls below:",
        "user-wallets-refill-auto-activate-modal-refill-subtitle": "Refill with amount:",
        "user-wallets-refill-auto-activate-modal-submit-button": "Activate auto refill",
        "user-wallets-refill-auto-activate-modal-update-button": "Update auto refill",
        "user-wallets-refill-auto-activate-modal-delete-button": "Delete auto refill",
        "user-wallets-refill-auto-activate-success-modal-subtitle": "Auto top up activated",


        // User > Archive > Drawer
        "user-archive-drawer-resource-booking": "Ressourcebooking",
        "user-archive-drawer-meeting-service": "Mødeforplejning",
        "user-archive-drawer-daily-purchases": "Daglige køb",
        "user-archive-drawer-refill-wallet": "Tank-op",


        // User > Archive > Drawer > Transactions
        "user-archive-transactions-table-id": "Ordre ID",
        "user-archive-transactions-table-transaction-time": "Transaktionstid",
        "user-archive-transactions-table-delivery-time": "Leveringstid",

        // User > Archive > Meeting service
        "user-archive-meeting-service-title": "\n .title = Mødeforplejning",
        "user-archive-meeting-service-table-id": "Ordre ID",
        "user-archive-meeting-service-table-booked-date": "Bogføringsdato",
        "user-archive-meeting-service-table-delivery-time": "Leveringstid",
        "user-archive-meeting-service-table-meeting": "Møde",
        "user-archive-meeting-service-table-amount": "Beløb",
        "user-archive-meeting-service-table-action-receipt": "Kvittering",
        "user-archive-meeting-service-table-action-duplicate": "Dupliker",
        "user-archive-meeting-service-table-action-send-message": "Send besked",
        "user-archive-meeting-service-table-filter-start-date": "Startdato",
        "user-archive-meeting-service-table-filter-end-date": "Slutdato",

        // Standard components

        // Standard components > Filter button
        "table-filters-button":"Filtre",

        // Create order
        "create-order-access-denied-on-behalf-of": "Du har ikke adgang til at bestille på vegne af den valgte bruger.",
        "create-order-confirm-order-button": "Næste",
        "create-order-book-button": "Reservér",
        "create-order-update-button": "Opdater",
        "create-order-undo-button": "\n .title = Fortryd alt",
        "create-order-wish": "\n .title = Ønske",
        "create-order-wish-dialog-title": "\n .dialogTitle = Tilføj produktønske",
        "create-order-wish-dialog-message": "Hvis du tilføjer et produktønske, skal din ordre godkendes manuelt af shopejeren.",
        "create-order-wish-dialog-product-name-field": "\n .label =Produktnavn * \n .placeholder =Indtast produktnavn:",
        "create-order-wish-dialog-product-items-field": "\n .label =Antal * \n .placeholder =Indtast antal:",
        "create-order-wish-dialog-product-price-field": "\n .label =Produktpris * \n .placeholder =Indtast pris (DKK):",
        "create-order-wish-dialog-submit-button": "Bekræft",
        "create-order-favorite": "\n .title = Se mine favoritprodukter",
        "create-order-favorite-show-all-products": "\n .title = Vis alle produkter",
        "create-order-list": "\n .title = Vis en liste over produkter",
        "create-order-grid": "\n .title = Vis et gitter med produkter",
        "create-order-products-empty": "Ingen resultater",
        "create-order-product-sale-text": "Kun 10 tilbage",
        "offer-tag-good-price": "Skarp pris",
        "offer-tag-great-offer": "Godt tilbud",
        "offer-tag-buy-now": "Slå til nu",
        "offer-tag-discount": "Tilbud",
        "offer-tag-week-offer": "Ugens tilbud",
        "offer-tag-day-offer": "Dagens tilbud",
        "offer-tag-save-x-percentage": "Spar { $amount }%",
        "offer-tag-save-x-price": "Spar { $amount } kr",
        "offer-tag-limited-on-sale": "{ $amount } tilbage",
        "create-order-tooltip-order-summary-button": "\n .title = Vis ordreoversigt",
        "create-order-order-summary-no-items": "Ordreoversigten er tom. Tilføj varer til din ordre for at se detaljerne.",
        "create-order-order-summary": "Ordreoversigt",
        "create-order-order-summary-resources": "\n .title = Ressourcer",
        "create-order-order-summary-resources-booking-time": "Booking",
        "create-order-order-summary-meeting-services": "\n .title = Mødeforplejning",
        "create-order-order-summary-meeting-services-delivery-time": "Levering { $number }",
        "create-order-order-summary-meeting-services-total": "I alt",
        "create-order-order-summary-meeting-services-empty": "Ingen varer tilføjet endnu",
        "create-order-order-summary-meeting-services-product-item": "{$count} vare",
        "create-order-order-summary-meeting-services-product-items": "{$count} varer",
        "create-order-order-summary-meeting-services-product-warning-price-list-tooltip": "\n .title = Den valgte prisliste matcher ikke produktets prisliste — forhøjelse er ikke tilgængelig.",
        "create-order-order-summary-meeting-services-product-warning-missing-product-tooltip": "\n .title = Dette produkt er ikke tilgængeligt i den valgte shopliste",
        "create-order-order-summary-meeting-services-product-price-mismatch-dialog": "\n .dialogTitle = Priserne på dine produkter er ændret",
        "create-order-order-summary-meeting-services-product-price-mismatch-dialog-message": "Nogle produkter i din ordre har ændret pris. Hvis du fortsætter med at opdatere ordren, vil alle varer blive opdateret til deres aktuelle pris.",
        "create-order-order-summary-meeting-services-product-price-mismatch-dialog-submit-button": "Opdater",
        "create-order-order-summary-meeting-services-product-price-mismatch-dialog-cancel-button": "Opdater ikke priser",
        "create-order-order-summary-meeting-services-invalid-time-card-empty-title": "Levering uden varer",
        "create-order-order-summary-meeting-services-invalid-time-card-empty": "Der blev ikke tilføjet nogen varer til leveringen kl. {$time}. Tilføj venligst varer eller fjern leveringstidspunktet.",
        "create-order-order-summary-meeting-services-invalid-times-card-empty": "Der blev ikke tilføjet nogen varer til leveringen kl. {$time}. Tilføj venligst varer eller fjern leveringstidspunkterne.",
        "create-order-order-summary-meeting-services-invalid-times-card-empty-button": "Ok",
        "create-order-confirm-booking-meeting-details": "Mødedetaljer",
        "create-order-confirm-booking-update-meeting-details": "Opdater mødedetaljer #{ $id }",
        "create-order-confirm-booking-dialog-add-attendees": "Tilføj deltagere",
        "create-order-confirm-booking-dialog-back-button": "Tilbage",
        "create-order-confirm-booking-meeting-information-tab": "Mødeinformation",
        "create-order-confirm-booking-participants-tab": "Deltagere",
        "create-order-confirm-booking-other-tab": "Andet",
        "create-order-confirm-booking-dialog-confirm-button": "Bekræft",
        "create-order-confirm-booking-dialog-submit-button": "Fuldfør booking",
        "create-order-confirm-booking-dialog-add-attendee-button": "Tilføj deltagere",
        "create-order-confirm-booking-dialog-bulk-add-attendees-button": "Kopier og indsæt",
        "create-order-confirm-booking-dialog-bulk-add-attendees-button-tooltip": "\n .title = Tilføj flere deltagere ved at indsætte en liste over navne og virksomheder",
        "create-order-confirm-booking-dialog-bulk-add-attendees-description": "Indtast ét navn og virksomhed per linje.",
        "create-order-confirm-booking-dialog-bulk-add-attendees-field": "\n .placeholder = Navn, Virksomhed",
        "create-order-confirm-booking-dialog-bulk-add-attendees-drawer-button": "Tilføj deltagere",
        "create-order-confirm-booking-selected-resources": "Valgte ressourcer ({ $count }):",
        "create-order-confirm-booking-booking-time": "Bookingstid: { $time }",
        "create-order-confirm-booking-rooms": "Lokaler:",
        "create-order-confirm-booking-equipment": "AV-udstyr:",
        "create-order-confirm-booking-cars": "Biler:",
        "create-order-confirm-booking-time-range-picker-from-field": "\n .label =Fra tid:",
        "create-order-confirm-booking-time-range-picker-to-field": "\n .label =Til tid:",
        "create-order-confirm-booking-time-range-picker-error": "Ressource er ikke tilgængelig på dette tidspunkt",
        "create-order-confirm-booking-table-setup": "Bordopsætning",
        "create-order-confirm-booking-select-setup": "Vælg opsætning",
        "create-order-confirm-booking-message-title": "Beskeder til servicecenter",
        "create-order-attendees-dialog-submit-button": "Gem",
        "create-order-attendees-dialog-title": "Deltagere",
        "create-order-note-add-button": "Tilføj",
        "create-order-note-edit-button": "Rediger",
        "create-order-note-dialog-title": "\n .dialogTitle = Ordrebesked",
        "create-order-note-dialog-alert": "\n .title = Din ordremeddelelse vil være synlig på ordrespecifikationen. Du må ikke inkludere personligt identificerbar information, såsom detaljer om dit helbred eller din religion.",
        "create-order-note-dialog-field": "\n .label = Din ordrebesked \n .helperText = Resterende tegn: { $count }",
        "create-order-note-save-button": "Gem",
        "create-order-extra-services": "Ekstra serviceydelser",
        "create-order-extra-services-delivery": "\n .title = Levering kl. { $time }",
        "create-order-extra-services-min-max": "Min. { $min } - Maks. { $max }",
        "create-order-extra-services-add-button": "Tilføj",
        "create-order-extra-services-remove-button": "Fjern",
        "create-order-participants-add-button": "+ Tilføj deltagere",
        "create-order-participants-edit-button": "Rediger deltagere",
        "create-order-participants-count-list": "{ $count } deltagere",
        "create-order-participants-count-one-item": "{ $count } deltager",
        "create-order-participants-dialog-name-column": "Navn",
        "create-order-participants-dialog-company-column": "Virksomhed",
        "create-order-participants-dialog-email-column": "E-mail",
        "create-order-participants-dialog-external-internal-column": "Ekstern",
        "create-order-participants-dialog-field-name": "\n .placeholder = Deltagernavn",
        "create-order-participants-dialog-field-company": "\n .placeholder = Virksomhed",
        "create-order-participants-dialog-field-email": "\n .placeholder = E-mailadresse",
        "create-order-add-filters-button": "Tilføj filtre",
        "create-order-add-search-input": "\n .placeholder = Søg",
        "create-order-tooltip-view-button": "\n .title = Vælg bookingvisning",
        "create-order-view-timeline": "Tidslinje",
        "create-order-view-available-time": "Tilgængelig tid",
        "create-order-view-room-finder": "Rumfinder",
        "create-order-calendar-today-button": "I dag",
        "create-order-calendar-go-to-date-button": "Gå til dato",
        "create-order-calendar-no-resources-message": "Der er ingen tilgængelige ressourcer. Juster venligst filtrene",
        "create-order-calendar-go-to-date-label": "\n .label = Vælg dato",
        "create-order-calendar-go-button": "Gå",
        "create-order-calendar-all-day-label": "Hele dagen",
        "create-order-calendar-week-button": "Nuværende uge",
        "create-order-calendar-prev-week-button": "Forrige uge",
        "create-order-calendar-next-week-button": "Næste uge",
        "create-order-calendar-event-tooltip": "\n .title = Klik for at booke",
        "create-order-confirm-booking-confirm-dialog": "\n .title = Bekræft booking\n .message =Din booking er ikke fuldført. Bekræft venligst din booking, før du fortsætter.\n .buttonLabelSubmit = Bekræft\n .buttonLabelCancel = Annuller",
        "create-order-confirm-booking-confirm-no-resources-dialog": "\n .title = Booking ikke fuldført\n .message =Du har endnu ikke valgt nogen ressourcer. Hvis du forlader nu, bliver din booking ikke fuldført.\n .buttonLabelSubmit = Vælg ressourcer\n .buttonLabelCancel = Forlad alligevel",
        "create-order-change-time-dialog": "\n .title = Ændre bookingtid?\n .buttonLabelSubmit = Brug ny tid\n .buttonLabelCancel = Behold oprindelig tid",
        "create-order-change-time-dialog-message-top": "Din Outlook-mødeindkaldelse er planlagt til:",
        "create-order-change-time-dialog-message-bottom": "Vil du ændre bookingtiden til:",
        "create-order-drawer-other-location": "+ Anden placering",
        "create-order-drawer-delivery-location-field": "\n .label = Leveringssted",
        "create-order-drawer-repeat-order": "Gentag ordre",
        "create-order-drawer-repeat-order-every": "Gentag hver:",
        "create-order-drawer-repeat-order-every-day": "\n .label = Dag",
        "create-order-drawer-repeat-order-every-week": "\n .label = Uge",
        "create-order-drawer-repeat-order-on": "Gentag på:",
        "create-order-drawer-repeat-order-starts": "Starter:",
        "create-order-drawer-repeat-order-ends": "Slutter:",
        "create-order-drawer-repeat-order-ends-on": "\n .label = På",
        "create-order-drawer-repeat-order-ends-after": "\n .label = Efter",
        "create-order-drawer-repeat-order-ends-after-times": "gange",
        "create-order-drawer-repeat-order-confirm-button": "Bekræft",
        "create-order-drawer-repeat-order-summary": "Gentages hver { $interval }{ $days }, fra { $startDate }{ $repeatCount }{ $endDate }.",
        "create-order-drawer-repeat-order-summary-interval-day": "dag",
        "create-order-drawer-repeat-order-summary-interval-days": "{ $count } dage",
        "create-order-drawer-repeat-order-summary-interval-week": "uge",
        "create-order-drawer-repeat-order-summary-interval-weeks": "{ $count } uger",
        "create-order-drawer-repeat-order-summary-days-suffix": " på { $days }",
        "create-order-drawer-repeat-order-summary-repeat-count-suffix": ", { $count } gange",
        "create-order-drawer-repeat-order-summary-end-date-suffix": ", slutter den { $date }",
        "create-order-tooltip-resource-info-button": "\n .title = Vis ressourceoplysninger",
        "create-order-tooltip-resource-lock-button": "\n .title = Kan kun bookes af valgte brugere",
        "create-order-tooltip-resource-image-button": "\n .title = Vis plantegning",
        "create-order-hover-local-event-start": "Starttid: { $start }",
        "create-order-hover-local-event-end": "Sluttid: { $end }",
        "create-order-hover-local-event-host": "Vært: { $host }",
        "create-order-tabs-error": "Du kan ikke afgive en ordre",
        "create-order-tabs-error-body": "Du kan ikke afgive en ordre, fordi din konto ikke har den nødvendige adgang. Kontakt venligst support, hvis du har brug for flere oplysninger.",
        "create-order-tabs-error-dialog-close-button": "Gå tilbage",
        "create-order-tabs-error-dialog-confirm-button": "Vælg en anden bruger",
        "create-order-price-list-confirm-dialog": "\n .title = Fjern produkter\n .buttonLabelSubmit = Fjern",
        "create-order-price-list-confirm-dialog-message": "Er du sikker på, at du vil fjerne alle produkter fra alle leveringstidspunkter?",
        "create-order-close-confirm-dialog": "\n .title = Kassér ændringer \n .buttonLabelSubmit = Kassér",
        "create-order-close-confirm-dialog-message": "Hvis du klikker på Kassér, går alle indtastede oplysninger tabt.",
        "create-order-drawer-messages-dialog-title": "\n .dialogTitle = Beskeder fra shopejeren",
        "create-order-drawer-message-read-more": "...Læs mere",
        "create-order-book-period-message-dialog-title": "\n .dialogTitle = Du kan ikke klikke på tidslinjen, mens du bruger tilstanden `Reservér periode`",
        "create-order-book-period-message-dialog-note": "For at booke ressourcer skal du klikke på ressourcerne i venstre panel",
        "create-order-book-period-busy-message": "Den valgte ressource er ikke tilgængelig for hele perioden",
        "create-order-book-period-busy-error": "Kunne ikke tjekke ressourcetilgængelighed",
        "create-order-book-period-confirm-cancel-changes-dialog": "\n .title = Fjern det nuværende valg\n .buttonLabelSubmit = Bekræft\n .buttonLabelCancel = Annuller",
        "create-order-book-period-confirm-cancel-changes-dialog-message": "Ændring af perioden vil rydde dit nuværende valg. Vil du fortsætte?",
        "create-order-past-booking-attempt-message": "Du kan ikke booke tilbage i tiden. Starttidspunktet for bookingen skal være lig med eller senere end det aktuelle tidspunkt",
        "create-order-book-period-past-booking": "Kan ikke vælge en periode i fortiden",
        "create-order-change-current-event-dialog": "\n .title = Du er i gang med at opdatere booking { $orderDetails } \n .message =Er du sikker på, at du vil nulstille ændringerne og opdatere en anden booking?\n .buttonLabelSubmit = Bekræft\n .buttonLabelCancel = Annuller",
        "create-order-change-current-event-create-dialog": "\n .title = Du er i gang med at oprette en booking \n .message =Er du sikker på, at du vil nulstille ændringerne og opdatere en anden booking?\n .buttonLabelSubmit = Bekræft\n .buttonLabelCancel = Annuller",
        "create-order-timeline-permission-error": "Du har ikke rettigheder til at opdatere denne booking, da den tilhører en anden bruger",
        "create-order-timeline-error-select": "Dette tidsrum er ikke tilgængeligt for de valgte ressourcer",
        "create-order-timeline-error-busy-or-overlap": "Denne ressource er allerede optaget på det valgte tidspunkt, eller der er registreret overlap med buffer!",

        "create-order-select-price-list-dialog": "Vælg prisliste",
        "create-order-empty-price-list-dialog": "Ingen prisliste tilgængelig",
        "create-order-empty-price-list-dialog-body": "Der er i øjeblikket ingen prislister tilgængelige",
        "create-order-empty-price-list-dialog-body-message": "Kontakt venligst shopejeren for at anmode om adgang til dem",
        "create-order-select-price-list-no-price-lists-title": "Der er i øjeblikket ingen prislister tilgængelige. Kontakt venligst shopejeren for at anmode om adgang til dem.",
        "create-order-select-price-list-no-search-results": "Din søging gav ingen resultater",
        "create-order-select-price-list-favorites-section": "Mine favoritter ({ $count })",
        "create-order-select-price-list-favorites-view-all": "Vis alle ({ $count })",
        "create-order-products-empty-favorites-title": "Du har ingen favoritvarer",
        "create-order-no-products-dialog-title": "\n .dialogTitle = Prislisten indeholder ingen produkter",
        "create-order-no-products-dialog-message": "Kontakt venligst shopejeren for at få adgang til produkterne",
        "create-order-no-longer-available-dialog-title": "\n .dialogTitle = Prislisten er ikke længere tilgængelig",
        "create-order-no-longer-available-dialog-message": "Prislisten, der blev brugt til denne ordre, er ikke længere tilgængelig. Vælg venligst en anden prisliste for at fortsætte.",
        "create-order-no-products-dialog-button-label-cancel": "Gå til forsiden",
        "create-order-no-products-dialog-button-label-submit": "Vælg en anden prisliste",
        "create-order-products-empty-favorites-description": "Du kan tilføje favoritvarer, så du kan gennemføre en ordre hurtigere. Tilføj en favoritvare ved at klikke på hjerteikonet på produktkortet",
        "create-order-credit-note-overlay-title": "Kreditnota",
        "create-order-credit-note-overlay-message-with-order-id": "Du er ved at oprette en kreditnota for ordre-ID <orderIdLink>#{ $orderId }</orderIdLink>.<lineBreak></lineBreak>Tilføj venligst de produkter, du ønsker at kreditere, i kurven til højre.",
        "create-order-select-price-list-external-meetings": "Eksterne møder",
        "create-order-select-price-list-external-meetings-description": "Vælg dette, hvis du vil bestille til et eksternt møde",
        "create-order-on-behalf-of-dialog": "Bestil på vegne af",
        "create-order-on-behalf-of-dialog-description": "For at oprette en ordre som administrator skal du først vælge den bruger, du opretter ordren for.",
        "create-order-on-behalf-of-dialog-select-company-field": "\n .label = Vælg firma",
        "create-order-on-behalf-of-dialog-select-user-field": "\n .label = Vælg bruger\n .placeholder = Indtast brugernavn:",
        "create-order-on-behalf-of-dialog-select-user-field-no-results": "Ingen resultater",
        "create-order-on-behalf-of-dialog-select-company-host-field": "\n .label = Værtsfirma:",
        "create-order-on-behalf-of-dialog-select-host-field": "\n .label = Vært:\n .placeholder = Indtast værtsnavn:",
        "create-order-on-behalf-of-dialog-button": "Fortsæt",
        "create-order-bill-receiver-ean": "EAN:",
        "create-order-bill-receiver-email": "E-mail:",
        "create-order-bill-receiver-contact": "Kontakt:",
        "create-order-bill-receiver-add-button": "+ Tilføj fakturamodtager",
        "create-order-bill-receiver-autocomplete-no-options": "Ingen muligheder",
        "create-order-vat-included": "(inkl. moms)",
        "create-order-vat-excl": "(ekskl. moms)",


        "create-order-success-dialog-resource-booking-title": "Ressourcer booket!",
        "create-order-success-dialog-meeting-service-title": "Mødeforplejning gemt!",
        "create-order-success-dialog-description": "Hvad vil du gøre nu?",
        "create-order-success-dialog-action-meeting-service": "Tilføj mødeforplejning til ordren",
        "create-order-success-dialog-action-meeting-service-update": "Opdater mødeforplejning",
        "create-order-success-dialog-action-add-resource-booking": "Tilføj ressourcebooking",
        "create-order-success-dialog-action-update-resource-booking": "Opdater ressourcebooking",
        "create-order-success-dialog-action-create-booking": "Opret en ny booking",
        "create-order-success-dialog-action-create-meeting-service": "Opret ny mødeforplejning",
        "create-order-success-dialog-action-finish": "Jeg er færdig",
        "create-order-success-dialog-action-calendar": "Tilføj møde til kalenderen",

        // Confirm order dialog
        "confirm-order-dialog-order-error": "Kunne ikke indlæse kvittering med id #{ $orderId }",
        "confirm-order-dialog-order-error-description": "Denne ordre kunne ikke behandles på grund af manglende eller ugyldige data.",
        "confirm-order-dialog-title": "Bekræft ordre",
        "confirm-order-dialog-title-update-order": "Opdater ordre #{ $id }",
        "confirm-order-dialog-title-credit-note-order": "Opret kreditnota",
        "confirm-order-dialog-title-supplementary-order": "Opret tillægsordre",
        "confirm-order-dialog-meeting-details": "Mødedetaljer",
        "confirm-order-dialog-meeting-time": "Mødetidspunkt:",
        "confirm-order-dialog-delivery-date": "Leveringsdato:",
        "confirm-order-dialog-delivery-date-time-format": "d. LLL yyyy, HH:mm",
        "confirm-order-dialog-delivery-location": "Leveringssted:",
        "confirm-order-dialog-delivery-location-mode-eating-in-canteen": "Spisning i kantinen",
        "confirm-order-dialog-delivery-location-mode-pick-up": "Afhentning",
        "confirm-order-dialog-seats": "Pladser:",
        "confirm-order-dialog-merchant": "Shopejer:",
        "confirm-order-timestamp-created": "Oprettet:",
        "confirm-order-timestamp-updated": "Opdateret:",
        "confirm-order-dialog-contact": "Kontakt",
        "confirm-order-dialog-host": "Vært:",
        "confirm-order-dialog-ordered-by": "Bestilt af:",
        "confirm-order-dialog-bill-receiver": "Fakturamodtager",
        "confirm-order-dialog-bill-receiver-contact": "Kontakt:",
        "confirm-order-dialog-bill-receiver-contact-email": "E-mail:",
        "confirm-order-dialog-bill-receiver-cost-centers": "Omkostningssteder:",
        "confirm-order-dialog-bill-receiver-meeting-type": "Mødetype:",
        "confirm-order-dialog-bill-receiver-department": "Afdeling:",
        "confirm-order-dialog-bill-receiver-debitor": "Debitor: { $name }",
        "confirm-order-dialog-order-summary": "Ordreoversigt",
        "confirm-order-dialog-order-summary-delivery-date": "Levering: { $date }",
        "confirm-order-dialog-order-summary-delivery-date-time": "Levering: { $date }, { $time }",
        "confirm-order-dialog-order-summary-table-meeting-service": "Mødeforplejning",
        "confirm-order-dialog-order-summary-table-items": "Antal",
        "confirm-order-dialog-order-summary-table-amount": "Beløb",
        "confirm-order-dialog-order-summary-table-amount-no-vat": "Beløb",
        "confirm-order-dialog-order-summary-table-meeting-services-total": "I alt",
        "confirm-order-dialog-order-summary-table-meeting-services-total-no-vat": "I alt",
        "confirm-order-dialog-order-summary-table-meeting-services-vat": "Moms udgør ({ $percentage }%)",
        "confirm-order-dialog-order-summary-table-meeting-services-total-include-vat": "Samlet beløb inkl. moms",
        "confirm-order-dialog-repeat-order": "\n .title = Gentag ordre",
        "confirm-order-dialog-repeat-order-text": "Gentag ordre",
        "confirm-order-dialog-attendees": "\n .title = Deltagere",
        "confirm-order-dialog-attendees-subtitle": "{ $internalCount } interne, { $externalCount } eksterne",
        "confirm-order-dialog-attendees-internal": "\n .title = Interne deltagere:",
        "confirm-order-dialog-attendees-external": "\n .title = Eksterne deltagere:",
        "confirm-order-dialog-resources": "\n .title = Ressourcer",
        "confirm-order-dialog-back-button": "Fortsæt redigering",
        "confirm-order-dialog-next-button": "Bekræft ordre",
        "confirm-order-dialog-booking-time": "Bookingtid: { $timeRange }",

        "user-order-receipt-page-share-button": "Del",
        "user-order-receipt-page-not-loaded-message": "  Ordre-id { $orderId } kunne ikke læses. Kontakt venligst support.",
        "user-order-receipt-page-not-found-public-message": "Beklager, ordren blev ikke fundet. Kontakt venligst support på <link>{ $supportEmail }</link>, hvis du har brug for hjælp.",
        "user-order-receipt-page-loading": "Indlæser ordre...",
        "user-order-receipt-page-share-modal-title": "Del kvittering",
        "user-order-receipt-page-share-modal-subtitle": "Del dette link for at lade andre se kvitteringen.",
        "user-order-receipt-page-print-button": "Udskriv",
        "user-order-receipt-page-header-orders-count": "Ordrer: {$orderCount} valgt",
        "user-pos-order-receipt-page-header-orders-count": "Kvitteringer: {$orderCount} valgt",
        "merchant-receipt-dropdown-search-label": "\n .label = Søg..." ,

        "create-order-delivery-times-add-button": "Tilføj leveringstidspunkter",
        "create-order-delivery-times-add-btn": "Tilføj",
        "create-order-delivery-times-add-delivery-time-title": "Tilføj leveringstidspunkt",
        "create-order-delivery-times-update-delivery-time": "Opdater leveringstidspunkt",
        "create-order-delivery-times-add-delivery-time": "Tilføj leveringstidspunkt:",
        "create-order-delivery-times-dialog-title-add": "Tilføj leveringstidspunkter",
        "create-order-delivery-times-dialog-title-edit": "Rediger leveringstidspunkter",
        "create-order-delivery-times-dialog-subtitle": "Du skal vælge en dato for leveringen.",
        "create-order-delivery-times-dialog-subtitle-example": "Du kan angive flere leveringstidspunkter til heldagsmøder, f.eks. levering kl. 10:00 og kl. 13:00.",
        "create-order-delivery-times-dialog-delivery-date": "Leveringsdato",
        "create-order-delivery-times-dialog-delivery-date-details": "Leveringsdato:",
        "create-order-delivery-times-dialog-delivery-time-event-start": "Desværre kan du ikke oprette en mødeforplejningsordre. Shopejeren leverer kun mellem {$minTime} og {$maxTime}.",
        "create-order-delivery-times-dialog-delivery-time-event-start-today": "Desværre kan du ikke oprette en mødeforplejningsordre i dag, fordi shopejeren ikke leverer senere end { $time }",
        "create-order-delivery-times-dialog-delivery-date-close-tooltip": "Salgssted er lukket på denne dato",
        "create-order-delivery-times-dialog-delivery-times": "Leveringstidspunkter",
        "create-order-delivery-times-dialog-delivery-field": "\n .label = Levering { $count }",
        "create-order-delivery-times-dialog-add-delivery-button": "+ Tilføj levering",
        "create-order-delivery-times-dialog-submit-button": "Bekræft",
        "create-order-delivery-times-dialog-close-button": "Ok",
        "create-order-delivery-times-empty-error": "Ingen aktiv leveringstid valgt",
        "create-order-cost-centers-missing-dialog-title": "Omkostningssteder er ikke tilgængelige",
        "create-order-cost-centers-missing-message": "Der er ingen omkostningssteder tilgængelige for \"{ $dimensionName }\". Kontakt venligst din administrator for at få oprettet omkostningssteder.",
        "create-order-delivery-location-required": "Leveringsadresse er påkrævet",
        "create-order-multiple-deliveries-date-and-time-required": "Du skal vælge en leveringsdato og mindst ét leveringstidspunkt",
        "create-order-validation-date-invalid": "{ $label } skal være en gyldig dato",
        "create-order-validation-must-be-checked": "{ $label } skal være markeret",
        "create-order-validation-required": "{ $label } er påkrævet",
        "create-order-validation-min": "{ $label } skal være mindst { $min }",
        "create-order-validation-max": "{ $label } skal være højst { $max }",
        "create-order-validation-must-be-true": "{ $label } skal være sand",
        "create-order-validation-email-invalid": "{ $label } skal være en gyldig e-mailadresse",
        "create-order-validation-format-invalid": "{ $label } har ikke korrekt format",
        "create-order-delivery-times-same-time-error": "Det samme tidspunkt kan ikke tilføjes to gange",
        "create-order-delivery-times-opening-hours-error": "Det valgte tidspunkt ligger ikke inden for åbningstiderne for denne dato",
        "create-order-delivery-times-past-time-error": "Leveringstidspunktet kan ikke ligge i fortiden",
        "create-order-refund-amount-exceeds-initial-error": "Kreditnotaen må ikke overstige det oprindelige beløb.",
        "create-order-delivery-deadline-message-dialog-title": "\n .title = Deadline er overskredet \n .buttonLabelSubmit = Afgiv ordre \n .buttonLabelCancel = Annuller ordre",
        "create-order-delivery-deadline-message-dialog-description": "Du kan stadig afgive ordren, men den skal godkendes af personalet, hvilket betyder, at du ikke kan forvente, at ordren bliver leveret.",

        "create-order-timeline-booked-period": "Reservér periode",
        "create-order-timeline-booked-period-start-date-time-label": "\n .label = Starttid",
        "create-order-timeline-booked-period-end-date-time-label": "\n .label = Sluttid",

        "resource-booking-chip-filter-select-booking-duration-hours": "hours",
        "resource-booking-chip-filter-select-booking-duration-minutes": "minutes",
        "resource-booking-chip-filter-select-meeting-type-title-internal-meeting": "Internal meeting",
        "resource-booking-chip-filter-select-meeting-type-title-internal-meeting-description": "The meeting is with coworkers only, no external guests.",
        "resource-booking-chip-filter-select-meeting-type-title-external-meeting": "External meeting",
        "resource-booking-chip-filter-select-meeting-type-title-external-meeting-description": "Meeting has external guests.",
        "resource-booking-chip-filter-select-title-floors": "Select floor",
        "resource-booking-chip-filter-select-title-fixedavids": "Select fixed AV-equipment",
        "resource-booking-chip-filter-select-title-meetingtype": "Select meeting type",
        "resource-booking-chip-filter-select-title-sittings": "Number of seats",
        "resource-booking-chip-filter-select-title-tablesetupids": "Select table arrangements",
        "resource-booking-chip-filter-select-title-resourcetypeids": "Select resource type",
        "resource-booking-chip-filter-select-title-servicecenterids": "Select service centers",
        "resource-booking-chip-filter-select-title-meetingduration": "Booking duration",

        // Resource details dialog
        "resource-details-dialog-service-center": "Service center",
        "resource-details-dialog-floor": "Floor",
        "resource-details-dialog-description": "Description",
        "resource-details-dialog-square-meters": "Square meters",
        "resource-details-dialog-walk-direction":"Walk direction",
        "resource-details-dialog-reserved-for": "Reserved for",
        "resource-details-dialog-reserved-for-internal": "Internal meetings",
        "resource-details-dialog-reserved-for-external": "External meetings",
        "resource-details-dialog-capacity": "Capacity",
        "resource-details-dialog-capacity-quantity": "{ $quantity } people",
        "resource-details-dialog-table-arrangement": "Table arrangement",
        "resource-details-dialog-av-equipment": "AV-equipment",


        // Service center > Navigation
        "service-center-nav-item-user-label": "\n .title = Hjem" ,
        "service-center-nav-item-canteen-label": "\n .title = Kommende møder" ,
        "service-center-nav-item-guests-label": "\n .title = Gæsteliste",
        "service-center-nav-item-calendar-label": "\n .title = Kalender" ,
        "service-center-nav-item-reports-label": "\n .title = Statistik" ,
        "service-center-nav-item-settings-label": "\n .title = Administration" ,

        // Service center > Reports > Dashboard
        "service-center-reports-dashboard-check-in-button": "Tjek ind",
        "service-center-reports-dashboard-checked-id": "Tjekket ind",
        "service-center-reports-dashboard-check-in-guests-button": "Gæste tjek-ind",
        "service-center-reports-dashboard-meeting-title": "Møde",
        "service-center-reports-dashboard-search-label": "\n .label = Søg" ,
        "service-center-reports-dashboard-meeting-pagination": "Resultater pr side",
        "service-center-reports-dashboard-check-in-title": "Tjek-ind kø",
        "service-center-reports-dashboard-guest-check-in-title": "Gæste tjek-ind",
        "service-center-reports-dashboard-no-guests":"Ingen gæster i tjek-ind køen",
        "service-center-reports-dashboard-news-title": "Nyheder",
        "service-center-reports-dashboard-no-news":"Ingen nyheder",
        "service-center-reports-dashboard-no-meeting-selected":"Ingen møde valgt",
        "service-center-reports-dashboard-no-meetings":"Der er ingen møder i dag.",

        // Service center > Reports > Upcoming meetings
        "service-center-reports-upcoming-meetings-title": "\n .title = Kommende møder",

        // Service center > Reports > Dashboard > Check in modal
        "service-center-reports-dashboard-check-in-modal-title": "Gæste tjek-ind",
        "service-center-reports-dashboard-print-labels-modal-title": "Udskriv gæstekort",
        "service-center-reports-dashboard-printing-labels-modal-title": "Udskriver gæstekort",
        "service-center-reports-dashboard-printing-labels-modal-subtitle": "Gæstekort at udskrive ({ $amount})",
        "service-center-reports-dashboard-printing-labels-of": "af",
        "service-center-reports-dashboard-printing-labels-cancel": "Annuller",
        "service-center-reports-dashboard-printing-labels-print": "Udskriv",

        // Label printer errors
        "label-printer-error-no-labels": "Ingen etiketter at udskrive",
        "label-printer-error-cancelled": "Udskrivning annulleret af bruger",
        "label-printer-error-required-fields": "Udfyld venligst alle påkrævede felter og sørg for, at gruppestørrelsen er mindst 1",
        "label-printer-error-failed-guest-label": "Kunne ikke udskrive gæsteetiket",
        "label-printer-error-unknown-guest-label": "Ukendt fejl ved udskrivning af gæsteetiket",
        "label-printer-error-failed-label-for": "Kunne ikke udskrive etiket for { $name }",
        "label-printer-error-printing-label-for": "Fejl ved udskrivning af etiket for { $name }",
        "label-printer-error-failed-group-labels": "Kunne ikke udskrive gruppeetiketter",
        "label-printer-error-unknown-group-labels": "Ukendt fejl ved udskrivning af gruppeetiketter",
        "label-printer-error-failed-takeaway-labels": "Kunne ikke udskrive takeaway-etiketter",
        "label-printer-error-unknown-takeaway-labels": "Ukendt fejl ved udskrivning af takeaway-etiketter",

        "service-center-reports-check-in-modal-guest-details": "Gæstedetaljer",
        "service-center-reports-check-success-title": "Gæst tjekket ind",
        "service-center-reports-check-validation-error": "Please select a host and company before checking in.",
        "service-center-reports-check-in-modal-single": "Individ",
        "service-center-reports-check-in-modal-group": "Gruppe",
        "service-center-reports-check-in-modal-host-name": "\n .label = Værtsnavn",
        "service-center-reports-check-in-modal-host-company": "\n .label = Værtsfirma",
        "service-center-reports-check-in-modal-guest-name": "\n .label = Gæstenavn",
        "service-center-reports-check-in-modal-number-of-guests": "\n .label = Antal gæster",
        "service-center-reports-check-in-modal-guest-company": "\n .label = Gæstefirma",
        "service-center-reports-check-in-modal-guests-company": "\n .label = Gæstefirma",
        "service-center-reports-check-in-modal-print-guest-card": "\n .label = Udskriv gæstekort",
        "service-center-reports-check-in-modal-send-host-notification": "\n .label = Adviser vært",
        "service-center-reports-check-in-modal-send-host-notification-tooltip": "\n .title = Vært vil modtage besked om, at gæsten er ankommet.",
        "service-center-reports-check-in-modal-write-message-to-host": "\n .label = Skriv besked til vært",
        "service-center-reports-check-in-modal-settings": "Indstillinger",
        "service-center-reports-check-in-modal-check-in-button": "Tjek ind",
        "service-center-reports-check-in-modal-guest-check-in-title": "Gæste tjek-ind",
        "service-center-reports-check-in-modal-guest-check-in-subtitle": "Gæster at tjekke ind ({ $amount})",

        "service-center-reports-check-in-modal-guest-details-printer-dialog-printing": "Printing label...",
        "service-center-reports-check-in-modal-guest-details-printer-not-installed-modal-title": "Chrome label printer extension is not installed",
        "service-center-reports-check-in-modal-guest-details-printer-not-installed-modal-cta-message": "Click <hereLink>here</hereLink> to open Chrome web store where you can install the extension.",
        "service-center-reports-check-in-modal-guest-details-printer-not-installed-modal-message":" To print labels, please install the Brother b-PAC Extension and reload page.",


        // Service center > Reports > Dashboard > Meetings drawer
        "service-center-reports-dashboard-meetings-drawer-user-details-dialog-name": "Name:",
        "service-center-reports-dashboard-meetings-drawer-user-details-dialog-company-name": "Company: ",
        "service-center-reports-dashboard-meetings-drawer-user-details-dialog-department-name": "Department: ",
        "service-center-reports-dashboard-meetings-drawer-user-details-dialog-email": "E-mail: ",
        "service-center-reports-dashboard-meetings-drawer-user-details-dialog-business-phone": "Phone number: ",
        "service-center-reports-dashboard-meetings-drawer-user-details-dialog-mobile-phone": "Mobile number: ",
        "service-center-reports-dashboard-meetings-drawer-meeting-time": "Mødetidspunkt: ",
        "service-center-reports-dashboard-meetings-drawer-host": "Vært: ",
        "service-center-reports-dashboard-meetings-drawer-host-company": "Company: ",
        "service-center-reports-dashboard-meetings-drawer-location": "Lokation: ",
        "service-center-reports-dashboard-meetings-drawer-manage-all-button": "Administrer alle",
        "service-center-reports-dashboard-meetings-drawer-guests-title": "Gæster",
        "service-center-reports-dashboard-meetings-drawer-manage-all-bulk-print-labels": "Bulk udskriv gæstekort",
        "service-center-reports-dashboard-meetings-drawer-manage-all-bulk-check-in": "Tjek alle ind",
        "service-center-reports-dashboard-meetings-drawer-guests-list-checked-title": "\n .title = Tjekket ind",
        "service-center-reports-dashboard-meetings-drawer-guests-list-not-checked-title": "\n .title = Ikke tjekket ind",
        "service-center-reports-dashboard-meetings-drawer-guests-list-floating-check-action": "\n .title = Tjek ind",
        "service-center-reports-dashboard-meetings-drawer-guests-list-floating-print-guest-action": "Udskriv gæstekort",
        "service-center-reports-dashboard-meetings-drawer-guests-list-floating-other-action":"\n .title = Andet",
        "service-center-reports-dashboard-meetings-drawer-selected-guests": "Valgte gæster",
        "service-center-reports-dashboard-meetings-drawer-manage-meeting-dropdown-item-manage-meeting-display": "Manage meeting display",
        "service-center-reports-dashboard-meetings-drawer-manage-meeting-modal-name-field-required-error": "Name is required",
        "service-center-reports-dashboard-meetings-drawer-manage-meeting-modal-success-message": "Successfully updated meeting display",
        "service-center-reports-dashboard-meetings-drawer-manage-meeting-modal-title": "Manage meeting on displays",
        "service-center-reports-dashboard-meetings-drawer-manage-meeting-modal-meeting-name-label": "\n .label = New meeting name on displays \n .placeholder = Enter new meeting name",
        "service-center-reports-dashboard-meetings-drawer-manage-meeting-modal-switch-label": "Show as canceled",
         "service-center-reports-dashboard-meetings-drawer-manage-meeting-modal-show-on-screens-switch-label": "Vis på skærme",
        "service-center-reports-dashboard-meetings-drawer-manage-meeting-modal-submit-button": "Save",

        "service-center-reports-dashboard-meetings-drawer-manage-meeting-modal-alert-change-name-label": "Change meeting name:",
        "service-center-reports-dashboard-meetings-drawer-manage-meeting-modal-alert-change-name-description": " If the meeting name is not appropriate for display on meeting displays, you can edit it here. This modification will only affect the name shown on the displays.",
        "service-center-reports-dashboard-meetings-drawer-manage-meeting-modal-alert-cancel-meeting-label": "Cancel meeting:",
        "service-center-reports-dashboard-meetings-drawer-manage-meeting-modal-alert-cancel-meeting-description": " If you need to cancel a meeting while keeping it visible, you can simply mark it as canceled.",

        // Service center > Reports > Dashboard > Statistics
        "service-center-reports-statistics-page-header": "Statistics",
        "service-center-reports-statistics-occupancy-tab-title": "Occupancy",
        "service-center-reports-statistic-occupancy-table-date-range-filter": "\n .label = Date range",
        "service-center-reports-statistic-occupancy-table-resource-title": "Resource",
        "service-center-reports-statistic-occupancy-table-occupancy-rate-title": "Occupancy rate",
        "service-center-reports-statistic-occupancy-table-status-title": "Status",

        "service-center-reports-statistics-cancellations-tab-title": "Cancellations",
        "service-center-reports-statistic-cancellations-table-cancellation-rate-title": "Cancellation rate",

        "service-center-reports-statistics-booking-duration-tab-title": "Booking duration",
        "service-center-reports-statistic-booking-duration-table-number-of-bookings-title": "Bookings amount",
        "service-center-reports-statistic-booking-duration-table-average-duration-title":  "Avg. duration",

        "service-center-reports-statistics-guests-tab-title": "Guests",
        "service-center-reports-statistic-guests-table-date-title": "Date",
        "service-center-reports-statistic-guests-table-guests-title": "Guests",

        "service-center-reports-statistics-peak-hours-tab-title": "Peak hours",
        "service-center-reports-statistics-peak-hours-heat-map-title": "Peak hours",

        "service-center-reports-statistics-customer-usage-tab-title": "Customer usage",
        "service-center-reports-statistic-customer-usage-table-usage-rate-title": "Usage rate",
        "service-center-reports-statistic-customer-usage-filter-customer-label": 'Customer',

        // Service center > Reports > Dashboard > Guests
        "service-center-reports-dashboard-guests-page-header": "\n .title = Gæster",
        "service-center-reports-dashboard-guests-table-guest-title": "Gæst",
        "service-center-reports-dashboard-guests-table-host-title": "Vært",
        "service-center-reports-dashboard-guests-table-check-in-time-title": "Check-ind",
        "service-center-reports-dashboard-guests-table-check-in-time-tooltip": "Meeting start",
        "service-center-reports-dashboard-guests-table-check-out-time-title": "Check-ud",
        "service-center-reports-dashboard-guests-table-host-company-title": "Værtsfirma",
        "service-center-reports-dashboard-guests-table-host-company-status": "Status",
        "service-center-reports-dashboard-guests-table-host-company-status-checked-in": "Tjekket ind",
        "service-center-reports-dashboard-guests-table-host-company-status-checked-out": "Tjekket ud",
        "service-center-reports-dashboard-guests-table-host-company-status-expected": "Forventet",
        "service-center-reports-dashboard-guests-table-host-company-status-pending": "Venter i kø",
        "service-center-reports-dashboard-guests-table-host-company-status-checked-in-hover-tooltip": "The guest has been checked in.",
        "service-center-reports-dashboard-guests-table-host-company-status-checked-out-hover-tooltip": "The guest has been checked out.",
        "service-center-reports-dashboard-guests-table-host-company-status-expected-hover-tooltip": "The guest has been invited but has not checked in yet.",
        "service-center-reports-dashboard-guests-table-host-company-status-pending-hover-tooltip": "The guest has completed self-check-in; however, the reception team should extend a warm welcome and provide a guest card.",
        "service-center-reports-dashboard-guests-table-floating-action-bar-guest-card": "\n .title = Gæstekort",
        "service-center-reports-dashboard-guests-table-date-range-filter": "Periode",

        // Service center > Admin > Organization > DEVICES
        "service-center-admin-organization-devices-title": "\n .title = Devices",
        "service-center-admin-organization-devices-button-title": "Create Device",

        // Service center > Admin > Organization > Resources
        "service-center-admin-organization-resources-title": "\n .title = Resources",
         "service-center-admin-organization-resources-create-button": "Create resource",
        "service-center-admin-organization-resources-rooms-tab": "Rooms",
        "service-center-admin-organization-resources-mobile-av-equipment-tab": "AV equipment",
        "service-center-admin-organization-resources-cars-tab": "Cars",
        "service-center-admin-organization-resources-table-header-name": "Name",
        "service-center-admin-organization-resources-table-room-header-id": "Room no",
        "service-center-admin-organization-resources-table-mobile-av-header-id": "Serial no",
        "service-center-admin-organization-resources-table-cars-header-id": "Reg no",
        "service-center-admin-organization-resources-table-header-status": "Status",
        "service-center-admin-organization-resources-table-edit-item": "Edit",
        "service-center-admin-organization-resources-table-delete-item": "Delete",
        "service-center-admin-organization-resources-table-room-delete-modal-title": "room",
        "service-center-admin-organization-resources-table-mobile-av-equipment-delete-modal-title": "mobile AV equipment",
        "service-center-admin-organization-resources-table-car-delete-modal-title": "car",

        "service-center-admin-organization-resources-status-not-approved": "Ikke godkendt",
        "service-center-admin-organization-resources-status-approved": "Godkendt",
        "service-center-admin-organization-resources-status-rejected": "Afvist",
        "service-center-admin-organization-resources-status-preparing": "Forbereder",
        "service-center-admin-organization-resources-status-delivered": "Leveret",
        "service-center-admin-organization-resources-status-to-be-booked": "Skal bookes",
        "service-center-admin-organization-resources-status-booked": "Bogført",

        "service-center-admin-organization-resources-status-menu-not-approved": "Forkast godkendelse",
        "service-center-admin-organization-resources-status-menu-approved": "Godkend",
        "service-center-admin-organization-resources-status-menu-rejected": "Afvis",
        "service-center-admin-organization-resources-status-menu-preparing": "Forbered",
        "service-center-admin-organization-resources-status-menu-delivered": "Leveret",
        "service-center-admin-organization-resources-status-menu-booked": "Bogfør",
        "service-center-admin-organization-resources-status-menu-ready": "Klar",
        "service-center-admin-organization-resources-status-menu-default": "Ingen status",

        // Service center > Admin > Organization > Resources > Create Mobile AV
        "service-center-admin-organization-resources-create-mobile-av-title": "\n .title = Create Mobile AV",
        "service-center-admin-organization-resources-update-mobile-av-title": "\n .title = Update Mobile AV",
        "resources-create-edit-mobile-av-general-tab-error": "General tab has validation error",

        // Service center > Admin > Organization > Resources > Create car
        "service-center-admin-organization-resources-create-car-title": "\n .title = Create car",
        "service-center-admin-organization-resources-update-car-title": "\n .title = Update car",
        "resources-create-edit-car-general-tab-error": "General tab has validation error",

        // Service center > Admin > Organization > Resources > Create car > General
        "resources-create-edit-car-general-tab-general": "Stamdata",
        "resources-create-car-tab-general-registration-number-label": "\n .label = Registreringsnummer",
        "resources-create-car-tab-general-name-label": "\n .label = Betegnelse",
        "resources-create-car-tab-general-description-label": "\n .label = Beskrivelse",
        "resources-create-car-tab-general-car-type-label": "\n .label = Biltype",
        "resources-create-car-tab-general-location-of-keys-label": "\n .label = Nøglelokation",
        "resources-create-car-tab-general-parking-location-label": "\n .label = Standard parkeringslokation",
        "resources-create-car-tab-general-active-label": "Aktiv:",
        "resources-create-car-tab-general-in-service-label": "I drift:",
        "resources-create-car-tab-general-side-settings": "\n .title = Settings",

        // Service center > Admin > Organization > Resources > Create Mobile AV > General
        "resources-create-edit-mobile-av-general-tab-general": "General",
        "resources-create-mobile-av-tab-general-serial-number-label": "\n .label = Serienr",
        "resources-create-mobile-av-tab-general-name-label": "\n .label = Betegnelse",
        "resources-create-mobile-av-tab-general-floor-label": "\n .label = Sal",
        "resources-create-mobile-av-tab-general-description-label": "\n .label = Beskrivelse",
        "resources-create-mobile-av-tab-general-storage-location-label": "\n .label = Opbevaringssted",
        "resources-create-mobile-av-tab-general-cleanup-buffer-label": "\n .label = Afrydningsbuffer",
        "resources-create-mobile-av-tab-general-color-code-label": "\n .label = Farvekode",
        "resources-create-mobile-av-tab-general-active-label": "Active:",
        "resources-create-mobile-av-tab-general-side-settings": "\n .title = Settings",

        // Service center > Admin > Organization > Resources > Create room
        "service-center-admin-organization-resources-create-room-title": "\n .title = Create room",
        "resources-create-edit-room-general-tab-error": "General tab has validation error",

        // Service center > Admin > Organization > Resources > Create room > General
        "resources-create-edit-room-general-tab-general": "General",
        "resources-create-room-tab-general-room-number-label": "\n .label = Room number",
        "resources-create-room-tab-general-name-label": "\n .label = Name",
        "resources-create-room-tab-general-description-label": "\n .label = Description",
        "resources-create-room-tab-general-seats-label": "\n .label = Seats",
        "resources-create-room-tab-general-active-label": "Active:",
        "resources-create-room-tab-general-other-location-description": `\n .title = Marking a room as "Other location" will allow the user to type an ad-hoc location to hold the meeting such as their office.`,
        "resources-create-room-tab-general-other-location-label": "Other location:",
        "resources-create-room-tab-general-side-settings": "\n .title = Settings",
        "resources-create-room-tab-general-meeting-display": "\n .title = Meeting display",
        "resources-create-room-tab-general-floor-label": "\n .label = Floor",
        "resources-create-room-tab-general-walk-direction-label": "\n .label = Walk direction",
        "resources-create-room-tab-general-walk-direction-north": "North",
        "resources-create-room-tab-general-walk-direction-east": "East",
        "resources-create-room-tab-general-walk-direction-south": "South",
        "resources-create-room-tab-general-walk-direction-west": "West",
        "resources-create-room-tab-general-color-red": "Red",
        "resources-create-room-tab-general-color-green": "Green",
        "resources-create-room-tab-general-color-blue": "Blue",
        "resources-create-room-tab-general-color-black": "Black",
        "resources-create-room-tab-general-color-light-blue": "Light blue",
        "resources-create-room-tab-general-tags-label":  "\n .label = Tags",
        "resources-create-room-tab-general-tags-info-description":  `\n .label = Create one or more tags to be used for filtering resources. For example "External meeting room", "Guest meeting room", "Conference room", "Call room" etc.`,
        "resources-create-room-tab-general-fixed-av-equipment-label":  "\n .label = Fixed AV equipment",
        "resources-create-room-tab-general-side-filter-details": "\n .title = Filter details",
        "resources-create-room-tab-general-area-label": "\n .label = Area (sqm) \n .placeholder = Area of room in sqm",
        "resources-create-room-tab-general-cleanup-buffer-label": "\n .label = Cleanup buffer",
        "resources-create-room-tab-general-color-code-label": "\n .label = Color code",
        "resources-create-room-tab-general-email-address-label": "\n .label = Email address",
        "resources-create-room-tab-general-side-integrations": "\n .title = Calendar integration",
        "resources-create-room-tab-general-side-integrations-meeting-invite": "\n .description = Used for integrating with Exchange or other calendar systems. The email address will be added to the meeting invitation by FacilityNet Outlook Add-in when booking the room.",
        "resources-create-room-tab-general-side-integrations-starleaf": "\n .description =Used for integrating with StarLeaf equipment that come with a dedicated email address used for integration.",
        "resources-create-room-tab-general-side-integrations-ews": "\n .description = Used for integrating with equipment that reads from a calendar. The calendar of the mailbox will be booked using an EWS service account when booking the room.",

        "resources-create-room-tab-general-book-using-ews": "Book using EWS",
        "resources-create-room-tab-general-add-reminder-button-label": "Add reminder",

        // Service center > Admin > Organization > Resources > Create room > Table arrangements
        "resources-create-edit-room-general-tab-table-arrangements": "Table arrangements",
        "tab-table-arrangements-standard": "Standard",
        "tab-table-arrangements-option": "Option",

        // Service center > Admin > Organization > Resources > Create room > Notifiations
        "resources-create-edit-room-general-tab-notifications": "Notifiations",
        "resources-create-edit-room-general-tab-table-header-type": "Type",
        "resources-create-edit-room-general-tab-table-header-sent": "Sent",
        "resources-create-edit-room-general-tab-table-header-content": "Content",

        // Service center > Admin > Organization > Resources > Create room > Availability
        "resources-create-edit-room-general-tab-availability": "Availability",
        "tab-availability-closed-periods-title": "Unavailable period",
        "tab-availability-table-start-header": "Start",
        "tab-availability-table-end-header": "End",
        "tab-availability-table-reason-header": "Reason",
        "tab-availability-table-edit-action": "Edit",
        "tab-availability-table-delete-action": "Delete",
        "tab-availability-add-closed-period-action": "Add unavailable period",
        "tab-availability-side-daily-closing-times-title": "\n .title = Daily closing times",
        "tab-availability-side-daily-booking-times-title": "\n .title = Booking Time",
        "tab-availability-side-start-time-label": "\n .label = Start time",
        "tab-availability-side-end-time-label": "\n .label = End time",
        "tab-availability-modal-reason-label": "\n .label = Reason",
        "tab-availability-modal-title": "Add closed period",
        "tab-availability-modal-add-button": "Add",
        "tab-availability-modal-booking-time-dropdown-label": "\n .label = Booking time type",
        "tab-availability-modal-booking-time-dropdown-accept": "Accept Booking Time",
        "tab-availability-modal-booking-time-dropdown-block": "Block Booking Time",

        "tab-availability-add-reminder-dialog-title": "Add reminder",
        "tab-availability-add-reminder-edit-dialog-title": "Edit reminder",
        "tab-availability-add-reminder-dialog-field-type-label": "\n .label = Type",
        "tab-availability-add-reminder-dialog-field-time-label": "\n .label = Sent",
        "tab-availability-add-reminder-dialog-field-text-label": "\n .label = Text",
        "tab-availability-add-reminder-dialog-submit-button-label": "Add",

        "tab-availability-add-reminder-dialog-form-time-suffix-hours-before": "hours before meeting start",
        "tab-availability-add-reminder-dialog-form-time-suffix-minutes-before": "minutes before meeting start",
        "tab-availability-add-reminder-dialog-form-time-suffix-hours-after": "hours after meeting end",
        "tab-availability-add-reminder-dialog-form-time-suffix-minutes-after": "minutes after meeting end",

        "reminder-type-option-meeting-start": "Meeting start reminder",
        "reminder-type-option-first-reminder": "First  reminder",
        "reminder-type-option-preparation": "Preparation",
        "reminder-type-option-cleanup": "Cleanup",
        "reminder-type-option-custom-reminder": "Custom reminder",
        "reminder-type-option-meeting-confirmation": "Meeting confirmation",

        "integration-type-option-none": "None",
        "integration-type-option-meeting-invite": "Meeting Invite",
        "integration-type-option-ews": "EWS",
        "integration-type-option-starleaf": "Starleaf",

        // Service center > Admin > Organization > Resources > Create room > Access control
        "resources-create-edit-room-general-tab-access-control": "Access control",
        "tab-access-control-restricted-access-title": "\n .title =Restricted access",
        "tab-access-control-visible-everyone-switch":'Visible for everyone',
        "tab-access-control-reserved-for-company-title":"Reserved for company:",
        "tab-access-control-bookable-by-departments-title":"Bookable by departments:",
        "tab-access-control-select-department-select-item":"Select a department",
        "tab-access-control-add-button":"Add",


        // Service center > Admin > Account > Admins
        "service-center-admin-account-admins-page-header": "\n .title = Administrators",
        "service-center-admin-account-admins-table-header-name":"Name",
        "service-center-admin-account-admins-table-header-email":"Email",
        "service-center-admin-account-admins-table-header-status":"Status",
        "service-center-admin-account-admins-table-status-active":"Active",
        "service-center-admin-account-admins-table-status-inactive": "Inactive",
        "service-center-admin-account-admins-table-button-details": "Show details",
        "service-center-admin-account-admins-table-button-edit": "Edit user",
        "service-center-admin-account-admins-table-button-delete": "Delete user",
        "service-center-admin-account-admins-button-create": "Create",
    }
}


type TranslationId = keyof typeof translations["en-US"]
type TranslationIdDa = keyof typeof translations["da-DK"]

// --- This section verifies at compile time that all keys in English translation is present in Danish translation and vice versa
const allEnglishTranslationKeys: TranslationId = Object.keys(translations["en-US"]) as unknown as TranslationId
const allDanishTranslationKeys: TranslationIdDa = Object.keys(translations["da-DK"]) as unknown as TranslationIdDa
const missingEnKeysInDaTranslation: TranslationIdDa = allEnglishTranslationKeys
const missingDaKeysInEnTranslation: TranslationId = allDanishTranslationKeys
// ---

export type TranslationKey = keyof typeof translations["en-US"]
export type StrictTranslations = typeof translations
export type Translations = Record<string, Record<string, string>>
